(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree0d0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree0d0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cRQVA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ddPRw"));

});
parcelRegister("ddPRw", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $9a04b807fb974aad$export$ffb0004e005737fa; }, function (v) { return $9a04b807fb974aad$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $9a04b807fb974aad$export$34b9dba7ce09269b; }, function (v) { return $9a04b807fb974aad$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $9a04b807fb974aad$export$25062201e9e25d76; }, function (v) { return $9a04b807fb974aad$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9a04b807fb974aad$export$ffb0004e005737fa;
var $9a04b807fb974aad$export$34b9dba7ce09269b;
var $9a04b807fb974aad$export$25062201e9e25d76;
'use strict';

var $cBna0 = parcelRequire("cBna0");
var $9a04b807fb974aad$var$k = Symbol.for("react.element"), $9a04b807fb974aad$var$l = Symbol.for("react.fragment"), $9a04b807fb974aad$var$m = Object.prototype.hasOwnProperty, $9a04b807fb974aad$var$n = $cBna0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $9a04b807fb974aad$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $9a04b807fb974aad$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$9a04b807fb974aad$var$m.call(a, b) && !$9a04b807fb974aad$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $9a04b807fb974aad$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $9a04b807fb974aad$var$n.current
    };
}
$9a04b807fb974aad$export$ffb0004e005737fa = $9a04b807fb974aad$var$l;
$9a04b807fb974aad$export$34b9dba7ce09269b = $9a04b807fb974aad$var$q;
$9a04b807fb974aad$export$25062201e9e25d76 = $9a04b807fb974aad$var$q;

});
parcelRegister("cBna0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5Cq1m"));

});
parcelRegister("5Cq1m", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $4174af9238e39f46$export$dca3b0875bd9a954; }, function (v) { return $4174af9238e39f46$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $4174af9238e39f46$export$16fa2f45be04daa8; }, function (v) { return $4174af9238e39f46$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4174af9238e39f46$export$ffb0004e005737fa; }, function (v) { return $4174af9238e39f46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $4174af9238e39f46$export$e2c29f18771995cb; }, function (v) { return $4174af9238e39f46$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $4174af9238e39f46$export$221d75b3f55bb0bd; }, function (v) { return $4174af9238e39f46$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4174af9238e39f46$export$5f8d39834fd61797; }, function (v) { return $4174af9238e39f46$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4174af9238e39f46$export$74bf444e3cd11ea5; }, function (v) { return $4174af9238e39f46$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4174af9238e39f46$export$ae55be85d98224ed; }, function (v) { return $4174af9238e39f46$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $4174af9238e39f46$export$3ba232387fd5d6dd; }, function (v) { return $4174af9238e39f46$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $4174af9238e39f46$export$e530037191fcd5d7; }, function (v) { return $4174af9238e39f46$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $4174af9238e39f46$export$fd42f52fd3ae1109; }, function (v) { return $4174af9238e39f46$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $4174af9238e39f46$export$c8a8987d4410bf2d; }, function (v) { return $4174af9238e39f46$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $4174af9238e39f46$export$d38cd72104c1f0e9; }, function (v) { return $4174af9238e39f46$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $4174af9238e39f46$export$7d1e3a5e95ceca43; }, function (v) { return $4174af9238e39f46$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $4174af9238e39f46$export$257a8862b851cb5b; }, function (v) { return $4174af9238e39f46$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $4174af9238e39f46$export$a8257692ac88316c; }, function (v) { return $4174af9238e39f46$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $4174af9238e39f46$export$488013bae63b21da; }, function (v) { return $4174af9238e39f46$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $4174af9238e39f46$export$7c73462e0d25e514; }, function (v) { return $4174af9238e39f46$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $4174af9238e39f46$export$7568632d0d33d16d; }, function (v) { return $4174af9238e39f46$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $4174af9238e39f46$export$88948ce120ea2619; }, function (v) { return $4174af9238e39f46$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $4174af9238e39f46$export$35808ee640e87ca7; }, function (v) { return $4174af9238e39f46$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $4174af9238e39f46$export$fae74005e78b1a27; }, function (v) { return $4174af9238e39f46$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $4174af9238e39f46$export$dc8fbce3eb94dc1e; }, function (v) { return $4174af9238e39f46$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $4174af9238e39f46$export$6a7bc4e911dc01cf; }, function (v) { return $4174af9238e39f46$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $4174af9238e39f46$export$6d9c69b0de29b591; }, function (v) { return $4174af9238e39f46$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $4174af9238e39f46$export$f680877a34711e37; }, function (v) { return $4174af9238e39f46$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $4174af9238e39f46$export$d5a552a76deda3c2; }, function (v) { return $4174af9238e39f46$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $4174af9238e39f46$export$aaabe4eda9ed9969; }, function (v) { return $4174af9238e39f46$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $4174af9238e39f46$export$e5c5a5f917a5871c; }, function (v) { return $4174af9238e39f46$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $4174af9238e39f46$export$1538c33de8887b59; }, function (v) { return $4174af9238e39f46$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $4174af9238e39f46$export$13e3392192263954; }, function (v) { return $4174af9238e39f46$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $4174af9238e39f46$export$b8f5890fc79d6aca; }, function (v) { return $4174af9238e39f46$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $4174af9238e39f46$export$60241385465d0a34; }, function (v) { return $4174af9238e39f46$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $4174af9238e39f46$export$306c0aa65ff9ec16; }, function (v) { return $4174af9238e39f46$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $4174af9238e39f46$export$7b286972b8d8ccbf; }, function (v) { return $4174af9238e39f46$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $4174af9238e39f46$export$83d89fbfd8236492; }, function (v) { return $4174af9238e39f46$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4174af9238e39f46$export$dca3b0875bd9a954;
var $4174af9238e39f46$export$16fa2f45be04daa8;
var $4174af9238e39f46$export$ffb0004e005737fa;
var $4174af9238e39f46$export$e2c29f18771995cb;
var $4174af9238e39f46$export$221d75b3f55bb0bd;
var $4174af9238e39f46$export$5f8d39834fd61797;
var $4174af9238e39f46$export$74bf444e3cd11ea5;
var $4174af9238e39f46$export$ae55be85d98224ed;
var $4174af9238e39f46$export$3ba232387fd5d6dd;
var $4174af9238e39f46$export$e530037191fcd5d7;
var $4174af9238e39f46$export$fd42f52fd3ae1109;
var $4174af9238e39f46$export$c8a8987d4410bf2d;
var $4174af9238e39f46$export$d38cd72104c1f0e9;
var $4174af9238e39f46$export$7d1e3a5e95ceca43;
var $4174af9238e39f46$export$257a8862b851cb5b;
var $4174af9238e39f46$export$a8257692ac88316c;
var $4174af9238e39f46$export$488013bae63b21da;
var $4174af9238e39f46$export$7c73462e0d25e514;
var $4174af9238e39f46$export$7568632d0d33d16d;
var $4174af9238e39f46$export$88948ce120ea2619;
var $4174af9238e39f46$export$35808ee640e87ca7;
var $4174af9238e39f46$export$fae74005e78b1a27;
var $4174af9238e39f46$export$dc8fbce3eb94dc1e;
var $4174af9238e39f46$export$6a7bc4e911dc01cf;
var $4174af9238e39f46$export$6d9c69b0de29b591;
var $4174af9238e39f46$export$f680877a34711e37;
var $4174af9238e39f46$export$d5a552a76deda3c2;
var $4174af9238e39f46$export$aaabe4eda9ed9969;
var $4174af9238e39f46$export$e5c5a5f917a5871c;
var $4174af9238e39f46$export$1538c33de8887b59;
var $4174af9238e39f46$export$13e3392192263954;
var $4174af9238e39f46$export$b8f5890fc79d6aca;
var $4174af9238e39f46$export$60241385465d0a34;
var $4174af9238e39f46$export$306c0aa65ff9ec16;
var $4174af9238e39f46$export$7b286972b8d8ccbf;
var $4174af9238e39f46$export$83d89fbfd8236492;
'use strict';
var $4174af9238e39f46$var$l = Symbol.for("react.element"), $4174af9238e39f46$var$n = Symbol.for("react.portal"), $4174af9238e39f46$var$p = Symbol.for("react.fragment"), $4174af9238e39f46$var$q = Symbol.for("react.strict_mode"), $4174af9238e39f46$var$r = Symbol.for("react.profiler"), $4174af9238e39f46$var$t = Symbol.for("react.provider"), $4174af9238e39f46$var$u = Symbol.for("react.context"), $4174af9238e39f46$var$v = Symbol.for("react.forward_ref"), $4174af9238e39f46$var$w = Symbol.for("react.suspense"), $4174af9238e39f46$var$x = Symbol.for("react.memo"), $4174af9238e39f46$var$y = Symbol.for("react.lazy"), $4174af9238e39f46$var$z = Symbol.iterator;
function $4174af9238e39f46$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4174af9238e39f46$var$z && a[$4174af9238e39f46$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4174af9238e39f46$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $4174af9238e39f46$var$C = Object.assign, $4174af9238e39f46$var$D = {};
function $4174af9238e39f46$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4174af9238e39f46$var$D;
    this.updater = e || $4174af9238e39f46$var$B;
}
$4174af9238e39f46$var$E.prototype.isReactComponent = {};
$4174af9238e39f46$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$4174af9238e39f46$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $4174af9238e39f46$var$F() {}
$4174af9238e39f46$var$F.prototype = $4174af9238e39f46$var$E.prototype;
function $4174af9238e39f46$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $4174af9238e39f46$var$D;
    this.updater = e || $4174af9238e39f46$var$B;
}
var $4174af9238e39f46$var$H = $4174af9238e39f46$var$G.prototype = new $4174af9238e39f46$var$F;
$4174af9238e39f46$var$H.constructor = $4174af9238e39f46$var$G;
$4174af9238e39f46$var$C($4174af9238e39f46$var$H, $4174af9238e39f46$var$E.prototype);
$4174af9238e39f46$var$H.isPureReactComponent = !0;
var $4174af9238e39f46$var$I = Array.isArray, $4174af9238e39f46$var$J = Object.prototype.hasOwnProperty, $4174af9238e39f46$var$K = {
    current: null
}, $4174af9238e39f46$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4174af9238e39f46$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$4174af9238e39f46$var$J.call(b, d) && !$4174af9238e39f46$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $4174af9238e39f46$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $4174af9238e39f46$var$K.current
    };
}
function $4174af9238e39f46$var$N(a, b) {
    return {
        $$typeof: $4174af9238e39f46$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $4174af9238e39f46$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4174af9238e39f46$var$l;
}
function $4174af9238e39f46$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $4174af9238e39f46$var$P = /\/+/g;
function $4174af9238e39f46$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $4174af9238e39f46$var$escape("" + a.key) : b.toString(36);
}
function $4174af9238e39f46$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $4174af9238e39f46$var$l:
                case $4174af9238e39f46$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $4174af9238e39f46$var$Q(h, 0) : d, $4174af9238e39f46$var$I(c) ? (e = "", null != a && (e = a.replace($4174af9238e39f46$var$P, "$&/") + "/"), $4174af9238e39f46$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($4174af9238e39f46$var$O(c) && (c = $4174af9238e39f46$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($4174af9238e39f46$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($4174af9238e39f46$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $4174af9238e39f46$var$Q(k, g);
        h += $4174af9238e39f46$var$R(k, b, e, f, c);
    }
    else if (f = $4174af9238e39f46$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $4174af9238e39f46$var$Q(k, g++), h += $4174af9238e39f46$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $4174af9238e39f46$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $4174af9238e39f46$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $4174af9238e39f46$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $4174af9238e39f46$var$U = {
    current: null
}, $4174af9238e39f46$var$V = {
    transition: null
}, $4174af9238e39f46$var$W = {
    ReactCurrentDispatcher: $4174af9238e39f46$var$U,
    ReactCurrentBatchConfig: $4174af9238e39f46$var$V,
    ReactCurrentOwner: $4174af9238e39f46$var$K
};
function $4174af9238e39f46$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$4174af9238e39f46$export$dca3b0875bd9a954 = {
    map: $4174af9238e39f46$var$S,
    forEach: function(a, b, e) {
        $4174af9238e39f46$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $4174af9238e39f46$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $4174af9238e39f46$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$4174af9238e39f46$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$4174af9238e39f46$export$16fa2f45be04daa8 = $4174af9238e39f46$var$E;
$4174af9238e39f46$export$ffb0004e005737fa = $4174af9238e39f46$var$p;
$4174af9238e39f46$export$e2c29f18771995cb = $4174af9238e39f46$var$r;
$4174af9238e39f46$export$221d75b3f55bb0bd = $4174af9238e39f46$var$G;
$4174af9238e39f46$export$5f8d39834fd61797 = $4174af9238e39f46$var$q;
$4174af9238e39f46$export$74bf444e3cd11ea5 = $4174af9238e39f46$var$w;
$4174af9238e39f46$export$ae55be85d98224ed = $4174af9238e39f46$var$W;
$4174af9238e39f46$export$3ba232387fd5d6dd = $4174af9238e39f46$var$X;
$4174af9238e39f46$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $4174af9238e39f46$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $4174af9238e39f46$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$4174af9238e39f46$var$J.call(b, f) && !$4174af9238e39f46$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $4174af9238e39f46$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$4174af9238e39f46$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $4174af9238e39f46$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $4174af9238e39f46$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$4174af9238e39f46$export$c8a8987d4410bf2d = $4174af9238e39f46$var$M;
$4174af9238e39f46$export$d38cd72104c1f0e9 = function(a) {
    var b = $4174af9238e39f46$var$M.bind(null, a);
    b.type = a;
    return b;
};
$4174af9238e39f46$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$4174af9238e39f46$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $4174af9238e39f46$var$v,
        render: a
    };
};
$4174af9238e39f46$export$a8257692ac88316c = $4174af9238e39f46$var$O;
$4174af9238e39f46$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $4174af9238e39f46$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $4174af9238e39f46$var$T
    };
};
$4174af9238e39f46$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $4174af9238e39f46$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$4174af9238e39f46$export$7568632d0d33d16d = function(a) {
    var b = $4174af9238e39f46$var$V.transition;
    $4174af9238e39f46$var$V.transition = {};
    try {
        a();
    } finally{
        $4174af9238e39f46$var$V.transition = b;
    }
};
$4174af9238e39f46$export$88948ce120ea2619 = $4174af9238e39f46$var$X;
$4174af9238e39f46$export$35808ee640e87ca7 = function(a, b) {
    return $4174af9238e39f46$var$U.current.useCallback(a, b);
};
$4174af9238e39f46$export$fae74005e78b1a27 = function(a) {
    return $4174af9238e39f46$var$U.current.useContext(a);
};
$4174af9238e39f46$export$dc8fbce3eb94dc1e = function() {};
$4174af9238e39f46$export$6a7bc4e911dc01cf = function(a) {
    return $4174af9238e39f46$var$U.current.useDeferredValue(a);
};
$4174af9238e39f46$export$6d9c69b0de29b591 = function(a, b) {
    return $4174af9238e39f46$var$U.current.useEffect(a, b);
};
$4174af9238e39f46$export$f680877a34711e37 = function() {
    return $4174af9238e39f46$var$U.current.useId();
};
$4174af9238e39f46$export$d5a552a76deda3c2 = function(a, b, e) {
    return $4174af9238e39f46$var$U.current.useImperativeHandle(a, b, e);
};
$4174af9238e39f46$export$aaabe4eda9ed9969 = function(a, b) {
    return $4174af9238e39f46$var$U.current.useInsertionEffect(a, b);
};
$4174af9238e39f46$export$e5c5a5f917a5871c = function(a, b) {
    return $4174af9238e39f46$var$U.current.useLayoutEffect(a, b);
};
$4174af9238e39f46$export$1538c33de8887b59 = function(a, b) {
    return $4174af9238e39f46$var$U.current.useMemo(a, b);
};
$4174af9238e39f46$export$13e3392192263954 = function(a, b, e) {
    return $4174af9238e39f46$var$U.current.useReducer(a, b, e);
};
$4174af9238e39f46$export$b8f5890fc79d6aca = function(a) {
    return $4174af9238e39f46$var$U.current.useRef(a);
};
$4174af9238e39f46$export$60241385465d0a34 = function(a) {
    return $4174af9238e39f46$var$U.current.useState(a);
};
$4174af9238e39f46$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $4174af9238e39f46$var$U.current.useSyncExternalStore(a, b, e);
};
$4174af9238e39f46$export$7b286972b8d8ccbf = function() {
    return $4174af9238e39f46$var$U.current.useTransition();
};
$4174af9238e39f46$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("hatoH", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c7fa2c86ce4a41e2$export$882461b6382ed46c; }, function (v) { return $c7fa2c86ce4a41e2$export$882461b6382ed46c = v; });
var $c7fa2c86ce4a41e2$export$882461b6382ed46c;
var $c7fa2c86ce4a41e2$export$757ceba2d55c277e;
'use strict';

var $e15zo = parcelRequire("e15zo");
var $c7fa2c86ce4a41e2$var$i;
$c7fa2c86ce4a41e2$export$882461b6382ed46c = $e15zo.createRoot;
$c7fa2c86ce4a41e2$export$757ceba2d55c277e = $e15zo.hydrateRoot;

});
parcelRegister("e15zo", function(module, exports) {
'use strict';
function $a3457ac096ea6037$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a3457ac096ea6037$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a3457ac096ea6037$var$checkDCE();

module.exports = (parcelRequire("aK6Bj"));

});
parcelRegister("aK6Bj", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $7d23520ee3dc0ecc$export$ae55be85d98224ed; }, function (v) { return $7d23520ee3dc0ecc$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $7d23520ee3dc0ecc$export$d39a5bbd09211389; }, function (v) { return $7d23520ee3dc0ecc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $7d23520ee3dc0ecc$export$882461b6382ed46c; }, function (v) { return $7d23520ee3dc0ecc$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $7d23520ee3dc0ecc$export$466bfc07425424d5; }, function (v) { return $7d23520ee3dc0ecc$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7d23520ee3dc0ecc$export$cd75ccfd720a3cd4; }, function (v) { return $7d23520ee3dc0ecc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $7d23520ee3dc0ecc$export$fa8d919ba61d84db; }, function (v) { return $7d23520ee3dc0ecc$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $7d23520ee3dc0ecc$export$757ceba2d55c277e; }, function (v) { return $7d23520ee3dc0ecc$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $7d23520ee3dc0ecc$export$b3890eb0ae9dca99; }, function (v) { return $7d23520ee3dc0ecc$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $7d23520ee3dc0ecc$export$502457920280e6be; }, function (v) { return $7d23520ee3dc0ecc$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7d23520ee3dc0ecc$export$c78a37762a8d58e1; }, function (v) { return $7d23520ee3dc0ecc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $7d23520ee3dc0ecc$export$dc54d992c10e8a18; }, function (v) { return $7d23520ee3dc0ecc$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $7d23520ee3dc0ecc$export$83d89fbfd8236492; }, function (v) { return $7d23520ee3dc0ecc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $7d23520ee3dc0ecc$export$ae55be85d98224ed;
var $7d23520ee3dc0ecc$export$d39a5bbd09211389;
var $7d23520ee3dc0ecc$export$882461b6382ed46c;
var $7d23520ee3dc0ecc$export$466bfc07425424d5;
var $7d23520ee3dc0ecc$export$cd75ccfd720a3cd4;
var $7d23520ee3dc0ecc$export$fa8d919ba61d84db;
var $7d23520ee3dc0ecc$export$757ceba2d55c277e;
var $7d23520ee3dc0ecc$export$b3890eb0ae9dca99;
var $7d23520ee3dc0ecc$export$502457920280e6be;
var $7d23520ee3dc0ecc$export$c78a37762a8d58e1;
var $7d23520ee3dc0ecc$export$dc54d992c10e8a18;
var $7d23520ee3dc0ecc$export$83d89fbfd8236492;
'use strict';

var $cBna0 = parcelRequire("cBna0");

var $bObFs = parcelRequire("bObFs");
function $7d23520ee3dc0ecc$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $7d23520ee3dc0ecc$var$da = new Set, $7d23520ee3dc0ecc$var$ea = {};
function $7d23520ee3dc0ecc$var$fa(a, b) {
    $7d23520ee3dc0ecc$var$ha(a, b);
    $7d23520ee3dc0ecc$var$ha(a + "Capture", b);
}
function $7d23520ee3dc0ecc$var$ha(a, b) {
    $7d23520ee3dc0ecc$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$7d23520ee3dc0ecc$var$da.add(b[a]);
}
var $7d23520ee3dc0ecc$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $7d23520ee3dc0ecc$var$ja = Object.prototype.hasOwnProperty, $7d23520ee3dc0ecc$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $7d23520ee3dc0ecc$var$la = {}, $7d23520ee3dc0ecc$var$ma = {};
function $7d23520ee3dc0ecc$var$oa(a) {
    if ($7d23520ee3dc0ecc$var$ja.call($7d23520ee3dc0ecc$var$ma, a)) return !0;
    if ($7d23520ee3dc0ecc$var$ja.call($7d23520ee3dc0ecc$var$la, a)) return !1;
    if ($7d23520ee3dc0ecc$var$ka.test(a)) return $7d23520ee3dc0ecc$var$ma[a] = !0;
    $7d23520ee3dc0ecc$var$la[a] = !0;
    return !1;
}
function $7d23520ee3dc0ecc$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $7d23520ee3dc0ecc$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $7d23520ee3dc0ecc$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $7d23520ee3dc0ecc$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $7d23520ee3dc0ecc$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $7d23520ee3dc0ecc$var$z[b] = new $7d23520ee3dc0ecc$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $7d23520ee3dc0ecc$var$ra = /[\-:]([a-z])/g;
function $7d23520ee3dc0ecc$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($7d23520ee3dc0ecc$var$ra, $7d23520ee3dc0ecc$var$sa);
    $7d23520ee3dc0ecc$var$z[b] = new $7d23520ee3dc0ecc$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($7d23520ee3dc0ecc$var$ra, $7d23520ee3dc0ecc$var$sa);
    $7d23520ee3dc0ecc$var$z[b] = new $7d23520ee3dc0ecc$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($7d23520ee3dc0ecc$var$ra, $7d23520ee3dc0ecc$var$sa);
    $7d23520ee3dc0ecc$var$z[b] = new $7d23520ee3dc0ecc$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$7d23520ee3dc0ecc$var$z.xlinkHref = new $7d23520ee3dc0ecc$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $7d23520ee3dc0ecc$var$z[a] = new $7d23520ee3dc0ecc$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $7d23520ee3dc0ecc$var$ta(a, b, c, d) {
    var e = $7d23520ee3dc0ecc$var$z.hasOwnProperty(b) ? $7d23520ee3dc0ecc$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $7d23520ee3dc0ecc$var$qa(b, c, e, d) && (c = null), d || null === e ? $7d23520ee3dc0ecc$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $7d23520ee3dc0ecc$var$ua = $cBna0.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $7d23520ee3dc0ecc$var$va = Symbol.for("react.element"), $7d23520ee3dc0ecc$var$wa = Symbol.for("react.portal"), $7d23520ee3dc0ecc$var$ya = Symbol.for("react.fragment"), $7d23520ee3dc0ecc$var$za = Symbol.for("react.strict_mode"), $7d23520ee3dc0ecc$var$Aa = Symbol.for("react.profiler"), $7d23520ee3dc0ecc$var$Ba = Symbol.for("react.provider"), $7d23520ee3dc0ecc$var$Ca = Symbol.for("react.context"), $7d23520ee3dc0ecc$var$Da = Symbol.for("react.forward_ref"), $7d23520ee3dc0ecc$var$Ea = Symbol.for("react.suspense"), $7d23520ee3dc0ecc$var$Fa = Symbol.for("react.suspense_list"), $7d23520ee3dc0ecc$var$Ga = Symbol.for("react.memo"), $7d23520ee3dc0ecc$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $7d23520ee3dc0ecc$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $7d23520ee3dc0ecc$var$Ja = Symbol.iterator;
function $7d23520ee3dc0ecc$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $7d23520ee3dc0ecc$var$Ja && a[$7d23520ee3dc0ecc$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $7d23520ee3dc0ecc$var$A = Object.assign, $7d23520ee3dc0ecc$var$La;
function $7d23520ee3dc0ecc$var$Ma(a) {
    if (void 0 === $7d23520ee3dc0ecc$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $7d23520ee3dc0ecc$var$La = b && b[1] || "";
    }
    return "\n" + $7d23520ee3dc0ecc$var$La + a;
}
var $7d23520ee3dc0ecc$var$Na = !1;
function $7d23520ee3dc0ecc$var$Oa(a, b) {
    if (!a || $7d23520ee3dc0ecc$var$Na) return "";
    $7d23520ee3dc0ecc$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $7d23520ee3dc0ecc$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $7d23520ee3dc0ecc$var$Ma(a) : "";
}
function $7d23520ee3dc0ecc$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $7d23520ee3dc0ecc$var$Ma(a.type);
        case 16:
            return $7d23520ee3dc0ecc$var$Ma("Lazy");
        case 13:
            return $7d23520ee3dc0ecc$var$Ma("Suspense");
        case 19:
            return $7d23520ee3dc0ecc$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $7d23520ee3dc0ecc$var$Oa(a.type, !1), a;
        case 11:
            return a = $7d23520ee3dc0ecc$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $7d23520ee3dc0ecc$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $7d23520ee3dc0ecc$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $7d23520ee3dc0ecc$var$ya:
            return "Fragment";
        case $7d23520ee3dc0ecc$var$wa:
            return "Portal";
        case $7d23520ee3dc0ecc$var$Aa:
            return "Profiler";
        case $7d23520ee3dc0ecc$var$za:
            return "StrictMode";
        case $7d23520ee3dc0ecc$var$Ea:
            return "Suspense";
        case $7d23520ee3dc0ecc$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $7d23520ee3dc0ecc$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $7d23520ee3dc0ecc$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $7d23520ee3dc0ecc$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $7d23520ee3dc0ecc$var$Ga:
            return b = a.displayName || null, null !== b ? b : $7d23520ee3dc0ecc$var$Qa(a.type) || "Memo";
        case $7d23520ee3dc0ecc$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $7d23520ee3dc0ecc$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $7d23520ee3dc0ecc$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $7d23520ee3dc0ecc$var$Qa(b);
        case 8:
            return b === $7d23520ee3dc0ecc$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $7d23520ee3dc0ecc$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $7d23520ee3dc0ecc$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $7d23520ee3dc0ecc$var$Ua(a) {
    var b = $7d23520ee3dc0ecc$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $7d23520ee3dc0ecc$var$Va(a) {
    a._valueTracker || (a._valueTracker = $7d23520ee3dc0ecc$var$Ua(a));
}
function $7d23520ee3dc0ecc$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $7d23520ee3dc0ecc$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $7d23520ee3dc0ecc$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $7d23520ee3dc0ecc$var$Ya(a, b) {
    var c = b.checked;
    return $7d23520ee3dc0ecc$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $7d23520ee3dc0ecc$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $7d23520ee3dc0ecc$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $7d23520ee3dc0ecc$var$ab(a, b) {
    b = b.checked;
    null != b && $7d23520ee3dc0ecc$var$ta(a, "checked", b, !1);
}
function $7d23520ee3dc0ecc$var$bb(a, b) {
    $7d23520ee3dc0ecc$var$ab(a, b);
    var c = $7d23520ee3dc0ecc$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $7d23520ee3dc0ecc$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $7d23520ee3dc0ecc$var$cb(a, b.type, $7d23520ee3dc0ecc$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $7d23520ee3dc0ecc$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $7d23520ee3dc0ecc$var$cb(a, b, c) {
    if ("number" !== b || $7d23520ee3dc0ecc$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $7d23520ee3dc0ecc$var$eb = Array.isArray;
function $7d23520ee3dc0ecc$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $7d23520ee3dc0ecc$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $7d23520ee3dc0ecc$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($7d23520ee3dc0ecc$var$p(91));
    return $7d23520ee3dc0ecc$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $7d23520ee3dc0ecc$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($7d23520ee3dc0ecc$var$p(92));
            if ($7d23520ee3dc0ecc$var$eb(c)) {
                if (1 < c.length) throw Error($7d23520ee3dc0ecc$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $7d23520ee3dc0ecc$var$Sa(c)
    };
}
function $7d23520ee3dc0ecc$var$ib(a, b) {
    var c = $7d23520ee3dc0ecc$var$Sa(b.value), d = $7d23520ee3dc0ecc$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $7d23520ee3dc0ecc$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $7d23520ee3dc0ecc$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $7d23520ee3dc0ecc$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $7d23520ee3dc0ecc$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $7d23520ee3dc0ecc$var$mb, $7d23520ee3dc0ecc$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $7d23520ee3dc0ecc$var$mb = $7d23520ee3dc0ecc$var$mb || document.createElement("div");
        $7d23520ee3dc0ecc$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $7d23520ee3dc0ecc$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $7d23520ee3dc0ecc$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $7d23520ee3dc0ecc$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $7d23520ee3dc0ecc$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($7d23520ee3dc0ecc$var$pb).forEach(function(a) {
    $7d23520ee3dc0ecc$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $7d23520ee3dc0ecc$var$pb[b] = $7d23520ee3dc0ecc$var$pb[a];
    });
});
function $7d23520ee3dc0ecc$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $7d23520ee3dc0ecc$var$pb.hasOwnProperty(a) && $7d23520ee3dc0ecc$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $7d23520ee3dc0ecc$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $7d23520ee3dc0ecc$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $7d23520ee3dc0ecc$var$tb = $7d23520ee3dc0ecc$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $7d23520ee3dc0ecc$var$ub(a, b) {
    if (b) {
        if ($7d23520ee3dc0ecc$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($7d23520ee3dc0ecc$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($7d23520ee3dc0ecc$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($7d23520ee3dc0ecc$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($7d23520ee3dc0ecc$var$p(62));
    }
}
function $7d23520ee3dc0ecc$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $7d23520ee3dc0ecc$var$wb = null;
function $7d23520ee3dc0ecc$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $7d23520ee3dc0ecc$var$yb = null, $7d23520ee3dc0ecc$var$zb = null, $7d23520ee3dc0ecc$var$Ab = null;
function $7d23520ee3dc0ecc$var$Bb(a) {
    if (a = $7d23520ee3dc0ecc$var$Cb(a)) {
        if ("function" !== typeof $7d23520ee3dc0ecc$var$yb) throw Error($7d23520ee3dc0ecc$var$p(280));
        var b = a.stateNode;
        b && (b = $7d23520ee3dc0ecc$var$Db(b), $7d23520ee3dc0ecc$var$yb(a.stateNode, a.type, b));
    }
}
function $7d23520ee3dc0ecc$var$Eb(a) {
    $7d23520ee3dc0ecc$var$zb ? $7d23520ee3dc0ecc$var$Ab ? $7d23520ee3dc0ecc$var$Ab.push(a) : $7d23520ee3dc0ecc$var$Ab = [
        a
    ] : $7d23520ee3dc0ecc$var$zb = a;
}
function $7d23520ee3dc0ecc$var$Fb() {
    if ($7d23520ee3dc0ecc$var$zb) {
        var a = $7d23520ee3dc0ecc$var$zb, b = $7d23520ee3dc0ecc$var$Ab;
        $7d23520ee3dc0ecc$var$Ab = $7d23520ee3dc0ecc$var$zb = null;
        $7d23520ee3dc0ecc$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$7d23520ee3dc0ecc$var$Bb(b[a]);
    }
}
function $7d23520ee3dc0ecc$var$Gb(a, b) {
    return a(b);
}
function $7d23520ee3dc0ecc$var$Hb() {}
var $7d23520ee3dc0ecc$var$Ib = !1;
function $7d23520ee3dc0ecc$var$Jb(a, b, c) {
    if ($7d23520ee3dc0ecc$var$Ib) return a(b, c);
    $7d23520ee3dc0ecc$var$Ib = !0;
    try {
        return $7d23520ee3dc0ecc$var$Gb(a, b, c);
    } finally{
        if ($7d23520ee3dc0ecc$var$Ib = !1, null !== $7d23520ee3dc0ecc$var$zb || null !== $7d23520ee3dc0ecc$var$Ab) $7d23520ee3dc0ecc$var$Hb(), $7d23520ee3dc0ecc$var$Fb();
    }
}
function $7d23520ee3dc0ecc$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $7d23520ee3dc0ecc$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($7d23520ee3dc0ecc$var$p(231, b, typeof c));
    return c;
}
var $7d23520ee3dc0ecc$var$Lb = !1;
if ($7d23520ee3dc0ecc$var$ia) try {
    var $7d23520ee3dc0ecc$var$Mb = {};
    Object.defineProperty($7d23520ee3dc0ecc$var$Mb, "passive", {
        get: function() {
            $7d23520ee3dc0ecc$var$Lb = !0;
        }
    });
    window.addEventListener("test", $7d23520ee3dc0ecc$var$Mb, $7d23520ee3dc0ecc$var$Mb);
    window.removeEventListener("test", $7d23520ee3dc0ecc$var$Mb, $7d23520ee3dc0ecc$var$Mb);
} catch (a) {
    $7d23520ee3dc0ecc$var$Lb = !1;
}
function $7d23520ee3dc0ecc$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $7d23520ee3dc0ecc$var$Ob = !1, $7d23520ee3dc0ecc$var$Pb = null, $7d23520ee3dc0ecc$var$Qb = !1, $7d23520ee3dc0ecc$var$Rb = null, $7d23520ee3dc0ecc$var$Sb = {
    onError: function(a) {
        $7d23520ee3dc0ecc$var$Ob = !0;
        $7d23520ee3dc0ecc$var$Pb = a;
    }
};
function $7d23520ee3dc0ecc$var$Tb(a, b, c, d, e, f, g, h, k) {
    $7d23520ee3dc0ecc$var$Ob = !1;
    $7d23520ee3dc0ecc$var$Pb = null;
    $7d23520ee3dc0ecc$var$Nb.apply($7d23520ee3dc0ecc$var$Sb, arguments);
}
function $7d23520ee3dc0ecc$var$Ub(a, b, c, d, e, f, g, h, k) {
    $7d23520ee3dc0ecc$var$Tb.apply(this, arguments);
    if ($7d23520ee3dc0ecc$var$Ob) {
        if ($7d23520ee3dc0ecc$var$Ob) {
            var l = $7d23520ee3dc0ecc$var$Pb;
            $7d23520ee3dc0ecc$var$Ob = !1;
            $7d23520ee3dc0ecc$var$Pb = null;
        } else throw Error($7d23520ee3dc0ecc$var$p(198));
        $7d23520ee3dc0ecc$var$Qb || ($7d23520ee3dc0ecc$var$Qb = !0, $7d23520ee3dc0ecc$var$Rb = l);
    }
}
function $7d23520ee3dc0ecc$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $7d23520ee3dc0ecc$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $7d23520ee3dc0ecc$var$Xb(a) {
    if ($7d23520ee3dc0ecc$var$Vb(a) !== a) throw Error($7d23520ee3dc0ecc$var$p(188));
}
function $7d23520ee3dc0ecc$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $7d23520ee3dc0ecc$var$Vb(a);
        if (null === b) throw Error($7d23520ee3dc0ecc$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $7d23520ee3dc0ecc$var$Xb(e), a;
                if (f === d) return $7d23520ee3dc0ecc$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($7d23520ee3dc0ecc$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($7d23520ee3dc0ecc$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($7d23520ee3dc0ecc$var$p(190));
    }
    if (3 !== c.tag) throw Error($7d23520ee3dc0ecc$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $7d23520ee3dc0ecc$var$Zb(a) {
    a = $7d23520ee3dc0ecc$var$Yb(a);
    return null !== a ? $7d23520ee3dc0ecc$var$$b(a) : null;
}
function $7d23520ee3dc0ecc$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $7d23520ee3dc0ecc$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $7d23520ee3dc0ecc$var$ac = $bObFs.unstable_scheduleCallback, $7d23520ee3dc0ecc$var$bc = $bObFs.unstable_cancelCallback, $7d23520ee3dc0ecc$var$cc = $bObFs.unstable_shouldYield, $7d23520ee3dc0ecc$var$dc = $bObFs.unstable_requestPaint, $7d23520ee3dc0ecc$var$B = $bObFs.unstable_now, $7d23520ee3dc0ecc$var$ec = $bObFs.unstable_getCurrentPriorityLevel, $7d23520ee3dc0ecc$var$fc = $bObFs.unstable_ImmediatePriority, $7d23520ee3dc0ecc$var$gc = $bObFs.unstable_UserBlockingPriority, $7d23520ee3dc0ecc$var$hc = $bObFs.unstable_NormalPriority, $7d23520ee3dc0ecc$var$ic = $bObFs.unstable_LowPriority, $7d23520ee3dc0ecc$var$jc = $bObFs.unstable_IdlePriority, $7d23520ee3dc0ecc$var$kc = null, $7d23520ee3dc0ecc$var$lc = null;
function $7d23520ee3dc0ecc$var$mc(a) {
    if ($7d23520ee3dc0ecc$var$lc && "function" === typeof $7d23520ee3dc0ecc$var$lc.onCommitFiberRoot) try {
        $7d23520ee3dc0ecc$var$lc.onCommitFiberRoot($7d23520ee3dc0ecc$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $7d23520ee3dc0ecc$var$oc = Math.clz32 ? Math.clz32 : $7d23520ee3dc0ecc$var$nc, $7d23520ee3dc0ecc$var$pc = Math.log, $7d23520ee3dc0ecc$var$qc = Math.LN2;
function $7d23520ee3dc0ecc$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($7d23520ee3dc0ecc$var$pc(a) / $7d23520ee3dc0ecc$var$qc | 0) | 0;
}
var $7d23520ee3dc0ecc$var$rc = 64, $7d23520ee3dc0ecc$var$sc = 4194304;
function $7d23520ee3dc0ecc$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $7d23520ee3dc0ecc$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $7d23520ee3dc0ecc$var$tc(h) : (f &= g, 0 !== f && (d = $7d23520ee3dc0ecc$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $7d23520ee3dc0ecc$var$tc(g) : 0 !== f && (d = $7d23520ee3dc0ecc$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $7d23520ee3dc0ecc$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $7d23520ee3dc0ecc$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $7d23520ee3dc0ecc$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $7d23520ee3dc0ecc$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $7d23520ee3dc0ecc$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $7d23520ee3dc0ecc$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $7d23520ee3dc0ecc$var$yc() {
    var a = $7d23520ee3dc0ecc$var$rc;
    $7d23520ee3dc0ecc$var$rc <<= 1;
    0 === ($7d23520ee3dc0ecc$var$rc & 4194240) && ($7d23520ee3dc0ecc$var$rc = 64);
    return a;
}
function $7d23520ee3dc0ecc$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $7d23520ee3dc0ecc$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $7d23520ee3dc0ecc$var$oc(b);
    a[b] = c;
}
function $7d23520ee3dc0ecc$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $7d23520ee3dc0ecc$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $7d23520ee3dc0ecc$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $7d23520ee3dc0ecc$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $7d23520ee3dc0ecc$var$C = 0;
function $7d23520ee3dc0ecc$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $7d23520ee3dc0ecc$var$Ec, $7d23520ee3dc0ecc$var$Fc, $7d23520ee3dc0ecc$var$Gc, $7d23520ee3dc0ecc$var$Hc, $7d23520ee3dc0ecc$var$Ic, $7d23520ee3dc0ecc$var$Jc = !1, $7d23520ee3dc0ecc$var$Kc = [], $7d23520ee3dc0ecc$var$Lc = null, $7d23520ee3dc0ecc$var$Mc = null, $7d23520ee3dc0ecc$var$Nc = null, $7d23520ee3dc0ecc$var$Oc = new Map, $7d23520ee3dc0ecc$var$Pc = new Map, $7d23520ee3dc0ecc$var$Qc = [], $7d23520ee3dc0ecc$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $7d23520ee3dc0ecc$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $7d23520ee3dc0ecc$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $7d23520ee3dc0ecc$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $7d23520ee3dc0ecc$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $7d23520ee3dc0ecc$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $7d23520ee3dc0ecc$var$Pc.delete(b.pointerId);
    }
}
function $7d23520ee3dc0ecc$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $7d23520ee3dc0ecc$var$Cb(b), null !== b && $7d23520ee3dc0ecc$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $7d23520ee3dc0ecc$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $7d23520ee3dc0ecc$var$Lc = $7d23520ee3dc0ecc$var$Tc($7d23520ee3dc0ecc$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $7d23520ee3dc0ecc$var$Mc = $7d23520ee3dc0ecc$var$Tc($7d23520ee3dc0ecc$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $7d23520ee3dc0ecc$var$Nc = $7d23520ee3dc0ecc$var$Tc($7d23520ee3dc0ecc$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $7d23520ee3dc0ecc$var$Oc.set(f, $7d23520ee3dc0ecc$var$Tc($7d23520ee3dc0ecc$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $7d23520ee3dc0ecc$var$Pc.set(f, $7d23520ee3dc0ecc$var$Tc($7d23520ee3dc0ecc$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $7d23520ee3dc0ecc$var$Vc(a) {
    var b = $7d23520ee3dc0ecc$var$Wc(a.target);
    if (null !== b) {
        var c = $7d23520ee3dc0ecc$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $7d23520ee3dc0ecc$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $7d23520ee3dc0ecc$var$Ic(a.priority, function() {
                        $7d23520ee3dc0ecc$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $7d23520ee3dc0ecc$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $7d23520ee3dc0ecc$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $7d23520ee3dc0ecc$var$wb = d;
            c.target.dispatchEvent(d);
            $7d23520ee3dc0ecc$var$wb = null;
        } else return b = $7d23520ee3dc0ecc$var$Cb(c), null !== b && $7d23520ee3dc0ecc$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $7d23520ee3dc0ecc$var$Zc(a, b, c) {
    $7d23520ee3dc0ecc$var$Xc(a) && c.delete(b);
}
function $7d23520ee3dc0ecc$var$$c() {
    $7d23520ee3dc0ecc$var$Jc = !1;
    null !== $7d23520ee3dc0ecc$var$Lc && $7d23520ee3dc0ecc$var$Xc($7d23520ee3dc0ecc$var$Lc) && ($7d23520ee3dc0ecc$var$Lc = null);
    null !== $7d23520ee3dc0ecc$var$Mc && $7d23520ee3dc0ecc$var$Xc($7d23520ee3dc0ecc$var$Mc) && ($7d23520ee3dc0ecc$var$Mc = null);
    null !== $7d23520ee3dc0ecc$var$Nc && $7d23520ee3dc0ecc$var$Xc($7d23520ee3dc0ecc$var$Nc) && ($7d23520ee3dc0ecc$var$Nc = null);
    $7d23520ee3dc0ecc$var$Oc.forEach($7d23520ee3dc0ecc$var$Zc);
    $7d23520ee3dc0ecc$var$Pc.forEach($7d23520ee3dc0ecc$var$Zc);
}
function $7d23520ee3dc0ecc$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $7d23520ee3dc0ecc$var$Jc || ($7d23520ee3dc0ecc$var$Jc = !0, $bObFs.unstable_scheduleCallback($bObFs.unstable_NormalPriority, $7d23520ee3dc0ecc$var$$c)));
}
function $7d23520ee3dc0ecc$var$bd(a) {
    function b(b) {
        return $7d23520ee3dc0ecc$var$ad(b, a);
    }
    if (0 < $7d23520ee3dc0ecc$var$Kc.length) {
        $7d23520ee3dc0ecc$var$ad($7d23520ee3dc0ecc$var$Kc[0], a);
        for(var c = 1; c < $7d23520ee3dc0ecc$var$Kc.length; c++){
            var d = $7d23520ee3dc0ecc$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $7d23520ee3dc0ecc$var$Lc && $7d23520ee3dc0ecc$var$ad($7d23520ee3dc0ecc$var$Lc, a);
    null !== $7d23520ee3dc0ecc$var$Mc && $7d23520ee3dc0ecc$var$ad($7d23520ee3dc0ecc$var$Mc, a);
    null !== $7d23520ee3dc0ecc$var$Nc && $7d23520ee3dc0ecc$var$ad($7d23520ee3dc0ecc$var$Nc, a);
    $7d23520ee3dc0ecc$var$Oc.forEach(b);
    $7d23520ee3dc0ecc$var$Pc.forEach(b);
    for(c = 0; c < $7d23520ee3dc0ecc$var$Qc.length; c++)d = $7d23520ee3dc0ecc$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $7d23520ee3dc0ecc$var$Qc.length && (c = $7d23520ee3dc0ecc$var$Qc[0], null === c.blockedOn);)$7d23520ee3dc0ecc$var$Vc(c), null === c.blockedOn && $7d23520ee3dc0ecc$var$Qc.shift();
}
var $7d23520ee3dc0ecc$var$cd = $7d23520ee3dc0ecc$var$ua.ReactCurrentBatchConfig, $7d23520ee3dc0ecc$var$dd = !0;
function $7d23520ee3dc0ecc$var$ed(a, b, c, d) {
    var e = $7d23520ee3dc0ecc$var$C, f = $7d23520ee3dc0ecc$var$cd.transition;
    $7d23520ee3dc0ecc$var$cd.transition = null;
    try {
        $7d23520ee3dc0ecc$var$C = 1, $7d23520ee3dc0ecc$var$fd(a, b, c, d);
    } finally{
        $7d23520ee3dc0ecc$var$C = e, $7d23520ee3dc0ecc$var$cd.transition = f;
    }
}
function $7d23520ee3dc0ecc$var$gd(a, b, c, d) {
    var e = $7d23520ee3dc0ecc$var$C, f = $7d23520ee3dc0ecc$var$cd.transition;
    $7d23520ee3dc0ecc$var$cd.transition = null;
    try {
        $7d23520ee3dc0ecc$var$C = 4, $7d23520ee3dc0ecc$var$fd(a, b, c, d);
    } finally{
        $7d23520ee3dc0ecc$var$C = e, $7d23520ee3dc0ecc$var$cd.transition = f;
    }
}
function $7d23520ee3dc0ecc$var$fd(a, b, c, d) {
    if ($7d23520ee3dc0ecc$var$dd) {
        var e = $7d23520ee3dc0ecc$var$Yc(a, b, c, d);
        if (null === e) $7d23520ee3dc0ecc$var$hd(a, b, d, $7d23520ee3dc0ecc$var$id, c), $7d23520ee3dc0ecc$var$Sc(a, d);
        else if ($7d23520ee3dc0ecc$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($7d23520ee3dc0ecc$var$Sc(a, d), b & 4 && -1 < $7d23520ee3dc0ecc$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $7d23520ee3dc0ecc$var$Cb(e);
                null !== f && $7d23520ee3dc0ecc$var$Ec(f);
                f = $7d23520ee3dc0ecc$var$Yc(a, b, c, d);
                null === f && $7d23520ee3dc0ecc$var$hd(a, b, d, $7d23520ee3dc0ecc$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $7d23520ee3dc0ecc$var$hd(a, b, d, null, c);
    }
}
var $7d23520ee3dc0ecc$var$id = null;
function $7d23520ee3dc0ecc$var$Yc(a, b, c, d) {
    $7d23520ee3dc0ecc$var$id = null;
    a = $7d23520ee3dc0ecc$var$xb(d);
    a = $7d23520ee3dc0ecc$var$Wc(a);
    if (null !== a) {
        if (b = $7d23520ee3dc0ecc$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $7d23520ee3dc0ecc$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $7d23520ee3dc0ecc$var$id = a;
    return null;
}
function $7d23520ee3dc0ecc$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($7d23520ee3dc0ecc$var$ec()){
                case $7d23520ee3dc0ecc$var$fc:
                    return 1;
                case $7d23520ee3dc0ecc$var$gc:
                    return 4;
                case $7d23520ee3dc0ecc$var$hc:
                case $7d23520ee3dc0ecc$var$ic:
                    return 16;
                case $7d23520ee3dc0ecc$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $7d23520ee3dc0ecc$var$kd = null, $7d23520ee3dc0ecc$var$ld = null, $7d23520ee3dc0ecc$var$md = null;
function $7d23520ee3dc0ecc$var$nd() {
    if ($7d23520ee3dc0ecc$var$md) return $7d23520ee3dc0ecc$var$md;
    var a, b = $7d23520ee3dc0ecc$var$ld, c = b.length, d, e = "value" in $7d23520ee3dc0ecc$var$kd ? $7d23520ee3dc0ecc$var$kd.value : $7d23520ee3dc0ecc$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $7d23520ee3dc0ecc$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $7d23520ee3dc0ecc$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $7d23520ee3dc0ecc$var$pd() {
    return !0;
}
function $7d23520ee3dc0ecc$var$qd() {
    return !1;
}
function $7d23520ee3dc0ecc$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $7d23520ee3dc0ecc$var$pd : $7d23520ee3dc0ecc$var$qd;
        this.isPropagationStopped = $7d23520ee3dc0ecc$var$qd;
        return this;
    }
    $7d23520ee3dc0ecc$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $7d23520ee3dc0ecc$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $7d23520ee3dc0ecc$var$pd);
        },
        persist: function() {},
        isPersistent: $7d23520ee3dc0ecc$var$pd
    });
    return b;
}
var $7d23520ee3dc0ecc$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $7d23520ee3dc0ecc$var$td = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$sd), $7d23520ee3dc0ecc$var$ud = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$sd, {
    view: 0,
    detail: 0
}), $7d23520ee3dc0ecc$var$vd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$ud), $7d23520ee3dc0ecc$var$wd, $7d23520ee3dc0ecc$var$xd, $7d23520ee3dc0ecc$var$yd, $7d23520ee3dc0ecc$var$Ad = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $7d23520ee3dc0ecc$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $7d23520ee3dc0ecc$var$yd && ($7d23520ee3dc0ecc$var$yd && "mousemove" === a.type ? ($7d23520ee3dc0ecc$var$wd = a.screenX - $7d23520ee3dc0ecc$var$yd.screenX, $7d23520ee3dc0ecc$var$xd = a.screenY - $7d23520ee3dc0ecc$var$yd.screenY) : $7d23520ee3dc0ecc$var$xd = $7d23520ee3dc0ecc$var$wd = 0, $7d23520ee3dc0ecc$var$yd = a);
        return $7d23520ee3dc0ecc$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $7d23520ee3dc0ecc$var$xd;
    }
}), $7d23520ee3dc0ecc$var$Bd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Ad), $7d23520ee3dc0ecc$var$Cd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$Ad, {
    dataTransfer: 0
}), $7d23520ee3dc0ecc$var$Dd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Cd), $7d23520ee3dc0ecc$var$Ed = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$ud, {
    relatedTarget: 0
}), $7d23520ee3dc0ecc$var$Fd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Ed), $7d23520ee3dc0ecc$var$Gd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7d23520ee3dc0ecc$var$Hd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Gd), $7d23520ee3dc0ecc$var$Id = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $7d23520ee3dc0ecc$var$Jd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Id), $7d23520ee3dc0ecc$var$Kd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$sd, {
    data: 0
}), $7d23520ee3dc0ecc$var$Ld = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Kd), $7d23520ee3dc0ecc$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $7d23520ee3dc0ecc$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $7d23520ee3dc0ecc$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $7d23520ee3dc0ecc$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $7d23520ee3dc0ecc$var$Od[a]) ? !!b[a] : !1;
}
function $7d23520ee3dc0ecc$var$zd() {
    return $7d23520ee3dc0ecc$var$Pd;
}
var $7d23520ee3dc0ecc$var$Qd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $7d23520ee3dc0ecc$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $7d23520ee3dc0ecc$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $7d23520ee3dc0ecc$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $7d23520ee3dc0ecc$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $7d23520ee3dc0ecc$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $7d23520ee3dc0ecc$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $7d23520ee3dc0ecc$var$Rd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Qd), $7d23520ee3dc0ecc$var$Sd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $7d23520ee3dc0ecc$var$Td = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Sd), $7d23520ee3dc0ecc$var$Ud = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $7d23520ee3dc0ecc$var$zd
}), $7d23520ee3dc0ecc$var$Vd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Ud), $7d23520ee3dc0ecc$var$Wd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $7d23520ee3dc0ecc$var$Xd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Wd), $7d23520ee3dc0ecc$var$Yd = $7d23520ee3dc0ecc$var$A({}, $7d23520ee3dc0ecc$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $7d23520ee3dc0ecc$var$Zd = $7d23520ee3dc0ecc$var$rd($7d23520ee3dc0ecc$var$Yd), $7d23520ee3dc0ecc$var$$d = [
    9,
    13,
    27,
    32
], $7d23520ee3dc0ecc$var$ae = $7d23520ee3dc0ecc$var$ia && "CompositionEvent" in window, $7d23520ee3dc0ecc$var$be = null;
$7d23520ee3dc0ecc$var$ia && "documentMode" in document && ($7d23520ee3dc0ecc$var$be = document.documentMode);
var $7d23520ee3dc0ecc$var$ce = $7d23520ee3dc0ecc$var$ia && "TextEvent" in window && !$7d23520ee3dc0ecc$var$be, $7d23520ee3dc0ecc$var$de = $7d23520ee3dc0ecc$var$ia && (!$7d23520ee3dc0ecc$var$ae || $7d23520ee3dc0ecc$var$be && 8 < $7d23520ee3dc0ecc$var$be && 11 >= $7d23520ee3dc0ecc$var$be), $7d23520ee3dc0ecc$var$ee = String.fromCharCode(32), $7d23520ee3dc0ecc$var$fe = !1;
function $7d23520ee3dc0ecc$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $7d23520ee3dc0ecc$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $7d23520ee3dc0ecc$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $7d23520ee3dc0ecc$var$ie = !1;
function $7d23520ee3dc0ecc$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $7d23520ee3dc0ecc$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $7d23520ee3dc0ecc$var$fe = !0;
            return $7d23520ee3dc0ecc$var$ee;
        case "textInput":
            return a = b.data, a === $7d23520ee3dc0ecc$var$ee && $7d23520ee3dc0ecc$var$fe ? null : a;
        default:
            return null;
    }
}
function $7d23520ee3dc0ecc$var$ke(a, b) {
    if ($7d23520ee3dc0ecc$var$ie) return "compositionend" === a || !$7d23520ee3dc0ecc$var$ae && $7d23520ee3dc0ecc$var$ge(a, b) ? (a = $7d23520ee3dc0ecc$var$nd(), $7d23520ee3dc0ecc$var$md = $7d23520ee3dc0ecc$var$ld = $7d23520ee3dc0ecc$var$kd = null, $7d23520ee3dc0ecc$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $7d23520ee3dc0ecc$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $7d23520ee3dc0ecc$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $7d23520ee3dc0ecc$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$7d23520ee3dc0ecc$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $7d23520ee3dc0ecc$var$ne(a, b, c, d) {
    $7d23520ee3dc0ecc$var$Eb(d);
    b = $7d23520ee3dc0ecc$var$oe(b, "onChange");
    0 < b.length && (c = new $7d23520ee3dc0ecc$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $7d23520ee3dc0ecc$var$pe = null, $7d23520ee3dc0ecc$var$qe = null;
function $7d23520ee3dc0ecc$var$re(a) {
    $7d23520ee3dc0ecc$var$se(a, 0);
}
function $7d23520ee3dc0ecc$var$te(a) {
    var b = $7d23520ee3dc0ecc$var$ue(a);
    if ($7d23520ee3dc0ecc$var$Wa(b)) return a;
}
function $7d23520ee3dc0ecc$var$ve(a, b) {
    if ("change" === a) return b;
}
var $7d23520ee3dc0ecc$var$we = !1;
if ($7d23520ee3dc0ecc$var$ia) {
    var $7d23520ee3dc0ecc$var$xe;
    if ($7d23520ee3dc0ecc$var$ia) {
        var $7d23520ee3dc0ecc$var$ye = "oninput" in document;
        if (!$7d23520ee3dc0ecc$var$ye) {
            var $7d23520ee3dc0ecc$var$ze = document.createElement("div");
            $7d23520ee3dc0ecc$var$ze.setAttribute("oninput", "return;");
            $7d23520ee3dc0ecc$var$ye = "function" === typeof $7d23520ee3dc0ecc$var$ze.oninput;
        }
        $7d23520ee3dc0ecc$var$xe = $7d23520ee3dc0ecc$var$ye;
    } else $7d23520ee3dc0ecc$var$xe = !1;
    $7d23520ee3dc0ecc$var$we = $7d23520ee3dc0ecc$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $7d23520ee3dc0ecc$var$Ae() {
    $7d23520ee3dc0ecc$var$pe && ($7d23520ee3dc0ecc$var$pe.detachEvent("onpropertychange", $7d23520ee3dc0ecc$var$Be), $7d23520ee3dc0ecc$var$qe = $7d23520ee3dc0ecc$var$pe = null);
}
function $7d23520ee3dc0ecc$var$Be(a) {
    if ("value" === a.propertyName && $7d23520ee3dc0ecc$var$te($7d23520ee3dc0ecc$var$qe)) {
        var b = [];
        $7d23520ee3dc0ecc$var$ne(b, $7d23520ee3dc0ecc$var$qe, a, $7d23520ee3dc0ecc$var$xb(a));
        $7d23520ee3dc0ecc$var$Jb($7d23520ee3dc0ecc$var$re, b);
    }
}
function $7d23520ee3dc0ecc$var$Ce(a, b, c) {
    "focusin" === a ? ($7d23520ee3dc0ecc$var$Ae(), $7d23520ee3dc0ecc$var$pe = b, $7d23520ee3dc0ecc$var$qe = c, $7d23520ee3dc0ecc$var$pe.attachEvent("onpropertychange", $7d23520ee3dc0ecc$var$Be)) : "focusout" === a && $7d23520ee3dc0ecc$var$Ae();
}
function $7d23520ee3dc0ecc$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $7d23520ee3dc0ecc$var$te($7d23520ee3dc0ecc$var$qe);
}
function $7d23520ee3dc0ecc$var$Ee(a, b) {
    if ("click" === a) return $7d23520ee3dc0ecc$var$te(b);
}
function $7d23520ee3dc0ecc$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $7d23520ee3dc0ecc$var$te(b);
}
function $7d23520ee3dc0ecc$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $7d23520ee3dc0ecc$var$He = "function" === typeof Object.is ? Object.is : $7d23520ee3dc0ecc$var$Ge;
function $7d23520ee3dc0ecc$var$Ie(a, b) {
    if ($7d23520ee3dc0ecc$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$7d23520ee3dc0ecc$var$ja.call(b, e) || !$7d23520ee3dc0ecc$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $7d23520ee3dc0ecc$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $7d23520ee3dc0ecc$var$Ke(a, b) {
    var c = $7d23520ee3dc0ecc$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $7d23520ee3dc0ecc$var$Je(c);
    }
}
function $7d23520ee3dc0ecc$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $7d23520ee3dc0ecc$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $7d23520ee3dc0ecc$var$Me() {
    for(var a = window, b = $7d23520ee3dc0ecc$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $7d23520ee3dc0ecc$var$Xa(a.document);
    }
    return b;
}
function $7d23520ee3dc0ecc$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $7d23520ee3dc0ecc$var$Oe(a) {
    var b = $7d23520ee3dc0ecc$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $7d23520ee3dc0ecc$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $7d23520ee3dc0ecc$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $7d23520ee3dc0ecc$var$Ke(c, f);
                var g = $7d23520ee3dc0ecc$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $7d23520ee3dc0ecc$var$Pe = $7d23520ee3dc0ecc$var$ia && "documentMode" in document && 11 >= document.documentMode, $7d23520ee3dc0ecc$var$Qe = null, $7d23520ee3dc0ecc$var$Re = null, $7d23520ee3dc0ecc$var$Se = null, $7d23520ee3dc0ecc$var$Te = !1;
function $7d23520ee3dc0ecc$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $7d23520ee3dc0ecc$var$Te || null == $7d23520ee3dc0ecc$var$Qe || $7d23520ee3dc0ecc$var$Qe !== $7d23520ee3dc0ecc$var$Xa(d) || (d = $7d23520ee3dc0ecc$var$Qe, "selectionStart" in d && $7d23520ee3dc0ecc$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $7d23520ee3dc0ecc$var$Se && $7d23520ee3dc0ecc$var$Ie($7d23520ee3dc0ecc$var$Se, d) || ($7d23520ee3dc0ecc$var$Se = d, d = $7d23520ee3dc0ecc$var$oe($7d23520ee3dc0ecc$var$Re, "onSelect"), 0 < d.length && (b = new $7d23520ee3dc0ecc$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $7d23520ee3dc0ecc$var$Qe)));
}
function $7d23520ee3dc0ecc$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $7d23520ee3dc0ecc$var$We = {
    animationend: $7d23520ee3dc0ecc$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $7d23520ee3dc0ecc$var$Ve("Animation", "AnimationIteration"),
    animationstart: $7d23520ee3dc0ecc$var$Ve("Animation", "AnimationStart"),
    transitionend: $7d23520ee3dc0ecc$var$Ve("Transition", "TransitionEnd")
}, $7d23520ee3dc0ecc$var$Xe = {}, $7d23520ee3dc0ecc$var$Ye = {};
$7d23520ee3dc0ecc$var$ia && ($7d23520ee3dc0ecc$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $7d23520ee3dc0ecc$var$We.animationend.animation, delete $7d23520ee3dc0ecc$var$We.animationiteration.animation, delete $7d23520ee3dc0ecc$var$We.animationstart.animation), "TransitionEvent" in window || delete $7d23520ee3dc0ecc$var$We.transitionend.transition);
function $7d23520ee3dc0ecc$var$Ze(a) {
    if ($7d23520ee3dc0ecc$var$Xe[a]) return $7d23520ee3dc0ecc$var$Xe[a];
    if (!$7d23520ee3dc0ecc$var$We[a]) return a;
    var b = $7d23520ee3dc0ecc$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $7d23520ee3dc0ecc$var$Ye) return $7d23520ee3dc0ecc$var$Xe[a] = b[c];
    return a;
}
var $7d23520ee3dc0ecc$var$$e = $7d23520ee3dc0ecc$var$Ze("animationend"), $7d23520ee3dc0ecc$var$af = $7d23520ee3dc0ecc$var$Ze("animationiteration"), $7d23520ee3dc0ecc$var$bf = $7d23520ee3dc0ecc$var$Ze("animationstart"), $7d23520ee3dc0ecc$var$cf = $7d23520ee3dc0ecc$var$Ze("transitionend"), $7d23520ee3dc0ecc$var$df = new Map, $7d23520ee3dc0ecc$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $7d23520ee3dc0ecc$var$ff(a, b) {
    $7d23520ee3dc0ecc$var$df.set(a, b);
    $7d23520ee3dc0ecc$var$fa(b, [
        a
    ]);
}
for(var $7d23520ee3dc0ecc$var$gf = 0; $7d23520ee3dc0ecc$var$gf < $7d23520ee3dc0ecc$var$ef.length; $7d23520ee3dc0ecc$var$gf++){
    var $7d23520ee3dc0ecc$var$hf = $7d23520ee3dc0ecc$var$ef[$7d23520ee3dc0ecc$var$gf], $7d23520ee3dc0ecc$var$jf = $7d23520ee3dc0ecc$var$hf.toLowerCase(), $7d23520ee3dc0ecc$var$kf = $7d23520ee3dc0ecc$var$hf[0].toUpperCase() + $7d23520ee3dc0ecc$var$hf.slice(1);
    $7d23520ee3dc0ecc$var$ff($7d23520ee3dc0ecc$var$jf, "on" + $7d23520ee3dc0ecc$var$kf);
}
$7d23520ee3dc0ecc$var$ff($7d23520ee3dc0ecc$var$$e, "onAnimationEnd");
$7d23520ee3dc0ecc$var$ff($7d23520ee3dc0ecc$var$af, "onAnimationIteration");
$7d23520ee3dc0ecc$var$ff($7d23520ee3dc0ecc$var$bf, "onAnimationStart");
$7d23520ee3dc0ecc$var$ff("dblclick", "onDoubleClick");
$7d23520ee3dc0ecc$var$ff("focusin", "onFocus");
$7d23520ee3dc0ecc$var$ff("focusout", "onBlur");
$7d23520ee3dc0ecc$var$ff($7d23520ee3dc0ecc$var$cf, "onTransitionEnd");
$7d23520ee3dc0ecc$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$7d23520ee3dc0ecc$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$7d23520ee3dc0ecc$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$7d23520ee3dc0ecc$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$7d23520ee3dc0ecc$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$7d23520ee3dc0ecc$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$7d23520ee3dc0ecc$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$7d23520ee3dc0ecc$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$7d23520ee3dc0ecc$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$7d23520ee3dc0ecc$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $7d23520ee3dc0ecc$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $7d23520ee3dc0ecc$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($7d23520ee3dc0ecc$var$lf));
function $7d23520ee3dc0ecc$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $7d23520ee3dc0ecc$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $7d23520ee3dc0ecc$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7d23520ee3dc0ecc$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $7d23520ee3dc0ecc$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($7d23520ee3dc0ecc$var$Qb) throw a = $7d23520ee3dc0ecc$var$Rb, $7d23520ee3dc0ecc$var$Qb = !1, $7d23520ee3dc0ecc$var$Rb = null, a;
}
function $7d23520ee3dc0ecc$var$D(a, b) {
    var c = b[$7d23520ee3dc0ecc$var$of];
    void 0 === c && (c = b[$7d23520ee3dc0ecc$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($7d23520ee3dc0ecc$var$pf(b, a, 2, !1), c.add(d));
}
function $7d23520ee3dc0ecc$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $7d23520ee3dc0ecc$var$pf(c, a, d, b);
}
var $7d23520ee3dc0ecc$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $7d23520ee3dc0ecc$var$sf(a) {
    if (!a[$7d23520ee3dc0ecc$var$rf]) {
        a[$7d23520ee3dc0ecc$var$rf] = !0;
        $7d23520ee3dc0ecc$var$da.forEach(function(b) {
            "selectionchange" !== b && ($7d23520ee3dc0ecc$var$mf.has(b) || $7d23520ee3dc0ecc$var$qf(b, !1, a), $7d23520ee3dc0ecc$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$7d23520ee3dc0ecc$var$rf] || (b[$7d23520ee3dc0ecc$var$rf] = !0, $7d23520ee3dc0ecc$var$qf("selectionchange", !1, b));
    }
}
function $7d23520ee3dc0ecc$var$pf(a, b, c, d) {
    switch($7d23520ee3dc0ecc$var$jd(b)){
        case 1:
            var e = $7d23520ee3dc0ecc$var$ed;
            break;
        case 4:
            e = $7d23520ee3dc0ecc$var$gd;
            break;
        default:
            e = $7d23520ee3dc0ecc$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$7d23520ee3dc0ecc$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $7d23520ee3dc0ecc$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $7d23520ee3dc0ecc$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $7d23520ee3dc0ecc$var$Jb(function() {
        var d = f, e = $7d23520ee3dc0ecc$var$xb(c), g = [];
        a: {
            var h = $7d23520ee3dc0ecc$var$df.get(a);
            if (void 0 !== h) {
                var k = $7d23520ee3dc0ecc$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $7d23520ee3dc0ecc$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $7d23520ee3dc0ecc$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $7d23520ee3dc0ecc$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $7d23520ee3dc0ecc$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $7d23520ee3dc0ecc$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $7d23520ee3dc0ecc$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $7d23520ee3dc0ecc$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $7d23520ee3dc0ecc$var$Vd;
                        break;
                    case $7d23520ee3dc0ecc$var$$e:
                    case $7d23520ee3dc0ecc$var$af:
                    case $7d23520ee3dc0ecc$var$bf:
                        k = $7d23520ee3dc0ecc$var$Hd;
                        break;
                    case $7d23520ee3dc0ecc$var$cf:
                        k = $7d23520ee3dc0ecc$var$Xd;
                        break;
                    case "scroll":
                        k = $7d23520ee3dc0ecc$var$vd;
                        break;
                    case "wheel":
                        k = $7d23520ee3dc0ecc$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $7d23520ee3dc0ecc$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $7d23520ee3dc0ecc$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $7d23520ee3dc0ecc$var$Kb(w, x), null != F && t.push($7d23520ee3dc0ecc$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $7d23520ee3dc0ecc$var$wb && (n = c.relatedTarget || c.fromElement) && ($7d23520ee3dc0ecc$var$Wc(n) || n[$7d23520ee3dc0ecc$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $7d23520ee3dc0ecc$var$Wc(n) : null, null !== n && (J = $7d23520ee3dc0ecc$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $7d23520ee3dc0ecc$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $7d23520ee3dc0ecc$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $7d23520ee3dc0ecc$var$ue(k);
                        u = null == n ? h : $7d23520ee3dc0ecc$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $7d23520ee3dc0ecc$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $7d23520ee3dc0ecc$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $7d23520ee3dc0ecc$var$vf(F))u++;
                            for(; 0 < w - u;)t = $7d23520ee3dc0ecc$var$vf(t), w--;
                            for(; 0 < u - w;)x = $7d23520ee3dc0ecc$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $7d23520ee3dc0ecc$var$vf(t);
                                x = $7d23520ee3dc0ecc$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $7d23520ee3dc0ecc$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $7d23520ee3dc0ecc$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $7d23520ee3dc0ecc$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $7d23520ee3dc0ecc$var$ve;
                else if ($7d23520ee3dc0ecc$var$me(h)) {
                    if ($7d23520ee3dc0ecc$var$we) na = $7d23520ee3dc0ecc$var$Fe;
                    else {
                        na = $7d23520ee3dc0ecc$var$De;
                        var xa = $7d23520ee3dc0ecc$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $7d23520ee3dc0ecc$var$Ee);
                if (na && (na = na(a, d))) {
                    $7d23520ee3dc0ecc$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $7d23520ee3dc0ecc$var$cb(h, "number", h.value);
            }
            xa = d ? $7d23520ee3dc0ecc$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($7d23520ee3dc0ecc$var$me(xa) || "true" === xa.contentEditable) $7d23520ee3dc0ecc$var$Qe = xa, $7d23520ee3dc0ecc$var$Re = d, $7d23520ee3dc0ecc$var$Se = null;
                    break;
                case "focusout":
                    $7d23520ee3dc0ecc$var$Se = $7d23520ee3dc0ecc$var$Re = $7d23520ee3dc0ecc$var$Qe = null;
                    break;
                case "mousedown":
                    $7d23520ee3dc0ecc$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $7d23520ee3dc0ecc$var$Te = !1;
                    $7d23520ee3dc0ecc$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($7d23520ee3dc0ecc$var$Pe) break;
                case "keydown":
                case "keyup":
                    $7d23520ee3dc0ecc$var$Ue(g, c, e);
            }
            var $a;
            if ($7d23520ee3dc0ecc$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $7d23520ee3dc0ecc$var$ie ? $7d23520ee3dc0ecc$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($7d23520ee3dc0ecc$var$de && "ko" !== c.locale && ($7d23520ee3dc0ecc$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $7d23520ee3dc0ecc$var$ie && ($a = $7d23520ee3dc0ecc$var$nd()) : ($7d23520ee3dc0ecc$var$kd = e, $7d23520ee3dc0ecc$var$ld = "value" in $7d23520ee3dc0ecc$var$kd ? $7d23520ee3dc0ecc$var$kd.value : $7d23520ee3dc0ecc$var$kd.textContent, $7d23520ee3dc0ecc$var$ie = !0)), xa = $7d23520ee3dc0ecc$var$oe(d, ba), 0 < xa.length && (ba = new $7d23520ee3dc0ecc$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $7d23520ee3dc0ecc$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $7d23520ee3dc0ecc$var$ce ? $7d23520ee3dc0ecc$var$je(a, c) : $7d23520ee3dc0ecc$var$ke(a, c)) d = $7d23520ee3dc0ecc$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $7d23520ee3dc0ecc$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $7d23520ee3dc0ecc$var$se(g, b);
    });
}
function $7d23520ee3dc0ecc$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $7d23520ee3dc0ecc$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $7d23520ee3dc0ecc$var$Kb(a, c), null != f && d.unshift($7d23520ee3dc0ecc$var$tf(a, f, e)), f = $7d23520ee3dc0ecc$var$Kb(a, b), null != f && d.push($7d23520ee3dc0ecc$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $7d23520ee3dc0ecc$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $7d23520ee3dc0ecc$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $7d23520ee3dc0ecc$var$Kb(c, f), null != k && g.unshift($7d23520ee3dc0ecc$var$tf(c, k, h))) : e || (k = $7d23520ee3dc0ecc$var$Kb(c, f), null != k && g.push($7d23520ee3dc0ecc$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $7d23520ee3dc0ecc$var$xf = /\r\n?/g, $7d23520ee3dc0ecc$var$yf = /\u0000|\uFFFD/g;
function $7d23520ee3dc0ecc$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($7d23520ee3dc0ecc$var$xf, "\n").replace($7d23520ee3dc0ecc$var$yf, "");
}
function $7d23520ee3dc0ecc$var$Af(a, b, c) {
    b = $7d23520ee3dc0ecc$var$zf(b);
    if ($7d23520ee3dc0ecc$var$zf(a) !== b && c) throw Error($7d23520ee3dc0ecc$var$p(425));
}
function $7d23520ee3dc0ecc$var$Bf() {}
var $7d23520ee3dc0ecc$var$Cf = null, $7d23520ee3dc0ecc$var$Df = null;
function $7d23520ee3dc0ecc$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $7d23520ee3dc0ecc$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $7d23520ee3dc0ecc$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $7d23520ee3dc0ecc$var$Hf = "function" === typeof Promise ? Promise : void 0, $7d23520ee3dc0ecc$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $7d23520ee3dc0ecc$var$Hf ? function(a) {
    return $7d23520ee3dc0ecc$var$Hf.resolve(null).then(a).catch($7d23520ee3dc0ecc$var$If);
} : $7d23520ee3dc0ecc$var$Ff;
function $7d23520ee3dc0ecc$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $7d23520ee3dc0ecc$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $7d23520ee3dc0ecc$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $7d23520ee3dc0ecc$var$bd(b);
}
function $7d23520ee3dc0ecc$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $7d23520ee3dc0ecc$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $7d23520ee3dc0ecc$var$Nf = Math.random().toString(36).slice(2), $7d23520ee3dc0ecc$var$Of = "__reactFiber$" + $7d23520ee3dc0ecc$var$Nf, $7d23520ee3dc0ecc$var$Pf = "__reactProps$" + $7d23520ee3dc0ecc$var$Nf, $7d23520ee3dc0ecc$var$uf = "__reactContainer$" + $7d23520ee3dc0ecc$var$Nf, $7d23520ee3dc0ecc$var$of = "__reactEvents$" + $7d23520ee3dc0ecc$var$Nf, $7d23520ee3dc0ecc$var$Qf = "__reactListeners$" + $7d23520ee3dc0ecc$var$Nf, $7d23520ee3dc0ecc$var$Rf = "__reactHandles$" + $7d23520ee3dc0ecc$var$Nf;
function $7d23520ee3dc0ecc$var$Wc(a) {
    var b = a[$7d23520ee3dc0ecc$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$7d23520ee3dc0ecc$var$uf] || c[$7d23520ee3dc0ecc$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $7d23520ee3dc0ecc$var$Mf(a); null !== a;){
                if (c = a[$7d23520ee3dc0ecc$var$Of]) return c;
                a = $7d23520ee3dc0ecc$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $7d23520ee3dc0ecc$var$Cb(a) {
    a = a[$7d23520ee3dc0ecc$var$Of] || a[$7d23520ee3dc0ecc$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $7d23520ee3dc0ecc$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($7d23520ee3dc0ecc$var$p(33));
}
function $7d23520ee3dc0ecc$var$Db(a) {
    return a[$7d23520ee3dc0ecc$var$Pf] || null;
}
var $7d23520ee3dc0ecc$var$Sf = [], $7d23520ee3dc0ecc$var$Tf = -1;
function $7d23520ee3dc0ecc$var$Uf(a) {
    return {
        current: a
    };
}
function $7d23520ee3dc0ecc$var$E(a) {
    0 > $7d23520ee3dc0ecc$var$Tf || (a.current = $7d23520ee3dc0ecc$var$Sf[$7d23520ee3dc0ecc$var$Tf], $7d23520ee3dc0ecc$var$Sf[$7d23520ee3dc0ecc$var$Tf] = null, $7d23520ee3dc0ecc$var$Tf--);
}
function $7d23520ee3dc0ecc$var$G(a, b) {
    $7d23520ee3dc0ecc$var$Tf++;
    $7d23520ee3dc0ecc$var$Sf[$7d23520ee3dc0ecc$var$Tf] = a.current;
    a.current = b;
}
var $7d23520ee3dc0ecc$var$Vf = {}, $7d23520ee3dc0ecc$var$H = $7d23520ee3dc0ecc$var$Uf($7d23520ee3dc0ecc$var$Vf), $7d23520ee3dc0ecc$var$Wf = $7d23520ee3dc0ecc$var$Uf(!1), $7d23520ee3dc0ecc$var$Xf = $7d23520ee3dc0ecc$var$Vf;
function $7d23520ee3dc0ecc$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $7d23520ee3dc0ecc$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $7d23520ee3dc0ecc$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $7d23520ee3dc0ecc$var$$f() {
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf);
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$H);
}
function $7d23520ee3dc0ecc$var$ag(a, b, c) {
    if ($7d23520ee3dc0ecc$var$H.current !== $7d23520ee3dc0ecc$var$Vf) throw Error($7d23520ee3dc0ecc$var$p(168));
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$H, b);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$Wf, c);
}
function $7d23520ee3dc0ecc$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($7d23520ee3dc0ecc$var$p(108, $7d23520ee3dc0ecc$var$Ra(a) || "Unknown", e));
    return $7d23520ee3dc0ecc$var$A({}, c, d);
}
function $7d23520ee3dc0ecc$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $7d23520ee3dc0ecc$var$Vf;
    $7d23520ee3dc0ecc$var$Xf = $7d23520ee3dc0ecc$var$H.current;
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$H, a);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$Wf, $7d23520ee3dc0ecc$var$Wf.current);
    return !0;
}
function $7d23520ee3dc0ecc$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($7d23520ee3dc0ecc$var$p(169));
    c ? (a = $7d23520ee3dc0ecc$var$bg(a, b, $7d23520ee3dc0ecc$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf), $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$H), $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$H, a)) : $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$Wf, c);
}
var $7d23520ee3dc0ecc$var$eg = null, $7d23520ee3dc0ecc$var$fg = !1, $7d23520ee3dc0ecc$var$gg = !1;
function $7d23520ee3dc0ecc$var$hg(a) {
    null === $7d23520ee3dc0ecc$var$eg ? $7d23520ee3dc0ecc$var$eg = [
        a
    ] : $7d23520ee3dc0ecc$var$eg.push(a);
}
function $7d23520ee3dc0ecc$var$ig(a) {
    $7d23520ee3dc0ecc$var$fg = !0;
    $7d23520ee3dc0ecc$var$hg(a);
}
function $7d23520ee3dc0ecc$var$jg() {
    if (!$7d23520ee3dc0ecc$var$gg && null !== $7d23520ee3dc0ecc$var$eg) {
        $7d23520ee3dc0ecc$var$gg = !0;
        var a = 0, b = $7d23520ee3dc0ecc$var$C;
        try {
            var c = $7d23520ee3dc0ecc$var$eg;
            for($7d23520ee3dc0ecc$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $7d23520ee3dc0ecc$var$eg = null;
            $7d23520ee3dc0ecc$var$fg = !1;
        } catch (e) {
            throw null !== $7d23520ee3dc0ecc$var$eg && ($7d23520ee3dc0ecc$var$eg = $7d23520ee3dc0ecc$var$eg.slice(a + 1)), $7d23520ee3dc0ecc$var$ac($7d23520ee3dc0ecc$var$fc, $7d23520ee3dc0ecc$var$jg), e;
        } finally{
            $7d23520ee3dc0ecc$var$C = b, $7d23520ee3dc0ecc$var$gg = !1;
        }
    }
    return null;
}
var $7d23520ee3dc0ecc$var$kg = [], $7d23520ee3dc0ecc$var$lg = 0, $7d23520ee3dc0ecc$var$mg = null, $7d23520ee3dc0ecc$var$ng = 0, $7d23520ee3dc0ecc$var$og = [], $7d23520ee3dc0ecc$var$pg = 0, $7d23520ee3dc0ecc$var$qg = null, $7d23520ee3dc0ecc$var$rg = 1, $7d23520ee3dc0ecc$var$sg = "";
function $7d23520ee3dc0ecc$var$tg(a, b) {
    $7d23520ee3dc0ecc$var$kg[$7d23520ee3dc0ecc$var$lg++] = $7d23520ee3dc0ecc$var$ng;
    $7d23520ee3dc0ecc$var$kg[$7d23520ee3dc0ecc$var$lg++] = $7d23520ee3dc0ecc$var$mg;
    $7d23520ee3dc0ecc$var$mg = a;
    $7d23520ee3dc0ecc$var$ng = b;
}
function $7d23520ee3dc0ecc$var$ug(a, b, c) {
    $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$rg;
    $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$sg;
    $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$qg;
    $7d23520ee3dc0ecc$var$qg = a;
    var d = $7d23520ee3dc0ecc$var$rg;
    a = $7d23520ee3dc0ecc$var$sg;
    var e = 32 - $7d23520ee3dc0ecc$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $7d23520ee3dc0ecc$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $7d23520ee3dc0ecc$var$rg = 1 << 32 - $7d23520ee3dc0ecc$var$oc(b) + e | c << e | d;
        $7d23520ee3dc0ecc$var$sg = f + a;
    } else $7d23520ee3dc0ecc$var$rg = 1 << f | c << e | d, $7d23520ee3dc0ecc$var$sg = a;
}
function $7d23520ee3dc0ecc$var$vg(a) {
    null !== a.return && ($7d23520ee3dc0ecc$var$tg(a, 1), $7d23520ee3dc0ecc$var$ug(a, 1, 0));
}
function $7d23520ee3dc0ecc$var$wg(a) {
    for(; a === $7d23520ee3dc0ecc$var$mg;)$7d23520ee3dc0ecc$var$mg = $7d23520ee3dc0ecc$var$kg[--$7d23520ee3dc0ecc$var$lg], $7d23520ee3dc0ecc$var$kg[$7d23520ee3dc0ecc$var$lg] = null, $7d23520ee3dc0ecc$var$ng = $7d23520ee3dc0ecc$var$kg[--$7d23520ee3dc0ecc$var$lg], $7d23520ee3dc0ecc$var$kg[$7d23520ee3dc0ecc$var$lg] = null;
    for(; a === $7d23520ee3dc0ecc$var$qg;)$7d23520ee3dc0ecc$var$qg = $7d23520ee3dc0ecc$var$og[--$7d23520ee3dc0ecc$var$pg], $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg] = null, $7d23520ee3dc0ecc$var$sg = $7d23520ee3dc0ecc$var$og[--$7d23520ee3dc0ecc$var$pg], $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg] = null, $7d23520ee3dc0ecc$var$rg = $7d23520ee3dc0ecc$var$og[--$7d23520ee3dc0ecc$var$pg], $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg] = null;
}
var $7d23520ee3dc0ecc$var$xg = null, $7d23520ee3dc0ecc$var$yg = null, $7d23520ee3dc0ecc$var$I = !1, $7d23520ee3dc0ecc$var$zg = null;
function $7d23520ee3dc0ecc$var$Ag(a, b) {
    var c = $7d23520ee3dc0ecc$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $7d23520ee3dc0ecc$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $7d23520ee3dc0ecc$var$xg = a, $7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $7d23520ee3dc0ecc$var$xg = a, $7d23520ee3dc0ecc$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $7d23520ee3dc0ecc$var$qg ? {
                id: $7d23520ee3dc0ecc$var$rg,
                overflow: $7d23520ee3dc0ecc$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $7d23520ee3dc0ecc$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $7d23520ee3dc0ecc$var$xg = a, $7d23520ee3dc0ecc$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $7d23520ee3dc0ecc$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $7d23520ee3dc0ecc$var$Eg(a) {
    if ($7d23520ee3dc0ecc$var$I) {
        var b = $7d23520ee3dc0ecc$var$yg;
        if (b) {
            var c = b;
            if (!$7d23520ee3dc0ecc$var$Cg(a, b)) {
                if ($7d23520ee3dc0ecc$var$Dg(a)) throw Error($7d23520ee3dc0ecc$var$p(418));
                b = $7d23520ee3dc0ecc$var$Lf(c.nextSibling);
                var d = $7d23520ee3dc0ecc$var$xg;
                b && $7d23520ee3dc0ecc$var$Cg(a, b) ? $7d23520ee3dc0ecc$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $7d23520ee3dc0ecc$var$I = !1, $7d23520ee3dc0ecc$var$xg = a);
            }
        } else {
            if ($7d23520ee3dc0ecc$var$Dg(a)) throw Error($7d23520ee3dc0ecc$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $7d23520ee3dc0ecc$var$I = !1;
            $7d23520ee3dc0ecc$var$xg = a;
        }
    }
}
function $7d23520ee3dc0ecc$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $7d23520ee3dc0ecc$var$xg = a;
}
function $7d23520ee3dc0ecc$var$Gg(a) {
    if (a !== $7d23520ee3dc0ecc$var$xg) return !1;
    if (!$7d23520ee3dc0ecc$var$I) return $7d23520ee3dc0ecc$var$Fg(a), $7d23520ee3dc0ecc$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$7d23520ee3dc0ecc$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $7d23520ee3dc0ecc$var$yg)) {
        if ($7d23520ee3dc0ecc$var$Dg(a)) throw $7d23520ee3dc0ecc$var$Hg(), Error($7d23520ee3dc0ecc$var$p(418));
        for(; b;)$7d23520ee3dc0ecc$var$Ag(a, b), b = $7d23520ee3dc0ecc$var$Lf(b.nextSibling);
    }
    $7d23520ee3dc0ecc$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($7d23520ee3dc0ecc$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $7d23520ee3dc0ecc$var$yg = null;
        }
    } else $7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$xg ? $7d23520ee3dc0ecc$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $7d23520ee3dc0ecc$var$Hg() {
    for(var a = $7d23520ee3dc0ecc$var$yg; a;)a = $7d23520ee3dc0ecc$var$Lf(a.nextSibling);
}
function $7d23520ee3dc0ecc$var$Ig() {
    $7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$xg = null;
    $7d23520ee3dc0ecc$var$I = !1;
}
function $7d23520ee3dc0ecc$var$Jg(a) {
    null === $7d23520ee3dc0ecc$var$zg ? $7d23520ee3dc0ecc$var$zg = [
        a
    ] : $7d23520ee3dc0ecc$var$zg.push(a);
}
var $7d23520ee3dc0ecc$var$Kg = $7d23520ee3dc0ecc$var$ua.ReactCurrentBatchConfig;
function $7d23520ee3dc0ecc$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($7d23520ee3dc0ecc$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($7d23520ee3dc0ecc$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($7d23520ee3dc0ecc$var$p(284));
        if (!c._owner) throw Error($7d23520ee3dc0ecc$var$p(290, a));
    }
    return a;
}
function $7d23520ee3dc0ecc$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($7d23520ee3dc0ecc$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $7d23520ee3dc0ecc$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $7d23520ee3dc0ecc$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $7d23520ee3dc0ecc$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $7d23520ee3dc0ecc$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $7d23520ee3dc0ecc$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $7d23520ee3dc0ecc$var$Ha && $7d23520ee3dc0ecc$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $7d23520ee3dc0ecc$var$Lg(a, b, c), d.return = a, d;
        d = $7d23520ee3dc0ecc$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $7d23520ee3dc0ecc$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $7d23520ee3dc0ecc$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $7d23520ee3dc0ecc$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $7d23520ee3dc0ecc$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $7d23520ee3dc0ecc$var$va:
                    return c = $7d23520ee3dc0ecc$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $7d23520ee3dc0ecc$var$Lg(a, null, b), c.return = a, c;
                case $7d23520ee3dc0ecc$var$wa:
                    return b = $7d23520ee3dc0ecc$var$Sg(b, a.mode, c), b.return = a, b;
                case $7d23520ee3dc0ecc$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($7d23520ee3dc0ecc$var$eb(b) || $7d23520ee3dc0ecc$var$Ka(b)) return b = $7d23520ee3dc0ecc$var$Tg(b, a.mode, c, null), b.return = a, b;
            $7d23520ee3dc0ecc$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $7d23520ee3dc0ecc$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $7d23520ee3dc0ecc$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $7d23520ee3dc0ecc$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($7d23520ee3dc0ecc$var$eb(c) || $7d23520ee3dc0ecc$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $7d23520ee3dc0ecc$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $7d23520ee3dc0ecc$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $7d23520ee3dc0ecc$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $7d23520ee3dc0ecc$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($7d23520ee3dc0ecc$var$eb(d) || $7d23520ee3dc0ecc$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $7d23520ee3dc0ecc$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $7d23520ee3dc0ecc$var$Ka(h);
        if ("function" !== typeof l) throw Error($7d23520ee3dc0ecc$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($7d23520ee3dc0ecc$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $7d23520ee3dc0ecc$var$I && $7d23520ee3dc0ecc$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $7d23520ee3dc0ecc$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $7d23520ee3dc0ecc$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $7d23520ee3dc0ecc$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $7d23520ee3dc0ecc$var$Ha && $7d23520ee3dc0ecc$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $7d23520ee3dc0ecc$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $7d23520ee3dc0ecc$var$ya ? (d = $7d23520ee3dc0ecc$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $7d23520ee3dc0ecc$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $7d23520ee3dc0ecc$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $7d23520ee3dc0ecc$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $7d23520ee3dc0ecc$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $7d23520ee3dc0ecc$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($7d23520ee3dc0ecc$var$eb(f)) return n(a, d, f, h);
            if ($7d23520ee3dc0ecc$var$Ka(f)) return t(a, d, f, h);
            $7d23520ee3dc0ecc$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $7d23520ee3dc0ecc$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $7d23520ee3dc0ecc$var$Ug = $7d23520ee3dc0ecc$var$Og(!0), $7d23520ee3dc0ecc$var$Vg = $7d23520ee3dc0ecc$var$Og(!1), $7d23520ee3dc0ecc$var$Wg = $7d23520ee3dc0ecc$var$Uf(null), $7d23520ee3dc0ecc$var$Xg = null, $7d23520ee3dc0ecc$var$Yg = null, $7d23520ee3dc0ecc$var$Zg = null;
function $7d23520ee3dc0ecc$var$$g() {
    $7d23520ee3dc0ecc$var$Zg = $7d23520ee3dc0ecc$var$Yg = $7d23520ee3dc0ecc$var$Xg = null;
}
function $7d23520ee3dc0ecc$var$ah(a) {
    var b = $7d23520ee3dc0ecc$var$Wg.current;
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wg);
    a._currentValue = b;
}
function $7d23520ee3dc0ecc$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $7d23520ee3dc0ecc$var$ch(a, b) {
    $7d23520ee3dc0ecc$var$Xg = a;
    $7d23520ee3dc0ecc$var$Zg = $7d23520ee3dc0ecc$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($7d23520ee3dc0ecc$var$dh = !0), a.firstContext = null);
}
function $7d23520ee3dc0ecc$var$eh(a) {
    var b = a._currentValue;
    if ($7d23520ee3dc0ecc$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $7d23520ee3dc0ecc$var$Yg) {
            if (null === $7d23520ee3dc0ecc$var$Xg) throw Error($7d23520ee3dc0ecc$var$p(308));
            $7d23520ee3dc0ecc$var$Yg = a;
            $7d23520ee3dc0ecc$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $7d23520ee3dc0ecc$var$Yg = $7d23520ee3dc0ecc$var$Yg.next = a;
    }
    return b;
}
var $7d23520ee3dc0ecc$var$fh = null;
function $7d23520ee3dc0ecc$var$gh(a) {
    null === $7d23520ee3dc0ecc$var$fh ? $7d23520ee3dc0ecc$var$fh = [
        a
    ] : $7d23520ee3dc0ecc$var$fh.push(a);
}
function $7d23520ee3dc0ecc$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $7d23520ee3dc0ecc$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $7d23520ee3dc0ecc$var$ih(a, d);
}
function $7d23520ee3dc0ecc$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $7d23520ee3dc0ecc$var$jh = !1;
function $7d23520ee3dc0ecc$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $7d23520ee3dc0ecc$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $7d23520ee3dc0ecc$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $7d23520ee3dc0ecc$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($7d23520ee3dc0ecc$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $7d23520ee3dc0ecc$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $7d23520ee3dc0ecc$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $7d23520ee3dc0ecc$var$ih(a, c);
}
function $7d23520ee3dc0ecc$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7d23520ee3dc0ecc$var$Cc(a, c);
    }
}
function $7d23520ee3dc0ecc$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $7d23520ee3dc0ecc$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $7d23520ee3dc0ecc$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $7d23520ee3dc0ecc$var$A({}, q, r);
                            break a;
                        case 2:
                            $7d23520ee3dc0ecc$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $7d23520ee3dc0ecc$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $7d23520ee3dc0ecc$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($7d23520ee3dc0ecc$var$p(191, e));
            e.call(d);
        }
    }
}
var $7d23520ee3dc0ecc$var$th = {}, $7d23520ee3dc0ecc$var$uh = $7d23520ee3dc0ecc$var$Uf($7d23520ee3dc0ecc$var$th), $7d23520ee3dc0ecc$var$vh = $7d23520ee3dc0ecc$var$Uf($7d23520ee3dc0ecc$var$th), $7d23520ee3dc0ecc$var$wh = $7d23520ee3dc0ecc$var$Uf($7d23520ee3dc0ecc$var$th);
function $7d23520ee3dc0ecc$var$xh(a) {
    if (a === $7d23520ee3dc0ecc$var$th) throw Error($7d23520ee3dc0ecc$var$p(174));
    return a;
}
function $7d23520ee3dc0ecc$var$yh(a, b) {
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$wh, b);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$vh, a);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$uh, $7d23520ee3dc0ecc$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $7d23520ee3dc0ecc$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $7d23520ee3dc0ecc$var$lb(b, a);
    }
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$uh);
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$uh, b);
}
function $7d23520ee3dc0ecc$var$zh() {
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$uh);
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$vh);
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$wh);
}
function $7d23520ee3dc0ecc$var$Ah(a) {
    $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$wh.current);
    var b = $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$uh.current);
    var c = $7d23520ee3dc0ecc$var$lb(b, a.type);
    b !== c && ($7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$vh, a), $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$uh, c));
}
function $7d23520ee3dc0ecc$var$Bh(a) {
    $7d23520ee3dc0ecc$var$vh.current === a && ($7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$uh), $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$vh));
}
var $7d23520ee3dc0ecc$var$L = $7d23520ee3dc0ecc$var$Uf(0);
function $7d23520ee3dc0ecc$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $7d23520ee3dc0ecc$var$Dh = [];
function $7d23520ee3dc0ecc$var$Eh() {
    for(var a = 0; a < $7d23520ee3dc0ecc$var$Dh.length; a++)$7d23520ee3dc0ecc$var$Dh[a]._workInProgressVersionPrimary = null;
    $7d23520ee3dc0ecc$var$Dh.length = 0;
}
var $7d23520ee3dc0ecc$var$Fh = $7d23520ee3dc0ecc$var$ua.ReactCurrentDispatcher, $7d23520ee3dc0ecc$var$Gh = $7d23520ee3dc0ecc$var$ua.ReactCurrentBatchConfig, $7d23520ee3dc0ecc$var$Hh = 0, $7d23520ee3dc0ecc$var$M = null, $7d23520ee3dc0ecc$var$N = null, $7d23520ee3dc0ecc$var$O = null, $7d23520ee3dc0ecc$var$Ih = !1, $7d23520ee3dc0ecc$var$Jh = !1, $7d23520ee3dc0ecc$var$Kh = 0, $7d23520ee3dc0ecc$var$Lh = 0;
function $7d23520ee3dc0ecc$var$P() {
    throw Error($7d23520ee3dc0ecc$var$p(321));
}
function $7d23520ee3dc0ecc$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$7d23520ee3dc0ecc$var$He(a[c], b[c])) return !1;
    return !0;
}
function $7d23520ee3dc0ecc$var$Nh(a, b, c, d, e, f) {
    $7d23520ee3dc0ecc$var$Hh = f;
    $7d23520ee3dc0ecc$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $7d23520ee3dc0ecc$var$Fh.current = null === a || null === a.memoizedState ? $7d23520ee3dc0ecc$var$Oh : $7d23520ee3dc0ecc$var$Ph;
    a = c(d, e);
    if ($7d23520ee3dc0ecc$var$Jh) {
        f = 0;
        do {
            $7d23520ee3dc0ecc$var$Jh = !1;
            $7d23520ee3dc0ecc$var$Kh = 0;
            if (25 <= f) throw Error($7d23520ee3dc0ecc$var$p(301));
            f += 1;
            $7d23520ee3dc0ecc$var$O = $7d23520ee3dc0ecc$var$N = null;
            b.updateQueue = null;
            $7d23520ee3dc0ecc$var$Fh.current = $7d23520ee3dc0ecc$var$Qh;
            a = c(d, e);
        }while ($7d23520ee3dc0ecc$var$Jh);
    }
    $7d23520ee3dc0ecc$var$Fh.current = $7d23520ee3dc0ecc$var$Rh;
    b = null !== $7d23520ee3dc0ecc$var$N && null !== $7d23520ee3dc0ecc$var$N.next;
    $7d23520ee3dc0ecc$var$Hh = 0;
    $7d23520ee3dc0ecc$var$O = $7d23520ee3dc0ecc$var$N = $7d23520ee3dc0ecc$var$M = null;
    $7d23520ee3dc0ecc$var$Ih = !1;
    if (b) throw Error($7d23520ee3dc0ecc$var$p(300));
    return a;
}
function $7d23520ee3dc0ecc$var$Sh() {
    var a = 0 !== $7d23520ee3dc0ecc$var$Kh;
    $7d23520ee3dc0ecc$var$Kh = 0;
    return a;
}
function $7d23520ee3dc0ecc$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $7d23520ee3dc0ecc$var$O ? $7d23520ee3dc0ecc$var$M.memoizedState = $7d23520ee3dc0ecc$var$O = a : $7d23520ee3dc0ecc$var$O = $7d23520ee3dc0ecc$var$O.next = a;
    return $7d23520ee3dc0ecc$var$O;
}
function $7d23520ee3dc0ecc$var$Uh() {
    if (null === $7d23520ee3dc0ecc$var$N) {
        var a = $7d23520ee3dc0ecc$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $7d23520ee3dc0ecc$var$N.next;
    var b = null === $7d23520ee3dc0ecc$var$O ? $7d23520ee3dc0ecc$var$M.memoizedState : $7d23520ee3dc0ecc$var$O.next;
    if (null !== b) $7d23520ee3dc0ecc$var$O = b, $7d23520ee3dc0ecc$var$N = a;
    else {
        if (null === a) throw Error($7d23520ee3dc0ecc$var$p(310));
        $7d23520ee3dc0ecc$var$N = a;
        a = {
            memoizedState: $7d23520ee3dc0ecc$var$N.memoizedState,
            baseState: $7d23520ee3dc0ecc$var$N.baseState,
            baseQueue: $7d23520ee3dc0ecc$var$N.baseQueue,
            queue: $7d23520ee3dc0ecc$var$N.queue,
            next: null
        };
        null === $7d23520ee3dc0ecc$var$O ? $7d23520ee3dc0ecc$var$M.memoizedState = $7d23520ee3dc0ecc$var$O = a : $7d23520ee3dc0ecc$var$O = $7d23520ee3dc0ecc$var$O.next = a;
    }
    return $7d23520ee3dc0ecc$var$O;
}
function $7d23520ee3dc0ecc$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $7d23520ee3dc0ecc$var$Wh(a) {
    var b = $7d23520ee3dc0ecc$var$Uh(), c = b.queue;
    if (null === c) throw Error($7d23520ee3dc0ecc$var$p(311));
    c.lastRenderedReducer = a;
    var d = $7d23520ee3dc0ecc$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($7d23520ee3dc0ecc$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $7d23520ee3dc0ecc$var$M.lanes |= m;
                $7d23520ee3dc0ecc$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $7d23520ee3dc0ecc$var$He(d, b.memoizedState) || ($7d23520ee3dc0ecc$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $7d23520ee3dc0ecc$var$M.lanes |= f, $7d23520ee3dc0ecc$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $7d23520ee3dc0ecc$var$Xh(a) {
    var b = $7d23520ee3dc0ecc$var$Uh(), c = b.queue;
    if (null === c) throw Error($7d23520ee3dc0ecc$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $7d23520ee3dc0ecc$var$He(f, b.memoizedState) || ($7d23520ee3dc0ecc$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $7d23520ee3dc0ecc$var$Yh() {}
function $7d23520ee3dc0ecc$var$Zh(a, b) {
    var c = $7d23520ee3dc0ecc$var$M, d = $7d23520ee3dc0ecc$var$Uh(), e = b(), f = !$7d23520ee3dc0ecc$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $7d23520ee3dc0ecc$var$dh = !0);
    d = d.queue;
    $7d23520ee3dc0ecc$var$$h($7d23520ee3dc0ecc$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $7d23520ee3dc0ecc$var$O && $7d23520ee3dc0ecc$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $7d23520ee3dc0ecc$var$bi(9, $7d23520ee3dc0ecc$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $7d23520ee3dc0ecc$var$Q) throw Error($7d23520ee3dc0ecc$var$p(349));
        0 !== ($7d23520ee3dc0ecc$var$Hh & 30) || $7d23520ee3dc0ecc$var$di(c, b, e);
    }
    return e;
}
function $7d23520ee3dc0ecc$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $7d23520ee3dc0ecc$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7d23520ee3dc0ecc$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $7d23520ee3dc0ecc$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $7d23520ee3dc0ecc$var$ei(b) && $7d23520ee3dc0ecc$var$fi(a);
}
function $7d23520ee3dc0ecc$var$ai(a, b, c) {
    return c(function() {
        $7d23520ee3dc0ecc$var$ei(b) && $7d23520ee3dc0ecc$var$fi(a);
    });
}
function $7d23520ee3dc0ecc$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$7d23520ee3dc0ecc$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $7d23520ee3dc0ecc$var$fi(a) {
    var b = $7d23520ee3dc0ecc$var$ih(a, 1);
    null !== b && $7d23520ee3dc0ecc$var$gi(b, a, 1, -1);
}
function $7d23520ee3dc0ecc$var$hi(a) {
    var b = $7d23520ee3dc0ecc$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $7d23520ee3dc0ecc$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $7d23520ee3dc0ecc$var$ii.bind(null, $7d23520ee3dc0ecc$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $7d23520ee3dc0ecc$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $7d23520ee3dc0ecc$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $7d23520ee3dc0ecc$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $7d23520ee3dc0ecc$var$ji() {
    return $7d23520ee3dc0ecc$var$Uh().memoizedState;
}
function $7d23520ee3dc0ecc$var$ki(a, b, c, d) {
    var e = $7d23520ee3dc0ecc$var$Th();
    $7d23520ee3dc0ecc$var$M.flags |= a;
    e.memoizedState = $7d23520ee3dc0ecc$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $7d23520ee3dc0ecc$var$li(a, b, c, d) {
    var e = $7d23520ee3dc0ecc$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $7d23520ee3dc0ecc$var$N) {
        var g = $7d23520ee3dc0ecc$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $7d23520ee3dc0ecc$var$Mh(d, g.deps)) {
            e.memoizedState = $7d23520ee3dc0ecc$var$bi(b, c, f, d);
            return;
        }
    }
    $7d23520ee3dc0ecc$var$M.flags |= a;
    e.memoizedState = $7d23520ee3dc0ecc$var$bi(1 | b, c, f, d);
}
function $7d23520ee3dc0ecc$var$mi(a, b) {
    return $7d23520ee3dc0ecc$var$ki(8390656, 8, a, b);
}
function $7d23520ee3dc0ecc$var$$h(a, b) {
    return $7d23520ee3dc0ecc$var$li(2048, 8, a, b);
}
function $7d23520ee3dc0ecc$var$ni(a, b) {
    return $7d23520ee3dc0ecc$var$li(4, 2, a, b);
}
function $7d23520ee3dc0ecc$var$oi(a, b) {
    return $7d23520ee3dc0ecc$var$li(4, 4, a, b);
}
function $7d23520ee3dc0ecc$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $7d23520ee3dc0ecc$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $7d23520ee3dc0ecc$var$li(4, 4, $7d23520ee3dc0ecc$var$pi.bind(null, b, a), c);
}
function $7d23520ee3dc0ecc$var$ri() {}
function $7d23520ee3dc0ecc$var$si(a, b) {
    var c = $7d23520ee3dc0ecc$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7d23520ee3dc0ecc$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7d23520ee3dc0ecc$var$ti(a, b) {
    var c = $7d23520ee3dc0ecc$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $7d23520ee3dc0ecc$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $7d23520ee3dc0ecc$var$ui(a, b, c) {
    if (0 === ($7d23520ee3dc0ecc$var$Hh & 21)) return a.baseState && (a.baseState = !1, $7d23520ee3dc0ecc$var$dh = !0), a.memoizedState = c;
    $7d23520ee3dc0ecc$var$He(c, b) || (c = $7d23520ee3dc0ecc$var$yc(), $7d23520ee3dc0ecc$var$M.lanes |= c, $7d23520ee3dc0ecc$var$rh |= c, a.baseState = !0);
    return b;
}
function $7d23520ee3dc0ecc$var$vi(a, b) {
    var c = $7d23520ee3dc0ecc$var$C;
    $7d23520ee3dc0ecc$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $7d23520ee3dc0ecc$var$Gh.transition;
    $7d23520ee3dc0ecc$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $7d23520ee3dc0ecc$var$C = c, $7d23520ee3dc0ecc$var$Gh.transition = d;
    }
}
function $7d23520ee3dc0ecc$var$wi() {
    return $7d23520ee3dc0ecc$var$Uh().memoizedState;
}
function $7d23520ee3dc0ecc$var$xi(a, b, c) {
    var d = $7d23520ee3dc0ecc$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7d23520ee3dc0ecc$var$zi(a)) $7d23520ee3dc0ecc$var$Ai(b, c);
    else if (c = $7d23520ee3dc0ecc$var$hh(a, b, c, d), null !== c) {
        var e = $7d23520ee3dc0ecc$var$R();
        $7d23520ee3dc0ecc$var$gi(c, a, d, e);
        $7d23520ee3dc0ecc$var$Bi(c, b, d);
    }
}
function $7d23520ee3dc0ecc$var$ii(a, b, c) {
    var d = $7d23520ee3dc0ecc$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($7d23520ee3dc0ecc$var$zi(a)) $7d23520ee3dc0ecc$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($7d23520ee3dc0ecc$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $7d23520ee3dc0ecc$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $7d23520ee3dc0ecc$var$hh(a, b, e, d);
        null !== c && (e = $7d23520ee3dc0ecc$var$R(), $7d23520ee3dc0ecc$var$gi(c, a, d, e), $7d23520ee3dc0ecc$var$Bi(c, b, d));
    }
}
function $7d23520ee3dc0ecc$var$zi(a) {
    var b = a.alternate;
    return a === $7d23520ee3dc0ecc$var$M || null !== b && b === $7d23520ee3dc0ecc$var$M;
}
function $7d23520ee3dc0ecc$var$Ai(a, b) {
    $7d23520ee3dc0ecc$var$Jh = $7d23520ee3dc0ecc$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $7d23520ee3dc0ecc$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $7d23520ee3dc0ecc$var$Cc(a, c);
    }
}
var $7d23520ee3dc0ecc$var$Rh = {
    readContext: $7d23520ee3dc0ecc$var$eh,
    useCallback: $7d23520ee3dc0ecc$var$P,
    useContext: $7d23520ee3dc0ecc$var$P,
    useEffect: $7d23520ee3dc0ecc$var$P,
    useImperativeHandle: $7d23520ee3dc0ecc$var$P,
    useInsertionEffect: $7d23520ee3dc0ecc$var$P,
    useLayoutEffect: $7d23520ee3dc0ecc$var$P,
    useMemo: $7d23520ee3dc0ecc$var$P,
    useReducer: $7d23520ee3dc0ecc$var$P,
    useRef: $7d23520ee3dc0ecc$var$P,
    useState: $7d23520ee3dc0ecc$var$P,
    useDebugValue: $7d23520ee3dc0ecc$var$P,
    useDeferredValue: $7d23520ee3dc0ecc$var$P,
    useTransition: $7d23520ee3dc0ecc$var$P,
    useMutableSource: $7d23520ee3dc0ecc$var$P,
    useSyncExternalStore: $7d23520ee3dc0ecc$var$P,
    useId: $7d23520ee3dc0ecc$var$P,
    unstable_isNewReconciler: !1
}, $7d23520ee3dc0ecc$var$Oh = {
    readContext: $7d23520ee3dc0ecc$var$eh,
    useCallback: function(a, b) {
        $7d23520ee3dc0ecc$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $7d23520ee3dc0ecc$var$eh,
    useEffect: $7d23520ee3dc0ecc$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $7d23520ee3dc0ecc$var$ki(4194308, 4, $7d23520ee3dc0ecc$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $7d23520ee3dc0ecc$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $7d23520ee3dc0ecc$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $7d23520ee3dc0ecc$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $7d23520ee3dc0ecc$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $7d23520ee3dc0ecc$var$xi.bind(null, $7d23520ee3dc0ecc$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $7d23520ee3dc0ecc$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $7d23520ee3dc0ecc$var$hi,
    useDebugValue: $7d23520ee3dc0ecc$var$ri,
    useDeferredValue: function(a) {
        return $7d23520ee3dc0ecc$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $7d23520ee3dc0ecc$var$hi(!1), b = a[0];
        a = $7d23520ee3dc0ecc$var$vi.bind(null, a[1]);
        $7d23520ee3dc0ecc$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $7d23520ee3dc0ecc$var$M, e = $7d23520ee3dc0ecc$var$Th();
        if ($7d23520ee3dc0ecc$var$I) {
            if (void 0 === c) throw Error($7d23520ee3dc0ecc$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $7d23520ee3dc0ecc$var$Q) throw Error($7d23520ee3dc0ecc$var$p(349));
            0 !== ($7d23520ee3dc0ecc$var$Hh & 30) || $7d23520ee3dc0ecc$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $7d23520ee3dc0ecc$var$mi($7d23520ee3dc0ecc$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $7d23520ee3dc0ecc$var$bi(9, $7d23520ee3dc0ecc$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $7d23520ee3dc0ecc$var$Th(), b = $7d23520ee3dc0ecc$var$Q.identifierPrefix;
        if ($7d23520ee3dc0ecc$var$I) {
            var c = $7d23520ee3dc0ecc$var$sg;
            var d = $7d23520ee3dc0ecc$var$rg;
            c = (d & ~(1 << 32 - $7d23520ee3dc0ecc$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $7d23520ee3dc0ecc$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $7d23520ee3dc0ecc$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $7d23520ee3dc0ecc$var$Ph = {
    readContext: $7d23520ee3dc0ecc$var$eh,
    useCallback: $7d23520ee3dc0ecc$var$si,
    useContext: $7d23520ee3dc0ecc$var$eh,
    useEffect: $7d23520ee3dc0ecc$var$$h,
    useImperativeHandle: $7d23520ee3dc0ecc$var$qi,
    useInsertionEffect: $7d23520ee3dc0ecc$var$ni,
    useLayoutEffect: $7d23520ee3dc0ecc$var$oi,
    useMemo: $7d23520ee3dc0ecc$var$ti,
    useReducer: $7d23520ee3dc0ecc$var$Wh,
    useRef: $7d23520ee3dc0ecc$var$ji,
    useState: function() {
        return $7d23520ee3dc0ecc$var$Wh($7d23520ee3dc0ecc$var$Vh);
    },
    useDebugValue: $7d23520ee3dc0ecc$var$ri,
    useDeferredValue: function(a) {
        var b = $7d23520ee3dc0ecc$var$Uh();
        return $7d23520ee3dc0ecc$var$ui(b, $7d23520ee3dc0ecc$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $7d23520ee3dc0ecc$var$Wh($7d23520ee3dc0ecc$var$Vh)[0], b = $7d23520ee3dc0ecc$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7d23520ee3dc0ecc$var$Yh,
    useSyncExternalStore: $7d23520ee3dc0ecc$var$Zh,
    useId: $7d23520ee3dc0ecc$var$wi,
    unstable_isNewReconciler: !1
}, $7d23520ee3dc0ecc$var$Qh = {
    readContext: $7d23520ee3dc0ecc$var$eh,
    useCallback: $7d23520ee3dc0ecc$var$si,
    useContext: $7d23520ee3dc0ecc$var$eh,
    useEffect: $7d23520ee3dc0ecc$var$$h,
    useImperativeHandle: $7d23520ee3dc0ecc$var$qi,
    useInsertionEffect: $7d23520ee3dc0ecc$var$ni,
    useLayoutEffect: $7d23520ee3dc0ecc$var$oi,
    useMemo: $7d23520ee3dc0ecc$var$ti,
    useReducer: $7d23520ee3dc0ecc$var$Xh,
    useRef: $7d23520ee3dc0ecc$var$ji,
    useState: function() {
        return $7d23520ee3dc0ecc$var$Xh($7d23520ee3dc0ecc$var$Vh);
    },
    useDebugValue: $7d23520ee3dc0ecc$var$ri,
    useDeferredValue: function(a) {
        var b = $7d23520ee3dc0ecc$var$Uh();
        return null === $7d23520ee3dc0ecc$var$N ? b.memoizedState = a : $7d23520ee3dc0ecc$var$ui(b, $7d23520ee3dc0ecc$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $7d23520ee3dc0ecc$var$Xh($7d23520ee3dc0ecc$var$Vh)[0], b = $7d23520ee3dc0ecc$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $7d23520ee3dc0ecc$var$Yh,
    useSyncExternalStore: $7d23520ee3dc0ecc$var$Zh,
    useId: $7d23520ee3dc0ecc$var$wi,
    unstable_isNewReconciler: !1
};
function $7d23520ee3dc0ecc$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $7d23520ee3dc0ecc$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $7d23520ee3dc0ecc$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $7d23520ee3dc0ecc$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $7d23520ee3dc0ecc$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $7d23520ee3dc0ecc$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $7d23520ee3dc0ecc$var$R(), e = $7d23520ee3dc0ecc$var$yi(a), f = $7d23520ee3dc0ecc$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7d23520ee3dc0ecc$var$nh(a, f, e);
        null !== b && ($7d23520ee3dc0ecc$var$gi(b, a, e, d), $7d23520ee3dc0ecc$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $7d23520ee3dc0ecc$var$R(), e = $7d23520ee3dc0ecc$var$yi(a), f = $7d23520ee3dc0ecc$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $7d23520ee3dc0ecc$var$nh(a, f, e);
        null !== b && ($7d23520ee3dc0ecc$var$gi(b, a, e, d), $7d23520ee3dc0ecc$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $7d23520ee3dc0ecc$var$R(), d = $7d23520ee3dc0ecc$var$yi(a), e = $7d23520ee3dc0ecc$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $7d23520ee3dc0ecc$var$nh(a, e, d);
        null !== b && ($7d23520ee3dc0ecc$var$gi(b, a, d, c), $7d23520ee3dc0ecc$var$oh(b, a, d));
    }
};
function $7d23520ee3dc0ecc$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$7d23520ee3dc0ecc$var$Ie(c, d) || !$7d23520ee3dc0ecc$var$Ie(e, f) : !0;
}
function $7d23520ee3dc0ecc$var$Gi(a, b, c) {
    var d = !1, e = $7d23520ee3dc0ecc$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $7d23520ee3dc0ecc$var$eh(f) : (e = $7d23520ee3dc0ecc$var$Zf(b) ? $7d23520ee3dc0ecc$var$Xf : $7d23520ee3dc0ecc$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $7d23520ee3dc0ecc$var$Yf(a, e) : $7d23520ee3dc0ecc$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $7d23520ee3dc0ecc$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $7d23520ee3dc0ecc$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $7d23520ee3dc0ecc$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $7d23520ee3dc0ecc$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $7d23520ee3dc0ecc$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $7d23520ee3dc0ecc$var$eh(f) : (f = $7d23520ee3dc0ecc$var$Zf(b) ? $7d23520ee3dc0ecc$var$Xf : $7d23520ee3dc0ecc$var$H.current, e.context = $7d23520ee3dc0ecc$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($7d23520ee3dc0ecc$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $7d23520ee3dc0ecc$var$Ei.enqueueReplaceState(e, e.state, null), $7d23520ee3dc0ecc$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $7d23520ee3dc0ecc$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $7d23520ee3dc0ecc$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $7d23520ee3dc0ecc$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $7d23520ee3dc0ecc$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $7d23520ee3dc0ecc$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $7d23520ee3dc0ecc$var$Ni(a, b, c) {
    c = $7d23520ee3dc0ecc$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $7d23520ee3dc0ecc$var$Oi || ($7d23520ee3dc0ecc$var$Oi = !0, $7d23520ee3dc0ecc$var$Pi = d);
        $7d23520ee3dc0ecc$var$Li(a, b);
    };
    return c;
}
function $7d23520ee3dc0ecc$var$Qi(a, b, c) {
    c = $7d23520ee3dc0ecc$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $7d23520ee3dc0ecc$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $7d23520ee3dc0ecc$var$Li(a, b);
        "function" !== typeof d && (null === $7d23520ee3dc0ecc$var$Ri ? $7d23520ee3dc0ecc$var$Ri = new Set([
            this
        ]) : $7d23520ee3dc0ecc$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $7d23520ee3dc0ecc$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $7d23520ee3dc0ecc$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $7d23520ee3dc0ecc$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $7d23520ee3dc0ecc$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $7d23520ee3dc0ecc$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $7d23520ee3dc0ecc$var$mh(-1, 1), b.tag = 2, $7d23520ee3dc0ecc$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $7d23520ee3dc0ecc$var$Wi = $7d23520ee3dc0ecc$var$ua.ReactCurrentOwner, $7d23520ee3dc0ecc$var$dh = !1;
function $7d23520ee3dc0ecc$var$Xi(a, b, c, d) {
    b.child = null === a ? $7d23520ee3dc0ecc$var$Vg(b, null, c, d) : $7d23520ee3dc0ecc$var$Ug(b, a.child, c, d);
}
function $7d23520ee3dc0ecc$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $7d23520ee3dc0ecc$var$ch(b, e);
    d = $7d23520ee3dc0ecc$var$Nh(a, b, c, d, f, e);
    c = $7d23520ee3dc0ecc$var$Sh();
    if (null !== a && !$7d23520ee3dc0ecc$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7d23520ee3dc0ecc$var$Zi(a, b, e);
    $7d23520ee3dc0ecc$var$I && c && $7d23520ee3dc0ecc$var$vg(b);
    b.flags |= 1;
    $7d23520ee3dc0ecc$var$Xi(a, b, d, e);
    return b.child;
}
function $7d23520ee3dc0ecc$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$7d23520ee3dc0ecc$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $7d23520ee3dc0ecc$var$bj(a, b, f, d, e);
        a = $7d23520ee3dc0ecc$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $7d23520ee3dc0ecc$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $7d23520ee3dc0ecc$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $7d23520ee3dc0ecc$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $7d23520ee3dc0ecc$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($7d23520ee3dc0ecc$var$Ie(f, d) && a.ref === b.ref) {
            if ($7d23520ee3dc0ecc$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($7d23520ee3dc0ecc$var$dh = !0);
            else return b.lanes = a.lanes, $7d23520ee3dc0ecc$var$Zi(a, b, e);
        }
    }
    return $7d23520ee3dc0ecc$var$cj(a, b, c, d, e);
}
function $7d23520ee3dc0ecc$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$ej, $7d23520ee3dc0ecc$var$fj), $7d23520ee3dc0ecc$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$ej, $7d23520ee3dc0ecc$var$fj), $7d23520ee3dc0ecc$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$ej, $7d23520ee3dc0ecc$var$fj);
            $7d23520ee3dc0ecc$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$ej, $7d23520ee3dc0ecc$var$fj), $7d23520ee3dc0ecc$var$fj |= d;
    $7d23520ee3dc0ecc$var$Xi(a, b, e, c);
    return b.child;
}
function $7d23520ee3dc0ecc$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $7d23520ee3dc0ecc$var$cj(a, b, c, d, e) {
    var f = $7d23520ee3dc0ecc$var$Zf(c) ? $7d23520ee3dc0ecc$var$Xf : $7d23520ee3dc0ecc$var$H.current;
    f = $7d23520ee3dc0ecc$var$Yf(b, f);
    $7d23520ee3dc0ecc$var$ch(b, e);
    c = $7d23520ee3dc0ecc$var$Nh(a, b, c, d, f, e);
    d = $7d23520ee3dc0ecc$var$Sh();
    if (null !== a && !$7d23520ee3dc0ecc$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $7d23520ee3dc0ecc$var$Zi(a, b, e);
    $7d23520ee3dc0ecc$var$I && d && $7d23520ee3dc0ecc$var$vg(b);
    b.flags |= 1;
    $7d23520ee3dc0ecc$var$Xi(a, b, c, e);
    return b.child;
}
function $7d23520ee3dc0ecc$var$hj(a, b, c, d, e) {
    if ($7d23520ee3dc0ecc$var$Zf(c)) {
        var f = !0;
        $7d23520ee3dc0ecc$var$cg(b);
    } else f = !1;
    $7d23520ee3dc0ecc$var$ch(b, e);
    if (null === b.stateNode) $7d23520ee3dc0ecc$var$ij(a, b), $7d23520ee3dc0ecc$var$Gi(b, c, d), $7d23520ee3dc0ecc$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $7d23520ee3dc0ecc$var$eh(l) : (l = $7d23520ee3dc0ecc$var$Zf(c) ? $7d23520ee3dc0ecc$var$Xf : $7d23520ee3dc0ecc$var$H.current, l = $7d23520ee3dc0ecc$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $7d23520ee3dc0ecc$var$Hi(b, g, d, l);
        $7d23520ee3dc0ecc$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $7d23520ee3dc0ecc$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $7d23520ee3dc0ecc$var$Wf.current || $7d23520ee3dc0ecc$var$jh ? ("function" === typeof m && ($7d23520ee3dc0ecc$var$Di(b, c, m, d), k = b.memoizedState), (h = $7d23520ee3dc0ecc$var$jh || $7d23520ee3dc0ecc$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $7d23520ee3dc0ecc$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $7d23520ee3dc0ecc$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $7d23520ee3dc0ecc$var$eh(k) : (k = $7d23520ee3dc0ecc$var$Zf(c) ? $7d23520ee3dc0ecc$var$Xf : $7d23520ee3dc0ecc$var$H.current, k = $7d23520ee3dc0ecc$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $7d23520ee3dc0ecc$var$Hi(b, g, d, k);
        $7d23520ee3dc0ecc$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $7d23520ee3dc0ecc$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $7d23520ee3dc0ecc$var$Wf.current || $7d23520ee3dc0ecc$var$jh ? ("function" === typeof y && ($7d23520ee3dc0ecc$var$Di(b, c, y, d), n = b.memoizedState), (l = $7d23520ee3dc0ecc$var$jh || $7d23520ee3dc0ecc$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $7d23520ee3dc0ecc$var$jj(a, b, c, d, f, e);
}
function $7d23520ee3dc0ecc$var$jj(a, b, c, d, e, f) {
    $7d23520ee3dc0ecc$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $7d23520ee3dc0ecc$var$dg(b, c, !1), $7d23520ee3dc0ecc$var$Zi(a, b, f);
    d = b.stateNode;
    $7d23520ee3dc0ecc$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $7d23520ee3dc0ecc$var$Ug(b, a.child, null, f), b.child = $7d23520ee3dc0ecc$var$Ug(b, null, h, f)) : $7d23520ee3dc0ecc$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $7d23520ee3dc0ecc$var$dg(b, c, !0);
    return b.child;
}
function $7d23520ee3dc0ecc$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $7d23520ee3dc0ecc$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $7d23520ee3dc0ecc$var$ag(a, b.context, !1);
    $7d23520ee3dc0ecc$var$yh(a, b.containerInfo);
}
function $7d23520ee3dc0ecc$var$lj(a, b, c, d, e) {
    $7d23520ee3dc0ecc$var$Ig();
    $7d23520ee3dc0ecc$var$Jg(e);
    b.flags |= 256;
    $7d23520ee3dc0ecc$var$Xi(a, b, c, d);
    return b.child;
}
var $7d23520ee3dc0ecc$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $7d23520ee3dc0ecc$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $7d23520ee3dc0ecc$var$oj(a, b, c) {
    var d = b.pendingProps, e = $7d23520ee3dc0ecc$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, e & 1);
    if (null === a) {
        $7d23520ee3dc0ecc$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $7d23520ee3dc0ecc$var$pj(g, d, 0, null), a = $7d23520ee3dc0ecc$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $7d23520ee3dc0ecc$var$nj(c), b.memoizedState = $7d23520ee3dc0ecc$var$mj, a) : $7d23520ee3dc0ecc$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $7d23520ee3dc0ecc$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $7d23520ee3dc0ecc$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $7d23520ee3dc0ecc$var$Pg(h, f) : (f = $7d23520ee3dc0ecc$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $7d23520ee3dc0ecc$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $7d23520ee3dc0ecc$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $7d23520ee3dc0ecc$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $7d23520ee3dc0ecc$var$qj(a, b) {
    b = $7d23520ee3dc0ecc$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $7d23520ee3dc0ecc$var$sj(a, b, c, d) {
    null !== d && $7d23520ee3dc0ecc$var$Jg(d);
    $7d23520ee3dc0ecc$var$Ug(b, a.child, null, c);
    a = $7d23520ee3dc0ecc$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $7d23520ee3dc0ecc$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $7d23520ee3dc0ecc$var$Ki(Error($7d23520ee3dc0ecc$var$p(422))), $7d23520ee3dc0ecc$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $7d23520ee3dc0ecc$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $7d23520ee3dc0ecc$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $7d23520ee3dc0ecc$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $7d23520ee3dc0ecc$var$nj(g);
        b.memoizedState = $7d23520ee3dc0ecc$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $7d23520ee3dc0ecc$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($7d23520ee3dc0ecc$var$p(419));
        d = $7d23520ee3dc0ecc$var$Ki(f, d, void 0);
        return $7d23520ee3dc0ecc$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($7d23520ee3dc0ecc$var$dh || h) {
        d = $7d23520ee3dc0ecc$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $7d23520ee3dc0ecc$var$ih(a, e), $7d23520ee3dc0ecc$var$gi(d, a, e, -1));
        }
        $7d23520ee3dc0ecc$var$tj();
        d = $7d23520ee3dc0ecc$var$Ki(Error($7d23520ee3dc0ecc$var$p(421)));
        return $7d23520ee3dc0ecc$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $7d23520ee3dc0ecc$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$Lf(e.nextSibling);
    $7d23520ee3dc0ecc$var$xg = b;
    $7d23520ee3dc0ecc$var$I = !0;
    $7d23520ee3dc0ecc$var$zg = null;
    null !== a && ($7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$rg, $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$sg, $7d23520ee3dc0ecc$var$og[$7d23520ee3dc0ecc$var$pg++] = $7d23520ee3dc0ecc$var$qg, $7d23520ee3dc0ecc$var$rg = a.id, $7d23520ee3dc0ecc$var$sg = a.overflow, $7d23520ee3dc0ecc$var$qg = b);
    b = $7d23520ee3dc0ecc$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $7d23520ee3dc0ecc$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $7d23520ee3dc0ecc$var$bh(a.return, b, c);
}
function $7d23520ee3dc0ecc$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $7d23520ee3dc0ecc$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $7d23520ee3dc0ecc$var$Xi(a, b, d.children, c);
    d = $7d23520ee3dc0ecc$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $7d23520ee3dc0ecc$var$vj(a, c, b);
            else if (19 === a.tag) $7d23520ee3dc0ecc$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $7d23520ee3dc0ecc$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $7d23520ee3dc0ecc$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $7d23520ee3dc0ecc$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $7d23520ee3dc0ecc$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $7d23520ee3dc0ecc$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $7d23520ee3dc0ecc$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $7d23520ee3dc0ecc$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $7d23520ee3dc0ecc$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($7d23520ee3dc0ecc$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $7d23520ee3dc0ecc$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $7d23520ee3dc0ecc$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $7d23520ee3dc0ecc$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $7d23520ee3dc0ecc$var$kj(b);
            $7d23520ee3dc0ecc$var$Ig();
            break;
        case 5:
            $7d23520ee3dc0ecc$var$Ah(b);
            break;
        case 1:
            $7d23520ee3dc0ecc$var$Zf(b.type) && $7d23520ee3dc0ecc$var$cg(b);
            break;
        case 4:
            $7d23520ee3dc0ecc$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, $7d23520ee3dc0ecc$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $7d23520ee3dc0ecc$var$oj(a, b, c);
                $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, $7d23520ee3dc0ecc$var$L.current & 1);
                a = $7d23520ee3dc0ecc$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, $7d23520ee3dc0ecc$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $7d23520ee3dc0ecc$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, $7d23520ee3dc0ecc$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $7d23520ee3dc0ecc$var$dj(a, b, c);
    }
    return $7d23520ee3dc0ecc$var$Zi(a, b, c);
}
var $7d23520ee3dc0ecc$var$zj, $7d23520ee3dc0ecc$var$Aj, $7d23520ee3dc0ecc$var$Bj, $7d23520ee3dc0ecc$var$Cj;
$7d23520ee3dc0ecc$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$7d23520ee3dc0ecc$var$Aj = function() {};
$7d23520ee3dc0ecc$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $7d23520ee3dc0ecc$var$Ya(a, e);
                d = $7d23520ee3dc0ecc$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $7d23520ee3dc0ecc$var$A({}, e, {
                    value: void 0
                });
                d = $7d23520ee3dc0ecc$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $7d23520ee3dc0ecc$var$gb(a, e);
                d = $7d23520ee3dc0ecc$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $7d23520ee3dc0ecc$var$Bf);
        }
        $7d23520ee3dc0ecc$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($7d23520ee3dc0ecc$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($7d23520ee3dc0ecc$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $7d23520ee3dc0ecc$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$7d23520ee3dc0ecc$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $7d23520ee3dc0ecc$var$Dj(a, b) {
    if (!$7d23520ee3dc0ecc$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $7d23520ee3dc0ecc$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $7d23520ee3dc0ecc$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $7d23520ee3dc0ecc$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $7d23520ee3dc0ecc$var$S(b), null;
        case 1:
            return $7d23520ee3dc0ecc$var$Zf(b.type) && $7d23520ee3dc0ecc$var$$f(), $7d23520ee3dc0ecc$var$S(b), null;
        case 3:
            d = b.stateNode;
            $7d23520ee3dc0ecc$var$zh();
            $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf);
            $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$H);
            $7d23520ee3dc0ecc$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $7d23520ee3dc0ecc$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $7d23520ee3dc0ecc$var$zg && ($7d23520ee3dc0ecc$var$Fj($7d23520ee3dc0ecc$var$zg), $7d23520ee3dc0ecc$var$zg = null));
            $7d23520ee3dc0ecc$var$Aj(a, b);
            $7d23520ee3dc0ecc$var$S(b);
            return null;
        case 5:
            $7d23520ee3dc0ecc$var$Bh(b);
            var e = $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $7d23520ee3dc0ecc$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($7d23520ee3dc0ecc$var$p(166));
                    $7d23520ee3dc0ecc$var$S(b);
                    return null;
                }
                a = $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$uh.current);
                if ($7d23520ee3dc0ecc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$7d23520ee3dc0ecc$var$Of] = b;
                    d[$7d23520ee3dc0ecc$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $7d23520ee3dc0ecc$var$D("cancel", d);
                            $7d23520ee3dc0ecc$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $7d23520ee3dc0ecc$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $7d23520ee3dc0ecc$var$lf.length; e++)$7d23520ee3dc0ecc$var$D($7d23520ee3dc0ecc$var$lf[e], d);
                            break;
                        case "source":
                            $7d23520ee3dc0ecc$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $7d23520ee3dc0ecc$var$D("error", d);
                            $7d23520ee3dc0ecc$var$D("load", d);
                            break;
                        case "details":
                            $7d23520ee3dc0ecc$var$D("toggle", d);
                            break;
                        case "input":
                            $7d23520ee3dc0ecc$var$Za(d, f);
                            $7d23520ee3dc0ecc$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $7d23520ee3dc0ecc$var$D("invalid", d);
                            break;
                        case "textarea":
                            $7d23520ee3dc0ecc$var$hb(d, f), $7d23520ee3dc0ecc$var$D("invalid", d);
                    }
                    $7d23520ee3dc0ecc$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $7d23520ee3dc0ecc$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $7d23520ee3dc0ecc$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $7d23520ee3dc0ecc$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $7d23520ee3dc0ecc$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $7d23520ee3dc0ecc$var$Va(d);
                            $7d23520ee3dc0ecc$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $7d23520ee3dc0ecc$var$Va(d);
                            $7d23520ee3dc0ecc$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $7d23520ee3dc0ecc$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $7d23520ee3dc0ecc$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$7d23520ee3dc0ecc$var$Of] = b;
                    a[$7d23520ee3dc0ecc$var$Pf] = d;
                    $7d23520ee3dc0ecc$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $7d23520ee3dc0ecc$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $7d23520ee3dc0ecc$var$D("cancel", a);
                                $7d23520ee3dc0ecc$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $7d23520ee3dc0ecc$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $7d23520ee3dc0ecc$var$lf.length; e++)$7d23520ee3dc0ecc$var$D($7d23520ee3dc0ecc$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $7d23520ee3dc0ecc$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $7d23520ee3dc0ecc$var$D("error", a);
                                $7d23520ee3dc0ecc$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $7d23520ee3dc0ecc$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $7d23520ee3dc0ecc$var$Za(a, d);
                                e = $7d23520ee3dc0ecc$var$Ya(a, d);
                                $7d23520ee3dc0ecc$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $7d23520ee3dc0ecc$var$A({}, d, {
                                    value: void 0
                                });
                                $7d23520ee3dc0ecc$var$D("invalid", a);
                                break;
                            case "textarea":
                                $7d23520ee3dc0ecc$var$hb(a, d);
                                e = $7d23520ee3dc0ecc$var$gb(a, d);
                                $7d23520ee3dc0ecc$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $7d23520ee3dc0ecc$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $7d23520ee3dc0ecc$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $7d23520ee3dc0ecc$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $7d23520ee3dc0ecc$var$ob(a, k) : "number" === typeof k && $7d23520ee3dc0ecc$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($7d23520ee3dc0ecc$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $7d23520ee3dc0ecc$var$D("scroll", a) : null != k && $7d23520ee3dc0ecc$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $7d23520ee3dc0ecc$var$Va(a);
                                $7d23520ee3dc0ecc$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $7d23520ee3dc0ecc$var$Va(a);
                                $7d23520ee3dc0ecc$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $7d23520ee3dc0ecc$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $7d23520ee3dc0ecc$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $7d23520ee3dc0ecc$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $7d23520ee3dc0ecc$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $7d23520ee3dc0ecc$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $7d23520ee3dc0ecc$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($7d23520ee3dc0ecc$var$p(166));
                c = $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$wh.current);
                $7d23520ee3dc0ecc$var$xh($7d23520ee3dc0ecc$var$uh.current);
                if ($7d23520ee3dc0ecc$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$7d23520ee3dc0ecc$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $7d23520ee3dc0ecc$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $7d23520ee3dc0ecc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $7d23520ee3dc0ecc$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$7d23520ee3dc0ecc$var$Of] = b, b.stateNode = d;
            }
            $7d23520ee3dc0ecc$var$S(b);
            return null;
        case 13:
            $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($7d23520ee3dc0ecc$var$I && null !== $7d23520ee3dc0ecc$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $7d23520ee3dc0ecc$var$Hg(), $7d23520ee3dc0ecc$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $7d23520ee3dc0ecc$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($7d23520ee3dc0ecc$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($7d23520ee3dc0ecc$var$p(317));
                        f[$7d23520ee3dc0ecc$var$Of] = b;
                    } else $7d23520ee3dc0ecc$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $7d23520ee3dc0ecc$var$S(b);
                    f = !1;
                } else null !== $7d23520ee3dc0ecc$var$zg && ($7d23520ee3dc0ecc$var$Fj($7d23520ee3dc0ecc$var$zg), $7d23520ee3dc0ecc$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($7d23520ee3dc0ecc$var$L.current & 1) ? 0 === $7d23520ee3dc0ecc$var$T && ($7d23520ee3dc0ecc$var$T = 3) : $7d23520ee3dc0ecc$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $7d23520ee3dc0ecc$var$S(b);
            return null;
        case 4:
            return $7d23520ee3dc0ecc$var$zh(), $7d23520ee3dc0ecc$var$Aj(a, b), null === a && $7d23520ee3dc0ecc$var$sf(b.stateNode.containerInfo), $7d23520ee3dc0ecc$var$S(b), null;
        case 10:
            return $7d23520ee3dc0ecc$var$ah(b.type._context), $7d23520ee3dc0ecc$var$S(b), null;
        case 17:
            return $7d23520ee3dc0ecc$var$Zf(b.type) && $7d23520ee3dc0ecc$var$$f(), $7d23520ee3dc0ecc$var$S(b), null;
        case 19:
            $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L);
            f = b.memoizedState;
            if (null === f) return $7d23520ee3dc0ecc$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $7d23520ee3dc0ecc$var$Dj(f, !1);
                else {
                    if (0 !== $7d23520ee3dc0ecc$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $7d23520ee3dc0ecc$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $7d23520ee3dc0ecc$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, $7d23520ee3dc0ecc$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $7d23520ee3dc0ecc$var$B() > $7d23520ee3dc0ecc$var$Gj && (b.flags |= 128, d = !0, $7d23520ee3dc0ecc$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $7d23520ee3dc0ecc$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $7d23520ee3dc0ecc$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$7d23520ee3dc0ecc$var$I) return $7d23520ee3dc0ecc$var$S(b), null;
                    } else 2 * $7d23520ee3dc0ecc$var$B() - f.renderingStartTime > $7d23520ee3dc0ecc$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $7d23520ee3dc0ecc$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $7d23520ee3dc0ecc$var$B(), b.sibling = null, c = $7d23520ee3dc0ecc$var$L.current, $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$L, d ? c & 1 | 2 : c & 1), b;
            $7d23520ee3dc0ecc$var$S(b);
            return null;
        case 22:
        case 23:
            return $7d23520ee3dc0ecc$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($7d23520ee3dc0ecc$var$fj & 1073741824) && ($7d23520ee3dc0ecc$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $7d23520ee3dc0ecc$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($7d23520ee3dc0ecc$var$p(156, b.tag));
}
function $7d23520ee3dc0ecc$var$Ij(a, b) {
    $7d23520ee3dc0ecc$var$wg(b);
    switch(b.tag){
        case 1:
            return $7d23520ee3dc0ecc$var$Zf(b.type) && $7d23520ee3dc0ecc$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $7d23520ee3dc0ecc$var$zh(), $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf), $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$H), $7d23520ee3dc0ecc$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $7d23520ee3dc0ecc$var$Bh(b), null;
        case 13:
            $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($7d23520ee3dc0ecc$var$p(340));
                $7d23520ee3dc0ecc$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L), null;
        case 4:
            return $7d23520ee3dc0ecc$var$zh(), null;
        case 10:
            return $7d23520ee3dc0ecc$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $7d23520ee3dc0ecc$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $7d23520ee3dc0ecc$var$Jj = !1, $7d23520ee3dc0ecc$var$U = !1, $7d23520ee3dc0ecc$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $7d23520ee3dc0ecc$var$V = null;
function $7d23520ee3dc0ecc$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $7d23520ee3dc0ecc$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $7d23520ee3dc0ecc$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $7d23520ee3dc0ecc$var$W(a, b, d);
    }
}
var $7d23520ee3dc0ecc$var$Nj = !1;
function $7d23520ee3dc0ecc$var$Oj(a, b) {
    $7d23520ee3dc0ecc$var$Cf = $7d23520ee3dc0ecc$var$dd;
    a = $7d23520ee3dc0ecc$var$Me();
    if ($7d23520ee3dc0ecc$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $7d23520ee3dc0ecc$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $7d23520ee3dc0ecc$var$dd = !1;
    for($7d23520ee3dc0ecc$var$V = b; null !== $7d23520ee3dc0ecc$var$V;)if (b = $7d23520ee3dc0ecc$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $7d23520ee3dc0ecc$var$V = a;
    else for(; null !== $7d23520ee3dc0ecc$var$V;){
        b = $7d23520ee3dc0ecc$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $7d23520ee3dc0ecc$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($7d23520ee3dc0ecc$var$p(163));
            }
        } catch (F) {
            $7d23520ee3dc0ecc$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $7d23520ee3dc0ecc$var$V = a;
            break;
        }
        $7d23520ee3dc0ecc$var$V = b.return;
    }
    n = $7d23520ee3dc0ecc$var$Nj;
    $7d23520ee3dc0ecc$var$Nj = !1;
    return n;
}
function $7d23520ee3dc0ecc$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $7d23520ee3dc0ecc$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $7d23520ee3dc0ecc$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $7d23520ee3dc0ecc$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $7d23520ee3dc0ecc$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $7d23520ee3dc0ecc$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$7d23520ee3dc0ecc$var$Of], delete b[$7d23520ee3dc0ecc$var$Pf], delete b[$7d23520ee3dc0ecc$var$of], delete b[$7d23520ee3dc0ecc$var$Qf], delete b[$7d23520ee3dc0ecc$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $7d23520ee3dc0ecc$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $7d23520ee3dc0ecc$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $7d23520ee3dc0ecc$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $7d23520ee3dc0ecc$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $7d23520ee3dc0ecc$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($7d23520ee3dc0ecc$var$Vj(a, b, c), a = a.sibling; null !== a;)$7d23520ee3dc0ecc$var$Vj(a, b, c), a = a.sibling;
}
function $7d23520ee3dc0ecc$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($7d23520ee3dc0ecc$var$Wj(a, b, c), a = a.sibling; null !== a;)$7d23520ee3dc0ecc$var$Wj(a, b, c), a = a.sibling;
}
var $7d23520ee3dc0ecc$var$X = null, $7d23520ee3dc0ecc$var$Xj = !1;
function $7d23520ee3dc0ecc$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$7d23520ee3dc0ecc$var$Zj(a, b, c), c = c.sibling;
}
function $7d23520ee3dc0ecc$var$Zj(a, b, c) {
    if ($7d23520ee3dc0ecc$var$lc && "function" === typeof $7d23520ee3dc0ecc$var$lc.onCommitFiberUnmount) try {
        $7d23520ee3dc0ecc$var$lc.onCommitFiberUnmount($7d23520ee3dc0ecc$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $7d23520ee3dc0ecc$var$U || $7d23520ee3dc0ecc$var$Lj(c, b);
        case 6:
            var d = $7d23520ee3dc0ecc$var$X, e = $7d23520ee3dc0ecc$var$Xj;
            $7d23520ee3dc0ecc$var$X = null;
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
            $7d23520ee3dc0ecc$var$X = d;
            $7d23520ee3dc0ecc$var$Xj = e;
            null !== $7d23520ee3dc0ecc$var$X && ($7d23520ee3dc0ecc$var$Xj ? (a = $7d23520ee3dc0ecc$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $7d23520ee3dc0ecc$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $7d23520ee3dc0ecc$var$X && ($7d23520ee3dc0ecc$var$Xj ? (a = $7d23520ee3dc0ecc$var$X, c = c.stateNode, 8 === a.nodeType ? $7d23520ee3dc0ecc$var$Kf(a.parentNode, c) : 1 === a.nodeType && $7d23520ee3dc0ecc$var$Kf(a, c), $7d23520ee3dc0ecc$var$bd(a)) : $7d23520ee3dc0ecc$var$Kf($7d23520ee3dc0ecc$var$X, c.stateNode));
            break;
        case 4:
            d = $7d23520ee3dc0ecc$var$X;
            e = $7d23520ee3dc0ecc$var$Xj;
            $7d23520ee3dc0ecc$var$X = c.stateNode.containerInfo;
            $7d23520ee3dc0ecc$var$Xj = !0;
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
            $7d23520ee3dc0ecc$var$X = d;
            $7d23520ee3dc0ecc$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$7d23520ee3dc0ecc$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $7d23520ee3dc0ecc$var$Mj(c, b, g) : 0 !== (f & 4) && $7d23520ee3dc0ecc$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
            break;
        case 1:
            if (!$7d23520ee3dc0ecc$var$U && ($7d23520ee3dc0ecc$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $7d23520ee3dc0ecc$var$W(c, b, h);
            }
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
            break;
        case 21:
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($7d23520ee3dc0ecc$var$U = (d = $7d23520ee3dc0ecc$var$U) || null !== c.memoizedState, $7d23520ee3dc0ecc$var$Yj(a, b, c), $7d23520ee3dc0ecc$var$U = d) : $7d23520ee3dc0ecc$var$Yj(a, b, c);
            break;
        default:
            $7d23520ee3dc0ecc$var$Yj(a, b, c);
    }
}
function $7d23520ee3dc0ecc$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $7d23520ee3dc0ecc$var$Kj);
        b.forEach(function(b) {
            var d = $7d23520ee3dc0ecc$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $7d23520ee3dc0ecc$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $7d23520ee3dc0ecc$var$X = h.stateNode;
                        $7d23520ee3dc0ecc$var$Xj = !1;
                        break a;
                    case 3:
                        $7d23520ee3dc0ecc$var$X = h.stateNode.containerInfo;
                        $7d23520ee3dc0ecc$var$Xj = !0;
                        break a;
                    case 4:
                        $7d23520ee3dc0ecc$var$X = h.stateNode.containerInfo;
                        $7d23520ee3dc0ecc$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $7d23520ee3dc0ecc$var$X) throw Error($7d23520ee3dc0ecc$var$p(160));
            $7d23520ee3dc0ecc$var$Zj(f, g, e);
            $7d23520ee3dc0ecc$var$X = null;
            $7d23520ee3dc0ecc$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $7d23520ee3dc0ecc$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$7d23520ee3dc0ecc$var$dk(b, a), b = b.sibling;
}
function $7d23520ee3dc0ecc$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            if (d & 4) {
                try {
                    $7d23520ee3dc0ecc$var$Pj(3, a, a.return), $7d23520ee3dc0ecc$var$Qj(3, a);
                } catch (t) {
                    $7d23520ee3dc0ecc$var$W(a, a.return, t);
                }
                try {
                    $7d23520ee3dc0ecc$var$Pj(5, a, a.return);
                } catch (t) {
                    $7d23520ee3dc0ecc$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            d & 512 && null !== c && $7d23520ee3dc0ecc$var$Lj(c, c.return);
            break;
        case 5:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            d & 512 && null !== c && $7d23520ee3dc0ecc$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $7d23520ee3dc0ecc$var$ob(e, "");
                } catch (t) {
                    $7d23520ee3dc0ecc$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $7d23520ee3dc0ecc$var$ab(e, f);
                    $7d23520ee3dc0ecc$var$vb(h, g);
                    var l = $7d23520ee3dc0ecc$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $7d23520ee3dc0ecc$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $7d23520ee3dc0ecc$var$nb(e, q) : "children" === m ? $7d23520ee3dc0ecc$var$ob(e, q) : $7d23520ee3dc0ecc$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $7d23520ee3dc0ecc$var$bb(e, f);
                            break;
                        case "textarea":
                            $7d23520ee3dc0ecc$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $7d23520ee3dc0ecc$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $7d23520ee3dc0ecc$var$fb(e, !!f.multiple, f.defaultValue, !0) : $7d23520ee3dc0ecc$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$7d23520ee3dc0ecc$var$Pf] = f;
                } catch (t) {
                    $7d23520ee3dc0ecc$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($7d23520ee3dc0ecc$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $7d23520ee3dc0ecc$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $7d23520ee3dc0ecc$var$bd(b.containerInfo);
            } catch (t) {
                $7d23520ee3dc0ecc$var$W(a, a.return, t);
            }
            break;
        case 4:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            break;
        case 13:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($7d23520ee3dc0ecc$var$fk = $7d23520ee3dc0ecc$var$B()));
            d & 4 && $7d23520ee3dc0ecc$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($7d23520ee3dc0ecc$var$U = (l = $7d23520ee3dc0ecc$var$U) || m, $7d23520ee3dc0ecc$var$ck(b, a), $7d23520ee3dc0ecc$var$U = l) : $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($7d23520ee3dc0ecc$var$V = a, m = a.child; null !== m;){
                    for(q = $7d23520ee3dc0ecc$var$V = m; null !== $7d23520ee3dc0ecc$var$V;){
                        r = $7d23520ee3dc0ecc$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $7d23520ee3dc0ecc$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $7d23520ee3dc0ecc$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $7d23520ee3dc0ecc$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $7d23520ee3dc0ecc$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $7d23520ee3dc0ecc$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $7d23520ee3dc0ecc$var$V = y) : $7d23520ee3dc0ecc$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $7d23520ee3dc0ecc$var$rb("display", g));
                            } catch (t) {
                                $7d23520ee3dc0ecc$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $7d23520ee3dc0ecc$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $7d23520ee3dc0ecc$var$ck(b, a);
            $7d23520ee3dc0ecc$var$ek(a);
            d & 4 && $7d23520ee3dc0ecc$var$ak(a);
            break;
        case 21:
            break;
        default:
            $7d23520ee3dc0ecc$var$ck(b, a), $7d23520ee3dc0ecc$var$ek(a);
    }
}
function $7d23520ee3dc0ecc$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($7d23520ee3dc0ecc$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($7d23520ee3dc0ecc$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($7d23520ee3dc0ecc$var$ob(e, ""), d.flags &= -33);
                    var f = $7d23520ee3dc0ecc$var$Uj(a);
                    $7d23520ee3dc0ecc$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $7d23520ee3dc0ecc$var$Uj(a);
                    $7d23520ee3dc0ecc$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($7d23520ee3dc0ecc$var$p(161));
            }
        } catch (k) {
            $7d23520ee3dc0ecc$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $7d23520ee3dc0ecc$var$hk(a, b, c) {
    $7d23520ee3dc0ecc$var$V = a;
    $7d23520ee3dc0ecc$var$ik(a, b, c);
}
function $7d23520ee3dc0ecc$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $7d23520ee3dc0ecc$var$V;){
        var e = $7d23520ee3dc0ecc$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $7d23520ee3dc0ecc$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $7d23520ee3dc0ecc$var$U;
                h = $7d23520ee3dc0ecc$var$Jj;
                var l = $7d23520ee3dc0ecc$var$U;
                $7d23520ee3dc0ecc$var$Jj = g;
                if (($7d23520ee3dc0ecc$var$U = k) && !l) for($7d23520ee3dc0ecc$var$V = e; null !== $7d23520ee3dc0ecc$var$V;)g = $7d23520ee3dc0ecc$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $7d23520ee3dc0ecc$var$jk(e) : null !== k ? (k.return = g, $7d23520ee3dc0ecc$var$V = k) : $7d23520ee3dc0ecc$var$jk(e);
                for(; null !== f;)$7d23520ee3dc0ecc$var$V = f, $7d23520ee3dc0ecc$var$ik(f, b, c), f = f.sibling;
                $7d23520ee3dc0ecc$var$V = e;
                $7d23520ee3dc0ecc$var$Jj = h;
                $7d23520ee3dc0ecc$var$U = l;
            }
            $7d23520ee3dc0ecc$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $7d23520ee3dc0ecc$var$V = f) : $7d23520ee3dc0ecc$var$kk(a, b, c);
    }
}
function $7d23520ee3dc0ecc$var$kk(a) {
    for(; null !== $7d23520ee3dc0ecc$var$V;){
        var b = $7d23520ee3dc0ecc$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $7d23520ee3dc0ecc$var$U || $7d23520ee3dc0ecc$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$7d23520ee3dc0ecc$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $7d23520ee3dc0ecc$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $7d23520ee3dc0ecc$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $7d23520ee3dc0ecc$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $7d23520ee3dc0ecc$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($7d23520ee3dc0ecc$var$p(163));
                }
                $7d23520ee3dc0ecc$var$U || b.flags & 512 && $7d23520ee3dc0ecc$var$Rj(b);
            } catch (r) {
                $7d23520ee3dc0ecc$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $7d23520ee3dc0ecc$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7d23520ee3dc0ecc$var$V = c;
            break;
        }
        $7d23520ee3dc0ecc$var$V = b.return;
    }
}
function $7d23520ee3dc0ecc$var$gk(a) {
    for(; null !== $7d23520ee3dc0ecc$var$V;){
        var b = $7d23520ee3dc0ecc$var$V;
        if (b === a) {
            $7d23520ee3dc0ecc$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $7d23520ee3dc0ecc$var$V = c;
            break;
        }
        $7d23520ee3dc0ecc$var$V = b.return;
    }
}
function $7d23520ee3dc0ecc$var$jk(a) {
    for(; null !== $7d23520ee3dc0ecc$var$V;){
        var b = $7d23520ee3dc0ecc$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $7d23520ee3dc0ecc$var$Qj(4, b);
                    } catch (k) {
                        $7d23520ee3dc0ecc$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $7d23520ee3dc0ecc$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $7d23520ee3dc0ecc$var$Rj(b);
                    } catch (k) {
                        $7d23520ee3dc0ecc$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $7d23520ee3dc0ecc$var$Rj(b);
                    } catch (k) {
                        $7d23520ee3dc0ecc$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $7d23520ee3dc0ecc$var$W(b, b.return, k);
        }
        if (b === a) {
            $7d23520ee3dc0ecc$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $7d23520ee3dc0ecc$var$V = h;
            break;
        }
        $7d23520ee3dc0ecc$var$V = b.return;
    }
}
var $7d23520ee3dc0ecc$var$lk = Math.ceil, $7d23520ee3dc0ecc$var$mk = $7d23520ee3dc0ecc$var$ua.ReactCurrentDispatcher, $7d23520ee3dc0ecc$var$nk = $7d23520ee3dc0ecc$var$ua.ReactCurrentOwner, $7d23520ee3dc0ecc$var$ok = $7d23520ee3dc0ecc$var$ua.ReactCurrentBatchConfig, $7d23520ee3dc0ecc$var$K = 0, $7d23520ee3dc0ecc$var$Q = null, $7d23520ee3dc0ecc$var$Y = null, $7d23520ee3dc0ecc$var$Z = 0, $7d23520ee3dc0ecc$var$fj = 0, $7d23520ee3dc0ecc$var$ej = $7d23520ee3dc0ecc$var$Uf(0), $7d23520ee3dc0ecc$var$T = 0, $7d23520ee3dc0ecc$var$pk = null, $7d23520ee3dc0ecc$var$rh = 0, $7d23520ee3dc0ecc$var$qk = 0, $7d23520ee3dc0ecc$var$rk = 0, $7d23520ee3dc0ecc$var$sk = null, $7d23520ee3dc0ecc$var$tk = null, $7d23520ee3dc0ecc$var$fk = 0, $7d23520ee3dc0ecc$var$Gj = Infinity, $7d23520ee3dc0ecc$var$uk = null, $7d23520ee3dc0ecc$var$Oi = !1, $7d23520ee3dc0ecc$var$Pi = null, $7d23520ee3dc0ecc$var$Ri = null, $7d23520ee3dc0ecc$var$vk = !1, $7d23520ee3dc0ecc$var$wk = null, $7d23520ee3dc0ecc$var$xk = 0, $7d23520ee3dc0ecc$var$yk = 0, $7d23520ee3dc0ecc$var$zk = null, $7d23520ee3dc0ecc$var$Ak = -1, $7d23520ee3dc0ecc$var$Bk = 0;
function $7d23520ee3dc0ecc$var$R() {
    return 0 !== ($7d23520ee3dc0ecc$var$K & 6) ? $7d23520ee3dc0ecc$var$B() : -1 !== $7d23520ee3dc0ecc$var$Ak ? $7d23520ee3dc0ecc$var$Ak : $7d23520ee3dc0ecc$var$Ak = $7d23520ee3dc0ecc$var$B();
}
function $7d23520ee3dc0ecc$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($7d23520ee3dc0ecc$var$K & 2) && 0 !== $7d23520ee3dc0ecc$var$Z) return $7d23520ee3dc0ecc$var$Z & -$7d23520ee3dc0ecc$var$Z;
    if (null !== $7d23520ee3dc0ecc$var$Kg.transition) return 0 === $7d23520ee3dc0ecc$var$Bk && ($7d23520ee3dc0ecc$var$Bk = $7d23520ee3dc0ecc$var$yc()), $7d23520ee3dc0ecc$var$Bk;
    a = $7d23520ee3dc0ecc$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $7d23520ee3dc0ecc$var$jd(a.type);
    return a;
}
function $7d23520ee3dc0ecc$var$gi(a, b, c, d) {
    if (50 < $7d23520ee3dc0ecc$var$yk) throw $7d23520ee3dc0ecc$var$yk = 0, $7d23520ee3dc0ecc$var$zk = null, Error($7d23520ee3dc0ecc$var$p(185));
    $7d23520ee3dc0ecc$var$Ac(a, c, d);
    if (0 === ($7d23520ee3dc0ecc$var$K & 2) || a !== $7d23520ee3dc0ecc$var$Q) a === $7d23520ee3dc0ecc$var$Q && (0 === ($7d23520ee3dc0ecc$var$K & 2) && ($7d23520ee3dc0ecc$var$qk |= c), 4 === $7d23520ee3dc0ecc$var$T && $7d23520ee3dc0ecc$var$Ck(a, $7d23520ee3dc0ecc$var$Z)), $7d23520ee3dc0ecc$var$Dk(a, d), 1 === c && 0 === $7d23520ee3dc0ecc$var$K && 0 === (b.mode & 1) && ($7d23520ee3dc0ecc$var$Gj = $7d23520ee3dc0ecc$var$B() + 500, $7d23520ee3dc0ecc$var$fg && $7d23520ee3dc0ecc$var$jg());
}
function $7d23520ee3dc0ecc$var$Dk(a, b) {
    var c = a.callbackNode;
    $7d23520ee3dc0ecc$var$wc(a, b);
    var d = $7d23520ee3dc0ecc$var$uc(a, a === $7d23520ee3dc0ecc$var$Q ? $7d23520ee3dc0ecc$var$Z : 0);
    if (0 === d) null !== c && $7d23520ee3dc0ecc$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $7d23520ee3dc0ecc$var$bc(c);
        if (1 === b) 0 === a.tag ? $7d23520ee3dc0ecc$var$ig($7d23520ee3dc0ecc$var$Ek.bind(null, a)) : $7d23520ee3dc0ecc$var$hg($7d23520ee3dc0ecc$var$Ek.bind(null, a)), $7d23520ee3dc0ecc$var$Jf(function() {
            0 === ($7d23520ee3dc0ecc$var$K & 6) && $7d23520ee3dc0ecc$var$jg();
        }), c = null;
        else {
            switch($7d23520ee3dc0ecc$var$Dc(d)){
                case 1:
                    c = $7d23520ee3dc0ecc$var$fc;
                    break;
                case 4:
                    c = $7d23520ee3dc0ecc$var$gc;
                    break;
                case 16:
                    c = $7d23520ee3dc0ecc$var$hc;
                    break;
                case 536870912:
                    c = $7d23520ee3dc0ecc$var$jc;
                    break;
                default:
                    c = $7d23520ee3dc0ecc$var$hc;
            }
            c = $7d23520ee3dc0ecc$var$Fk(c, $7d23520ee3dc0ecc$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $7d23520ee3dc0ecc$var$Gk(a, b) {
    $7d23520ee3dc0ecc$var$Ak = -1;
    $7d23520ee3dc0ecc$var$Bk = 0;
    if (0 !== ($7d23520ee3dc0ecc$var$K & 6)) throw Error($7d23520ee3dc0ecc$var$p(327));
    var c = a.callbackNode;
    if ($7d23520ee3dc0ecc$var$Hk() && a.callbackNode !== c) return null;
    var d = $7d23520ee3dc0ecc$var$uc(a, a === $7d23520ee3dc0ecc$var$Q ? $7d23520ee3dc0ecc$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $7d23520ee3dc0ecc$var$Ik(a, d);
    else {
        b = d;
        var e = $7d23520ee3dc0ecc$var$K;
        $7d23520ee3dc0ecc$var$K |= 2;
        var f = $7d23520ee3dc0ecc$var$Jk();
        if ($7d23520ee3dc0ecc$var$Q !== a || $7d23520ee3dc0ecc$var$Z !== b) $7d23520ee3dc0ecc$var$uk = null, $7d23520ee3dc0ecc$var$Gj = $7d23520ee3dc0ecc$var$B() + 500, $7d23520ee3dc0ecc$var$Kk(a, b);
        for(;;)try {
            $7d23520ee3dc0ecc$var$Lk();
            break;
        } catch (h) {
            $7d23520ee3dc0ecc$var$Mk(a, h);
        }
        $7d23520ee3dc0ecc$var$$g();
        $7d23520ee3dc0ecc$var$mk.current = f;
        $7d23520ee3dc0ecc$var$K = e;
        null !== $7d23520ee3dc0ecc$var$Y ? b = 0 : ($7d23520ee3dc0ecc$var$Q = null, $7d23520ee3dc0ecc$var$Z = 0, b = $7d23520ee3dc0ecc$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $7d23520ee3dc0ecc$var$xc(a), 0 !== e && (d = e, b = $7d23520ee3dc0ecc$var$Nk(a, e)));
        if (1 === b) throw c = $7d23520ee3dc0ecc$var$pk, $7d23520ee3dc0ecc$var$Kk(a, 0), $7d23520ee3dc0ecc$var$Ck(a, d), $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B()), c;
        if (6 === b) $7d23520ee3dc0ecc$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$7d23520ee3dc0ecc$var$Ok(e) && (b = $7d23520ee3dc0ecc$var$Ik(a, d), 2 === b && (f = $7d23520ee3dc0ecc$var$xc(a), 0 !== f && (d = f, b = $7d23520ee3dc0ecc$var$Nk(a, f))), 1 === b)) throw c = $7d23520ee3dc0ecc$var$pk, $7d23520ee3dc0ecc$var$Kk(a, 0), $7d23520ee3dc0ecc$var$Ck(a, d), $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($7d23520ee3dc0ecc$var$p(345));
                case 2:
                    $7d23520ee3dc0ecc$var$Pk(a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk);
                    break;
                case 3:
                    $7d23520ee3dc0ecc$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $7d23520ee3dc0ecc$var$fk + 500 - $7d23520ee3dc0ecc$var$B(), 10 < b)) {
                        if (0 !== $7d23520ee3dc0ecc$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $7d23520ee3dc0ecc$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $7d23520ee3dc0ecc$var$Ff($7d23520ee3dc0ecc$var$Pk.bind(null, a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk), b);
                        break;
                    }
                    $7d23520ee3dc0ecc$var$Pk(a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk);
                    break;
                case 4:
                    $7d23520ee3dc0ecc$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $7d23520ee3dc0ecc$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $7d23520ee3dc0ecc$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $7d23520ee3dc0ecc$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $7d23520ee3dc0ecc$var$Ff($7d23520ee3dc0ecc$var$Pk.bind(null, a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk), d);
                        break;
                    }
                    $7d23520ee3dc0ecc$var$Pk(a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk);
                    break;
                case 5:
                    $7d23520ee3dc0ecc$var$Pk(a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk);
                    break;
                default:
                    throw Error($7d23520ee3dc0ecc$var$p(329));
            }
        }
    }
    $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B());
    return a.callbackNode === c ? $7d23520ee3dc0ecc$var$Gk.bind(null, a) : null;
}
function $7d23520ee3dc0ecc$var$Nk(a, b) {
    var c = $7d23520ee3dc0ecc$var$sk;
    a.current.memoizedState.isDehydrated && ($7d23520ee3dc0ecc$var$Kk(a, b).flags |= 256);
    a = $7d23520ee3dc0ecc$var$Ik(a, b);
    2 !== a && (b = $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$tk = c, null !== b && $7d23520ee3dc0ecc$var$Fj(b));
    return a;
}
function $7d23520ee3dc0ecc$var$Fj(a) {
    null === $7d23520ee3dc0ecc$var$tk ? $7d23520ee3dc0ecc$var$tk = a : $7d23520ee3dc0ecc$var$tk.push.apply($7d23520ee3dc0ecc$var$tk, a);
}
function $7d23520ee3dc0ecc$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$7d23520ee3dc0ecc$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $7d23520ee3dc0ecc$var$Ck(a, b) {
    b &= ~$7d23520ee3dc0ecc$var$rk;
    b &= ~$7d23520ee3dc0ecc$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $7d23520ee3dc0ecc$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $7d23520ee3dc0ecc$var$Ek(a) {
    if (0 !== ($7d23520ee3dc0ecc$var$K & 6)) throw Error($7d23520ee3dc0ecc$var$p(327));
    $7d23520ee3dc0ecc$var$Hk();
    var b = $7d23520ee3dc0ecc$var$uc(a, 0);
    if (0 === (b & 1)) return $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B()), null;
    var c = $7d23520ee3dc0ecc$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $7d23520ee3dc0ecc$var$xc(a);
        0 !== d && (b = d, c = $7d23520ee3dc0ecc$var$Nk(a, d));
    }
    if (1 === c) throw c = $7d23520ee3dc0ecc$var$pk, $7d23520ee3dc0ecc$var$Kk(a, 0), $7d23520ee3dc0ecc$var$Ck(a, b), $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B()), c;
    if (6 === c) throw Error($7d23520ee3dc0ecc$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $7d23520ee3dc0ecc$var$Pk(a, $7d23520ee3dc0ecc$var$tk, $7d23520ee3dc0ecc$var$uk);
    $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B());
    return null;
}
function $7d23520ee3dc0ecc$var$Qk(a, b) {
    var c = $7d23520ee3dc0ecc$var$K;
    $7d23520ee3dc0ecc$var$K |= 1;
    try {
        return a(b);
    } finally{
        $7d23520ee3dc0ecc$var$K = c, 0 === $7d23520ee3dc0ecc$var$K && ($7d23520ee3dc0ecc$var$Gj = $7d23520ee3dc0ecc$var$B() + 500, $7d23520ee3dc0ecc$var$fg && $7d23520ee3dc0ecc$var$jg());
    }
}
function $7d23520ee3dc0ecc$var$Rk(a) {
    null !== $7d23520ee3dc0ecc$var$wk && 0 === $7d23520ee3dc0ecc$var$wk.tag && 0 === ($7d23520ee3dc0ecc$var$K & 6) && $7d23520ee3dc0ecc$var$Hk();
    var b = $7d23520ee3dc0ecc$var$K;
    $7d23520ee3dc0ecc$var$K |= 1;
    var c = $7d23520ee3dc0ecc$var$ok.transition, d = $7d23520ee3dc0ecc$var$C;
    try {
        if ($7d23520ee3dc0ecc$var$ok.transition = null, $7d23520ee3dc0ecc$var$C = 1, a) return a();
    } finally{
        $7d23520ee3dc0ecc$var$C = d, $7d23520ee3dc0ecc$var$ok.transition = c, $7d23520ee3dc0ecc$var$K = b, 0 === ($7d23520ee3dc0ecc$var$K & 6) && $7d23520ee3dc0ecc$var$jg();
    }
}
function $7d23520ee3dc0ecc$var$Hj() {
    $7d23520ee3dc0ecc$var$fj = $7d23520ee3dc0ecc$var$ej.current;
    $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$ej);
}
function $7d23520ee3dc0ecc$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $7d23520ee3dc0ecc$var$Gf(c));
    if (null !== $7d23520ee3dc0ecc$var$Y) for(c = $7d23520ee3dc0ecc$var$Y.return; null !== c;){
        var d = c;
        $7d23520ee3dc0ecc$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $7d23520ee3dc0ecc$var$$f();
                break;
            case 3:
                $7d23520ee3dc0ecc$var$zh();
                $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$Wf);
                $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$H);
                $7d23520ee3dc0ecc$var$Eh();
                break;
            case 5:
                $7d23520ee3dc0ecc$var$Bh(d);
                break;
            case 4:
                $7d23520ee3dc0ecc$var$zh();
                break;
            case 13:
                $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L);
                break;
            case 19:
                $7d23520ee3dc0ecc$var$E($7d23520ee3dc0ecc$var$L);
                break;
            case 10:
                $7d23520ee3dc0ecc$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $7d23520ee3dc0ecc$var$Hj();
        }
        c = c.return;
    }
    $7d23520ee3dc0ecc$var$Q = a;
    $7d23520ee3dc0ecc$var$Y = a = $7d23520ee3dc0ecc$var$Pg(a.current, null);
    $7d23520ee3dc0ecc$var$Z = $7d23520ee3dc0ecc$var$fj = b;
    $7d23520ee3dc0ecc$var$T = 0;
    $7d23520ee3dc0ecc$var$pk = null;
    $7d23520ee3dc0ecc$var$rk = $7d23520ee3dc0ecc$var$qk = $7d23520ee3dc0ecc$var$rh = 0;
    $7d23520ee3dc0ecc$var$tk = $7d23520ee3dc0ecc$var$sk = null;
    if (null !== $7d23520ee3dc0ecc$var$fh) {
        for(b = 0; b < $7d23520ee3dc0ecc$var$fh.length; b++)if (c = $7d23520ee3dc0ecc$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $7d23520ee3dc0ecc$var$fh = null;
    }
    return a;
}
function $7d23520ee3dc0ecc$var$Mk(a, b) {
    do {
        var c = $7d23520ee3dc0ecc$var$Y;
        try {
            $7d23520ee3dc0ecc$var$$g();
            $7d23520ee3dc0ecc$var$Fh.current = $7d23520ee3dc0ecc$var$Rh;
            if ($7d23520ee3dc0ecc$var$Ih) {
                for(var d = $7d23520ee3dc0ecc$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $7d23520ee3dc0ecc$var$Ih = !1;
            }
            $7d23520ee3dc0ecc$var$Hh = 0;
            $7d23520ee3dc0ecc$var$O = $7d23520ee3dc0ecc$var$N = $7d23520ee3dc0ecc$var$M = null;
            $7d23520ee3dc0ecc$var$Jh = !1;
            $7d23520ee3dc0ecc$var$Kh = 0;
            $7d23520ee3dc0ecc$var$nk.current = null;
            if (null === c || null === c.return) {
                $7d23520ee3dc0ecc$var$T = 1;
                $7d23520ee3dc0ecc$var$pk = b;
                $7d23520ee3dc0ecc$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $7d23520ee3dc0ecc$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $7d23520ee3dc0ecc$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $7d23520ee3dc0ecc$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $7d23520ee3dc0ecc$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $7d23520ee3dc0ecc$var$Si(f, l, b);
                            $7d23520ee3dc0ecc$var$tj();
                            break a;
                        }
                        k = Error($7d23520ee3dc0ecc$var$p(426));
                    }
                } else if ($7d23520ee3dc0ecc$var$I && h.mode & 1) {
                    var J = $7d23520ee3dc0ecc$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $7d23520ee3dc0ecc$var$Vi(J, g, h, f, b);
                        $7d23520ee3dc0ecc$var$Jg($7d23520ee3dc0ecc$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $7d23520ee3dc0ecc$var$Ji(k, h);
                4 !== $7d23520ee3dc0ecc$var$T && ($7d23520ee3dc0ecc$var$T = 2);
                null === $7d23520ee3dc0ecc$var$sk ? $7d23520ee3dc0ecc$var$sk = [
                    f
                ] : $7d23520ee3dc0ecc$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $7d23520ee3dc0ecc$var$Ni(f, k, b);
                            $7d23520ee3dc0ecc$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $7d23520ee3dc0ecc$var$Ri || !$7d23520ee3dc0ecc$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $7d23520ee3dc0ecc$var$Qi(f, h, b);
                                $7d23520ee3dc0ecc$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $7d23520ee3dc0ecc$var$Sk(c);
        } catch (na) {
            b = na;
            $7d23520ee3dc0ecc$var$Y === c && null !== c && ($7d23520ee3dc0ecc$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $7d23520ee3dc0ecc$var$Jk() {
    var a = $7d23520ee3dc0ecc$var$mk.current;
    $7d23520ee3dc0ecc$var$mk.current = $7d23520ee3dc0ecc$var$Rh;
    return null === a ? $7d23520ee3dc0ecc$var$Rh : a;
}
function $7d23520ee3dc0ecc$var$tj() {
    if (0 === $7d23520ee3dc0ecc$var$T || 3 === $7d23520ee3dc0ecc$var$T || 2 === $7d23520ee3dc0ecc$var$T) $7d23520ee3dc0ecc$var$T = 4;
    null === $7d23520ee3dc0ecc$var$Q || 0 === ($7d23520ee3dc0ecc$var$rh & 268435455) && 0 === ($7d23520ee3dc0ecc$var$qk & 268435455) || $7d23520ee3dc0ecc$var$Ck($7d23520ee3dc0ecc$var$Q, $7d23520ee3dc0ecc$var$Z);
}
function $7d23520ee3dc0ecc$var$Ik(a, b) {
    var c = $7d23520ee3dc0ecc$var$K;
    $7d23520ee3dc0ecc$var$K |= 2;
    var d = $7d23520ee3dc0ecc$var$Jk();
    if ($7d23520ee3dc0ecc$var$Q !== a || $7d23520ee3dc0ecc$var$Z !== b) $7d23520ee3dc0ecc$var$uk = null, $7d23520ee3dc0ecc$var$Kk(a, b);
    for(;;)try {
        $7d23520ee3dc0ecc$var$Tk();
        break;
    } catch (e) {
        $7d23520ee3dc0ecc$var$Mk(a, e);
    }
    $7d23520ee3dc0ecc$var$$g();
    $7d23520ee3dc0ecc$var$K = c;
    $7d23520ee3dc0ecc$var$mk.current = d;
    if (null !== $7d23520ee3dc0ecc$var$Y) throw Error($7d23520ee3dc0ecc$var$p(261));
    $7d23520ee3dc0ecc$var$Q = null;
    $7d23520ee3dc0ecc$var$Z = 0;
    return $7d23520ee3dc0ecc$var$T;
}
function $7d23520ee3dc0ecc$var$Tk() {
    for(; null !== $7d23520ee3dc0ecc$var$Y;)$7d23520ee3dc0ecc$var$Uk($7d23520ee3dc0ecc$var$Y);
}
function $7d23520ee3dc0ecc$var$Lk() {
    for(; null !== $7d23520ee3dc0ecc$var$Y && !$7d23520ee3dc0ecc$var$cc();)$7d23520ee3dc0ecc$var$Uk($7d23520ee3dc0ecc$var$Y);
}
function $7d23520ee3dc0ecc$var$Uk(a) {
    var b = $7d23520ee3dc0ecc$var$Vk(a.alternate, a, $7d23520ee3dc0ecc$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $7d23520ee3dc0ecc$var$Sk(a) : $7d23520ee3dc0ecc$var$Y = b;
    $7d23520ee3dc0ecc$var$nk.current = null;
}
function $7d23520ee3dc0ecc$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $7d23520ee3dc0ecc$var$Ej(c, b, $7d23520ee3dc0ecc$var$fj), null !== c) {
                $7d23520ee3dc0ecc$var$Y = c;
                return;
            }
        } else {
            c = $7d23520ee3dc0ecc$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $7d23520ee3dc0ecc$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $7d23520ee3dc0ecc$var$T = 6;
                $7d23520ee3dc0ecc$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $7d23520ee3dc0ecc$var$Y = b;
            return;
        }
        $7d23520ee3dc0ecc$var$Y = b = a;
    }while (null !== b);
    0 === $7d23520ee3dc0ecc$var$T && ($7d23520ee3dc0ecc$var$T = 5);
}
function $7d23520ee3dc0ecc$var$Pk(a, b, c) {
    var d = $7d23520ee3dc0ecc$var$C, e = $7d23520ee3dc0ecc$var$ok.transition;
    try {
        $7d23520ee3dc0ecc$var$ok.transition = null, $7d23520ee3dc0ecc$var$C = 1, $7d23520ee3dc0ecc$var$Wk(a, b, c, d);
    } finally{
        $7d23520ee3dc0ecc$var$ok.transition = e, $7d23520ee3dc0ecc$var$C = d;
    }
    return null;
}
function $7d23520ee3dc0ecc$var$Wk(a, b, c, d) {
    do $7d23520ee3dc0ecc$var$Hk();
    while (null !== $7d23520ee3dc0ecc$var$wk);
    if (0 !== ($7d23520ee3dc0ecc$var$K & 6)) throw Error($7d23520ee3dc0ecc$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($7d23520ee3dc0ecc$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $7d23520ee3dc0ecc$var$Bc(a, f);
    a === $7d23520ee3dc0ecc$var$Q && ($7d23520ee3dc0ecc$var$Y = $7d23520ee3dc0ecc$var$Q = null, $7d23520ee3dc0ecc$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $7d23520ee3dc0ecc$var$vk || ($7d23520ee3dc0ecc$var$vk = !0, $7d23520ee3dc0ecc$var$Fk($7d23520ee3dc0ecc$var$hc, function() {
        $7d23520ee3dc0ecc$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $7d23520ee3dc0ecc$var$ok.transition;
        $7d23520ee3dc0ecc$var$ok.transition = null;
        var g = $7d23520ee3dc0ecc$var$C;
        $7d23520ee3dc0ecc$var$C = 1;
        var h = $7d23520ee3dc0ecc$var$K;
        $7d23520ee3dc0ecc$var$K |= 4;
        $7d23520ee3dc0ecc$var$nk.current = null;
        $7d23520ee3dc0ecc$var$Oj(a, c);
        $7d23520ee3dc0ecc$var$dk(c, a);
        $7d23520ee3dc0ecc$var$Oe($7d23520ee3dc0ecc$var$Df);
        $7d23520ee3dc0ecc$var$dd = !!$7d23520ee3dc0ecc$var$Cf;
        $7d23520ee3dc0ecc$var$Df = $7d23520ee3dc0ecc$var$Cf = null;
        a.current = c;
        $7d23520ee3dc0ecc$var$hk(c, a, e);
        $7d23520ee3dc0ecc$var$dc();
        $7d23520ee3dc0ecc$var$K = h;
        $7d23520ee3dc0ecc$var$C = g;
        $7d23520ee3dc0ecc$var$ok.transition = f;
    } else a.current = c;
    $7d23520ee3dc0ecc$var$vk && ($7d23520ee3dc0ecc$var$vk = !1, $7d23520ee3dc0ecc$var$wk = a, $7d23520ee3dc0ecc$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($7d23520ee3dc0ecc$var$Ri = null);
    $7d23520ee3dc0ecc$var$mc(c.stateNode, d);
    $7d23520ee3dc0ecc$var$Dk(a, $7d23520ee3dc0ecc$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($7d23520ee3dc0ecc$var$Oi) throw $7d23520ee3dc0ecc$var$Oi = !1, a = $7d23520ee3dc0ecc$var$Pi, $7d23520ee3dc0ecc$var$Pi = null, a;
    0 !== ($7d23520ee3dc0ecc$var$xk & 1) && 0 !== a.tag && $7d23520ee3dc0ecc$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $7d23520ee3dc0ecc$var$zk ? $7d23520ee3dc0ecc$var$yk++ : ($7d23520ee3dc0ecc$var$yk = 0, $7d23520ee3dc0ecc$var$zk = a) : $7d23520ee3dc0ecc$var$yk = 0;
    $7d23520ee3dc0ecc$var$jg();
    return null;
}
function $7d23520ee3dc0ecc$var$Hk() {
    if (null !== $7d23520ee3dc0ecc$var$wk) {
        var a = $7d23520ee3dc0ecc$var$Dc($7d23520ee3dc0ecc$var$xk), b = $7d23520ee3dc0ecc$var$ok.transition, c = $7d23520ee3dc0ecc$var$C;
        try {
            $7d23520ee3dc0ecc$var$ok.transition = null;
            $7d23520ee3dc0ecc$var$C = 16 > a ? 16 : a;
            if (null === $7d23520ee3dc0ecc$var$wk) var d = !1;
            else {
                a = $7d23520ee3dc0ecc$var$wk;
                $7d23520ee3dc0ecc$var$wk = null;
                $7d23520ee3dc0ecc$var$xk = 0;
                if (0 !== ($7d23520ee3dc0ecc$var$K & 6)) throw Error($7d23520ee3dc0ecc$var$p(331));
                var e = $7d23520ee3dc0ecc$var$K;
                $7d23520ee3dc0ecc$var$K |= 4;
                for($7d23520ee3dc0ecc$var$V = a.current; null !== $7d23520ee3dc0ecc$var$V;){
                    var f = $7d23520ee3dc0ecc$var$V, g = f.child;
                    if (0 !== ($7d23520ee3dc0ecc$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($7d23520ee3dc0ecc$var$V = l; null !== $7d23520ee3dc0ecc$var$V;){
                                    var m = $7d23520ee3dc0ecc$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $7d23520ee3dc0ecc$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $7d23520ee3dc0ecc$var$V = q;
                                    else for(; null !== $7d23520ee3dc0ecc$var$V;){
                                        m = $7d23520ee3dc0ecc$var$V;
                                        var r = m.sibling, y = m.return;
                                        $7d23520ee3dc0ecc$var$Sj(m);
                                        if (m === l) {
                                            $7d23520ee3dc0ecc$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $7d23520ee3dc0ecc$var$V = r;
                                            break;
                                        }
                                        $7d23520ee3dc0ecc$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $7d23520ee3dc0ecc$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $7d23520ee3dc0ecc$var$V = g;
                    else b: for(; null !== $7d23520ee3dc0ecc$var$V;){
                        f = $7d23520ee3dc0ecc$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $7d23520ee3dc0ecc$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $7d23520ee3dc0ecc$var$V = x;
                            break b;
                        }
                        $7d23520ee3dc0ecc$var$V = f.return;
                    }
                }
                var w = a.current;
                for($7d23520ee3dc0ecc$var$V = w; null !== $7d23520ee3dc0ecc$var$V;){
                    g = $7d23520ee3dc0ecc$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $7d23520ee3dc0ecc$var$V = u;
                    else b: for(g = w; null !== $7d23520ee3dc0ecc$var$V;){
                        h = $7d23520ee3dc0ecc$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $7d23520ee3dc0ecc$var$Qj(9, h);
                            }
                        } catch (na) {
                            $7d23520ee3dc0ecc$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $7d23520ee3dc0ecc$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $7d23520ee3dc0ecc$var$V = F;
                            break b;
                        }
                        $7d23520ee3dc0ecc$var$V = h.return;
                    }
                }
                $7d23520ee3dc0ecc$var$K = e;
                $7d23520ee3dc0ecc$var$jg();
                if ($7d23520ee3dc0ecc$var$lc && "function" === typeof $7d23520ee3dc0ecc$var$lc.onPostCommitFiberRoot) try {
                    $7d23520ee3dc0ecc$var$lc.onPostCommitFiberRoot($7d23520ee3dc0ecc$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $7d23520ee3dc0ecc$var$C = c, $7d23520ee3dc0ecc$var$ok.transition = b;
        }
    }
    return !1;
}
function $7d23520ee3dc0ecc$var$Xk(a, b, c) {
    b = $7d23520ee3dc0ecc$var$Ji(c, b);
    b = $7d23520ee3dc0ecc$var$Ni(a, b, 1);
    a = $7d23520ee3dc0ecc$var$nh(a, b, 1);
    b = $7d23520ee3dc0ecc$var$R();
    null !== a && ($7d23520ee3dc0ecc$var$Ac(a, 1, b), $7d23520ee3dc0ecc$var$Dk(a, b));
}
function $7d23520ee3dc0ecc$var$W(a, b, c) {
    if (3 === a.tag) $7d23520ee3dc0ecc$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $7d23520ee3dc0ecc$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $7d23520ee3dc0ecc$var$Ri || !$7d23520ee3dc0ecc$var$Ri.has(d))) {
                a = $7d23520ee3dc0ecc$var$Ji(c, a);
                a = $7d23520ee3dc0ecc$var$Qi(b, a, 1);
                b = $7d23520ee3dc0ecc$var$nh(b, a, 1);
                a = $7d23520ee3dc0ecc$var$R();
                null !== b && ($7d23520ee3dc0ecc$var$Ac(b, 1, a), $7d23520ee3dc0ecc$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $7d23520ee3dc0ecc$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $7d23520ee3dc0ecc$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $7d23520ee3dc0ecc$var$Q === a && ($7d23520ee3dc0ecc$var$Z & c) === c && (4 === $7d23520ee3dc0ecc$var$T || 3 === $7d23520ee3dc0ecc$var$T && ($7d23520ee3dc0ecc$var$Z & 130023424) === $7d23520ee3dc0ecc$var$Z && 500 > $7d23520ee3dc0ecc$var$B() - $7d23520ee3dc0ecc$var$fk ? $7d23520ee3dc0ecc$var$Kk(a, 0) : $7d23520ee3dc0ecc$var$rk |= c);
    $7d23520ee3dc0ecc$var$Dk(a, b);
}
function $7d23520ee3dc0ecc$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $7d23520ee3dc0ecc$var$sc, $7d23520ee3dc0ecc$var$sc <<= 1, 0 === ($7d23520ee3dc0ecc$var$sc & 130023424) && ($7d23520ee3dc0ecc$var$sc = 4194304)));
    var c = $7d23520ee3dc0ecc$var$R();
    a = $7d23520ee3dc0ecc$var$ih(a, b);
    null !== a && ($7d23520ee3dc0ecc$var$Ac(a, b, c), $7d23520ee3dc0ecc$var$Dk(a, c));
}
function $7d23520ee3dc0ecc$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $7d23520ee3dc0ecc$var$Yk(a, c);
}
function $7d23520ee3dc0ecc$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($7d23520ee3dc0ecc$var$p(314));
    }
    null !== d && d.delete(b);
    $7d23520ee3dc0ecc$var$Yk(a, c);
}
var $7d23520ee3dc0ecc$var$Vk;
$7d23520ee3dc0ecc$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $7d23520ee3dc0ecc$var$Wf.current) $7d23520ee3dc0ecc$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $7d23520ee3dc0ecc$var$dh = !1, $7d23520ee3dc0ecc$var$yj(a, b, c);
            $7d23520ee3dc0ecc$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $7d23520ee3dc0ecc$var$dh = !1, $7d23520ee3dc0ecc$var$I && 0 !== (b.flags & 1048576) && $7d23520ee3dc0ecc$var$ug(b, $7d23520ee3dc0ecc$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $7d23520ee3dc0ecc$var$ij(a, b);
            a = b.pendingProps;
            var e = $7d23520ee3dc0ecc$var$Yf(b, $7d23520ee3dc0ecc$var$H.current);
            $7d23520ee3dc0ecc$var$ch(b, c);
            e = $7d23520ee3dc0ecc$var$Nh(null, b, d, a, e, c);
            var f = $7d23520ee3dc0ecc$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $7d23520ee3dc0ecc$var$Zf(d) ? (f = !0, $7d23520ee3dc0ecc$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $7d23520ee3dc0ecc$var$kh(b), e.updater = $7d23520ee3dc0ecc$var$Ei, b.stateNode = e, e._reactInternals = b, $7d23520ee3dc0ecc$var$Ii(b, d, a, c), b = $7d23520ee3dc0ecc$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $7d23520ee3dc0ecc$var$I && f && $7d23520ee3dc0ecc$var$vg(b), $7d23520ee3dc0ecc$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $7d23520ee3dc0ecc$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $7d23520ee3dc0ecc$var$Zk(d);
                a = $7d23520ee3dc0ecc$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $7d23520ee3dc0ecc$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $7d23520ee3dc0ecc$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $7d23520ee3dc0ecc$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $7d23520ee3dc0ecc$var$$i(null, b, d, $7d23520ee3dc0ecc$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($7d23520ee3dc0ecc$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7d23520ee3dc0ecc$var$Ci(d, e), $7d23520ee3dc0ecc$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7d23520ee3dc0ecc$var$Ci(d, e), $7d23520ee3dc0ecc$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $7d23520ee3dc0ecc$var$kj(b);
                if (null === a) throw Error($7d23520ee3dc0ecc$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $7d23520ee3dc0ecc$var$lh(a, b);
                $7d23520ee3dc0ecc$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $7d23520ee3dc0ecc$var$Ji(Error($7d23520ee3dc0ecc$var$p(423)), b);
                        b = $7d23520ee3dc0ecc$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $7d23520ee3dc0ecc$var$Ji(Error($7d23520ee3dc0ecc$var$p(424)), b);
                        b = $7d23520ee3dc0ecc$var$lj(a, b, d, c, e);
                        break a;
                    } else for($7d23520ee3dc0ecc$var$yg = $7d23520ee3dc0ecc$var$Lf(b.stateNode.containerInfo.firstChild), $7d23520ee3dc0ecc$var$xg = b, $7d23520ee3dc0ecc$var$I = !0, $7d23520ee3dc0ecc$var$zg = null, c = $7d23520ee3dc0ecc$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $7d23520ee3dc0ecc$var$Ig();
                    if (d === e) {
                        b = $7d23520ee3dc0ecc$var$Zi(a, b, c);
                        break a;
                    }
                    $7d23520ee3dc0ecc$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $7d23520ee3dc0ecc$var$Ah(b), null === a && $7d23520ee3dc0ecc$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $7d23520ee3dc0ecc$var$Ef(d, e) ? g = null : null !== f && $7d23520ee3dc0ecc$var$Ef(d, f) && (b.flags |= 32), $7d23520ee3dc0ecc$var$gj(a, b), $7d23520ee3dc0ecc$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $7d23520ee3dc0ecc$var$Eg(b), null;
        case 13:
            return $7d23520ee3dc0ecc$var$oj(a, b, c);
        case 4:
            return $7d23520ee3dc0ecc$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $7d23520ee3dc0ecc$var$Ug(b, null, d, c) : $7d23520ee3dc0ecc$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7d23520ee3dc0ecc$var$Ci(d, e), $7d23520ee3dc0ecc$var$Yi(a, b, d, e, c);
        case 7:
            return $7d23520ee3dc0ecc$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $7d23520ee3dc0ecc$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $7d23520ee3dc0ecc$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $7d23520ee3dc0ecc$var$G($7d23520ee3dc0ecc$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($7d23520ee3dc0ecc$var$He(f.value, g)) {
                        if (f.children === e.children && !$7d23520ee3dc0ecc$var$Wf.current) {
                            b = $7d23520ee3dc0ecc$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $7d23520ee3dc0ecc$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $7d23520ee3dc0ecc$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($7d23520ee3dc0ecc$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $7d23520ee3dc0ecc$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $7d23520ee3dc0ecc$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $7d23520ee3dc0ecc$var$ch(b, c), e = $7d23520ee3dc0ecc$var$eh(e), d = d(e), b.flags |= 1, $7d23520ee3dc0ecc$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $7d23520ee3dc0ecc$var$Ci(d, b.pendingProps), e = $7d23520ee3dc0ecc$var$Ci(d.type, e), $7d23520ee3dc0ecc$var$$i(a, b, d, e, c);
        case 15:
            return $7d23520ee3dc0ecc$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $7d23520ee3dc0ecc$var$Ci(d, e), $7d23520ee3dc0ecc$var$ij(a, b), b.tag = 1, $7d23520ee3dc0ecc$var$Zf(d) ? (a = !0, $7d23520ee3dc0ecc$var$cg(b)) : a = !1, $7d23520ee3dc0ecc$var$ch(b, c), $7d23520ee3dc0ecc$var$Gi(b, d, e), $7d23520ee3dc0ecc$var$Ii(b, d, e, c), $7d23520ee3dc0ecc$var$jj(null, b, d, !0, a, c);
        case 19:
            return $7d23520ee3dc0ecc$var$xj(a, b, c);
        case 22:
            return $7d23520ee3dc0ecc$var$dj(a, b, c);
    }
    throw Error($7d23520ee3dc0ecc$var$p(156, b.tag));
};
function $7d23520ee3dc0ecc$var$Fk(a, b) {
    return $7d23520ee3dc0ecc$var$ac(a, b);
}
function $7d23520ee3dc0ecc$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $7d23520ee3dc0ecc$var$Bg(a, b, c, d) {
    return new $7d23520ee3dc0ecc$var$$k(a, b, c, d);
}
function $7d23520ee3dc0ecc$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $7d23520ee3dc0ecc$var$Zk(a) {
    if ("function" === typeof a) return $7d23520ee3dc0ecc$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $7d23520ee3dc0ecc$var$Da) return 11;
        if (a === $7d23520ee3dc0ecc$var$Ga) return 14;
    }
    return 2;
}
function $7d23520ee3dc0ecc$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $7d23520ee3dc0ecc$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $7d23520ee3dc0ecc$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $7d23520ee3dc0ecc$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $7d23520ee3dc0ecc$var$ya:
            return $7d23520ee3dc0ecc$var$Tg(c.children, e, f, b);
        case $7d23520ee3dc0ecc$var$za:
            g = 8;
            e |= 8;
            break;
        case $7d23520ee3dc0ecc$var$Aa:
            return a = $7d23520ee3dc0ecc$var$Bg(12, c, b, e | 2), a.elementType = $7d23520ee3dc0ecc$var$Aa, a.lanes = f, a;
        case $7d23520ee3dc0ecc$var$Ea:
            return a = $7d23520ee3dc0ecc$var$Bg(13, c, b, e), a.elementType = $7d23520ee3dc0ecc$var$Ea, a.lanes = f, a;
        case $7d23520ee3dc0ecc$var$Fa:
            return a = $7d23520ee3dc0ecc$var$Bg(19, c, b, e), a.elementType = $7d23520ee3dc0ecc$var$Fa, a.lanes = f, a;
        case $7d23520ee3dc0ecc$var$Ia:
            return $7d23520ee3dc0ecc$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $7d23520ee3dc0ecc$var$Ba:
                    g = 10;
                    break a;
                case $7d23520ee3dc0ecc$var$Ca:
                    g = 9;
                    break a;
                case $7d23520ee3dc0ecc$var$Da:
                    g = 11;
                    break a;
                case $7d23520ee3dc0ecc$var$Ga:
                    g = 14;
                    break a;
                case $7d23520ee3dc0ecc$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($7d23520ee3dc0ecc$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $7d23520ee3dc0ecc$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $7d23520ee3dc0ecc$var$Tg(a, b, c, d) {
    a = $7d23520ee3dc0ecc$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $7d23520ee3dc0ecc$var$pj(a, b, c, d) {
    a = $7d23520ee3dc0ecc$var$Bg(22, a, d, b);
    a.elementType = $7d23520ee3dc0ecc$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $7d23520ee3dc0ecc$var$Qg(a, b, c) {
    a = $7d23520ee3dc0ecc$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $7d23520ee3dc0ecc$var$Sg(a, b, c) {
    b = $7d23520ee3dc0ecc$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $7d23520ee3dc0ecc$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $7d23520ee3dc0ecc$var$zc(0);
    this.expirationTimes = $7d23520ee3dc0ecc$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $7d23520ee3dc0ecc$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $7d23520ee3dc0ecc$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $7d23520ee3dc0ecc$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $7d23520ee3dc0ecc$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $7d23520ee3dc0ecc$var$kh(f);
    return a;
}
function $7d23520ee3dc0ecc$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $7d23520ee3dc0ecc$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $7d23520ee3dc0ecc$var$dl(a) {
    if (!a) return $7d23520ee3dc0ecc$var$Vf;
    a = a._reactInternals;
    a: {
        if ($7d23520ee3dc0ecc$var$Vb(a) !== a || 1 !== a.tag) throw Error($7d23520ee3dc0ecc$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($7d23520ee3dc0ecc$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($7d23520ee3dc0ecc$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($7d23520ee3dc0ecc$var$Zf(c)) return $7d23520ee3dc0ecc$var$bg(a, c, b);
    }
    return b;
}
function $7d23520ee3dc0ecc$var$el(a, b, c, d, e, f, g, h, k) {
    a = $7d23520ee3dc0ecc$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $7d23520ee3dc0ecc$var$dl(null);
    c = a.current;
    d = $7d23520ee3dc0ecc$var$R();
    e = $7d23520ee3dc0ecc$var$yi(c);
    f = $7d23520ee3dc0ecc$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $7d23520ee3dc0ecc$var$nh(c, f, e);
    a.current.lanes = e;
    $7d23520ee3dc0ecc$var$Ac(a, e, d);
    $7d23520ee3dc0ecc$var$Dk(a, d);
    return a;
}
function $7d23520ee3dc0ecc$var$fl(a, b, c, d) {
    var e = b.current, f = $7d23520ee3dc0ecc$var$R(), g = $7d23520ee3dc0ecc$var$yi(e);
    c = $7d23520ee3dc0ecc$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $7d23520ee3dc0ecc$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $7d23520ee3dc0ecc$var$nh(e, b, g);
    null !== a && ($7d23520ee3dc0ecc$var$gi(a, e, g, f), $7d23520ee3dc0ecc$var$oh(a, e, g));
    return g;
}
function $7d23520ee3dc0ecc$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $7d23520ee3dc0ecc$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $7d23520ee3dc0ecc$var$il(a, b) {
    $7d23520ee3dc0ecc$var$hl(a, b);
    (a = a.alternate) && $7d23520ee3dc0ecc$var$hl(a, b);
}
function $7d23520ee3dc0ecc$var$jl() {
    return null;
}
var $7d23520ee3dc0ecc$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $7d23520ee3dc0ecc$var$ll(a) {
    this._internalRoot = a;
}
$7d23520ee3dc0ecc$var$ml.prototype.render = $7d23520ee3dc0ecc$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($7d23520ee3dc0ecc$var$p(409));
    $7d23520ee3dc0ecc$var$fl(a, b, null, null);
};
$7d23520ee3dc0ecc$var$ml.prototype.unmount = $7d23520ee3dc0ecc$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $7d23520ee3dc0ecc$var$Rk(function() {
            $7d23520ee3dc0ecc$var$fl(null, a, null, null);
        });
        b[$7d23520ee3dc0ecc$var$uf] = null;
    }
};
function $7d23520ee3dc0ecc$var$ml(a) {
    this._internalRoot = a;
}
$7d23520ee3dc0ecc$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $7d23520ee3dc0ecc$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $7d23520ee3dc0ecc$var$Qc.length && 0 !== b && b < $7d23520ee3dc0ecc$var$Qc[c].priority; c++);
        $7d23520ee3dc0ecc$var$Qc.splice(c, 0, a);
        0 === c && $7d23520ee3dc0ecc$var$Vc(a);
    }
};
function $7d23520ee3dc0ecc$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $7d23520ee3dc0ecc$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $7d23520ee3dc0ecc$var$pl() {}
function $7d23520ee3dc0ecc$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $7d23520ee3dc0ecc$var$gl(g);
                f.call(a);
            };
        }
        var g = $7d23520ee3dc0ecc$var$el(b, d, a, 0, null, !1, !1, "", $7d23520ee3dc0ecc$var$pl);
        a._reactRootContainer = g;
        a[$7d23520ee3dc0ecc$var$uf] = g.current;
        $7d23520ee3dc0ecc$var$sf(8 === a.nodeType ? a.parentNode : a);
        $7d23520ee3dc0ecc$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $7d23520ee3dc0ecc$var$gl(k);
            h.call(a);
        };
    }
    var k = $7d23520ee3dc0ecc$var$bl(a, 0, !1, null, null, !1, !1, "", $7d23520ee3dc0ecc$var$pl);
    a._reactRootContainer = k;
    a[$7d23520ee3dc0ecc$var$uf] = k.current;
    $7d23520ee3dc0ecc$var$sf(8 === a.nodeType ? a.parentNode : a);
    $7d23520ee3dc0ecc$var$Rk(function() {
        $7d23520ee3dc0ecc$var$fl(b, k, c, d);
    });
    return k;
}
function $7d23520ee3dc0ecc$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $7d23520ee3dc0ecc$var$gl(g);
                h.call(a);
            };
        }
        $7d23520ee3dc0ecc$var$fl(b, g, a, e);
    } else g = $7d23520ee3dc0ecc$var$ql(c, b, a, e, d);
    return $7d23520ee3dc0ecc$var$gl(g);
}
$7d23520ee3dc0ecc$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $7d23520ee3dc0ecc$var$tc(b.pendingLanes);
                0 !== c && ($7d23520ee3dc0ecc$var$Cc(b, c | 1), $7d23520ee3dc0ecc$var$Dk(b, $7d23520ee3dc0ecc$var$B()), 0 === ($7d23520ee3dc0ecc$var$K & 6) && ($7d23520ee3dc0ecc$var$Gj = $7d23520ee3dc0ecc$var$B() + 500, $7d23520ee3dc0ecc$var$jg()));
            }
            break;
        case 13:
            $7d23520ee3dc0ecc$var$Rk(function() {
                var b = $7d23520ee3dc0ecc$var$ih(a, 1);
                if (null !== b) {
                    var c = $7d23520ee3dc0ecc$var$R();
                    $7d23520ee3dc0ecc$var$gi(b, a, 1, c);
                }
            }), $7d23520ee3dc0ecc$var$il(a, 1);
    }
};
$7d23520ee3dc0ecc$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $7d23520ee3dc0ecc$var$ih(a, 134217728);
        if (null !== b) {
            var c = $7d23520ee3dc0ecc$var$R();
            $7d23520ee3dc0ecc$var$gi(b, a, 134217728, c);
        }
        $7d23520ee3dc0ecc$var$il(a, 134217728);
    }
};
$7d23520ee3dc0ecc$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $7d23520ee3dc0ecc$var$yi(a), c = $7d23520ee3dc0ecc$var$ih(a, b);
        if (null !== c) {
            var d = $7d23520ee3dc0ecc$var$R();
            $7d23520ee3dc0ecc$var$gi(c, a, b, d);
        }
        $7d23520ee3dc0ecc$var$il(a, b);
    }
};
$7d23520ee3dc0ecc$var$Hc = function() {
    return $7d23520ee3dc0ecc$var$C;
};
$7d23520ee3dc0ecc$var$Ic = function(a, b) {
    var c = $7d23520ee3dc0ecc$var$C;
    try {
        return $7d23520ee3dc0ecc$var$C = a, b();
    } finally{
        $7d23520ee3dc0ecc$var$C = c;
    }
};
$7d23520ee3dc0ecc$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $7d23520ee3dc0ecc$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $7d23520ee3dc0ecc$var$Db(d);
                        if (!e) throw Error($7d23520ee3dc0ecc$var$p(90));
                        $7d23520ee3dc0ecc$var$Wa(d);
                        $7d23520ee3dc0ecc$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $7d23520ee3dc0ecc$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $7d23520ee3dc0ecc$var$fb(a, !!c.multiple, b, !1);
    }
};
$7d23520ee3dc0ecc$var$Gb = $7d23520ee3dc0ecc$var$Qk;
$7d23520ee3dc0ecc$var$Hb = $7d23520ee3dc0ecc$var$Rk;
var $7d23520ee3dc0ecc$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $7d23520ee3dc0ecc$var$Cb,
        $7d23520ee3dc0ecc$var$ue,
        $7d23520ee3dc0ecc$var$Db,
        $7d23520ee3dc0ecc$var$Eb,
        $7d23520ee3dc0ecc$var$Fb,
        $7d23520ee3dc0ecc$var$Qk
    ]
}, $7d23520ee3dc0ecc$var$tl = {
    findFiberByHostInstance: $7d23520ee3dc0ecc$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $7d23520ee3dc0ecc$var$ul = {
    bundleType: $7d23520ee3dc0ecc$var$tl.bundleType,
    version: $7d23520ee3dc0ecc$var$tl.version,
    rendererPackageName: $7d23520ee3dc0ecc$var$tl.rendererPackageName,
    rendererConfig: $7d23520ee3dc0ecc$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $7d23520ee3dc0ecc$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $7d23520ee3dc0ecc$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $7d23520ee3dc0ecc$var$tl.findFiberByHostInstance || $7d23520ee3dc0ecc$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $7d23520ee3dc0ecc$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$7d23520ee3dc0ecc$var$vl.isDisabled && $7d23520ee3dc0ecc$var$vl.supportsFiber) try {
        $7d23520ee3dc0ecc$var$kc = $7d23520ee3dc0ecc$var$vl.inject($7d23520ee3dc0ecc$var$ul), $7d23520ee3dc0ecc$var$lc = $7d23520ee3dc0ecc$var$vl;
    } catch (a) {}
}
$7d23520ee3dc0ecc$export$ae55be85d98224ed = $7d23520ee3dc0ecc$var$sl;
$7d23520ee3dc0ecc$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$7d23520ee3dc0ecc$var$nl(b)) throw Error($7d23520ee3dc0ecc$var$p(200));
    return $7d23520ee3dc0ecc$var$cl(a, b, null, c);
};
$7d23520ee3dc0ecc$export$882461b6382ed46c = function(a, b) {
    if (!$7d23520ee3dc0ecc$var$nl(a)) throw Error($7d23520ee3dc0ecc$var$p(299));
    var c = !1, d = "", e = $7d23520ee3dc0ecc$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $7d23520ee3dc0ecc$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$7d23520ee3dc0ecc$var$uf] = b.current;
    $7d23520ee3dc0ecc$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $7d23520ee3dc0ecc$var$ll(b);
};
$7d23520ee3dc0ecc$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($7d23520ee3dc0ecc$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($7d23520ee3dc0ecc$var$p(268, a));
    }
    a = $7d23520ee3dc0ecc$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$7d23520ee3dc0ecc$export$cd75ccfd720a3cd4 = function(a) {
    return $7d23520ee3dc0ecc$var$Rk(a);
};
$7d23520ee3dc0ecc$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$7d23520ee3dc0ecc$var$ol(b)) throw Error($7d23520ee3dc0ecc$var$p(200));
    return $7d23520ee3dc0ecc$var$rl(null, a, b, !0, c);
};
$7d23520ee3dc0ecc$export$757ceba2d55c277e = function(a, b, c) {
    if (!$7d23520ee3dc0ecc$var$nl(a)) throw Error($7d23520ee3dc0ecc$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $7d23520ee3dc0ecc$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $7d23520ee3dc0ecc$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$7d23520ee3dc0ecc$var$uf] = b.current;
    $7d23520ee3dc0ecc$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $7d23520ee3dc0ecc$var$ml(b);
};
$7d23520ee3dc0ecc$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$7d23520ee3dc0ecc$var$ol(b)) throw Error($7d23520ee3dc0ecc$var$p(200));
    return $7d23520ee3dc0ecc$var$rl(null, a, b, !1, c);
};
$7d23520ee3dc0ecc$export$502457920280e6be = function(a) {
    if (!$7d23520ee3dc0ecc$var$ol(a)) throw Error($7d23520ee3dc0ecc$var$p(40));
    return a._reactRootContainer ? ($7d23520ee3dc0ecc$var$Rk(function() {
        $7d23520ee3dc0ecc$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$7d23520ee3dc0ecc$var$uf] = null;
        });
    }), !0) : !1;
};
$7d23520ee3dc0ecc$export$c78a37762a8d58e1 = $7d23520ee3dc0ecc$var$Qk;
$7d23520ee3dc0ecc$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$7d23520ee3dc0ecc$var$ol(c)) throw Error($7d23520ee3dc0ecc$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($7d23520ee3dc0ecc$var$p(38));
    return $7d23520ee3dc0ecc$var$rl(a, b, c, !1, d);
};
$7d23520ee3dc0ecc$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bObFs", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jJgHI"));

});
parcelRegister("jJgHI", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e5cf2d62930e3f4b$export$c4744153514ff05d; }, function (v) { return $e5cf2d62930e3f4b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e5cf2d62930e3f4b$export$3e506c1ccc9cc1a7; }, function (v) { return $e5cf2d62930e3f4b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e5cf2d62930e3f4b$export$e26fe2ed2fa76875; }, function (v) { return $e5cf2d62930e3f4b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e5cf2d62930e3f4b$export$502329bbf4b505b1; }, function (v) { return $e5cf2d62930e3f4b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e5cf2d62930e3f4b$export$6e3807111c4874c4; }, function (v) { return $e5cf2d62930e3f4b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e5cf2d62930e3f4b$export$c27134553091fb3a; }, function (v) { return $e5cf2d62930e3f4b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e5cf2d62930e3f4b$export$33ee1acdc04fd2a2; }, function (v) { return $e5cf2d62930e3f4b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e5cf2d62930e3f4b$export$b00a404bbd5edef2; }, function (v) { return $e5cf2d62930e3f4b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e5cf2d62930e3f4b$export$8352ce38b91d0c62; }, function (v) { return $e5cf2d62930e3f4b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e5cf2d62930e3f4b$export$d66a1c1c77bd778b; }, function (v) { return $e5cf2d62930e3f4b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e5cf2d62930e3f4b$export$d3dfb8e4810cb555; }, function (v) { return $e5cf2d62930e3f4b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e5cf2d62930e3f4b$export$839f9183b0465a69; }, function (v) { return $e5cf2d62930e3f4b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e5cf2d62930e3f4b$export$72fdf0e06517287b; }, function (v) { return $e5cf2d62930e3f4b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e5cf2d62930e3f4b$export$4b844e58a3e414b4; }, function (v) { return $e5cf2d62930e3f4b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e5cf2d62930e3f4b$export$816d2913ae6b83b1; }, function (v) { return $e5cf2d62930e3f4b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e5cf2d62930e3f4b$export$61bcfe829111a1d0; }, function (v) { return $e5cf2d62930e3f4b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e5cf2d62930e3f4b$export$7ee8c9beb337bc3f; }, function (v) { return $e5cf2d62930e3f4b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e5cf2d62930e3f4b$export$b5836b71941fa3ed; }, function (v) { return $e5cf2d62930e3f4b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e5cf2d62930e3f4b$export$cf845f2c119da08a; }, function (v) { return $e5cf2d62930e3f4b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e5cf2d62930e3f4b$export$c4744153514ff05d;
var $e5cf2d62930e3f4b$export$3e506c1ccc9cc1a7;
var $e5cf2d62930e3f4b$export$e26fe2ed2fa76875;
var $e5cf2d62930e3f4b$export$502329bbf4b505b1;
var $e5cf2d62930e3f4b$export$6e3807111c4874c4;
var $e5cf2d62930e3f4b$export$c27134553091fb3a;
var $e5cf2d62930e3f4b$export$33ee1acdc04fd2a2;
var $e5cf2d62930e3f4b$export$b00a404bbd5edef2;
var $e5cf2d62930e3f4b$export$8352ce38b91d0c62;
var $e5cf2d62930e3f4b$export$d66a1c1c77bd778b;
var $e5cf2d62930e3f4b$export$d3dfb8e4810cb555;
var $e5cf2d62930e3f4b$export$839f9183b0465a69;
var $e5cf2d62930e3f4b$export$72fdf0e06517287b;
var $e5cf2d62930e3f4b$export$4b844e58a3e414b4;
var $e5cf2d62930e3f4b$export$816d2913ae6b83b1;
var $e5cf2d62930e3f4b$export$61bcfe829111a1d0;
var $e5cf2d62930e3f4b$export$7ee8c9beb337bc3f;
var $e5cf2d62930e3f4b$export$b5836b71941fa3ed;
var $e5cf2d62930e3f4b$export$cf845f2c119da08a;
'use strict';
function $e5cf2d62930e3f4b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e5cf2d62930e3f4b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e5cf2d62930e3f4b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e5cf2d62930e3f4b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e5cf2d62930e3f4b$var$g(C, c)) n < e && 0 > $e5cf2d62930e3f4b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e5cf2d62930e3f4b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e5cf2d62930e3f4b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e5cf2d62930e3f4b$var$l = performance;
    $e5cf2d62930e3f4b$export$c4744153514ff05d = function() {
        return $e5cf2d62930e3f4b$var$l.now();
    };
} else {
    var $e5cf2d62930e3f4b$var$p = Date, $e5cf2d62930e3f4b$var$q = $e5cf2d62930e3f4b$var$p.now();
    $e5cf2d62930e3f4b$export$c4744153514ff05d = function() {
        return $e5cf2d62930e3f4b$var$p.now() - $e5cf2d62930e3f4b$var$q;
    };
}
var $e5cf2d62930e3f4b$var$r = [], $e5cf2d62930e3f4b$var$t = [], $e5cf2d62930e3f4b$var$u = 1, $e5cf2d62930e3f4b$var$v = null, $e5cf2d62930e3f4b$var$y = 3, $e5cf2d62930e3f4b$var$z = !1, $e5cf2d62930e3f4b$var$A = !1, $e5cf2d62930e3f4b$var$B = !1, $e5cf2d62930e3f4b$var$D = "function" === typeof setTimeout ? setTimeout : null, $e5cf2d62930e3f4b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e5cf2d62930e3f4b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e5cf2d62930e3f4b$var$G(a) {
    for(var b = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$t); null !== b;){
        if (null === b.callback) $e5cf2d62930e3f4b$var$k($e5cf2d62930e3f4b$var$t);
        else if (b.startTime <= a) $e5cf2d62930e3f4b$var$k($e5cf2d62930e3f4b$var$t), b.sortIndex = b.expirationTime, $e5cf2d62930e3f4b$var$f($e5cf2d62930e3f4b$var$r, b);
        else break;
        b = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$t);
    }
}
function $e5cf2d62930e3f4b$var$H(a) {
    $e5cf2d62930e3f4b$var$B = !1;
    $e5cf2d62930e3f4b$var$G(a);
    if (!$e5cf2d62930e3f4b$var$A) {
        if (null !== $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r)) $e5cf2d62930e3f4b$var$A = !0, $e5cf2d62930e3f4b$var$I($e5cf2d62930e3f4b$var$J);
        else {
            var b = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$t);
            null !== b && $e5cf2d62930e3f4b$var$K($e5cf2d62930e3f4b$var$H, b.startTime - a);
        }
    }
}
function $e5cf2d62930e3f4b$var$J(a, b) {
    $e5cf2d62930e3f4b$var$A = !1;
    $e5cf2d62930e3f4b$var$B && ($e5cf2d62930e3f4b$var$B = !1, $e5cf2d62930e3f4b$var$E($e5cf2d62930e3f4b$var$L), $e5cf2d62930e3f4b$var$L = -1);
    $e5cf2d62930e3f4b$var$z = !0;
    var c = $e5cf2d62930e3f4b$var$y;
    try {
        $e5cf2d62930e3f4b$var$G(b);
        for($e5cf2d62930e3f4b$var$v = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r); null !== $e5cf2d62930e3f4b$var$v && (!($e5cf2d62930e3f4b$var$v.expirationTime > b) || a && !$e5cf2d62930e3f4b$var$M());){
            var d = $e5cf2d62930e3f4b$var$v.callback;
            if ("function" === typeof d) {
                $e5cf2d62930e3f4b$var$v.callback = null;
                $e5cf2d62930e3f4b$var$y = $e5cf2d62930e3f4b$var$v.priorityLevel;
                var e = d($e5cf2d62930e3f4b$var$v.expirationTime <= b);
                b = $e5cf2d62930e3f4b$export$c4744153514ff05d();
                "function" === typeof e ? $e5cf2d62930e3f4b$var$v.callback = e : $e5cf2d62930e3f4b$var$v === $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r) && $e5cf2d62930e3f4b$var$k($e5cf2d62930e3f4b$var$r);
                $e5cf2d62930e3f4b$var$G(b);
            } else $e5cf2d62930e3f4b$var$k($e5cf2d62930e3f4b$var$r);
            $e5cf2d62930e3f4b$var$v = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r);
        }
        if (null !== $e5cf2d62930e3f4b$var$v) var w = !0;
        else {
            var m = $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$t);
            null !== m && $e5cf2d62930e3f4b$var$K($e5cf2d62930e3f4b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e5cf2d62930e3f4b$var$v = null, $e5cf2d62930e3f4b$var$y = c, $e5cf2d62930e3f4b$var$z = !1;
    }
}
var $e5cf2d62930e3f4b$var$N = !1, $e5cf2d62930e3f4b$var$O = null, $e5cf2d62930e3f4b$var$L = -1, $e5cf2d62930e3f4b$var$P = 5, $e5cf2d62930e3f4b$var$Q = -1;
function $e5cf2d62930e3f4b$var$M() {
    return $e5cf2d62930e3f4b$export$c4744153514ff05d() - $e5cf2d62930e3f4b$var$Q < $e5cf2d62930e3f4b$var$P ? !1 : !0;
}
function $e5cf2d62930e3f4b$var$R() {
    if (null !== $e5cf2d62930e3f4b$var$O) {
        var a = $e5cf2d62930e3f4b$export$c4744153514ff05d();
        $e5cf2d62930e3f4b$var$Q = a;
        var b = !0;
        try {
            b = $e5cf2d62930e3f4b$var$O(!0, a);
        } finally{
            b ? $e5cf2d62930e3f4b$var$S() : ($e5cf2d62930e3f4b$var$N = !1, $e5cf2d62930e3f4b$var$O = null);
        }
    } else $e5cf2d62930e3f4b$var$N = !1;
}
var $e5cf2d62930e3f4b$var$S;
if ("function" === typeof $e5cf2d62930e3f4b$var$F) $e5cf2d62930e3f4b$var$S = function() {
    $e5cf2d62930e3f4b$var$F($e5cf2d62930e3f4b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e5cf2d62930e3f4b$var$T = new MessageChannel, $e5cf2d62930e3f4b$var$U = $e5cf2d62930e3f4b$var$T.port2;
    $e5cf2d62930e3f4b$var$T.port1.onmessage = $e5cf2d62930e3f4b$var$R;
    $e5cf2d62930e3f4b$var$S = function() {
        $e5cf2d62930e3f4b$var$U.postMessage(null);
    };
} else $e5cf2d62930e3f4b$var$S = function() {
    $e5cf2d62930e3f4b$var$D($e5cf2d62930e3f4b$var$R, 0);
};
function $e5cf2d62930e3f4b$var$I(a) {
    $e5cf2d62930e3f4b$var$O = a;
    $e5cf2d62930e3f4b$var$N || ($e5cf2d62930e3f4b$var$N = !0, $e5cf2d62930e3f4b$var$S());
}
function $e5cf2d62930e3f4b$var$K(a, b) {
    $e5cf2d62930e3f4b$var$L = $e5cf2d62930e3f4b$var$D(function() {
        a($e5cf2d62930e3f4b$export$c4744153514ff05d());
    }, b);
}
$e5cf2d62930e3f4b$export$3e506c1ccc9cc1a7 = 5;
$e5cf2d62930e3f4b$export$e26fe2ed2fa76875 = 1;
$e5cf2d62930e3f4b$export$502329bbf4b505b1 = 4;
$e5cf2d62930e3f4b$export$6e3807111c4874c4 = 3;
$e5cf2d62930e3f4b$export$c27134553091fb3a = null;
$e5cf2d62930e3f4b$export$33ee1acdc04fd2a2 = 2;
$e5cf2d62930e3f4b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e5cf2d62930e3f4b$export$8352ce38b91d0c62 = function() {
    $e5cf2d62930e3f4b$var$A || $e5cf2d62930e3f4b$var$z || ($e5cf2d62930e3f4b$var$A = !0, $e5cf2d62930e3f4b$var$I($e5cf2d62930e3f4b$var$J));
};
$e5cf2d62930e3f4b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e5cf2d62930e3f4b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e5cf2d62930e3f4b$export$d3dfb8e4810cb555 = function() {
    return $e5cf2d62930e3f4b$var$y;
};
$e5cf2d62930e3f4b$export$839f9183b0465a69 = function() {
    return $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r);
};
$e5cf2d62930e3f4b$export$72fdf0e06517287b = function(a) {
    switch($e5cf2d62930e3f4b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e5cf2d62930e3f4b$var$y;
    }
    var c = $e5cf2d62930e3f4b$var$y;
    $e5cf2d62930e3f4b$var$y = b;
    try {
        return a();
    } finally{
        $e5cf2d62930e3f4b$var$y = c;
    }
};
$e5cf2d62930e3f4b$export$4b844e58a3e414b4 = function() {};
$e5cf2d62930e3f4b$export$816d2913ae6b83b1 = function() {};
$e5cf2d62930e3f4b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e5cf2d62930e3f4b$var$y;
    $e5cf2d62930e3f4b$var$y = a;
    try {
        return b();
    } finally{
        $e5cf2d62930e3f4b$var$y = c;
    }
};
$e5cf2d62930e3f4b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e5cf2d62930e3f4b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e5cf2d62930e3f4b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e5cf2d62930e3f4b$var$f($e5cf2d62930e3f4b$var$t, a), null === $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$r) && a === $e5cf2d62930e3f4b$var$h($e5cf2d62930e3f4b$var$t) && ($e5cf2d62930e3f4b$var$B ? ($e5cf2d62930e3f4b$var$E($e5cf2d62930e3f4b$var$L), $e5cf2d62930e3f4b$var$L = -1) : $e5cf2d62930e3f4b$var$B = !0, $e5cf2d62930e3f4b$var$K($e5cf2d62930e3f4b$var$H, c - d))) : (a.sortIndex = e, $e5cf2d62930e3f4b$var$f($e5cf2d62930e3f4b$var$r, a), $e5cf2d62930e3f4b$var$A || $e5cf2d62930e3f4b$var$z || ($e5cf2d62930e3f4b$var$A = !0, $e5cf2d62930e3f4b$var$I($e5cf2d62930e3f4b$var$J)));
    return a;
};
$e5cf2d62930e3f4b$export$b5836b71941fa3ed = $e5cf2d62930e3f4b$var$M;
$e5cf2d62930e3f4b$export$cf845f2c119da08a = function(a) {
    var b = $e5cf2d62930e3f4b$var$y;
    return function() {
        var c = $e5cf2d62930e3f4b$var$y;
        $e5cf2d62930e3f4b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e5cf2d62930e3f4b$var$y = c;
        }
    };
};

});





parcelRegister("cV1mW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("gksg3")).default; });

var $gksg3 = parcelRequire("gksg3");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $967bdec45432b2f8$export$1c00760e9e5a4e95, AxiosError: $967bdec45432b2f8$export$c1fbed17c2f6a328, CanceledError: $967bdec45432b2f8$export$1ab0c6b20d94fa14, isCancel: $967bdec45432b2f8$export$3b22524397b493c6, CancelToken: $967bdec45432b2f8$export$fd08e3cb425f0d61, VERSION: $967bdec45432b2f8$export$a4ad2735b021c132, all: $967bdec45432b2f8$export$84bf76cd7afc7469, Cancel: $967bdec45432b2f8$export$848c9b7ead0df967, isAxiosError: $967bdec45432b2f8$export$fbafdbe06a5b5a9a, spread: $967bdec45432b2f8$export$3ae0fd4797ed47c8, toFormData: $967bdec45432b2f8$export$10ae0d317ea97f8b, AxiosHeaders: $967bdec45432b2f8$export$4e7d6ff0f3e6520, HttpStatusCode: $967bdec45432b2f8$export$a972f69c851492b3, formToJSON: $967bdec45432b2f8$export$86d7c59254d6a2c9, getAdapter: $967bdec45432b2f8$export$17ddc20a97d669e2, mergeConfig: $967bdec45432b2f8$export$7ec1ebcfa9d8bd6a, create: $967bdec45432b2f8$export$185802fd694ee1f5 } = (0, $gksg3.default);

});
parcelRegister("gksg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be346f0b91a167cb$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $66H2k = parcelRequire("66H2k");

var $kx4G1 = parcelRequire("kx4G1");

var $ifI1B = parcelRequire("ifI1B");

var $iHD77 = parcelRequire("iHD77");

var $5lNfY = parcelRequire("5lNfY");

var $hTina = parcelRequire("hTina");

var $jqOhz = parcelRequire("jqOhz");

var $2WjLv = parcelRequire("2WjLv");

var $3Xfy7 = parcelRequire("3Xfy7");

var $k00R5 = parcelRequire("k00R5");

var $3FHb3 = parcelRequire("3FHb3");

var $k8nYv = parcelRequire("k8nYv");

var $215ge = parcelRequire("215ge");

var $fcwQ6 = parcelRequire("fcwQ6");

var $ktrSD = parcelRequire("ktrSD");

var $edCxT = parcelRequire("edCxT");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $be346f0b91a167cb$var$createInstance(defaultConfig) {
    const context = new (0, $kx4G1.default)(defaultConfig);
    const instance = (0, $66H2k.default)((0, $kx4G1.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $1d3Re.default).extend(instance, (0, $kx4G1.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $1d3Re.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $be346f0b91a167cb$var$createInstance((0, $ifI1B.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $be346f0b91a167cb$var$axios = $be346f0b91a167cb$var$createInstance((0, $iHD77.default));
// Expose Axios class to allow class inheritance
$be346f0b91a167cb$var$axios.Axios = (0, $kx4G1.default);
// Expose Cancel & CancelToken
$be346f0b91a167cb$var$axios.CanceledError = (0, $hTina.default);
$be346f0b91a167cb$var$axios.CancelToken = (0, $jqOhz.default);
$be346f0b91a167cb$var$axios.isCancel = (0, $2WjLv.default);
$be346f0b91a167cb$var$axios.VERSION = (0, $3Xfy7.VERSION);
$be346f0b91a167cb$var$axios.toFormData = (0, $k00R5.default);
// Expose AxiosError class
$be346f0b91a167cb$var$axios.AxiosError = (0, $3FHb3.default);
// alias for CanceledError for backward compatibility
$be346f0b91a167cb$var$axios.Cancel = $be346f0b91a167cb$var$axios.CanceledError;
// Expose all/spread
$be346f0b91a167cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$be346f0b91a167cb$var$axios.spread = (0, $k8nYv.default);
// Expose isAxiosError
$be346f0b91a167cb$var$axios.isAxiosError = (0, $215ge.default);
// Expose mergeConfig
$be346f0b91a167cb$var$axios.mergeConfig = (0, $ifI1B.default);
$be346f0b91a167cb$var$axios.AxiosHeaders = (0, $fcwQ6.default);
$be346f0b91a167cb$var$axios.formToJSON = (thing)=>(0, $5lNfY.default)((0, $1d3Re.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$be346f0b91a167cb$var$axios.getAdapter = (0, $ktrSD.default).getAdapter;
$be346f0b91a167cb$var$axios.HttpStatusCode = (0, $edCxT.default);
$be346f0b91a167cb$var$axios.default = $be346f0b91a167cb$var$axios;
var // this module should only have a default export
$be346f0b91a167cb$export$2e2bcd8739ae039 = $be346f0b91a167cb$var$axios;

});
parcelRegister("1d3Re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e19ff6696ce928a$export$2e2bcd8739ae039; });

var $66H2k = parcelRequire("66H2k");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $0e19ff6696ce928a$var$toString } = Object.prototype;
const { getPrototypeOf: $0e19ff6696ce928a$var$getPrototypeOf } = Object;
const { iterator: $0e19ff6696ce928a$var$iterator, toStringTag: $0e19ff6696ce928a$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $0e19ff6696ce928a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $0e19ff6696ce928a$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($0e19ff6696ce928a$var$hasOwnProperty(obj, prop)) return true;
        obj = $0e19ff6696ce928a$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $0e19ff6696ce928a$var$getSafeProp = (obj, prop)=>obj != null && $0e19ff6696ce928a$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $0e19ff6696ce928a$var$kindOf = ((cache)=>(thing)=>{
        const str = $0e19ff6696ce928a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0e19ff6696ce928a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0e19ff6696ce928a$var$kindOf(thing) === type;
};
const $0e19ff6696ce928a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0e19ff6696ce928a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0e19ff6696ce928a$var$isUndefined = $0e19ff6696ce928a$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0e19ff6696ce928a$var$isBuffer(val) {
    return val !== null && !$0e19ff6696ce928a$var$isUndefined(val) && val.constructor !== null && !$0e19ff6696ce928a$var$isUndefined(val.constructor) && $0e19ff6696ce928a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0e19ff6696ce928a$var$isArrayBuffer = $0e19ff6696ce928a$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0e19ff6696ce928a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0e19ff6696ce928a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0e19ff6696ce928a$var$isString = $0e19ff6696ce928a$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0e19ff6696ce928a$var$isFunction = $0e19ff6696ce928a$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0e19ff6696ce928a$var$isNumber = $0e19ff6696ce928a$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0e19ff6696ce928a$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0e19ff6696ce928a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0e19ff6696ce928a$var$isPlainObject = (val)=>{
    if (!$0e19ff6696ce928a$var$isObject(val)) return false;
    const prototype = $0e19ff6696ce928a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $0e19ff6696ce928a$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$0e19ff6696ce928a$var$hasOwnInPrototypeChain(val, $0e19ff6696ce928a$var$toStringTag) && !$0e19ff6696ce928a$var$hasOwnInPrototypeChain(val, $0e19ff6696ce928a$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $0e19ff6696ce928a$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$0e19ff6696ce928a$var$isObject(val) || $0e19ff6696ce928a$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0e19ff6696ce928a$var$isDate = $0e19ff6696ce928a$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0e19ff6696ce928a$var$isFile = $0e19ff6696ce928a$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $0e19ff6696ce928a$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $0e19ff6696ce928a$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0e19ff6696ce928a$var$isBlob = $0e19ff6696ce928a$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $0e19ff6696ce928a$var$isFileList = $0e19ff6696ce928a$var$kindOfTest('FileList');
const $0e19ff6696ce928a$var$isSet = $0e19ff6696ce928a$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0e19ff6696ce928a$var$isStream = (val)=>$0e19ff6696ce928a$var$isObject(val) && $0e19ff6696ce928a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $0e19ff6696ce928a$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $0e19ff6696ce928a$var$G = $0e19ff6696ce928a$var$getGlobal();
const $0e19ff6696ce928a$var$FormDataCtor = typeof $0e19ff6696ce928a$var$G.FormData !== 'undefined' ? $0e19ff6696ce928a$var$G.FormData : undefined;
const $0e19ff6696ce928a$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($0e19ff6696ce928a$var$FormDataCtor && thing instanceof $0e19ff6696ce928a$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $0e19ff6696ce928a$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$0e19ff6696ce928a$var$isFunction(thing.append)) return false;
    const kind = $0e19ff6696ce928a$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $0e19ff6696ce928a$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0e19ff6696ce928a$var$isURLSearchParams = $0e19ff6696ce928a$var$kindOfTest('URLSearchParams');
const [$0e19ff6696ce928a$var$isReadableStream, $0e19ff6696ce928a$var$isRequest, $0e19ff6696ce928a$var$isResponse, $0e19ff6696ce928a$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($0e19ff6696ce928a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0e19ff6696ce928a$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $0e19ff6696ce928a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0e19ff6696ce928a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($0e19ff6696ce928a$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $0e19ff6696ce928a$var$findKey(obj, key) {
    if ($0e19ff6696ce928a$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0e19ff6696ce928a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $0e19ff6696ce928a$var$isContextDefined = (context)=>!$0e19ff6696ce928a$var$isUndefined(context) && context !== $0e19ff6696ce928a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0e19ff6696ce928a$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $0e19ff6696ce928a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $0e19ff6696ce928a$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $0e19ff6696ce928a$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($0e19ff6696ce928a$var$isPlainObject(existing) && $0e19ff6696ce928a$var$isPlainObject(val)) result[targetKey] = $0e19ff6696ce928a$var$merge(existing, val);
        else if ($0e19ff6696ce928a$var$isPlainObject(val)) result[targetKey] = $0e19ff6696ce928a$var$merge({}, val);
        else if ($0e19ff6696ce928a$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$0e19ff6696ce928a$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $0e19ff6696ce928a$var$isBuffer(source)) continue;
        $0e19ff6696ce928a$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $0e19ff6696ce928a$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($0e19ff6696ce928a$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0e19ff6696ce928a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0e19ff6696ce928a$var$forEach(b, (val, key)=>{
        if (thisArg && $0e19ff6696ce928a$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $66H2k.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0e19ff6696ce928a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0e19ff6696ce928a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0e19ff6696ce928a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0e19ff6696ce928a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0e19ff6696ce928a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0e19ff6696ce928a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0e19ff6696ce928a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0e19ff6696ce928a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0e19ff6696ce928a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $0e19ff6696ce928a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0e19ff6696ce928a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$0e19ff6696ce928a$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0e19ff6696ce928a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0e19ff6696ce928a$var$isHTMLForm = $0e19ff6696ce928a$var$kindOfTest('HTMLFormElement');
const $0e19ff6696ce928a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $0e19ff6696ce928a$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0e19ff6696ce928a$var$isRegExp = $0e19ff6696ce928a$var$kindOfTest('RegExp');
const $0e19ff6696ce928a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0e19ff6696ce928a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0e19ff6696ce928a$var$freezeMethods = (obj)=>{
    $0e19ff6696ce928a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0e19ff6696ce928a$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$0e19ff6696ce928a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $0e19ff6696ce928a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0e19ff6696ce928a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0e19ff6696ce928a$var$noop = ()=>{};
const $0e19ff6696ce928a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0e19ff6696ce928a$var$isSpecCompliantForm(thing) {
    return !!(thing && $0e19ff6696ce928a$var$isFunction(thing.append) && thing[$0e19ff6696ce928a$var$toStringTag] === 'FormData' && thing[$0e19ff6696ce928a$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $0e19ff6696ce928a$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($0e19ff6696ce928a$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($0e19ff6696ce928a$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($0e19ff6696ce928a$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$0e19ff6696ce928a$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $0e19ff6696ce928a$var$isArray(source) ? [] : {};
                    $0e19ff6696ce928a$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$0e19ff6696ce928a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $0e19ff6696ce928a$var$isAsyncFn = $0e19ff6696ce928a$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $0e19ff6696ce928a$var$isThenable = (thing)=>thing && ($0e19ff6696ce928a$var$isObject(thing) || $0e19ff6696ce928a$var$isFunction(thing)) && $0e19ff6696ce928a$var$isFunction(thing.then) && $0e19ff6696ce928a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $0e19ff6696ce928a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0e19ff6696ce928a$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $0e19ff6696ce928a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0e19ff6696ce928a$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $0e19ff6696ce928a$var$isFunction($0e19ff6696ce928a$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $0e19ff6696ce928a$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($0e19ff6696ce928a$var$_global) : $0e19ff6696ce928a$var$_setImmediate;
// *********************
const $0e19ff6696ce928a$var$isIterable = (thing)=>thing != null && $0e19ff6696ce928a$var$isFunction(thing[$0e19ff6696ce928a$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $0e19ff6696ce928a$var$isSafeIterable = (thing)=>thing != null && $0e19ff6696ce928a$var$hasOwnInPrototypeChain(thing, $0e19ff6696ce928a$var$iterator) && $0e19ff6696ce928a$var$isIterable(thing);
var $0e19ff6696ce928a$export$2e2bcd8739ae039 = {
    isArray: $0e19ff6696ce928a$var$isArray,
    isArrayBuffer: $0e19ff6696ce928a$var$isArrayBuffer,
    isBuffer: $0e19ff6696ce928a$var$isBuffer,
    isFormData: $0e19ff6696ce928a$var$isFormData,
    isArrayBufferView: $0e19ff6696ce928a$var$isArrayBufferView,
    isString: $0e19ff6696ce928a$var$isString,
    isNumber: $0e19ff6696ce928a$var$isNumber,
    isBoolean: $0e19ff6696ce928a$var$isBoolean,
    isObject: $0e19ff6696ce928a$var$isObject,
    isPlainObject: $0e19ff6696ce928a$var$isPlainObject,
    isEmptyObject: $0e19ff6696ce928a$var$isEmptyObject,
    isReadableStream: $0e19ff6696ce928a$var$isReadableStream,
    isRequest: $0e19ff6696ce928a$var$isRequest,
    isResponse: $0e19ff6696ce928a$var$isResponse,
    isHeaders: $0e19ff6696ce928a$var$isHeaders,
    isUndefined: $0e19ff6696ce928a$var$isUndefined,
    isDate: $0e19ff6696ce928a$var$isDate,
    isFile: $0e19ff6696ce928a$var$isFile,
    isReactNativeBlob: $0e19ff6696ce928a$var$isReactNativeBlob,
    isReactNative: $0e19ff6696ce928a$var$isReactNative,
    isBlob: $0e19ff6696ce928a$var$isBlob,
    isRegExp: $0e19ff6696ce928a$var$isRegExp,
    isFunction: $0e19ff6696ce928a$var$isFunction,
    isStream: $0e19ff6696ce928a$var$isStream,
    isURLSearchParams: $0e19ff6696ce928a$var$isURLSearchParams,
    isTypedArray: $0e19ff6696ce928a$var$isTypedArray,
    isFileList: $0e19ff6696ce928a$var$isFileList,
    forEach: $0e19ff6696ce928a$var$forEach,
    merge: $0e19ff6696ce928a$var$merge,
    extend: $0e19ff6696ce928a$var$extend,
    trim: $0e19ff6696ce928a$var$trim,
    stripBOM: $0e19ff6696ce928a$var$stripBOM,
    inherits: $0e19ff6696ce928a$var$inherits,
    toFlatObject: $0e19ff6696ce928a$var$toFlatObject,
    kindOf: $0e19ff6696ce928a$var$kindOf,
    kindOfTest: $0e19ff6696ce928a$var$kindOfTest,
    endsWith: $0e19ff6696ce928a$var$endsWith,
    toArray: $0e19ff6696ce928a$var$toArray,
    forEachEntry: $0e19ff6696ce928a$var$forEachEntry,
    matchAll: $0e19ff6696ce928a$var$matchAll,
    isHTMLForm: $0e19ff6696ce928a$var$isHTMLForm,
    hasOwnProperty: $0e19ff6696ce928a$var$hasOwnProperty,
    hasOwnProp: $0e19ff6696ce928a$var$hasOwnProperty,
    hasOwnInPrototypeChain: $0e19ff6696ce928a$var$hasOwnInPrototypeChain,
    getSafeProp: $0e19ff6696ce928a$var$getSafeProp,
    reduceDescriptors: $0e19ff6696ce928a$var$reduceDescriptors,
    freezeMethods: $0e19ff6696ce928a$var$freezeMethods,
    toObjectSet: $0e19ff6696ce928a$var$toObjectSet,
    toCamelCase: $0e19ff6696ce928a$var$toCamelCase,
    noop: $0e19ff6696ce928a$var$noop,
    toFiniteNumber: $0e19ff6696ce928a$var$toFiniteNumber,
    findKey: $0e19ff6696ce928a$var$findKey,
    global: $0e19ff6696ce928a$var$_global,
    isContextDefined: $0e19ff6696ce928a$var$isContextDefined,
    isSpecCompliantForm: $0e19ff6696ce928a$var$isSpecCompliantForm,
    toJSONObject: $0e19ff6696ce928a$var$toJSONObject,
    isAsyncFn: $0e19ff6696ce928a$var$isAsyncFn,
    isThenable: $0e19ff6696ce928a$var$isThenable,
    setImmediate: $0e19ff6696ce928a$var$_setImmediate,
    asap: $0e19ff6696ce928a$var$asap,
    isIterable: $0e19ff6696ce928a$var$isIterable,
    isSafeIterable: $0e19ff6696ce928a$var$isSafeIterable
};

});
parcelRegister("66H2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4724afcde421e793$export$2e2bcd8739ae039; });
'use strict';
function $4724afcde421e793$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("kx4G1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef2a8472a344663b$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $dM5qK = parcelRequire("dM5qK");

var $ajtzD = parcelRequire("ajtzD");

var $fA4rw = parcelRequire("fA4rw");

var $ifI1B = parcelRequire("ifI1B");

var $aC2nR = parcelRequire("aC2nR");

var $6vVrp = parcelRequire("6vVrp");

var $fcwQ6 = parcelRequire("fcwQ6");

var $YSmbN = parcelRequire("YSmbN");
'use strict';
const $ef2a8472a344663b$var$validators = (0, $6vVrp.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $ef2a8472a344663b$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $ajtzD.default)(),
            response: new (0, $ajtzD.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ifI1B.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $6vVrp.default).assertOptions(transitional, {
            silentJSONParsing: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean),
            forcedJSONParsing: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean),
            clarifyTimeoutError: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean),
            legacyInterceptorReqResOrdering: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean),
            advertiseZstdAcceptEncoding: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean),
            validateStatusUndefinedResolves: $ef2a8472a344663b$var$validators.transitional($ef2a8472a344663b$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $1d3Re.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $6vVrp.default).assertOptions(paramsSerializer, {
                encode: $ef2a8472a344663b$var$validators.function,
                serialize: $ef2a8472a344663b$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $6vVrp.default).assertOptions(config, {
            baseUrl: $ef2a8472a344663b$var$validators.spelling('baseURL'),
            withXsrfToken: $ef2a8472a344663b$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $1d3Re.default).merge(headers.common, headers[config.method]);
        headers && (0, $1d3Re.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $fcwQ6.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $YSmbN.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $fA4rw.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $1d3Re.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $fA4rw.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $fA4rw.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ifI1B.default)(this.defaults, config);
        const fullPath = (0, $aC2nR.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $dM5qK.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $1d3Re.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $ef2a8472a344663b$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ifI1B.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $1d3Re.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $1d3Re.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ifI1B.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $ef2a8472a344663b$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $ef2a8472a344663b$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $ef2a8472a344663b$export$2e2bcd8739ae039 = $ef2a8472a344663b$var$Axios;

});
parcelRegister("dM5qK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a073f86c4f2af302$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $fq8ZW = parcelRequire("fq8ZW");
'use strict';
function $a073f86c4f2af302$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $a073f86c4f2af302$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $1d3Re.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $1d3Re.default).getSafeProp(_options, 'encode') || $a073f86c4f2af302$export$c564cdbbe6da493;
    const serializeFn = (0, $1d3Re.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $1d3Re.default).isURLSearchParams(params) ? params.toString() : new (0, $fq8ZW.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("fq8ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3a04387b01ce0d5$export$2e2bcd8739ae039; });

var $k00R5 = parcelRequire("k00R5");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $b3a04387b01ce0d5$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $b3a04387b01ce0d5$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $k00R5.default)(params, this, options);
}
const $b3a04387b01ce0d5$var$prototype = $b3a04387b01ce0d5$var$AxiosURLSearchParams.prototype;
$b3a04387b01ce0d5$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$b3a04387b01ce0d5$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $b3a04387b01ce0d5$var$encode) : $b3a04387b01ce0d5$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $b3a04387b01ce0d5$export$2e2bcd8739ae039 = $b3a04387b01ce0d5$var$AxiosURLSearchParams;

});
parcelRegister("k00R5", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $e8f47895b6fb86e6$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $e8f47895b6fb86e6$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $3FHb3 = parcelRequire("3FHb3");

var $1eVVT = parcelRequire("1eVVT");

var $1eVVT = parcelRequire("1eVVT");
'use strict';
const $e8f47895b6fb86e6$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e8f47895b6fb86e6$var$isVisitable(thing) {
    return (0, $1d3Re.default).isPlainObject(thing) || (0, $1d3Re.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e8f47895b6fb86e6$var$removeBrackets(key) {
    return (0, $1d3Re.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e8f47895b6fb86e6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e8f47895b6fb86e6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e8f47895b6fb86e6$var$isFlatArray(arr) {
    return (0, $1d3Re.default).isArray(arr) && !arr.some($e8f47895b6fb86e6$var$isVisitable);
}
const $e8f47895b6fb86e6$var$predicates = (0, $1d3Re.default).toFlatObject((0, $1d3Re.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e8f47895b6fb86e6$var$toFormData(obj, formData, options) {
    if (!(0, $1d3Re.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $1eVVT.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $1d3Re.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $1d3Re.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $e8f47895b6fb86e6$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $1d3Re.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $1d3Re.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $1d3Re.default).isDate(value)) return value.toISOString();
        if ((0, $1d3Re.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $1d3Re.default).isBlob(value)) throw new (0, $3FHb3.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $1d3Re.default).isArrayBuffer(value) || (0, $1d3Re.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $1eVVT.default) && (0, $1eVVT.default).isBufferAvailable()) return (0, $1eVVT.default).from(value);
            throw new (0, $3FHb3.default)('Blob is not supported. Use a Buffer instead.', (0, $3FHb3.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $3FHb3.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $3FHb3.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $1d3Re.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $1d3Re.default).isReactNative(formData) && (0, $1d3Re.default).isReactNativeBlob(value)) {
            formData.append($e8f47895b6fb86e6$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $1d3Re.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $1d3Re.default).isArray(value) && $e8f47895b6fb86e6$var$isFlatArray(value) || ((0, $1d3Re.default).isFileList(value) || (0, $1d3Re.default).endsWith(key, '[]')) && (arr = (0, $1d3Re.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e8f47895b6fb86e6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $1d3Re.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e8f47895b6fb86e6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($e8f47895b6fb86e6$var$isVisitable(value)) return true;
        formData.append($e8f47895b6fb86e6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($e8f47895b6fb86e6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e8f47895b6fb86e6$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $1d3Re.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $1d3Re.default).forEach(value, function each(el, key) {
            const result = !((0, $1d3Re.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $1d3Re.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $1d3Re.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $e8f47895b6fb86e6$export$2e2bcd8739ae039 = $e8f47895b6fb86e6$var$toFormData;

});
parcelRegister("3FHb3", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $2ac6b187c4c24999$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "default", function () { return $2ac6b187c4c24999$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $fcwQ6 = parcelRequire("fcwQ6");
'use strict';
const $2ac6b187c4c24999$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $2ac6b187c4c24999$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $1d3Re.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $1d3Re.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $2ac6b187c4c24999$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $1d3Re.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $fcwQ6.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $1d3Re.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $1d3Re.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $1d3Re.default).isPlainObject(source) && $2ac6b187c4c24999$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $2ac6b187c4c24999$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $1d3Re.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $2ac6b187c4c24999$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $2ac6b187c4c24999$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $2ac6b187c4c24999$var$stringifySafely(entry.message) : $2ac6b187c4c24999$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $2ac6b187c4c24999$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $1d3Re.default).isArray(error.errors) && error.errors.length) message = $2ac6b187c4c24999$var$aggregateErrorMessage(error);
        const axiosError = new $2ac6b187c4c24999$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $1d3Re.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $1d3Re.default).isArray(redactKeys) && redactKeys.length > 0 ? $2ac6b187c4c24999$var$redactConfig(config, redactKeys) : (0, $1d3Re.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$2ac6b187c4c24999$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$2ac6b187c4c24999$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$2ac6b187c4c24999$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$2ac6b187c4c24999$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$2ac6b187c4c24999$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$2ac6b187c4c24999$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$2ac6b187c4c24999$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$2ac6b187c4c24999$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$2ac6b187c4c24999$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$2ac6b187c4c24999$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$2ac6b187c4c24999$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$2ac6b187c4c24999$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$2ac6b187c4c24999$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$2ac6b187c4c24999$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $2ac6b187c4c24999$export$2e2bcd8739ae039 = $2ac6b187c4c24999$var$AxiosError;

});
parcelRegister("fcwQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11173346a82bac6$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $ac8fv = parcelRequire("ac8fv");

var $f1WWn = parcelRequire("f1WWn");
'use strict';
const $b11173346a82bac6$var$$internals = Symbol('internals');
function $b11173346a82bac6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $b11173346a82bac6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $1d3Re.default).isArray(value) ? value.map($b11173346a82bac6$var$normalizeValue) : (0, $f1WWn.sanitizeHeaderValue)(String(value));
}
function $b11173346a82bac6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $b11173346a82bac6$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $b11173346a82bac6$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $b11173346a82bac6$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $b11173346a82bac6$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $b11173346a82bac6$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $b11173346a82bac6$var$trimOWS(part.slice(0, equals));
        if (!$b11173346a82bac6$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $b11173346a82bac6$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $b11173346a82bac6$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $b11173346a82bac6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $b11173346a82bac6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $1d3Re.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $1d3Re.default).isString(value)) return;
    if ((0, $1d3Re.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $1d3Re.default).isRegExp(filter)) return filter.test(value);
}
function $b11173346a82bac6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $b11173346a82bac6$var$buildAccessors(obj, header) {
    const accessorName = (0, $1d3Re.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $b11173346a82bac6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $b11173346a82bac6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $1d3Re.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $b11173346a82bac6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $1d3Re.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $1d3Re.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $1d3Re.default).isString(header) && (header = header.trim()) && !$b11173346a82bac6$var$isValidHeaderName(header)) setHeaders((0, $ac8fv.default)(header), valueOrRewrite);
        else if ((0, $1d3Re.default).isObject(header) && (0, $1d3Re.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $1d3Re.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $1d3Re.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $1d3Re.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $b11173346a82bac6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1d3Re.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $b11173346a82bac6$var$parseTokens(value);
                if ((0, $1d3Re.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $1d3Re.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $b11173346a82bac6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $1d3Re.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $b11173346a82bac6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $b11173346a82bac6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $1d3Re.default).findKey(self, _header);
                if (key && (!matcher || $b11173346a82bac6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $1d3Re.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $b11173346a82bac6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $1d3Re.default).forEach(this, (value, header)=>{
            const key = (0, $1d3Re.default).findKey(headers, header);
            if (key) {
                self[key] = $b11173346a82bac6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $b11173346a82bac6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $b11173346a82bac6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $1d3Re.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $1d3Re.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $1d3Re.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $b11173346a82bac6$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$b11173346a82bac6$var$$internals] = this[$b11173346a82bac6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $b11173346a82bac6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $b11173346a82bac6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $1d3Re.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$b11173346a82bac6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $1d3Re.default).reduceDescriptors($b11173346a82bac6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $1d3Re.default).freezeMethods($b11173346a82bac6$var$AxiosHeaders);
var $b11173346a82bac6$export$2e2bcd8739ae039 = $b11173346a82bac6$var$AxiosHeaders;

});
parcelRegister("ac8fv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76c16c7c6e2f3a0b$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $76c16c7c6e2f3a0b$var$ignoreDuplicateOf = (0, $1d3Re.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $76c16c7c6e2f3a0b$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $1d3Re.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $1d3Re.default).hasOwnProp($76c16c7c6e2f3a0b$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("f1WWn", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $af14ab62882a5e04$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $af14ab62882a5e04$export$c30c72bb7e677d54; });

var $1d3Re = parcelRequire("1d3Re");
'use strict';
function $af14ab62882a5e04$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $af14ab62882a5e04$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $af14ab62882a5e04$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $af14ab62882a5e04$var$sanitizeValue(value, invalidChars) {
    if ((0, $1d3Re.default).isArray(value)) return value.map((item)=>$af14ab62882a5e04$var$sanitizeValue(item, invalidChars));
    return $af14ab62882a5e04$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $af14ab62882a5e04$export$9e344cffce061a22 = (value)=>$af14ab62882a5e04$var$sanitizeValue(value, $af14ab62882a5e04$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $af14ab62882a5e04$export$59dd66c2a12d8f62 = (value)=>$af14ab62882a5e04$var$sanitizeValue(value, $af14ab62882a5e04$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $af14ab62882a5e04$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $1d3Re.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $af14ab62882a5e04$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("1eVVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e74097d710ad541$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $0e74097d710ad541$export$2e2bcd8739ae039 = null;

});




parcelRegister("ajtzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78229e76ef130ca2$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");
'use strict';
class $78229e76ef130ca2$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $1d3Re.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $78229e76ef130ca2$export$2e2bcd8739ae039 = $78229e76ef130ca2$var$InterceptorManager;

});

parcelRegister("fA4rw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b57daa0eb6fff525$export$2e2bcd8739ae039; });

var $WXAey = parcelRequire("WXAey");

var $2WjLv = parcelRequire("2WjLv");

var $iHD77 = parcelRequire("iHD77");

var $hTina = parcelRequire("hTina");

var $fcwQ6 = parcelRequire("fcwQ6");

var $ktrSD = parcelRequire("ktrSD");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $b57daa0eb6fff525$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $hTina.default)(null, config);
}
function $b57daa0eb6fff525$export$2e2bcd8739ae039(config) {
    $b57daa0eb6fff525$var$throwIfCancellationRequested(config);
    config.headers = (0, $fcwQ6.default).from(config.headers);
    // Transform request data
    config.data = (0, $WXAey.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $ktrSD.default).getAdapter(config.adapter || (0, $iHD77.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $b57daa0eb6fff525$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $WXAey.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $fcwQ6.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $2WjLv.default)(reason)) {
            $b57daa0eb6fff525$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $WXAey.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $fcwQ6.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("WXAey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b13a2eb5e8cfa20$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $iHD77 = parcelRequire("iHD77");

var $fcwQ6 = parcelRequire("fcwQ6");
'use strict';
function $0b13a2eb5e8cfa20$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $iHD77.default);
    const context = response || config;
    const headers = (0, $fcwQ6.default).from(context.headers);
    let data = context.data;
    (0, $1d3Re.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("iHD77", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9da955b84c617ae$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $3FHb3 = parcelRequire("3FHb3");

var $YSmbN = parcelRequire("YSmbN");

var $k00R5 = parcelRequire("k00R5");

var $jYOvN = parcelRequire("jYOvN");

var $4zKY2 = parcelRequire("4zKY2");

var $5lNfY = parcelRequire("5lNfY");
'use strict';
const $d9da955b84c617ae$var$own = (obj, key)=>obj != null && (0, $1d3Re.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $d9da955b84c617ae$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $1d3Re.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $1d3Re.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $d9da955b84c617ae$var$defaults = {
    transitional: (0, $YSmbN.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $1d3Re.default).isObject(data);
            if (isObjectPayload && (0, $1d3Re.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $1d3Re.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5lNfY.default)(data)) : data;
            if ((0, $1d3Re.default).isArrayBuffer(data) || (0, $1d3Re.default).isBuffer(data) || (0, $1d3Re.default).isStream(data) || (0, $1d3Re.default).isFile(data) || (0, $1d3Re.default).isBlob(data) || (0, $1d3Re.default).isReadableStream(data)) return data;
            if ((0, $1d3Re.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $1d3Re.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $d9da955b84c617ae$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $jYOvN.default)(data, formSerializer).toString();
                if ((isFileList = (0, $1d3Re.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $d9da955b84c617ae$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $k00R5.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $d9da955b84c617ae$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $d9da955b84c617ae$var$own(this, 'transitional') || $d9da955b84c617ae$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $d9da955b84c617ae$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $1d3Re.default).isResponse(data) || (0, $1d3Re.default).isReadableStream(data)) return data;
            if (data && (0, $1d3Re.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $d9da955b84c617ae$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $3FHb3.default).from(e, (0, $3FHb3.default).ERR_BAD_RESPONSE, this, null, $d9da955b84c617ae$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4zKY2.default).classes.FormData,
        Blob: (0, $4zKY2.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $1d3Re.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $d9da955b84c617ae$var$defaults.headers[method] = {};
});
var $d9da955b84c617ae$export$2e2bcd8739ae039 = $d9da955b84c617ae$var$defaults;

});
parcelRegister("YSmbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b6fc4db9f7c47b9$export$2e2bcd8739ae039; });
'use strict';
var $0b6fc4db9f7c47b9$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("jYOvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8bacd87a4db7d66$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $k00R5 = parcelRequire("k00R5");

var $4zKY2 = parcelRequire("4zKY2");
'use strict';
function $e8bacd87a4db7d66$export$2e2bcd8739ae039(data, options) {
    return (0, $k00R5.default)(data, new (0, $4zKY2.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $4zKY2.default).isNode && (0, $1d3Re.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("4zKY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $354edd09e762d271$export$2e2bcd8739ae039; });

var $iehVP = parcelRequire("iehVP");

var $fQNHH = parcelRequire("fQNHH");
var $354edd09e762d271$export$2e2bcd8739ae039 = {
    ...$fQNHH,
    ...(0, $iehVP.default)
};

});
parcelRegister("iehVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d45771a849cc851e$export$2e2bcd8739ae039; });

var $9MwXY = parcelRequire("9MwXY");

var $5AghO = parcelRequire("5AghO");

var $ie6BU = parcelRequire("ie6BU");
var $d45771a849cc851e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $9MwXY.default,
        FormData: $5AghO.default,
        Blob: $ie6BU.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("9MwXY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71f22b3174d236f5$export$2e2bcd8739ae039; });

var $fq8ZW = parcelRequire("fq8ZW");
'use strict';
var $71f22b3174d236f5$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $fq8ZW.default);

});

parcelRegister("5AghO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $410cf2a7214927e7$export$2e2bcd8739ae039; });
'use strict';
var $410cf2a7214927e7$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("ie6BU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d44ea97ad8096847$export$2e2bcd8739ae039; });
'use strict';
var $d44ea97ad8096847$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("fQNHH", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $b8a2447ad4f110a4$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $b8a2447ad4f110a4$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $b8a2447ad4f110a4$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $b8a2447ad4f110a4$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $b8a2447ad4f110a4$export$f710a83a91838a36; });
const $b8a2447ad4f110a4$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $b8a2447ad4f110a4$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $b8a2447ad4f110a4$export$c0bcc9250309d66 = $b8a2447ad4f110a4$export$c4996c4b7b93b0bf && (!$b8a2447ad4f110a4$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($b8a2447ad4f110a4$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $b8a2447ad4f110a4$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $b8a2447ad4f110a4$export$f710a83a91838a36 = $b8a2447ad4f110a4$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("5lNfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e551f3d17b00092$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $3FHb3 = parcelRequire("3FHb3");

var $k00R5 = parcelRequire("k00R5");
'use strict';
const $3e551f3d17b00092$var$MAX_DEPTH = (0, $k00R5.DEFAULT_FORM_DATA_MAX_DEPTH);
function $3e551f3d17b00092$var$throwIfDepthExceeded(index) {
    if (index > $3e551f3d17b00092$var$MAX_DEPTH) throw new (0, $3FHb3.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $3e551f3d17b00092$var$MAX_DEPTH, (0, $3FHb3.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $3e551f3d17b00092$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $3e551f3d17b00092$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $3e551f3d17b00092$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $3e551f3d17b00092$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $3e551f3d17b00092$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $1d3Re.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $1d3Re.default).hasOwnProp(target, name)) target[name] = (0, $1d3Re.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $1d3Re.default).hasOwnProp(target, name) || !(0, $1d3Re.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $1d3Re.default).isArray(target[name])) target[name] = $3e551f3d17b00092$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $1d3Re.default).isFormData(formData) && (0, $1d3Re.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $1d3Re.default).forEachEntry(formData, (name, value)=>{
            buildPath($3e551f3d17b00092$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $3e551f3d17b00092$export$2e2bcd8739ae039 = $3e551f3d17b00092$var$formDataToJSON;

});



parcelRegister("2WjLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2240548241d18947$export$2e2bcd8739ae039; });
'use strict';
function $2240548241d18947$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("hTina", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d065d328a0bc2442$export$2e2bcd8739ae039; });

var $3FHb3 = parcelRequire("3FHb3");
'use strict';
class $d065d328a0bc2442$var$CanceledError extends (0, $3FHb3.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $3FHb3.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $d065d328a0bc2442$export$2e2bcd8739ae039 = $d065d328a0bc2442$var$CanceledError;

});

parcelRegister("ktrSD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee7c2484f11b9635$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $1eVVT = parcelRequire("1eVVT");

var $rA93g = parcelRequire("rA93g");

var $bguav = parcelRequire("bguav");

var $3FHb3 = parcelRequire("3FHb3");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $ee7c2484f11b9635$var$knownAdapters = {
    http: (0, $1eVVT.default),
    xhr: (0, $rA93g.default),
    fetch: {
        get: $bguav.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $1d3Re.default).forEach($ee7c2484f11b9635$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $ee7c2484f11b9635$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $ee7c2484f11b9635$var$isResolvedHandle = (adapter)=>(0, $1d3Re.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $ee7c2484f11b9635$var$getAdapter(adapters, config) {
    adapters = (0, $1d3Re.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$ee7c2484f11b9635$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $ee7c2484f11b9635$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $3FHb3.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $1d3Re.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($ee7c2484f11b9635$var$renderReason).join('\n') : ' ' + $ee7c2484f11b9635$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $3FHb3.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $3FHb3.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $ee7c2484f11b9635$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $ee7c2484f11b9635$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $ee7c2484f11b9635$var$knownAdapters
};

});
parcelRegister("rA93g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $052e8f5fde8e0710$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $5mDmq = parcelRequire("5mDmq");

var $YSmbN = parcelRequire("YSmbN");

var $3FHb3 = parcelRequire("3FHb3");

var $hTina = parcelRequire("hTina");

var $de8Qe = parcelRequire("de8Qe");

var $4zKY2 = parcelRequire("4zKY2");

var $fcwQ6 = parcelRequire("fcwQ6");

var $jDLxo = parcelRequire("jDLxo");

var $fWbpu = parcelRequire("fWbpu");

var $f1WWn = parcelRequire("f1WWn");
const $052e8f5fde8e0710$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $052e8f5fde8e0710$export$2e2bcd8739ae039 = $052e8f5fde8e0710$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $fWbpu.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $fcwQ6.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $fcwQ6.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $5mDmq.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3FHb3.default)('Request aborted', (0, $3FHb3.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $3FHb3.default)(msg, (0, $3FHb3.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $YSmbN.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $3FHb3.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3FHb3.default).ETIMEDOUT : (0, $3FHb3.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $1d3Re.default).forEach((0, $f1WWn.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $1d3Re.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $jDLxo.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $jDLxo.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $hTina.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $de8Qe.default)(_config.url);
        if (protocol && !(0, $4zKY2.default).protocols.includes(protocol)) {
            reject(new (0, $3FHb3.default)('Unsupported protocol ' + protocol + ':', (0, $3FHb3.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("5mDmq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e7d8a053dd3d9b4$export$2e2bcd8739ae039; });

var $3FHb3 = parcelRequire("3FHb3");
'use strict';
function $3e7d8a053dd3d9b4$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3FHb3.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $3FHb3.default).ERR_BAD_REQUEST : (0, $3FHb3.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("de8Qe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a1370e3963983e5$export$2e2bcd8739ae039; });
'use strict';
function $9a1370e3963983e5$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("jDLxo", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $e4c688d2cf745f07$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $e4c688d2cf745f07$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $e4c688d2cf745f07$export$5d35863c355a22a9; });

var $1j7Nn = parcelRequire("1j7Nn");

var $ixJDd = parcelRequire("ixJDd");

var $1d3Re = parcelRequire("1d3Re");
const $e4c688d2cf745f07$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1j7Nn.default)(50, 250);
    return (0, $ixJDd.default)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $e4c688d2cf745f07$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $e4c688d2cf745f07$export$5d35863c355a22a9 = (fn, scheduler = (0, $1d3Re.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("1j7Nn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f3d9ccf001118a6$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0f3d9ccf001118a6$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0f3d9ccf001118a6$export$2e2bcd8739ae039 = $0f3d9ccf001118a6$var$speedometer;

});

parcelRegister("ixJDd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7feb4810e0b3849$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $d7feb4810e0b3849$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $d7feb4810e0b3849$export$2e2bcd8739ae039 = $d7feb4810e0b3849$var$throttle;

});


parcelRegister("fWbpu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a51f96f54f7237$export$2e2bcd8739ae039; });

var $4zKY2 = parcelRequire("4zKY2");

var $1d3Re = parcelRequire("1d3Re");

var $3FHb3 = parcelRequire("3FHb3");

var $eYxWl = parcelRequire("eYxWl");

var $hUzp9 = parcelRequire("hUzp9");

var $aC2nR = parcelRequire("aC2nR");

var $ifI1B = parcelRequire("ifI1B");

var $fcwQ6 = parcelRequire("fcwQ6");

var $gRUtv = parcelRequire("gRUtv");

var $dM5qK = parcelRequire("dM5qK");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b9a51f96f54f7237$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b9a51f96f54f7237$var$resolveConfig(config) {
    const newConfig = (0, $ifI1B.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $1d3Re.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $fcwQ6.default).from(headers);
    newConfig.url = (0, $dM5qK.default)((0, $aC2nR.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $1d3Re.default).getSafeProp(auth, 'username') || '';
        const password = (0, $1d3Re.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $b9a51f96f54f7237$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $3FHb3.default).from(e, (0, $3FHb3.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $1d3Re.default).isFormData(data)) {
        if ((0, $4zKY2.default).hasStandardBrowserEnv || (0, $4zKY2.default).hasStandardBrowserWebWorkerEnv || (0, $1d3Re.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $1d3Re.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $gRUtv.default)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4zKY2.default).hasStandardBrowserEnv) {
        if ((0, $1d3Re.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $eYxWl.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $hUzp9.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b9a51f96f54f7237$export$2e2bcd8739ae039 = $b9a51f96f54f7237$var$resolveConfig;

});
parcelRegister("eYxWl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae70ff0fed1947cf$export$2e2bcd8739ae039; });

var $4zKY2 = parcelRequire("4zKY2");
var $ae70ff0fed1947cf$export$2e2bcd8739ae039 = (0, $4zKY2.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $4zKY2.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $4zKY2.default).origin), (0, $4zKY2.default).navigator && /(msie|trident)/i.test((0, $4zKY2.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("hUzp9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0a32146bd08c5ca$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $4zKY2 = parcelRequire("4zKY2");
var $d0a32146bd08c5ca$export$2e2bcd8739ae039 = (0, $4zKY2.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $1d3Re.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $1d3Re.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $1d3Re.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $1d3Re.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("aC2nR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9f4d5f540e0694$export$2e2bcd8739ae039; });

var $3FHb3 = parcelRequire("3FHb3");

var $94dCg = parcelRequire("94dCg");

var $c7T9l = parcelRequire("c7T9l");
'use strict';
const $7b9f4d5f540e0694$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $7b9f4d5f540e0694$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $7b9f4d5f540e0694$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $7b9f4d5f540e0694$var$normalizeURLForProtocolCheck(url) {
    return $7b9f4d5f540e0694$var$stripLeadingC0ControlOrSpace(url).replace($7b9f4d5f540e0694$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $7b9f4d5f540e0694$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $3FHb3.REDACTED}`;
    });
}
function $7b9f4d5f540e0694$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $3FHb3.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $3FHb3.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$7b9f4d5f540e0694$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $7b9f4d5f540e0694$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $7b9f4d5f540e0694$var$normalizeURLForProtocolCheck(url);
        if ($7b9f4d5f540e0694$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $3FHb3.default)(`Invalid URL ${JSON.stringify($7b9f4d5f540e0694$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $3FHb3.default).ERR_INVALID_URL, config);
    }
}
function $7b9f4d5f540e0694$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $7b9f4d5f540e0694$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $94dCg.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $7b9f4d5f540e0694$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $c7T9l.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("94dCg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $699f0ca3eba0731c$export$2e2bcd8739ae039; });
'use strict';
function $699f0ca3eba0731c$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("c7T9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d40eb175651f2ad$export$2e2bcd8739ae039; });
'use strict';
function $8d40eb175651f2ad$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("ifI1B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d49bc7251c5b2767$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");

var $fcwQ6 = parcelRequire("fcwQ6");
'use strict';
const $d49bc7251c5b2767$var$headersToObject = (thing)=>thing instanceof (0, $fcwQ6.default) ? {
        ...thing
    } : thing;
const $d49bc7251c5b2767$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $d49bc7251c5b2767$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $1d3Re.default).isPlainObject(target) && (0, $1d3Re.default).isPlainObject(source)) return (0, $1d3Re.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $1d3Re.default).isPlainObject(source)) return (0, $1d3Re.default).merge({}, source);
        else if ((0, $1d3Re.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $1d3Re.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $1d3Re.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $1d3Re.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $1d3Re.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $1d3Re.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $1d3Re.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $1d3Re.default).isUndefined(transitional2)) {
            if ((0, $1d3Re.default).isPlainObject(transitional2)) {
                if ((0, $1d3Re.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $1d3Re.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $1d3Re.default).isPlainObject(transitional1) && (0, $1d3Re.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $1d3Re.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $1d3Re.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($d49bc7251c5b2767$var$headersToObject(a), $d49bc7251c5b2767$var$headersToObject(b), prop, true)
    };
    (0, $1d3Re.default).forEach($d49bc7251c5b2767$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $1d3Re.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $1d3Re.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $1d3Re.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $1d3Re.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $1d3Re.default).hasOwnProp(config2, 'validateStatus') && (0, $1d3Re.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $1d3Re.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("gRUtv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47d674ec5a0e60c$export$2e2bcd8739ae039; });
'use strict';
const $c47d674ec5a0e60c$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $c47d674ec5a0e60c$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($c47d674ec5a0e60c$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("bguav", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $8338972cdacf8f2f$export$3105c6651375d4fa; });

var $4zKY2 = parcelRequire("4zKY2");

var $1d3Re = parcelRequire("1d3Re");

var $3FHb3 = parcelRequire("3FHb3");

var $gQATJ = parcelRequire("gQATJ");

var $k35IX = parcelRequire("k35IX");

var $fcwQ6 = parcelRequire("fcwQ6");

var $jDLxo = parcelRequire("jDLxo");

var $fWbpu = parcelRequire("fWbpu");

var $5mDmq = parcelRequire("5mDmq");

var $fMaIs = parcelRequire("fMaIs");

var $3Xfy7 = parcelRequire("3Xfy7");

var $f1WWn = parcelRequire("f1WWn");
const $8338972cdacf8f2f$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $8338972cdacf8f2f$var$isFunction } = (0, $1d3Re.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $8338972cdacf8f2f$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $8338972cdacf8f2f$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $1d3Re.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $8338972cdacf8f2f$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $8338972cdacf8f2f$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $8338972cdacf8f2f$var$factory = (env)=>{
    const globalObject = (0, $1d3Re.default).global !== undefined && (0, $1d3Re.default).global !== null ? (0, $1d3Re.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $1d3Re.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $8338972cdacf8f2f$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $8338972cdacf8f2f$var$isFunction(Request);
    const isResponseSupported = $8338972cdacf8f2f$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $8338972cdacf8f2f$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $8338972cdacf8f2f$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $4zKY2.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $8338972cdacf8f2f$var$test(()=>(0, $1d3Re.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $3FHb3.default)(`Response type '${type}' is not supported`, (0, $3FHb3.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $1d3Re.default).isBlob(body)) return body.size;
        if ((0, $1d3Re.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $4zKY2.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $1d3Re.default).isArrayBufferView(body) || (0, $1d3Re.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $1d3Re.default).isURLSearchParams(body)) body = body + '';
        if ((0, $1d3Re.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $1d3Re.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $fWbpu.default)(config);
        const hasMaxContentLength = (0, $1d3Re.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $1d3Re.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $1d3Re.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $gQATJ.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $3FHb3.default)('Request body larger than maxBodyLength limit', (0, $3FHb3.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $1d3Re.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $1d3Re.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($8338972cdacf8f2f$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $4zKY2.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $8338972cdacf8f2f$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $8338972cdacf8f2f$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($8338972cdacf8f2f$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $fMaIs.default)(url);
                if (estimated > maxContentLength) throw new (0, $3FHb3.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3FHb3.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $1d3Re.default).isReadableStream(data) || (0, $1d3Re.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $k35IX.trackStream)(stream, $8338972cdacf8f2f$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $1d3Re.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $jDLxo.progressEventDecorator)(requestContentLength, (0, $jDLxo.progressEventReducer)((0, $jDLxo.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $3FHb3.default)('Stream request bodies are not supported by the current fetch implementation', (0, $3FHb3.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $1d3Re.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $1d3Re.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $3Xfy7.VERSION), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $f1WWn.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $fcwQ6.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $1d3Re.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $3FHb3.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3FHb3.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $1d3Re.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $jDLxo.progressEventDecorator)(responseContentLength, (0, $jDLxo.progressEventReducer)((0, $jDLxo.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $3FHb3.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3FHb3.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $k35IX.trackStream)(response.body, $8338972cdacf8f2f$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $1d3Re.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $3FHb3.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3FHb3.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $5mDmq.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $fcwQ6.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $3FHb3.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $3FHb3.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $3FHb3.default)('Network Error', (0, $3FHb3.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $3FHb3.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $8338972cdacf8f2f$var$seedCache = new Map();
const $8338972cdacf8f2f$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $8338972cdacf8f2f$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $8338972cdacf8f2f$var$factory(env));
        map = target;
    }
    return target;
};
const $8338972cdacf8f2f$var$adapter = $8338972cdacf8f2f$export$3105c6651375d4fa();
var $8338972cdacf8f2f$export$2e2bcd8739ae039 = $8338972cdacf8f2f$var$adapter;

});
parcelRegister("gQATJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c43e1fd66abdf88b$export$2e2bcd8739ae039; });

var $hTina = parcelRequire("hTina");

var $3FHb3 = parcelRequire("3FHb3");

var $1d3Re = parcelRequire("1d3Re");
const $c43e1fd66abdf88b$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $3FHb3.default) ? err : new (0, $hTina.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $3FHb3.default)(`timeout of ${timeout}ms exceeded`, (0, $3FHb3.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $1d3Re.default).asap(unsubscribe);
    return signal;
};
var $c43e1fd66abdf88b$export$2e2bcd8739ae039 = $c43e1fd66abdf88b$var$composeSignals;

});

parcelRegister("k35IX", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $e988872b013d582f$export$b0119225647bd83; });
const $e988872b013d582f$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $e988872b013d582f$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $e988872b013d582f$var$readStream(iterable))yield* $e988872b013d582f$export$71b051935044bd5d(chunk, chunkSize);
};
const $e988872b013d582f$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $e988872b013d582f$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $e988872b013d582f$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("fMaIs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7c3a6b5b2b0c358$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $b7c3a6b5b2b0c358$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $b7c3a6b5b2b0c358$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $b7c3a6b5b2b0c358$var$isHexDigit(str.charCodeAt(i + 1)) && $b7c3a6b5b2b0c358$var$isHexDigit(str.charCodeAt(i + 2));
const $b7c3a6b5b2b0c358$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $b7c3a6b5b2b0c358$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $b7c3a6b5b2b0c358$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $b7c3a6b5b2b0c358$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $b7c3a6b5b2b0c358$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $b7c3a6b5b2b0c358$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $b7c3a6b5b2b0c358$var$isPercentEncodedByte(body, i, len)) {
            code = $b7c3a6b5b2b0c358$var$hexValue(body.charCodeAt(i + 1)) * 16 + $b7c3a6b5b2b0c358$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($b7c3a6b5b2b0c358$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$b7c3a6b5b2b0c358$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $b7c3a6b5b2b0c358$var$estimateBase64BufferAllocation(body);
    return $b7c3a6b5b2b0c358$var$base64Bytes(significant);
};
const $b7c3a6b5b2b0c358$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $b7c3a6b5b2b0c358$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $b7c3a6b5b2b0c358$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $b7c3a6b5b2b0c358$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $b7c3a6b5b2b0c358$var$estimatePercentDecodedBase64Bytes);
}
function $b7c3a6b5b2b0c358$export$1f39e64b554a246f(url) {
    return $b7c3a6b5b2b0c358$var$estimateDataURLBytes(url, $b7c3a6b5b2b0c358$var$estimateBase64BufferAllocation);
}

});

parcelRegister("3Xfy7", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $2e12f18fb6d00eb5$export$a4ad2735b021c132; });
const $2e12f18fb6d00eb5$export$a4ad2735b021c132 = "1.19.0";

});




parcelRegister("6vVrp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be231ed094507f7$export$2e2bcd8739ae039; });

var $3Xfy7 = parcelRequire("3Xfy7");

var $3FHb3 = parcelRequire("3FHb3");
'use strict';
const $4be231ed094507f7$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $4be231ed094507f7$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $4be231ed094507f7$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $4be231ed094507f7$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $3Xfy7.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $3FHb3.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $3FHb3.default).ERR_DEPRECATED);
        if (version && !$4be231ed094507f7$var$deprecatedWarnings[opt]) {
            $4be231ed094507f7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$4be231ed094507f7$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $4be231ed094507f7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $3FHb3.default)('options must be an object', (0, $3FHb3.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3FHb3.default)('option ' + opt + ' must be ' + result, (0, $3FHb3.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3FHb3.default)('Unknown option ' + opt, (0, $3FHb3.default).ERR_BAD_OPTION);
    }
}
var $4be231ed094507f7$export$2e2bcd8739ae039 = {
    assertOptions: $4be231ed094507f7$var$assertOptions,
    validators: $4be231ed094507f7$var$validators
};

});


parcelRegister("jqOhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e257730babc7995a$export$2e2bcd8739ae039; });

var $hTina = parcelRequire("hTina");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $e257730babc7995a$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $hTina.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $e257730babc7995a$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $e257730babc7995a$export$2e2bcd8739ae039 = $e257730babc7995a$var$CancelToken;

});

parcelRegister("k8nYv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea8726e97f3b3d1c$export$2e2bcd8739ae039; });
'use strict';
function $ea8726e97f3b3d1c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("215ge", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177fc16e7cf6ce24$export$2e2bcd8739ae039; });

var $1d3Re = parcelRequire("1d3Re");
'use strict';
function $177fc16e7cf6ce24$export$2e2bcd8739ae039(payload) {
    return (0, $1d3Re.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("edCxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5a02df55116eb34$export$2e2bcd8739ae039; });
const $a5a02df55116eb34$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a5a02df55116eb34$var$HttpStatusCode).forEach(([key, value])=>{
    $a5a02df55116eb34$var$HttpStatusCode[value] = key;
});
var $a5a02df55116eb34$export$2e2bcd8739ae039 = $a5a02df55116eb34$var$HttpStatusCode;

});



parcelRegister("dfdi6", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function r(s) {
            if (t[s]) return t[s].exports;
            var n = t[s] = {
                i: s,
                l: !1,
                exports: {}
            };
            return e[s].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, s) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: s
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var s = Object.create(null);
            if (r.r(s), Object.defineProperty(s, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(s, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return s;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 11);
    }([
        function(e, t, r) {
            "use strict";
            const s = r(12);
            e.exports = function(e, ...t) {
                if (!e) {
                    if (1 === t.length && t[0] instanceof Error) throw t[0];
                    throw new s(t);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(12), o = r(29);
            let a, i;
            const l = {
                isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
            };
            t.version = o.version, t.defaults = {
                abortEarly: !0,
                allowUnknown: !1,
                cache: !0,
                context: null,
                convert: !0,
                dateFormat: "iso",
                errors: {
                    escapeHtml: !1,
                    label: "path",
                    language: null,
                    render: !0,
                    stack: !1,
                    wrap: {
                        label: '"',
                        array: "[]"
                    }
                },
                externals: !0,
                messages: {},
                nonEnumerables: !1,
                noDefaults: !1,
                presence: "optional",
                skipFunctions: !1,
                stripUnknown: !1,
                warnings: !1
            }, t.symbols = {
                any: Symbol.for("@hapi/joi/schema"),
                arraySingle: Symbol("arraySingle"),
                deepDefault: Symbol("deepDefault"),
                literal: Symbol("literal"),
                override: Symbol("override"),
                prefs: Symbol("prefs"),
                ref: Symbol("ref"),
                values: Symbol("values"),
                template: Symbol("template")
            }, t.assertOptions = function(e, t, r = "Options") {
                s(e && "object" == typeof e && !Array.isArray(e), "Options must be of type object");
                const n = Object.keys(e).filter((e)=>!t.includes(e));
                s(0 === n.length, "".concat(r, " contain unknown keys: ").concat(n));
            }, t.checkPreferences = function(e) {
                i = i || r(16);
                const t = i.preferences.validate(e);
                if (t.error) throw new n([
                    t.error.details[0].message
                ]);
            }, t.compare = function(e, t, r) {
                switch(r){
                    case "=":
                        return e === t;
                    case ">":
                        return e > t;
                    case "<":
                        return e < t;
                    case ">=":
                        return e >= t;
                    case "<=":
                        return e <= t;
                }
            }, t.default = function(e, t) {
                return void 0 === e ? t : e;
            }, t.isIsoDate = function(e) {
                return l.isoDate.test(e);
            }, t.isNumber = function(e) {
                return "number" == typeof e && !isNaN(e);
            }, t.isResolvable = function(e) {
                return !!e && (e[t.symbols.ref] || e[t.symbols.template]);
            }, t.isSchema = function(e, r = {}) {
                const n = e && e[t.symbols.any];
                return !!n && (s(r.legacy || n.version === t.version, "Cannot mix different versions of joi schemas"), !0);
            }, t.isValues = function(e) {
                return e[t.symbols.values];
            }, t.limit = function(e) {
                return Number.isSafeInteger(e) && e >= 0;
            }, t.preferences = function(e, s) {
                a = a || r(9), e = e || {}, s = s || {};
                const n = Object.assign({}, e, s);
                return s.errors && e.errors && (n.errors = Object.assign({}, e.errors, s.errors), n.errors.wrap = Object.assign({}, e.errors.wrap, s.errors.wrap)), s.messages && (n.messages = a.compile(s.messages, e.messages)), delete n[t.symbols.prefs], n;
            }, t.tryWithPath = function(e, t, r = {}) {
                try {
                    return e();
                } catch (e) {
                    throw void 0 !== e.path ? e.path = t + "." + e.path : e.path = t, r.append && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
                }
            }, t.validateArg = function(e, r, { assert: s, message: n }) {
                if (t.isSchema(s)) {
                    const t = s.validate(e);
                    if (!t.error) return;
                    return t.error.message;
                }
                if (!s(e)) return r ? "".concat(r, " ").concat(n) : n;
            }, t.verifyFlat = function(e, t) {
                for (const r of e)s(!Array.isArray(r), "Method no longer accepts array arguments:", t);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(6), n = r(13), o = r(14), a = {
                needsProtoHack: new Set([
                    n.set,
                    n.map,
                    n.weakSet,
                    n.weakMap
                ])
            };
            e.exports = a.clone = function(e, t = {}, r = null) {
                if ("object" != typeof e || null === e) return e;
                let s = a.clone, i = r;
                if (t.shallow) {
                    if (!0 !== t.shallow) return a.cloneWithShallow(e, t);
                    s = (e)=>e;
                } else if (i) {
                    const t = i.get(e);
                    if (t) return t;
                } else i = new Map;
                const l = n.getInternalProto(e);
                if (l === n.buffer) return !1;
                if (l === n.date) return new Date(e.getTime());
                if (l === n.regex) return new RegExp(e);
                const c = a.base(e, l, t);
                if (c === e) return e;
                if (i && i.set(e, c), l === n.set) for (const r of e)c.add(s(r, t, i));
                else if (l === n.map) for (const [r, n] of e)c.set(r, s(n, t, i));
                const u = o.keys(e, t);
                for (const r of u){
                    if ("__proto__" === r) continue;
                    if (l === n.array && "length" === r) {
                        c.length = e.length;
                        continue;
                    }
                    const o = Object.getOwnPropertyDescriptor(e, r);
                    o ? o.get || o.set ? Object.defineProperty(c, r, o) : o.enumerable ? c[r] = s(e[r], t, i) : Object.defineProperty(c, r, {
                        enumerable: !1,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, i)
                    }) : Object.defineProperty(c, r, {
                        enumerable: !0,
                        writable: !0,
                        configurable: !0,
                        value: s(e[r], t, i)
                    });
                }
                return c;
            }, a.cloneWithShallow = function(e, t) {
                const r = t.shallow;
                (t = Object.assign({}, t)).shallow = !1;
                const n = new Map;
                for (const t of r){
                    const r = s(e, t);
                    "object" != typeof r && "function" != typeof r || n.set(r, r);
                }
                return a.clone(e, t, n);
            }, a.base = function(e, t, r) {
                if (!1 === r.prototype) return a.needsProtoHack.has(t) ? new t.constructor : t === n.array ? [] : {};
                const s = Object.getPrototypeOf(e);
                if (s && s.isImmutable) return e;
                if (t === n.array) {
                    const e = [];
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                if (a.needsProtoHack.has(t)) {
                    const e = new s.constructor;
                    return s !== t && Object.setPrototypeOf(e, s), e;
                }
                return Object.create(s);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(34), o = r(1), a = r(9);
            e.exports = n.extend({
                type: "any",
                flags: {
                    only: {
                        default: !1
                    }
                },
                terms: {
                    alterations: {
                        init: null
                    },
                    examples: {
                        init: null
                    },
                    externals: {
                        init: null
                    },
                    metas: {
                        init: []
                    },
                    notes: {
                        init: []
                    },
                    shared: {
                        init: null
                    },
                    tags: {
                        init: []
                    },
                    whens: {
                        init: null
                    }
                },
                rules: {
                    custom: {
                        method (e, t) {
                            return s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this.$_addRule({
                                name: "custom",
                                args: {
                                    method: e,
                                    description: t
                                }
                            });
                        },
                        validate (e, t, { method: r }) {
                            try {
                                return r(e, t);
                            } catch (e) {
                                return t.error("any.custom", {
                                    error: e
                                });
                            }
                        },
                        args: [
                            "method",
                            "description"
                        ],
                        multi: !0
                    },
                    messages: {
                        method (e) {
                            return this.prefs({
                                messages: e
                            });
                        }
                    },
                    shared: {
                        method (e) {
                            s(o.isSchema(e) && e._flags.id, "Schema must be a schema with an id");
                            const t = this.clone();
                            return t.$_terms.shared = t.$_terms.shared || [], t.$_terms.shared.push(e), t.$_mutateRegister(e), t;
                        }
                    },
                    warning: {
                        method (e, t) {
                            return s(e && "string" == typeof e, "Invalid warning code"), this.$_addRule({
                                name: "warning",
                                args: {
                                    code: e,
                                    local: t
                                },
                                warn: !0
                            });
                        },
                        validate: (e, t, { code: r, local: s })=>t.error(r, s),
                        args: [
                            "code",
                            "local"
                        ],
                        multi: !0
                    }
                },
                modifiers: {
                    keep (e, t = !0) {
                        e.keep = t;
                    },
                    message (e, t) {
                        e.message = a.compile(t);
                    },
                    warn (e, t = !0) {
                        e.warn = t;
                    }
                },
                manifest: {
                    build (e, t) {
                        for(const r in t){
                            const s = t[r];
                            if ([
                                "examples",
                                "externals",
                                "metas",
                                "notes",
                                "tags"
                            ].includes(r)) for (const t of s)e = e[r.slice(0, -1)](t);
                            else if ("alterations" !== r) {
                                if ("whens" !== r) {
                                    if ("shared" === r) for (const t of s)e = e.shared(t);
                                } else for (const t of s){
                                    const { ref: r, is: s, not: n, then: o, otherwise: a, concat: i } = t;
                                    e = i ? e.concat(i) : r ? e.when(r, {
                                        is: s,
                                        not: n,
                                        then: o,
                                        otherwise: a,
                                        switch: t.switch,
                                        break: t.break
                                    }) : e.when(s, {
                                        then: o,
                                        otherwise: a,
                                        break: t.break
                                    });
                                }
                            } else {
                                const t = {};
                                for (const { target: e, adjuster: r } of s)t[e] = r;
                                e = e.alter(t);
                            }
                        }
                        return e;
                    }
                },
                messages: {
                    "any.custom": "{{#label}} failed custom validation because {{#error.message}}",
                    "any.default": "{{#label}} threw an error when running default method",
                    "any.failover": "{{#label}} threw an error when running failover method",
                    "any.invalid": "{{#label}} contains an invalid value",
                    "any.only": '{{#label}} must be {if(#valids.length == 1, "", "one of ")}{{#valids}}',
                    "any.ref": '{{#label}} {{#arg}} references "{{#ref}}" which {{#reason}}',
                    "any.required": "{{#label}} is required",
                    "any.unknown": "{{#label}} is not allowed"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(32), n = r(1), o = r(7);
            t.Report = class {
                constructor(e, r, s, n, o, a, i){
                    if (this.code = e, this.flags = n, this.messages = o, this.path = a.path, this.prefs = i, this.state = a, this.value = r, this.message = null, this.template = null, this.local = s || {}, this.local.label = t.label(this.flags, this.state, this.prefs, this.messages), void 0 === this.value || this.local.hasOwnProperty("value") || (this.local.value = this.value), this.path.length) {
                        const e = this.path[this.path.length - 1];
                        "object" != typeof e && (this.local.key = e);
                    }
                }
                _setTemplate(e) {
                    if (this.template = e, !this.flags.label && 0 === this.path.length) {
                        const e = this._template(this.template, "root");
                        e && (this.local.label = e);
                    }
                }
                toString() {
                    if (this.message) return this.message;
                    const e = this.code;
                    if (!this.prefs.errors.render) return this.code;
                    const t = this._template(this.template) || this._template(this.prefs.messages) || this._template(this.messages);
                    return void 0 === t ? 'Error code "'.concat(e, '" is not defined, your custom type is missing the correct messages definition') : (this.message = t.render(this.value, this.state, this.prefs, this.local, {
                        errors: this.prefs.errors,
                        messages: [
                            this.prefs.messages,
                            this.messages
                        ]
                    }), this.prefs.errors.label || (this.message = this.message.replace(/^"" /, "").trim()), this.message);
                }
                _template(e, r) {
                    return t.template(this.value, e, r || this.code, this.state, this.prefs);
                }
            }, t.path = function(e) {
                let t = "";
                for (const r of e)"object" != typeof r && ("string" == typeof r ? (t && (t += "."), t += r) : t += "[".concat(r, "]"));
                return t;
            }, t.template = function(e, t, r, s, a) {
                if (!t) return;
                if (o.isTemplate(t)) return "root" !== r ? t : null;
                let i = a.errors.language;
                return n.isResolvable(i) && (i = i.resolve(e, s, a)), i && t[i] && void 0 !== t[i][r] ? t[i][r] : t[r];
            }, t.label = function(e, r, s, n) {
                if (e.label) return e.label;
                if (!s.errors.label) return "";
                let o = r.path;
                "key" === s.errors.label && r.path.length > 1 && (o = r.path.slice(-1));
                const a = t.path(o);
                return a || t.template(null, s.messages, "root", r, s) || n && t.template(null, n, "root", r, s) || "value";
            }, t.process = function(e, r, s) {
                if (!e) return null;
                const { override: n, message: o, details: a } = t.details(e);
                if (n) return n;
                if (s.errors.stack) return new t.ValidationError(o, a, r);
                const i = Error.stackTraceLimit;
                Error.stackTraceLimit = 0;
                const l = new t.ValidationError(o, a, r);
                return Error.stackTraceLimit = i, l;
            }, t.details = function(e, t = {}) {
                let r = [];
                const s = [];
                for (const n of e){
                    if (n instanceof Error) {
                        if (!1 !== t.override) return {
                            override: n
                        };
                        const e = n.toString();
                        r.push(e), s.push({
                            message: e,
                            type: "override",
                            context: {
                                error: n
                            }
                        });
                        continue;
                    }
                    const e = n.toString();
                    r.push(e), s.push({
                        message: e,
                        path: n.path.filter((e)=>"object" != typeof e),
                        type: n.code,
                        context: n.local
                    });
                }
                return r.length > 1 && (r = [
                    ...new Set(r)
                ]), {
                    message: r.join(". "),
                    details: s
                };
            }, t.ValidationError = class extends Error {
                constructor(e, t, r){
                    super(e), this._original = r, this.details = t;
                }
                static isError(e) {
                    return e instanceof t.ValidationError;
                }
            }, t.ValidationError.prototype.isJoi = !0, t.ValidationError.prototype.name = "ValidationError", t.ValidationError.prototype.annotate = s.error;
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(6), a = r(1);
            let i;
            const l = {
                symbol: Symbol("ref"),
                defaults: {
                    adjust: null,
                    in: !1,
                    iterables: null,
                    map: null,
                    separator: ".",
                    type: "value"
                }
            };
            t.create = function(e, t = {}) {
                s("string" == typeof e, "Invalid reference key:", e), a.assertOptions(t, [
                    "adjust",
                    "ancestor",
                    "in",
                    "iterables",
                    "map",
                    "prefix",
                    "separator"
                ]), s(!t.prefix || "object" == typeof t.prefix, "options.prefix must be of type object");
                const r = Object.assign({}, l.defaults, t);
                delete r.prefix;
                const n = r.separator, o = l.context(e, n, t.prefix);
                if (r.type = o.type, e = o.key, "value" === r.type) {
                    if (o.root && (s(!n || e[0] !== n, "Cannot specify relative path with root prefix"), r.ancestor = "root", e || (e = null)), n && n === e) e = null, r.ancestor = 0;
                    else if (void 0 !== r.ancestor) s(!n || !e || e[0] !== n, "Cannot combine prefix with ancestor option");
                    else {
                        const [t, s] = l.ancestor(e, n);
                        s && "" === (e = e.slice(s)) && (e = null), r.ancestor = t;
                    }
                }
                return r.path = n ? null === e ? [] : e.split(n) : [
                    e
                ], new l.Ref(r);
            }, t.in = function(e, r = {}) {
                return t.create(e, Object.assign({}, r, {
                    in: !0
                }));
            }, t.isRef = function(e) {
                return !!e && !!e[a.symbols.ref];
            }, l.Ref = class {
                constructor(e){
                    s("object" == typeof e, "Invalid reference construction"), a.assertOptions(e, [
                        "adjust",
                        "ancestor",
                        "in",
                        "iterables",
                        "map",
                        "path",
                        "separator",
                        "type",
                        "depth",
                        "key",
                        "root",
                        "display"
                    ]), s([
                        !1,
                        void 0
                    ].includes(e.separator) || "string" == typeof e.separator && 1 === e.separator.length, "Invalid separator"), s(!e.adjust || "function" == typeof e.adjust, "options.adjust must be a function"), s(!e.map || Array.isArray(e.map), "options.map must be an array"), s(!e.map || !e.adjust, "Cannot set both map and adjust options"), Object.assign(this, l.defaults, e), s("value" === this.type || void 0 === this.ancestor, "Non-value references cannot reference ancestors"), Array.isArray(this.map) && (this.map = new Map(this.map)), this.depth = this.path.length, this.key = this.path.length ? this.path.join(this.separator) : null, this.root = this.path[0], this.updateDisplay();
                }
                resolve(e, t, r, n, o = {}) {
                    return s(!this.in || o.in, "Invalid in() reference usage"), "global" === this.type ? this._resolve(r.context, t, o) : "local" === this.type ? this._resolve(n, t, o) : this.ancestor ? "root" === this.ancestor ? this._resolve(t.ancestors[t.ancestors.length - 1], t, o) : (s(this.ancestor <= t.ancestors.length, "Invalid reference exceeds the schema root:", this.display), this._resolve(t.ancestors[this.ancestor - 1], t, o)) : this._resolve(e, t, o);
                }
                _resolve(e, t, r) {
                    let s;
                    if ("value" === this.type && t.mainstay.shadow && !1 !== r.shadow && (s = t.mainstay.shadow.get(this.absolute(t))), void 0 === s && (s = o(e, this.path, {
                        iterables: this.iterables,
                        functions: !0
                    })), this.adjust && (s = this.adjust(s)), this.map) {
                        const e = this.map.get(s);
                        void 0 !== e && (s = e);
                    }
                    return t.mainstay && t.mainstay.tracer.resolve(t, this, s), s;
                }
                toString() {
                    return this.display;
                }
                absolute(e) {
                    return [
                        ...e.path.slice(0, -this.ancestor),
                        ...this.path
                    ];
                }
                clone() {
                    return new l.Ref(this);
                }
                describe() {
                    const e = {
                        path: this.path
                    };
                    "value" !== this.type && (e.type = this.type), "." !== this.separator && (e.separator = this.separator), "value" === this.type && 1 !== this.ancestor && (e.ancestor = this.ancestor), this.map && (e.map = [
                        ...this.map
                    ]);
                    for (const t of [
                        "adjust",
                        "iterables"
                    ])null !== this[t] && (e[t] = this[t]);
                    return !1 !== this.in && (e.in = !0), {
                        ref: e
                    };
                }
                updateDisplay() {
                    const e = null !== this.key ? this.key : "";
                    if ("value" !== this.type) return void (this.display = "ref:".concat(this.type, ":").concat(e));
                    if (!this.separator) return void (this.display = "ref:".concat(e));
                    if (!this.ancestor) return void (this.display = "ref:".concat(this.separator).concat(e));
                    if ("root" === this.ancestor) return void (this.display = "ref:root:".concat(e));
                    if (1 === this.ancestor) return void (this.display = "ref:".concat(e || ".."));
                    const t = new Array(this.ancestor + 1).fill(this.separator).join("");
                    this.display = "ref:".concat(t).concat(e || "");
                }
            }, l.Ref.prototype[a.symbols.ref] = !0, t.build = function(e) {
                return "value" === (e = Object.assign({}, l.defaults, e)).type && void 0 === e.ancestor && (e.ancestor = 1), new l.Ref(e);
            }, l.context = function(e, t, r = {}) {
                if (e = e.trim(), r) {
                    const s = void 0 === r.global ? "$" : r.global;
                    if (s !== t && e.startsWith(s)) return {
                        key: e.slice(s.length),
                        type: "global"
                    };
                    const n = void 0 === r.local ? "#" : r.local;
                    if (n !== t && e.startsWith(n)) return {
                        key: e.slice(n.length),
                        type: "local"
                    };
                    const o = void 0 === r.root ? "/" : r.root;
                    if (o !== t && e.startsWith(o)) return {
                        key: e.slice(o.length),
                        type: "value",
                        root: !0
                    };
                }
                return {
                    key: e,
                    type: "value"
                };
            }, l.ancestor = function(e, t) {
                if (!t) return [
                    1,
                    0
                ];
                if (e[0] !== t) return [
                    1,
                    0
                ];
                if (e[1] !== t) return [
                    0,
                    1
                ];
                let r = 2;
                for(; e[r] === t;)++r;
                return [
                    r - 1,
                    r
                ];
            }, t.toSibling = 0, t.toParent = 1, t.Manager = class {
                constructor(){
                    this.refs = [];
                }
                register(e, s) {
                    if (e) {
                        if (s = void 0 === s ? t.toParent : s, Array.isArray(e)) for (const t of e)this.register(t, s);
                        else if (a.isSchema(e)) for (const t of e._refs.refs)t.ancestor - s >= 0 && this.refs.push({
                            ancestor: t.ancestor - s,
                            root: t.root
                        });
                        else t.isRef(e) && "value" === e.type && e.ancestor - s >= 0 && this.refs.push({
                            ancestor: e.ancestor - s,
                            root: e.root
                        }), i = i || r(7), i.isTemplate(e) && this.register(e.refs(), s);
                    }
                }
                get length() {
                    return this.refs.length;
                }
                clone() {
                    const e = new t.Manager;
                    return e.refs = n(this.refs), e;
                }
                reset() {
                    this.refs = [];
                }
                roots() {
                    return this.refs.filter((e)=>!e.ancestor).map((e)=>e.root);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = {};
            e.exports = function(e, t, r) {
                if (!1 === t || null == t) return e;
                "string" == typeof (r = r || {}) && (r = {
                    separator: r
                });
                const o = Array.isArray(t);
                s(!o || !r.separator, "Separator option no valid for array-based chain");
                const a = o ? t : t.split(r.separator || ".");
                let i = e;
                for(let e = 0; e < a.length; ++e){
                    let o = a[e];
                    const l = r.iterables && n.iterables(i);
                    if (Array.isArray(i) || "set" === l) {
                        const e = Number(o);
                        Number.isInteger(e) && (o = e < 0 ? i.length + e : e);
                    }
                    if (!i || "function" == typeof i && !1 === r.functions || !l && void 0 === i[o]) {
                        s(!r.strict || e + 1 === a.length, "Missing segment", o, "in reach path ", t), s("object" == typeof i || !0 === r.functions || "function" != typeof i, "Invalid segment", o, "in reach path ", t), i = r.default;
                        break;
                    }
                    i = l ? "set" === l ? [
                        ...i
                    ][o] : i.get(o) : i[o];
                }
                return i;
            }, n.iterables = function(e) {
                return e instanceof Set ? "set" : e instanceof Map ? "map" : void 0;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(30), a = r(31), i = r(1), l = r(4), c = r(5), u = {
                symbol: Symbol("template"),
                opens: new Array(1e3).join("\0"),
                closes: new Array(1e3).join(""),
                dateFormat: {
                    date: Date.prototype.toDateString,
                    iso: Date.prototype.toISOString,
                    string: Date.prototype.toString,
                    time: Date.prototype.toTimeString,
                    utc: Date.prototype.toUTCString
                }
            };
            e.exports = u.Template = class {
                constructor(e, t){
                    s("string" == typeof e, "Template source must be a string"), s(!e.includes("\0") && !e.includes(""), "Template source cannot contain reserved control characters"), this.source = e, this.rendered = e, this._template = null, this._settings = n(t), this._parse();
                }
                _parse() {
                    if (!this.source.includes("{")) return;
                    const e = u.encode(this.source), t = u.split(e);
                    let r = !1;
                    const s = [], n = t.shift();
                    n && s.push(n);
                    for (const e of t){
                        const t = "{" !== e[0], n = t ? "}" : "}}", o = e.indexOf(n);
                        if (-1 === o || "{" === e[1]) {
                            s.push("{".concat(u.decode(e)));
                            continue;
                        }
                        const a = e.slice(t ? 0 : 1, o), i = this._ref(u.decode(a), t);
                        s.push(i), "string" != typeof i && (r = !0);
                        const l = e.slice(o + n.length);
                        l && s.push(u.decode(l));
                    }
                    r ? this._template = s : this.rendered = s.join("");
                }
                static date(e, t) {
                    return u.dateFormat[t.dateFormat].call(e);
                }
                describe(e = {}) {
                    if (!this._settings && e.compact) return this.source;
                    const t = {
                        template: this.source
                    };
                    return this._settings && (t.options = this._settings), t;
                }
                static build(e) {
                    return new u.Template(e.template, e.options);
                }
                isDynamic() {
                    return !!this._template;
                }
                static isTemplate(e) {
                    return !!e && !!e[i.symbols.template];
                }
                refs() {
                    if (!this._template) return;
                    const e = [];
                    for (const t of this._template)"string" != typeof t && e.push(...t.refs);
                    return e;
                }
                resolve(e, t, r, s) {
                    return this._template && 1 === this._template.length ? this._part(this._template[0], e, t, r, s, {}) : this.render(e, t, r, s);
                }
                _part(e, ...t) {
                    return e.ref ? e.ref.resolve(...t) : e.formula.evaluate(t);
                }
                render(e, t, r, s, n = {}) {
                    if (!this.isDynamic()) return this.rendered;
                    const a = [];
                    for (const i of this._template)if ("string" == typeof i) a.push(i);
                    else {
                        const l = this._part(i, e, t, r, s, n), c = u.stringify(l, r, n.errors);
                        if (void 0 !== c) {
                            const e = i.raw || !1 === (n.errors && n.errors.escapeHtml) ? c : o(c), t = i.ref && "local" === i.ref.type && "label" === i.ref.key && r.errors.wrap.label;
                            a.push(u.wrap(e, t));
                        }
                    }
                    return a.join("");
                }
                _ref(e, t) {
                    const r = [], s = (e)=>{
                        const t = c.create(e, this._settings);
                        return r.push(t), (e)=>t.resolve(...e);
                    };
                    try {
                        var n = new a.Parser(e, {
                            reference: s,
                            functions: u.functions,
                            constants: u.constants
                        });
                    } catch (t) {
                        throw t.message = 'Invalid template variable "'.concat(e, '" fails due to: ').concat(t.message), t;
                    }
                    return n.single ? "reference" === n.single.type ? {
                        ref: r[0],
                        raw: t,
                        refs: r
                    } : u.stringify(n.single.value) : {
                        formula: n,
                        raw: t,
                        refs: r
                    };
                }
                toString() {
                    return this.source;
                }
            }, u.Template.prototype[i.symbols.template] = !0, u.Template.prototype.isImmutable = !0, u.encode = function(e) {
                return e.replace(/\\(\{+)/g, (e, t)=>u.opens.slice(0, t.length)).replace(/\\(\}+)/g, (e, t)=>u.closes.slice(0, t.length));
            }, u.decode = function(e) {
                return e.replace(/\u0000/g, "{").replace(/\u0001/g, "}");
            }, u.split = function(e) {
                const t = [];
                let r = "";
                for(let s = 0; s < e.length; ++s){
                    const n = e[s];
                    if ("{" === n) {
                        let n = "";
                        for(; s + 1 < e.length && "{" === e[s + 1];)n += "{", ++s;
                        t.push(r), r = n;
                    } else r += n;
                }
                return t.push(r), t;
            }, u.wrap = function(e, t) {
                return t ? 1 === t.length ? "".concat(t).concat(e).concat(t) : "".concat(t[0]).concat(e).concat(t[1]) : e;
            }, u.stringify = function(e, t, r) {
                const s = typeof e;
                if (null === e) return "null";
                if ("string" === s) return e;
                if ("number" === s || "function" === s || "symbol" === s) return e.toString();
                if ("object" !== s) return JSON.stringify(e);
                if (e instanceof Date) return u.Template.date(e, t);
                if (e instanceof Map) {
                    const t = [];
                    for (const [r, s] of e.entries())t.push("".concat(r.toString(), " -> ").concat(s.toString()));
                    e = t;
                }
                if (!Array.isArray(e)) return e.toString();
                let n = "";
                for (const s of e)n = n + (n.length ? ", " : "") + u.stringify(s, t, r);
                return u.wrap(n, t.errors.wrap.array);
            }, u.constants = {
                true: !0,
                false: !1,
                null: null,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5
            }, u.functions = {
                if: (e, t, r)=>e ? t : r,
                msg (e) {
                    const [t, r, s, n, o] = this, a = o.messages;
                    if (!a) return "";
                    const i = l.template(t, a[0], e, r, s) || l.template(t, a[1], e, r, s);
                    return i ? i.render(t, r, s, n, o) : "";
                },
                number: (e)=>"number" == typeof e ? e : "string" == typeof e ? parseFloat(e) : "boolean" == typeof e ? e ? 1 : 0 : e instanceof Date ? e.getTime() : null
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(1), o = r(5), a = {};
            t.schema = function(e, t, r = {}) {
                n.assertOptions(r, [
                    "appendPath",
                    "override"
                ]);
                try {
                    return a.schema(e, t, r);
                } catch (e) {
                    throw r.appendPath && void 0 !== e.path && (e.message = "".concat(e.message, " (").concat(e.path, ")")), e;
                }
            }, a.schema = function(e, t, r) {
                s(void 0 !== t, "Invalid undefined schema"), Array.isArray(t) && (s(t.length, "Invalid empty array schema"), 1 === t.length && (t = t[0]));
                const o = (t, ...s)=>!1 !== r.override ? t.valid(e.override, ...s) : t.valid(...s);
                if (a.simple(t)) return o(e, t);
                if ("function" == typeof t) return e.custom(t);
                if (s("object" == typeof t, "Invalid schema content:", typeof t), n.isResolvable(t)) return o(e, t);
                if (n.isSchema(t)) return t;
                if (Array.isArray(t)) {
                    for (const r of t)if (!a.simple(r)) return e.alternatives().try(...t);
                    return o(e, ...t);
                }
                return t instanceof RegExp ? e.string().regex(t) : t instanceof Date ? o(e.date(), t) : (s(Object.getPrototypeOf(t) === Object.getPrototypeOf({}), "Schema can only contain plain objects"), e.object().keys(t));
            }, t.ref = function(e, t) {
                return o.isRef(e) ? e : o.create(e, t);
            }, t.compile = function(e, r, o = {}) {
                n.assertOptions(o, [
                    "legacy"
                ]);
                const i = r && r[n.symbols.any];
                if (i) return s(o.legacy || i.version === n.version, "Cannot mix different versions of joi schemas:", i.version, n.version), r;
                if ("object" != typeof r || !o.legacy) return t.schema(e, r, {
                    appendPath: !0
                });
                const l = a.walk(r);
                return l ? l.compile(l.root, r) : t.schema(e, r, {
                    appendPath: !0
                });
            }, a.walk = function(e) {
                if ("object" != typeof e) return null;
                if (Array.isArray(e)) {
                    for (const t of e){
                        const e = a.walk(t);
                        if (e) return e;
                    }
                    return null;
                }
                const t = e[n.symbols.any];
                if (t) return {
                    root: e[t.root],
                    compile: t.compile
                };
                s(Object.getPrototypeOf(e) === Object.getPrototypeOf({}), "Schema can only contain plain objects");
                for(const t in e){
                    const r = a.walk(e[t]);
                    if (r) return r;
                }
                return null;
            }, a.simple = function(e) {
                return null === e || [
                    "boolean",
                    "string",
                    "number"
                ].includes(typeof e);
            }, t.when = function(e, r, i) {
                if (void 0 === i && (s(r && "object" == typeof r, "Missing options"), i = r, r = o.create(".")), Array.isArray(i) && (i = {
                    switch: i
                }), n.assertOptions(i, [
                    "is",
                    "not",
                    "then",
                    "otherwise",
                    "switch",
                    "break"
                ]), n.isSchema(r)) return s(void 0 === i.is, '"is" can not be used with a schema condition'), s(void 0 === i.not, '"not" can not be used with a schema condition'), s(void 0 === i.switch, '"switch" can not be used with a schema condition'), a.condition(e, {
                    is: r,
                    then: i.then,
                    otherwise: i.otherwise,
                    break: i.break
                });
                if (s(o.isRef(r) || "string" == typeof r, "Invalid condition:", r), s(void 0 === i.not || void 0 === i.is, 'Cannot combine "is" with "not"'), void 0 === i.switch) {
                    let l = i;
                    void 0 !== i.not && (l = {
                        is: i.not,
                        then: i.otherwise,
                        otherwise: i.then,
                        break: i.break
                    });
                    let c = void 0 !== l.is ? e.$_compile(l.is) : e.$_root.invalid(null, !1, 0, "").required();
                    return s(void 0 !== l.then || void 0 !== l.otherwise, 'options must have at least one of "then", "otherwise", or "switch"'), s(void 0 === l.break || void 0 === l.then || void 0 === l.otherwise, "Cannot specify then, otherwise, and break all together"), void 0 === i.is || o.isRef(i.is) || n.isSchema(i.is) || (c = c.required()), a.condition(e, {
                        ref: t.ref(r),
                        is: c,
                        then: l.then,
                        otherwise: l.otherwise,
                        break: l.break
                    });
                }
                s(Array.isArray(i.switch), '"switch" must be an array'), s(void 0 === i.is, 'Cannot combine "switch" with "is"'), s(void 0 === i.not, 'Cannot combine "switch" with "not"'), s(void 0 === i.then, 'Cannot combine "switch" with "then"');
                const l = {
                    ref: t.ref(r),
                    switch: [],
                    break: i.break
                };
                for(let t = 0; t < i.switch.length; ++t){
                    const r = i.switch[t], a = t === i.switch.length - 1;
                    n.assertOptions(r, a ? [
                        "is",
                        "then",
                        "otherwise"
                    ] : [
                        "is",
                        "then"
                    ]), s(void 0 !== r.is, 'Switch statement missing "is"'), s(void 0 !== r.then, 'Switch statement missing "then"');
                    const c = {
                        is: e.$_compile(r.is),
                        then: e.$_compile(r.then)
                    };
                    if (o.isRef(r.is) || n.isSchema(r.is) || (c.is = c.is.required()), a) {
                        s(void 0 === i.otherwise || void 0 === r.otherwise, 'Cannot specify "otherwise" inside and outside a "switch"');
                        const t = void 0 !== i.otherwise ? i.otherwise : r.otherwise;
                        void 0 !== t && (s(void 0 === l.break, "Cannot specify both otherwise and break"), c.otherwise = e.$_compile(t));
                    }
                    l.switch.push(c);
                }
                return l;
            }, a.condition = function(e, t) {
                for (const r of [
                    "then",
                    "otherwise"
                ])void 0 === t[r] ? delete t[r] : t[r] = e.$_compile(t[r]);
                return t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(7);
            t.compile = function(e, t) {
                if ("string" == typeof e) return s(!t, "Cannot set single message string"), new o(e);
                if (o.isTemplate(e)) return s(!t, "Cannot set single message template"), e;
                s("object" == typeof e && !Array.isArray(e), "Invalid message options"), t = t ? n(t) : {};
                for(let r in e){
                    const n = e[r];
                    if ("root" === r || o.isTemplate(n)) {
                        t[r] = n;
                        continue;
                    }
                    if ("string" == typeof n) {
                        t[r] = new o(n);
                        continue;
                    }
                    s("object" == typeof n && !Array.isArray(n), "Invalid message for", r);
                    const a = r;
                    for(r in t[a] = t[a] || {}, n){
                        const e = n[r];
                        "root" === r || o.isTemplate(e) ? t[a][r] = e : (s("string" == typeof e, "Invalid message for", r, "in", a), t[a][r] = new o(e));
                    }
                }
                return t;
            }, t.decompile = function(e) {
                const t = {};
                for(let r in e){
                    const s = e[r];
                    if ("root" === r) {
                        t[r] = s;
                        continue;
                    }
                    if (o.isTemplate(s)) {
                        t[r] = s.describe({
                            compact: !0
                        });
                        continue;
                    }
                    const n = r;
                    for(r in t[n] = {}, s){
                        const e = s[r];
                        "root" !== r ? t[n][r] = e.describe({
                            compact: !0
                        }) : t[n][r] = e;
                    }
                }
                return t;
            }, t.merge = function(e, r) {
                if (!e) return t.compile(r);
                if (!r) return e;
                if ("string" == typeof r) return new o(r);
                if (o.isTemplate(r)) return r;
                const a = n(e);
                for(let e in r){
                    const t = r[e];
                    if ("root" === e || o.isTemplate(t)) {
                        a[e] = t;
                        continue;
                    }
                    if ("string" == typeof t) {
                        a[e] = new o(t);
                        continue;
                    }
                    s("object" == typeof t && !Array.isArray(t), "Invalid message for", e);
                    const n = e;
                    for(e in a[n] = a[n] || {}, t){
                        const r = t[e];
                        "root" === e || o.isTemplate(r) ? a[n][e] = r : (s("string" == typeof r, "Invalid message for", e, "in", n), a[n][e] = new o(r));
                    }
                }
                return a;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(13), n = {
                mismatched: null
            };
            e.exports = function(e, t, r) {
                return r = Object.assign({
                    prototype: !0
                }, r), !!n.isDeepEqual(e, t, r, []);
            }, n.isDeepEqual = function(e, t, r, o) {
                if (e === t) return 0 !== e || 1 / e == 1 / t;
                const a = typeof e;
                if (a !== typeof t) return !1;
                if (null === e || null === t) return !1;
                if ("function" === a) {
                    if (!r.deepFunction || e.toString() !== t.toString()) return !1;
                } else if ("object" !== a) return e != e && t != t;
                const i = n.getSharedType(e, t, !!r.prototype);
                switch(i){
                    case s.buffer:
                        return !1;
                    case s.promise:
                        return e === t;
                    case s.regex:
                        return e.toString() === t.toString();
                    case n.mismatched:
                        return !1;
                }
                for(let r = o.length - 1; r >= 0; --r)if (o[r].isSame(e, t)) return !0;
                o.push(new n.SeenEntry(e, t));
                try {
                    return !!n.isDeepEqualObj(i, e, t, r, o);
                } finally{
                    o.pop();
                }
            }, n.getSharedType = function(e, t, r) {
                if (r) return Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? n.mismatched : s.getInternalProto(e);
                const o = s.getInternalProto(e);
                return o !== s.getInternalProto(t) ? n.mismatched : o;
            }, n.valueOf = function(e) {
                const t = e.valueOf;
                if (void 0 === t) return e;
                try {
                    return t.call(e);
                } catch (e) {
                    return e;
                }
            }, n.hasOwnEnumerableProperty = function(e, t) {
                return Object.prototype.propertyIsEnumerable.call(e, t);
            }, n.isSetSimpleEqual = function(e, t) {
                for (const r of e)if (!t.has(r)) return !1;
                return !0;
            }, n.isDeepEqualObj = function(e, t, r, o, a) {
                const { isDeepEqual: i, valueOf: l, hasOwnEnumerableProperty: c } = n, { keys: u, getOwnPropertySymbols: f } = Object;
                if (e === s.array) {
                    if (!o.part) {
                        if (t.length !== r.length) return !1;
                        for(let e = 0; e < t.length; ++e)if (!i(t[e], r[e], o, a)) return !1;
                        return !0;
                    }
                    for (const e of t)for (const t of r)if (i(e, t, o, a)) return !0;
                } else if (e === s.set) {
                    if (t.size !== r.size) return !1;
                    if (!n.isSetSimpleEqual(t, r)) {
                        const e = new Set(r);
                        for (const r of t){
                            if (e.delete(r)) continue;
                            let t = !1;
                            for (const s of e)if (i(r, s, o, a)) {
                                e.delete(s), t = !0;
                                break;
                            }
                            if (!t) return !1;
                        }
                    }
                } else if (e === s.map) {
                    if (t.size !== r.size) return !1;
                    for (const [e, s] of t){
                        if (void 0 === s && !r.has(e)) return !1;
                        if (!i(s, r.get(e), o, a)) return !1;
                    }
                } else if (e === s.error && (t.name !== r.name || t.message !== r.message)) return !1;
                const m = l(t), h = l(r);
                if ((t !== m || r !== h) && !i(m, h, o, a)) return !1;
                const d = u(t);
                if (!o.part && d.length !== u(r).length && !o.skip) return !1;
                let p = 0;
                for (const e of d)if (o.skip && o.skip.includes(e)) void 0 === r[e] && ++p;
                else {
                    if (!c(r, e)) return !1;
                    if (!i(t[e], r[e], o, a)) return !1;
                }
                if (!o.part && d.length - p !== u(r).length) return !1;
                if (!1 !== o.symbols) {
                    const e = f(t), s = new Set(f(r));
                    for (const n of e){
                        if (!o.skip || !o.skip.includes(n)) {
                            if (c(t, n)) {
                                if (!c(r, n)) return !1;
                                if (!i(t[n], r[n], o, a)) return !1;
                            } else if (c(r, n)) return !1;
                        }
                        s.delete(n);
                    }
                    for (const e of s)if (c(r, e)) return !1;
                }
                return !0;
            }, n.SeenEntry = class {
                constructor(e, t){
                    this.obj = e, this.ref = t;
                }
                isSame(e, t) {
                    return this.obj === e && this.ref === t;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(15), a = r(1), i = r(8), l = r(4), c = r(17), u = r(18), f = r(5), m = r(7), h = r(19);
            let d;
            const p = {
                types: {
                    alternatives: r(33),
                    any: r(3),
                    array: r(39),
                    boolean: r(40),
                    date: r(41),
                    function: r(42),
                    link: r(45),
                    number: r(46),
                    object: r(47),
                    string: r(48),
                    symbol: r(52)
                },
                aliases: {
                    alt: "alternatives",
                    bool: "boolean",
                    func: "function"
                }
            };
            p.root = function() {
                const e = {
                    _types: new Set(Object.keys(p.types))
                };
                for (const t of e._types)e[t] = function(...e) {
                    return s(!e.length || [
                        "alternatives",
                        "link",
                        "object"
                    ].includes(t), "The", t, "type does not allow arguments"), p.generate(this, p.types[t], e);
                };
                for (const t of [
                    "allow",
                    "custom",
                    "disallow",
                    "equal",
                    "exist",
                    "forbidden",
                    "invalid",
                    "not",
                    "only",
                    "optional",
                    "options",
                    "prefs",
                    "preferences",
                    "required",
                    "strip",
                    "valid",
                    "when"
                ])e[t] = function(...e) {
                    return this.any()[t](...e);
                };
                Object.assign(e, p.methods);
                for(const t in p.aliases){
                    const r = p.aliases[t];
                    e[t] = e[r];
                }
                return e.x = e.expression, h.setup && h.setup(e), e;
            }, p.methods = {
                ValidationError: l.ValidationError,
                version: a.version,
                cache: o.provider,
                assert (e, t, ...r) {
                    p.assert(e, t, !0, r);
                },
                attempt: (e, t, ...r)=>p.assert(e, t, !1, r),
                build (e) {
                    return s("function" == typeof u.build, "Manifest functionality disabled"), u.build(this, e);
                },
                checkPreferences (e) {
                    a.checkPreferences(e);
                },
                compile (e, t) {
                    return i.compile(this, e, t);
                },
                defaults (e) {
                    s("function" == typeof e, "modifier must be a function");
                    const t = Object.assign({}, this);
                    for (const r of t._types){
                        const n = e(t[r]());
                        s(a.isSchema(n), "modifier must return a valid schema object"), t[r] = function(...e) {
                            return p.generate(this, n, e);
                        };
                    }
                    return t;
                },
                expression: (...e)=>new m(...e),
                extend (...e) {
                    a.verifyFlat(e, "extend"), d = d || r(16), s(e.length, "You need to provide at least one extension"), this.assert(e, d.extensions);
                    const t = Object.assign({}, this);
                    t._types = new Set(t._types);
                    for (let r of e){
                        "function" == typeof r && (r = r(t)), this.assert(r, d.extension);
                        const e = p.expandExtension(r, t);
                        for (const r of e){
                            s(void 0 === t[r.type] || t._types.has(r.type), "Cannot override name", r.type);
                            const e = r.base || this.any(), n = c.type(e, r);
                            t._types.add(r.type), t[r.type] = function(...e) {
                                return p.generate(this, n, e);
                            };
                        }
                    }
                    return t;
                },
                isError: l.ValidationError.isError,
                isExpression: m.isTemplate,
                isRef: f.isRef,
                isSchema: a.isSchema,
                in: (...e)=>f.in(...e),
                override: a.symbols.override,
                ref: (...e)=>f.create(...e),
                types () {
                    const e = {};
                    for (const t of this._types)e[t] = this[t]();
                    for(const t in p.aliases)e[t] = this[t]();
                    return e;
                }
            }, p.assert = function(e, t, r, s) {
                const o = s[0] instanceof Error || "string" == typeof s[0] ? s[0] : null, i = o ? s[1] : s[0], c = t.validate(e, a.preferences({
                    errors: {
                        stack: !0
                    }
                }, i || {}));
                let u = c.error;
                if (!u) return c.value;
                if (o instanceof Error) throw o;
                const f = r && "function" == typeof u.annotate ? u.annotate() : u.message;
                throw u instanceof l.ValidationError == !1 && (u = n(u)), u.message = o ? "".concat(o, " ").concat(f) : f, u;
            }, p.generate = function(e, t, r) {
                return s(e, "Must be invoked on a Joi instance."), t.$_root = e, t._definition.args && r.length ? t._definition.args(t, ...r) : t;
            }, p.expandExtension = function(e, t) {
                if ("string" == typeof e.type) return [
                    e
                ];
                const r = [];
                for (const s of t._types)if (e.type.test(s)) {
                    const n = Object.assign({}, e);
                    n.type = s, n.base = t[s](), r.push(n);
                }
                return r;
            }, e.exports = p.root();
        },
        function(e, t, r) {
            "use strict";
            const s = r(28);
            e.exports = class extends Error {
                constructor(e){
                    super(e.filter((e)=>"" !== e).map((e)=>"string" == typeof e ? e : e instanceof Error ? e.message : s(e)).join(" ") || "Unknown error"), "function" == typeof Error.captureStackTrace && Error.captureStackTrace(this, t.assert);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = {};
            t = e.exports = {
                array: Array.prototype,
                buffer: !1,
                date: Date.prototype,
                error: Error.prototype,
                generic: Object.prototype,
                map: Map.prototype,
                promise: Promise.prototype,
                regex: RegExp.prototype,
                set: Set.prototype,
                weakMap: WeakMap.prototype,
                weakSet: WeakSet.prototype
            }, s.typeMap = new Map([
                [
                    "[object Error]",
                    t.error
                ],
                [
                    "[object Map]",
                    t.map
                ],
                [
                    "[object Promise]",
                    t.promise
                ],
                [
                    "[object Set]",
                    t.set
                ],
                [
                    "[object WeakMap]",
                    t.weakMap
                ],
                [
                    "[object WeakSet]",
                    t.weakSet
                ]
            ]), t.getInternalProto = function(e) {
                if (Array.isArray(e)) return t.array;
                if (e instanceof Date) return t.date;
                if (e instanceof RegExp) return t.regex;
                if (e instanceof Error) return t.error;
                const r = Object.prototype.toString.call(e);
                return s.typeMap.get(r) || t.generic;
            };
        },
        function(e, t, r) {
            "use strict";
            t.keys = function(e, t = {}) {
                return !1 !== t.symbols ? Reflect.ownKeys(e) : Object.getOwnPropertyNames(e);
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(1), a = {
                max: 1e3,
                supported: new Set([
                    "undefined",
                    "boolean",
                    "number",
                    "string"
                ])
            };
            t.provider = {
                provision: (e)=>new a.Cache(e)
            }, a.Cache = class {
                constructor(e = {}){
                    o.assertOptions(e, [
                        "max"
                    ]), s(void 0 === e.max || e.max && e.max > 0 && isFinite(e.max), "Invalid max cache size"), this._max = e.max || a.max, this._map = new Map, this._list = new a.List;
                }
                get length() {
                    return this._map.size;
                }
                set(e, t) {
                    if (null !== e && !a.supported.has(typeof e)) return;
                    let r = this._map.get(e);
                    if (r) return r.value = t, void this._list.first(r);
                    r = this._list.unshift({
                        key: e,
                        value: t
                    }), this._map.set(e, r), this._compact();
                }
                get(e) {
                    const t = this._map.get(e);
                    if (t) return this._list.first(t), n(t.value);
                }
                _compact() {
                    if (this._map.size > this._max) {
                        const e = this._list.pop();
                        this._map.delete(e.key);
                    }
                }
            }, a.List = class {
                constructor(){
                    this.tail = null, this.head = null;
                }
                unshift(e) {
                    return e.next = null, e.prev = this.head, this.head && (this.head.next = e), this.head = e, this.tail || (this.tail = e), e;
                }
                first(e) {
                    e !== this.head && (this._remove(e), this.unshift(e));
                }
                pop() {
                    return this._remove(this.tail);
                }
                _remove(e) {
                    const { next: t, prev: r } = e;
                    return t.prev = r, r && (r.next = t), e === this.tail && (this.tail = t), e.prev = null, e.next = null, e;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(11), n = {};
            n.wrap = s.string().min(1).max(2).allow(!1), t.preferences = s.object({
                allowUnknown: s.boolean(),
                abortEarly: s.boolean(),
                cache: s.boolean(),
                context: s.object(),
                convert: s.boolean(),
                dateFormat: s.valid("date", "iso", "string", "time", "utc"),
                debug: s.boolean(),
                errors: {
                    escapeHtml: s.boolean(),
                    label: s.valid("path", "key", !1),
                    language: [
                        s.string(),
                        s.object().ref()
                    ],
                    render: s.boolean(),
                    stack: s.boolean(),
                    wrap: {
                        label: n.wrap,
                        array: n.wrap
                    }
                },
                externals: s.boolean(),
                messages: s.object(),
                noDefaults: s.boolean(),
                nonEnumerables: s.boolean(),
                presence: s.valid("required", "optional", "forbidden"),
                skipFunctions: s.boolean(),
                stripUnknown: s.object({
                    arrays: s.boolean(),
                    objects: s.boolean()
                }).or("arrays", "objects").allow(!0, !1),
                warnings: s.boolean()
            }).strict(), n.nameRx = /^[a-zA-Z0-9]\w*$/, n.rule = s.object({
                alias: s.array().items(s.string().pattern(n.nameRx)).single(),
                args: s.array().items(s.string(), s.object({
                    name: s.string().pattern(n.nameRx).required(),
                    ref: s.boolean(),
                    assert: s.alternatives([
                        s.function(),
                        s.object().schema()
                    ]).conditional("ref", {
                        is: !0,
                        then: s.required()
                    }),
                    normalize: s.function(),
                    message: s.string().when("assert", {
                        is: s.function(),
                        then: s.required()
                    })
                })),
                convert: s.boolean(),
                manifest: s.boolean(),
                method: s.function().allow(!1),
                multi: s.boolean(),
                validate: s.function()
            }), t.extension = s.object({
                type: s.alternatives([
                    s.string(),
                    s.object().regex()
                ]).required(),
                args: s.function(),
                base: s.object().schema().when("type", {
                    is: s.object().regex(),
                    then: s.forbidden()
                }),
                coerce: [
                    s.function().maxArity(3),
                    s.object({
                        method: s.function().maxArity(3).required(),
                        from: s.array().items(s.string()).single()
                    })
                ],
                flags: s.object().pattern(n.nameRx, s.object({
                    setter: s.string(),
                    default: s.any()
                })),
                manifest: {
                    build: s.function().arity(2)
                },
                messages: [
                    s.object(),
                    s.string()
                ],
                modifiers: s.object().pattern(n.nameRx, s.function().minArity(1).maxArity(2)),
                overrides: s.object().pattern(n.nameRx, s.function()),
                prepare: s.function().maxArity(3),
                rebuild: s.function().arity(1),
                rules: s.object().pattern(n.nameRx, n.rule),
                terms: s.object().pattern(n.nameRx, s.object({
                    init: s.array().allow(null).required(),
                    manifest: s.object().pattern(/.+/, [
                        s.valid("schema", "single"),
                        s.object({
                            mapped: s.object({
                                from: s.string().required(),
                                to: s.string().required()
                            }).required()
                        })
                    ])
                })),
                validate: s.function().maxArity(3)
            }).strict(), t.extensions = s.array().items(s.object(), s.function().arity(1)).strict(), n.desc = {
                buffer: s.object({
                    buffer: s.string()
                }),
                func: s.object({
                    function: s.function().required(),
                    options: {
                        literal: !0
                    }
                }),
                override: s.object({
                    override: !0
                }),
                ref: s.object({
                    ref: s.object({
                        type: s.valid("value", "global", "local"),
                        path: s.array().required(),
                        separator: s.string().length(1).allow(!1),
                        ancestor: s.number().min(0).integer().allow("root"),
                        map: s.array().items(s.array().length(2)).min(1),
                        adjust: s.function(),
                        iterables: s.boolean(),
                        in: s.boolean()
                    }).required()
                }),
                regex: s.object({
                    regex: s.string().min(3)
                }),
                special: s.object({
                    special: s.valid("deep").required()
                }),
                template: s.object({
                    template: s.string().required(),
                    options: s.object()
                }),
                value: s.object({
                    value: s.alternatives([
                        s.object(),
                        s.array()
                    ]).required()
                })
            }, n.desc.entity = s.alternatives([
                s.array().items(s.link("...")),
                s.boolean(),
                s.function(),
                s.number(),
                s.string(),
                n.desc.buffer,
                n.desc.func,
                n.desc.ref,
                n.desc.regex,
                n.desc.special,
                n.desc.template,
                n.desc.value,
                s.link("/")
            ]), n.desc.values = s.array().items(null, s.boolean(), s.function(), s.number().allow(1 / 0, -1 / 0), s.string().allow(""), s.symbol(), n.desc.buffer, n.desc.func, n.desc.override, n.desc.ref, n.desc.regex, n.desc.template, n.desc.value), n.desc.messages = s.object().pattern(/.+/, [
                s.string(),
                n.desc.template,
                s.object().pattern(/.+/, [
                    s.string(),
                    n.desc.template
                ])
            ]), t.description = s.object({
                type: s.string().required(),
                flags: s.object({
                    cast: s.string(),
                    default: s.any(),
                    description: s.string(),
                    empty: s.link("/"),
                    failover: n.desc.entity,
                    id: s.string(),
                    label: s.string(),
                    only: !0,
                    presence: [
                        "optional",
                        "required",
                        "forbidden"
                    ],
                    result: [
                        "raw",
                        "strip"
                    ],
                    strip: s.boolean(),
                    unit: s.string()
                }).unknown(),
                preferences: {
                    allowUnknown: s.boolean(),
                    abortEarly: s.boolean(),
                    cache: s.boolean(),
                    convert: s.boolean(),
                    dateFormat: [
                        "date",
                        "iso",
                        "string",
                        "time",
                        "utc"
                    ],
                    errors: {
                        escapeHtml: s.boolean(),
                        label: [
                            "path",
                            "key"
                        ],
                        language: [
                            s.string(),
                            n.desc.ref
                        ],
                        wrap: {
                            label: n.wrap,
                            array: n.wrap
                        }
                    },
                    externals: s.boolean(),
                    messages: n.desc.messages,
                    noDefaults: s.boolean(),
                    nonEnumerables: s.boolean(),
                    presence: [
                        "required",
                        "optional",
                        "forbidden"
                    ],
                    skipFunctions: s.boolean(),
                    stripUnknown: s.object({
                        arrays: s.boolean(),
                        objects: s.boolean()
                    }).or("arrays", "objects").allow(!0, !1),
                    warnings: s.boolean()
                },
                allow: n.desc.values,
                invalid: n.desc.values,
                rules: s.array().min(1).items({
                    name: s.string().required(),
                    args: s.object().min(1),
                    keep: s.boolean(),
                    message: [
                        s.string(),
                        n.desc.messages
                    ],
                    warn: s.boolean()
                }),
                keys: s.object().pattern(/.*/, s.link("/")),
                link: n.desc.ref
            }).pattern(/^[a-z]\w*$/, s.any());
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(1), a = r(9), i = {};
            t.type = function(e, t) {
                const r = Object.getPrototypeOf(e), l = n(r), c = e._assign(Object.create(l)), u = Object.assign({}, t);
                delete u.base, l._definition = u;
                const f = r._definition || {};
                u.messages = a.merge(f.messages, u.messages), u.properties = Object.assign({}, f.properties, u.properties), c.type = u.type, u.flags = Object.assign({}, f.flags, u.flags);
                const m = Object.assign({}, f.terms);
                if (u.terms) for(const e in u.terms){
                    const t = u.terms[e];
                    s(void 0 === c.$_terms[e], "Invalid term override for", u.type, e), c.$_terms[e] = t.init, m[e] = t;
                }
                u.terms = m, u.args || (u.args = f.args), u.prepare = i.prepare(u.prepare, f.prepare), u.coerce && ("function" == typeof u.coerce && (u.coerce = {
                    method: u.coerce
                }), u.coerce.from && !Array.isArray(u.coerce.from) && (u.coerce = {
                    method: u.coerce.method,
                    from: [].concat(u.coerce.from)
                })), u.coerce = i.coerce(u.coerce, f.coerce), u.validate = i.validate(u.validate, f.validate);
                const h = Object.assign({}, f.rules);
                if (u.rules) for(const e in u.rules){
                    const t = u.rules[e];
                    s("object" == typeof t, "Invalid rule definition for", u.type, e);
                    let r = t.method;
                    if (void 0 === r && (r = function() {
                        return this.$_addRule(e);
                    }), r && (s(!l[e], "Rule conflict in", u.type, e), l[e] = r), s(!h[e], "Rule conflict in", u.type, e), h[e] = t, t.alias) {
                        const e = [].concat(t.alias);
                        for (const r of e)l[r] = t.method;
                    }
                    t.args && (t.argsByName = new Map, t.args = t.args.map((e)=>("string" == typeof e && (e = {
                            name: e
                        }), s(!t.argsByName.has(e.name), "Duplicated argument name", e.name), o.isSchema(e.assert) && (e.assert = e.assert.strict().label(e.name)), t.argsByName.set(e.name, e), e)));
                }
                u.rules = h;
                const d = Object.assign({}, f.modifiers);
                if (u.modifiers) for(const e in u.modifiers){
                    s(!l[e], "Rule conflict in", u.type, e);
                    const t = u.modifiers[e];
                    s("function" == typeof t, "Invalid modifier definition for", u.type, e);
                    const r = function(t) {
                        return this.rule({
                            [e]: t
                        });
                    };
                    l[e] = r, d[e] = t;
                }
                if (u.modifiers = d, u.overrides) {
                    l._super = r, c.$_super = {};
                    for(const e in u.overrides)s(r[e], "Cannot override missing", e), c.$_super[e] = r[e].bind(c);
                    Object.assign(l, u.overrides);
                }
                u.cast = Object.assign({}, f.cast, u.cast);
                const p = Object.assign({}, f.manifest, u.manifest);
                return p.build = i.build(u.manifest && u.manifest.build, f.manifest && f.manifest.build), u.manifest = p, u.rebuild = i.rebuild(u.rebuild, f.rebuild), c;
            }, i.build = function(e, t) {
                return e && t ? function(r, s) {
                    return t(e(r, s), s);
                } : e || t;
            }, i.coerce = function(e, t) {
                return e && t ? {
                    from: e.from && t.from ? [
                        ...new Set([
                            ...e.from,
                            ...t.from
                        ])
                    ] : null,
                    method (r, s) {
                        let n;
                        if ((!t.from || t.from.includes(typeof r)) && (n = t.method(r, s), n)) {
                            if (n.errors || void 0 === n.value) return n;
                            r = n.value;
                        }
                        if (!e.from || e.from.includes(typeof r)) {
                            const t = e.method(r, s);
                            if (t) return t;
                        }
                        return n;
                    }
                } : e || t;
            }, i.prepare = function(e, t) {
                return e && t ? function(r, s) {
                    const n = e(r, s);
                    if (n) {
                        if (n.errors || void 0 === n.value) return n;
                        r = n.value;
                    }
                    return t(r, s) || n;
                } : e || t;
            }, i.rebuild = function(e, t) {
                return e && t ? function(r) {
                    t(r), e(r);
                } : e || t;
            }, i.validate = function(e, t) {
                return e && t ? function(r, s) {
                    const n = t(r, s);
                    if (n) {
                        if (n.errors && (!Array.isArray(n.errors) || n.errors.length)) return n;
                        r = n.value;
                    }
                    return e(r, s) || n;
                } : e || t;
            };
        },
        function(e, t) {},
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(14), a = {};
            e.exports = a.merge = function(e, t, r) {
                if (s(e && "object" == typeof e, "Invalid target value: must be an object"), s(null == t || "object" == typeof t, "Invalid source value: must be null, undefined, or an object"), !t) return e;
                if (r = Object.assign({
                    nullOverride: !0,
                    mergeArrays: !0
                }, r), Array.isArray(t)) {
                    s(Array.isArray(e), "Cannot merge array onto an object"), r.mergeArrays || (e.length = 0);
                    for(let s = 0; s < t.length; ++s)e.push(n(t[s], {
                        symbols: r.symbols
                    }));
                    return e;
                }
                const i = o.keys(t, r);
                for(let s = 0; s < i.length; ++s){
                    const o = i[s];
                    if ("__proto__" === o || !Object.prototype.propertyIsEnumerable.call(t, o)) continue;
                    const l = t[o];
                    if (l && "object" == typeof l) {
                        if (e[o] === l) continue;
                        !e[o] || "object" != typeof e[o] || Array.isArray(e[o]) !== Array.isArray(l) || l instanceof Date || l instanceof RegExp ? e[o] = n(l, {
                            symbols: r.symbols
                        }) : a.merge(e[o], l, r);
                    } else null != l ? e[o] = l : r.nullOverride && (e[o] = l);
                }
                return e;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(10), o = r(1), a = {};
            e.exports = a.Values = class {
                constructor(e, t){
                    this._values = new Set(e), this._refs = new Set(t), this._lowercase = a.lowercases(e), this._override = !1;
                }
                get length() {
                    return this._values.size + this._refs.size;
                }
                add(e, t) {
                    o.isResolvable(e) ? this._refs.has(e) || (this._refs.add(e), t && t.register(e)) : this.has(e, null, null, !1) || (this._values.add(e), "string" == typeof e && this._lowercase.set(e.toLowerCase(), e));
                }
                static merge(e, t, r) {
                    if (e = e || new a.Values, t) {
                        if (t._override) return t.clone();
                        for (const r of [
                            ...t._values,
                            ...t._refs
                        ])e.add(r);
                    }
                    if (r) for (const t of [
                        ...r._values,
                        ...r._refs
                    ])e.remove(t);
                    return e.length ? e : null;
                }
                remove(e) {
                    o.isResolvable(e) ? this._refs.delete(e) : (this._values.delete(e), "string" == typeof e && this._lowercase.delete(e.toLowerCase()));
                }
                has(e, t, r, s) {
                    return !!this.get(e, t, r, s);
                }
                get(e, t, r, s) {
                    if (!this.length) return !1;
                    if (this._values.has(e)) return {
                        value: e
                    };
                    if ("string" == typeof e && e && s) {
                        const t = this._lowercase.get(e.toLowerCase());
                        if (t) return {
                            value: t
                        };
                    }
                    if (!this._refs.size && "object" != typeof e) return !1;
                    if ("object" == typeof e) {
                        for (const t of this._values)if (n(t, e)) return {
                            value: t
                        };
                    }
                    if (t) for (const o of this._refs){
                        const a = o.resolve(e, t, r, null, {
                            in: !0
                        });
                        if (void 0 === a) continue;
                        const i = o.in && "object" == typeof a ? Array.isArray(a) ? a : Object.keys(a) : [
                            a
                        ];
                        for (const t of i)if (typeof t == typeof e) {
                            if (s && e && "string" == typeof e) {
                                if (t.toLowerCase() === e.toLowerCase()) return {
                                    value: t,
                                    ref: o
                                };
                            } else if (n(t, e)) return {
                                value: t,
                                ref: o
                            };
                        }
                    }
                    return !1;
                }
                override() {
                    this._override = !0;
                }
                values(e) {
                    if (e && e.display) {
                        const e = [];
                        for (const t of [
                            ...this._values,
                            ...this._refs
                        ])void 0 !== t && e.push(t);
                        return e;
                    }
                    return Array.from([
                        ...this._values,
                        ...this._refs
                    ]);
                }
                clone() {
                    const e = new a.Values(this._values, this._refs);
                    return e._override = this._override, e;
                }
                concat(e) {
                    s(!e._override, "Cannot concat override set of values");
                    const t = new a.Values([
                        ...this._values,
                        ...e._values
                    ], [
                        ...this._refs,
                        ...e._refs
                    ]);
                    return t._override = this._override, t;
                }
                describe() {
                    const e = [];
                    this._override && e.push({
                        override: !0
                    });
                    for (const t of this._values.values())e.push(t && "object" == typeof t ? {
                        value: t
                    } : t);
                    for (const t of this._refs.values())e.push(t.describe());
                    return e;
                }
            }, a.Values.prototype[o.symbols.values] = !0, a.Values.prototype.slice = a.Values.prototype.clone, a.lowercases = function(e) {
                const t = new Map;
                if (e) for (const r of e)"string" == typeof r && t.set(r.toLowerCase(), r);
                return t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(43), n = r(0), o = r(2), a = r(44), i = r(3), l = r(1), c = r(8), u = r(4), f = r(5), m = r(7), h = {
                renameDefaults: {
                    alias: !1,
                    multiple: !1,
                    override: !1
                }
            };
            e.exports = i.extend({
                type: "_keys",
                properties: {
                    typeof: "object"
                },
                flags: {
                    unknown: {
                        default: !1
                    }
                },
                terms: {
                    dependencies: {
                        init: null
                    },
                    keys: {
                        init: null,
                        manifest: {
                            mapped: {
                                from: "schema",
                                to: "key"
                            }
                        }
                    },
                    patterns: {
                        init: null
                    },
                    renames: {
                        init: null
                    }
                },
                args: (e, t)=>e.keys(t),
                validate (e, { schema: t, error: r, state: s, prefs: n }) {
                    if (!e || typeof e !== t.$_property("typeof") || Array.isArray(e)) return {
                        value: e,
                        errors: r("object.base", {
                            type: t.$_property("typeof")
                        })
                    };
                    if (!(t.$_terms.renames || t.$_terms.dependencies || t.$_terms.keys || t.$_terms.patterns || t.$_terms.externals)) return;
                    e = h.clone(e, n);
                    const o = [];
                    if (t.$_terms.renames && !h.rename(t, e, s, n, o)) return {
                        value: e,
                        errors: o
                    };
                    if (!t.$_terms.keys && !t.$_terms.patterns && !t.$_terms.dependencies) return {
                        value: e,
                        errors: o
                    };
                    const a = new Set(Object.keys(e));
                    if (t.$_terms.keys) {
                        const r = [
                            e,
                            ...s.ancestors
                        ];
                        for (const i of t.$_terms.keys){
                            const t = i.key, l = e[t];
                            a.delete(t);
                            const c = s.localize([
                                ...s.path,
                                t
                            ], r, i), u = i.schema.$_validate(l, c, n);
                            if (u.errors) {
                                if (n.abortEarly) return {
                                    value: e,
                                    errors: u.errors
                                };
                                o.push(...u.errors);
                            } else "strip" === i.schema._flags.result || void 0 === u.value && void 0 !== l ? delete e[t] : void 0 !== u.value && (e[t] = u.value);
                        }
                    }
                    if (a.size || t._flags._hasPatternMatch) {
                        const r = h.unknown(t, e, a, o, s, n);
                        if (r) return r;
                    }
                    if (t.$_terms.dependencies) for (const r of t.$_terms.dependencies){
                        if (r.key && void 0 === r.key.resolve(e, s, n, null, {
                            shadow: !1
                        })) continue;
                        const a = h.dependencies[r.rel](t, r, e, s, n);
                        if (a) {
                            const r = t.$_createError(a.code, e, a.context, s, n);
                            if (n.abortEarly) return {
                                value: e,
                                errors: r
                            };
                            o.push(r);
                        }
                    }
                    return {
                        value: e,
                        errors: o
                    };
                },
                rules: {
                    and: {
                        method (...e) {
                            return l.verifyFlat(e, "and"), h.dependency(this, "and", null, e);
                        }
                    },
                    append: {
                        method (e) {
                            return null == e || 0 === Object.keys(e).length ? this : this.keys(e);
                        }
                    },
                    assert: {
                        method (e, t, r) {
                            m.isTemplate(e) || (e = c.ref(e)), n(void 0 === r || "string" == typeof r, "Message must be a string"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const s = this.$_addRule({
                                name: "assert",
                                args: {
                                    subject: e,
                                    schema: t,
                                    message: r
                                }
                            });
                            return s.$_mutateRegister(e), s.$_mutateRegister(t), s;
                        },
                        validate (e, { error: t, prefs: r, state: s }, { subject: n, schema: o, message: a }) {
                            const i = n.resolve(e, s, r), l = f.isRef(n) ? n.absolute(s) : [];
                            return o.$_match(i, s.localize(l, [
                                e,
                                ...s.ancestors
                            ], o), r) ? e : t("object.assert", {
                                subject: n,
                                message: a
                            });
                        },
                        args: [
                            "subject",
                            "schema",
                            "message"
                        ],
                        multi: !0
                    },
                    instance: {
                        method (e, t) {
                            return n("function" == typeof e, "constructor must be a function"), t = t || e.name, this.$_addRule({
                                name: "instance",
                                args: {
                                    constructor: e,
                                    name: t
                                }
                            });
                        },
                        validate: (e, t, { constructor: r, name: s })=>e instanceof r ? e : t.error("object.instance", {
                                type: s,
                                value: e
                            }),
                        args: [
                            "constructor",
                            "name"
                        ]
                    },
                    keys: {
                        method (e) {
                            n(void 0 === e || "object" == typeof e, "Object schema must be a valid object"), n(!l.isSchema(e), "Object schema cannot be a joi schema");
                            const t = this.clone();
                            if (e) {
                                if (Object.keys(e).length) {
                                    t.$_terms.keys = t.$_terms.keys ? t.$_terms.keys.filter((t)=>!e.hasOwnProperty(t.key)) : new h.Keys;
                                    for(const r in e)l.tryWithPath(()=>t.$_terms.keys.push({
                                            key: r,
                                            schema: this.$_compile(e[r])
                                        }), r);
                                } else t.$_terms.keys = new h.Keys;
                            } else t.$_terms.keys = null;
                            return t.$_mutateRebuild();
                        }
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: o })=>l.compare(Object.keys(e).length, r, n) ? e : t.error("object." + s, {
                                limit: o.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: l.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    nand: {
                        method (...e) {
                            return l.verifyFlat(e, "nand"), h.dependency(this, "nand", null, e);
                        }
                    },
                    or: {
                        method (...e) {
                            return l.verifyFlat(e, "or"), h.dependency(this, "or", null, e);
                        }
                    },
                    oxor: {
                        method (...e) {
                            return h.dependency(this, "oxor", null, e);
                        }
                    },
                    pattern: {
                        method (e, t, r = {}) {
                            const s = e instanceof RegExp;
                            s || (e = this.$_compile(e, {
                                appendPath: !0
                            })), n(void 0 !== t, "Invalid rule"), l.assertOptions(r, [
                                "fallthrough",
                                "matches"
                            ]), s && n(!e.flags.includes("g") && !e.flags.includes("y"), "pattern should not use global or sticky mode"), t = this.$_compile(t, {
                                appendPath: !0
                            });
                            const o = this.clone();
                            o.$_terms.patterns = o.$_terms.patterns || [];
                            const a = {
                                [s ? "regex" : "schema"]: e,
                                rule: t
                            };
                            return r.matches && (a.matches = this.$_compile(r.matches), "array" !== a.matches.type && (a.matches = a.matches.$_root.array().items(a.matches)), o.$_mutateRegister(a.matches), o.$_setFlag("_hasPatternMatch", !0, {
                                clone: !1
                            })), r.fallthrough && (a.fallthrough = !0), o.$_terms.patterns.push(a), o.$_mutateRegister(t), o;
                        }
                    },
                    ref: {
                        method () {
                            return this.$_addRule("ref");
                        },
                        validate: (e, t)=>f.isRef(e) ? e : t.error("object.refType", {
                                value: e
                            })
                    },
                    regex: {
                        method () {
                            return this.$_addRule("regex");
                        },
                        validate: (e, t)=>e instanceof RegExp ? e : t.error("object.regex", {
                                value: e
                            })
                    },
                    rename: {
                        method (e, t, r = {}) {
                            n("string" == typeof e || e instanceof RegExp, "Rename missing the from argument"), n("string" == typeof t || t instanceof m, "Invalid rename to argument"), n(t !== e, "Cannot rename key to same name:", e), l.assertOptions(r, [
                                "alias",
                                "ignoreUndefined",
                                "override",
                                "multiple"
                            ]);
                            const o = this.clone();
                            o.$_terms.renames = o.$_terms.renames || [];
                            for (const t of o.$_terms.renames)n(t.from !== e, "Cannot rename the same key multiple times");
                            return t instanceof m && o.$_mutateRegister(t), o.$_terms.renames.push({
                                from: e,
                                to: t,
                                options: s(h.renameDefaults, r)
                            }), o;
                        }
                    },
                    schema: {
                        method (e = "any") {
                            return this.$_addRule({
                                name: "schema",
                                args: {
                                    type: e
                                }
                            });
                        },
                        validate: (e, t, { type: r })=>!l.isSchema(e) || "any" !== r && e.type !== r ? t.error("object.schema", {
                                type: r
                            }) : e
                    },
                    unknown: {
                        method (e) {
                            return this.$_setFlag("unknown", !1 !== e);
                        }
                    },
                    with: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "with", e, t, r);
                        }
                    },
                    without: {
                        method (e, t, r = {}) {
                            return h.dependency(this, "without", e, t, r);
                        }
                    },
                    xor: {
                        method (...e) {
                            return l.verifyFlat(e, "xor"), h.dependency(this, "xor", null, e);
                        }
                    }
                },
                overrides: {
                    default (e, t) {
                        return void 0 === e && (e = l.symbols.deepDefault), this.$_super.default(e, t);
                    }
                },
                rebuild (e) {
                    if (e.$_terms.keys) {
                        const t = new a.Sorter;
                        for (const r of e.$_terms.keys)l.tryWithPath(()=>t.add(r, {
                                after: r.schema.$_rootReferences(),
                                group: r.key
                            }), r.key);
                        e.$_terms.keys = new h.Keys(...t.nodes);
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.keys && (e = e.keys(t.keys)), t.dependencies) for (const { rel: r, key: s = null, peers: n, options: o } of t.dependencies)e = h.dependency(e, r, s, n, o);
                        if (t.patterns) for (const { regex: r, schema: s, rule: n, fallthrough: o, matches: a } of t.patterns)e = e.pattern(r || s, n, {
                            fallthrough: o,
                            matches: a
                        });
                        if (t.renames) for (const { from: r, to: s, options: n } of t.renames)e = e.rename(r, s, n);
                        return e;
                    }
                },
                messages: {
                    "object.and": "{{#label}} contains {{#presentWithLabels}} without its required peers {{#missingWithLabels}}",
                    "object.assert": '{{#label}} is invalid because {if(#subject.key, `"` + #subject.key + `" failed to ` + (#message || "pass the assertion test"), #message || "the assertion failed")}',
                    "object.base": "{{#label}} must be of type {{#type}}",
                    "object.instance": '{{#label}} must be an instance of "{{#type}}"',
                    "object.length": '{{#label}} must have {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.max": '{{#label}} must have less than or equal to {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.min": '{{#label}} must have at least {{#limit}} key{if(#limit == 1, "", "s")}',
                    "object.missing": "{{#label}} must contain at least one of {{#peersWithLabels}}",
                    "object.nand": '"{{#mainWithLabel}}" must not exist simultaneously with {{#peersWithLabels}}',
                    "object.oxor": "{{#label}} contains a conflict between optional exclusive peers {{#peersWithLabels}}",
                    "object.pattern.match": "{{#label}} keys failed to match pattern requirements",
                    "object.refType": "{{#label}} must be a Joi reference",
                    "object.regex": "{{#label}} must be a RegExp object",
                    "object.rename.multiple": '{{#label}} cannot rename "{{#from}}" because multiple renames are disabled and another key was already renamed to "{{#to}}"',
                    "object.rename.override": '{{#label}} cannot rename "{{#from}}" because override is disabled and target "{{#to}}" exists',
                    "object.schema": "{{#label}} must be a Joi schema of {{#type}} type",
                    "object.unknown": "{{#label}} is not allowed",
                    "object.with": '"{{#mainWithLabel}}" missing required peer "{{#peerWithLabel}}"',
                    "object.without": '"{{#mainWithLabel}}" conflict with forbidden peer "{{#peerWithLabel}}"',
                    "object.xor": "{{#label}} contains a conflict between exclusive peers {{#peersWithLabels}}"
                }
            }), h.clone = function(e, t) {
                if ("object" == typeof e) {
                    if (t.nonEnumerables) return o(e, {
                        shallow: !0
                    });
                    const r = Object.create(Object.getPrototypeOf(e));
                    return Object.assign(r, e), r;
                }
                const r = function(...t) {
                    return e.apply(this, t);
                };
                return r.prototype = o(e.prototype), Object.defineProperty(r, "name", {
                    value: e.name,
                    writable: !1
                }), Object.defineProperty(r, "length", {
                    value: e.length,
                    writable: !1
                }), Object.assign(r, e), r;
            }, h.dependency = function(e, t, r, s, o) {
                n(null === r || "string" == typeof r, t, "key must be a strings"), o || (o = s.length > 1 && "object" == typeof s[s.length - 1] ? s.pop() : {}), l.assertOptions(o, [
                    "separator"
                ]), s = [].concat(s);
                const a = l.default(o.separator, "."), i = [];
                for (const e of s)n("string" == typeof e, t, "peers must be a string or a reference"), i.push(c.ref(e, {
                    separator: a,
                    ancestor: 0,
                    prefix: !1
                }));
                null !== r && (r = c.ref(r, {
                    separator: a,
                    ancestor: 0,
                    prefix: !1
                }));
                const u = e.clone();
                return u.$_terms.dependencies = u.$_terms.dependencies || [], u.$_terms.dependencies.push(new h.Dependency(t, r, i, s)), u;
            }, h.dependencies = {
                and (e, t, r, s, n) {
                    const o = [], a = [], i = t.peers.length;
                    for (const e of t.peers)void 0 === e.resolve(r, s, n, null, {
                        shadow: !1
                    }) ? o.push(e.key) : a.push(e.key);
                    if (o.length !== i && a.length !== i) return {
                        code: "object.and",
                        context: {
                            present: a,
                            presentWithLabels: h.keysToLabels(e, a),
                            missing: o,
                            missingWithLabels: h.keysToLabels(e, o)
                        }
                    };
                },
                nand (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (o.length !== t.peers.length) return;
                    const a = t.paths[0], i = t.paths.slice(1);
                    return {
                        code: "object.nand",
                        context: {
                            main: a,
                            mainWithLabel: h.keysToLabels(e, a),
                            peers: i,
                            peersWithLabels: h.keysToLabels(e, i)
                        }
                    };
                },
                or (e, t, r, s, n) {
                    for (const e of t.peers)if (void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    })) return;
                    return {
                        code: "object.missing",
                        context: {
                            peers: t.paths,
                            peersWithLabels: h.keysToLabels(e, t.paths)
                        }
                    };
                },
                oxor (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (!o.length || 1 === o.length) return;
                    const a = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
                        code: "object.oxor",
                        context: a
                    };
                },
                with (e, t, r, s, n) {
                    for (const o of t.peers)if (void 0 === o.resolve(r, s, n, null, {
                        shadow: !1
                    })) return {
                        code: "object.with",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: o.key,
                            peerWithLabel: h.keysToLabels(e, o.key)
                        }
                    };
                },
                without (e, t, r, s, n) {
                    for (const o of t.peers)if (void 0 !== o.resolve(r, s, n, null, {
                        shadow: !1
                    })) return {
                        code: "object.without",
                        context: {
                            main: t.key.key,
                            mainWithLabel: h.keysToLabels(e, t.key.key),
                            peer: o.key,
                            peerWithLabel: h.keysToLabels(e, o.key)
                        }
                    };
                },
                xor (e, t, r, s, n) {
                    const o = [];
                    for (const e of t.peers)void 0 !== e.resolve(r, s, n, null, {
                        shadow: !1
                    }) && o.push(e.key);
                    if (1 === o.length) return;
                    const a = {
                        peers: t.paths,
                        peersWithLabels: h.keysToLabels(e, t.paths)
                    };
                    return 0 === o.length ? {
                        code: "object.missing",
                        context: a
                    } : (a.present = o, a.presentWithLabels = h.keysToLabels(e, o), {
                        code: "object.xor",
                        context: a
                    });
                }
            }, h.keysToLabels = function(e, t) {
                return Array.isArray(t) ? t.map((t)=>e.$_mapLabels(t)) : e.$_mapLabels(t);
            }, h.rename = function(e, t, r, s, n) {
                const o = {};
                for (const a of e.$_terms.renames){
                    const i = [], l = "string" != typeof a.from;
                    if (l) for(const e in t){
                        if (void 0 === t[e] && a.options.ignoreUndefined) continue;
                        if (e === a.to) continue;
                        const r = a.from.exec(e);
                        r && i.push({
                            from: e,
                            to: a.to,
                            match: r
                        });
                    }
                    else !Object.prototype.hasOwnProperty.call(t, a.from) || void 0 === t[a.from] && a.options.ignoreUndefined || i.push(a);
                    for (const c of i){
                        const i = c.from;
                        let u = c.to;
                        if (u instanceof m && (u = u.render(t, r, s, c.match)), i !== u) {
                            if (!a.options.multiple && o[u] && (n.push(e.$_createError("object.rename.multiple", t, {
                                from: i,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            if (Object.prototype.hasOwnProperty.call(t, u) && !a.options.override && !o[u] && (n.push(e.$_createError("object.rename.override", t, {
                                from: i,
                                to: u,
                                pattern: l
                            }, r, s)), s.abortEarly)) return !1;
                            void 0 === t[i] ? delete t[u] : t[u] = t[i], o[u] = !0, a.options.alias || delete t[i];
                        }
                    }
                }
                return !0;
            }, h.unknown = function(e, t, r, s, n, o) {
                if (e.$_terms.patterns) {
                    let a = !1;
                    const i = e.$_terms.patterns.map((e)=>{
                        if (e.matches) return a = !0, [];
                    }), l = [
                        t,
                        ...n.ancestors
                    ];
                    for (const a of r){
                        const c = t[a], u = [
                            ...n.path,
                            a
                        ];
                        for(let f = 0; f < e.$_terms.patterns.length; ++f){
                            const m = e.$_terms.patterns[f];
                            if (m.regex) {
                                const e = m.regex.test(a);
                                if (n.mainstay.tracer.debug(n, "rule", "pattern.".concat(f), e ? "pass" : "error"), !e) continue;
                            } else if (!m.schema.$_match(a, n.nest(m.schema, "pattern.".concat(f)), o)) continue;
                            r.delete(a);
                            const h = n.localize(u, l, {
                                schema: m.rule,
                                key: a
                            }), d = m.rule.$_validate(c, h, o);
                            if (d.errors) {
                                if (o.abortEarly) return {
                                    value: t,
                                    errors: d.errors
                                };
                                s.push(...d.errors);
                            }
                            if (m.matches && i[f].push(a), t[a] = d.value, !m.fallthrough) break;
                        }
                    }
                    if (a) for(let r = 0; r < i.length; ++r){
                        const a = i[r];
                        if (!a) continue;
                        const c = e.$_terms.patterns[r].matches, f = n.localize(n.path, l, c), m = c.$_validate(a, f, o);
                        if (m.errors) {
                            const r = u.details(m.errors, {
                                override: !1
                            });
                            r.matches = a;
                            const i = e.$_createError("object.pattern.match", t, r, n, o);
                            if (o.abortEarly) return {
                                value: t,
                                errors: i
                            };
                            s.push(i);
                        }
                    }
                }
                if (!r.size || !e.$_terms.keys && !e.$_terms.patterns) return;
                if (o.stripUnknown && !e._flags.unknown || o.skipFunctions) {
                    const e = !!o.stripUnknown && (!0 === o.stripUnknown || !!o.stripUnknown.objects);
                    for (const s of r)e ? (delete t[s], r.delete(s)) : "function" == typeof t[s] && r.delete(s);
                }
                if (!l.default(e._flags.unknown, o.allowUnknown)) for (const a of r){
                    const r = n.localize([
                        ...n.path,
                        a
                    ], []), i = e.$_createError("object.unknown", t[a], {
                        child: a
                    }, r, o, {
                        flags: !1
                    });
                    if (o.abortEarly) return {
                        value: t,
                        errors: i
                    };
                    s.push(i);
                }
            }, h.Dependency = class {
                constructor(e, t, r, s){
                    this.rel = e, this.key = t, this.peers = r, this.paths = s;
                }
                describe() {
                    const e = {
                        rel: this.rel,
                        peers: this.paths
                    };
                    return null !== this.key && (e.key = this.key.key), "." !== this.peers[0].separator && (e.options = {
                        separator: this.peers[0].separator
                    }), e;
                }
            }, h.Keys = class extends Array {
                concat(e) {
                    const t = this.slice(), r = new Map;
                    for(let e = 0; e < t.length; ++e)r.set(t[e].key, e);
                    for (const s of e){
                        const e = s.key, n = r.get(e);
                        void 0 !== n ? t[n] = {
                            key: e,
                            schema: t[n].schema.concat(s.schema)
                        } : t.push(s);
                    }
                    return t;
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(24), n = r(25), o = {
                minDomainSegments: 2,
                nonAsciiRx: /[^\x00-\x7f]/,
                domainControlRx: /[\x00-\x20@\:\/]/,
                tldSegmentRx: /^[a-zA-Z](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                domainSegmentRx: /^[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/,
                URL: s.URL || URL
            };
            t.analyze = function(e, t = {}) {
                if ("string" != typeof e) throw new Error("Invalid input: domain must be a string");
                if (!e) return n.code("DOMAIN_NON_EMPTY_STRING");
                if (e.length > 256) return n.code("DOMAIN_TOO_LONG");
                if (!!o.nonAsciiRx.test(e)) {
                    if (!1 === t.allowUnicode) return n.code("DOMAIN_INVALID_UNICODE_CHARS");
                    e = e.normalize("NFC");
                }
                if (o.domainControlRx.test(e)) return n.code("DOMAIN_INVALID_CHARS");
                e = o.punycode(e);
                const r = t.minDomainSegments || o.minDomainSegments, s = e.split(".");
                if (s.length < r) return n.code("DOMAIN_SEGMENTS_COUNT");
                const a = t.tlds;
                if (a) {
                    const e = s[s.length - 1].toLowerCase();
                    if (a.deny && a.deny.has(e) || a.allow && !a.allow.has(e)) return n.code("DOMAIN_FORBIDDEN_TLDS");
                }
                for(let e = 0; e < s.length; ++e){
                    const t = s[e];
                    if (!t.length) return n.code("DOMAIN_EMPTY_SEGMENT");
                    if (t.length > 63) return n.code("DOMAIN_LONG_SEGMENT");
                    if (e < s.length - 1) {
                        if (!o.domainSegmentRx.test(t)) return n.code("DOMAIN_INVALID_CHARS");
                    } else if (!o.tldSegmentRx.test(t)) return n.code("DOMAIN_INVALID_TLDS_CHARS");
                }
                return null;
            }, t.isValid = function(e, r) {
                return !t.analyze(e, r);
            }, o.punycode = function(e) {
                try {
                    return new o.URL("http://".concat(e)).host;
                } catch (t) {
                    return e;
                }
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            t.codes = {
                EMPTY_STRING: "Address must be a non-empty string",
                FORBIDDEN_UNICODE: "Address contains forbidden Unicode characters",
                MULTIPLE_AT_CHAR: "Address cannot contain more than one @ character",
                MISSING_AT_CHAR: "Address must contain one @ character",
                EMPTY_LOCAL: "Address local part cannot be empty",
                ADDRESS_TOO_LONG: "Address too long",
                LOCAL_TOO_LONG: "Address local part too long",
                EMPTY_LOCAL_SEGMENT: "Address local part contains empty dot-separated segment",
                INVALID_LOCAL_CHARS: "Address local part contains invalid character",
                DOMAIN_NON_EMPTY_STRING: "Domain must be a non-empty string",
                DOMAIN_TOO_LONG: "Domain too long",
                DOMAIN_INVALID_UNICODE_CHARS: "Domain contains forbidden Unicode characters",
                DOMAIN_INVALID_CHARS: "Domain contains invalid character",
                DOMAIN_INVALID_TLDS_CHARS: "Domain contains invalid tld character",
                DOMAIN_SEGMENTS_COUNT: "Domain lacks the minimum required number of segments",
                DOMAIN_FORBIDDEN_TLDS: "Domain uses forbidden TLD",
                DOMAIN_EMPTY_SEGMENT: "Domain contains empty dot-separated segment",
                DOMAIN_LONG_SEGMENT: "Domain contains dot-separated segment that is too long"
            }, t.code = function(e) {
                return {
                    code: e,
                    error: t.codes[e]
                };
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(27), o = {
                generate: function() {
                    const e = {}, t = "!\\$&'\\(\\)\\*\\+,;=", r = "\\w-\\.~%\\dA-Fa-f" + t + ":@", s = "[" + r + "]", n = "(?:0{0,2}\\d|0?[1-9]\\d|1\\d\\d|2[0-4]\\d|25[0-5])";
                    e.ipv4address = "(?:" + n + "\\.){3}" + n;
                    const o = "[\\dA-Fa-f]{1,4}", a = "(?:" + o + ":" + o + "|" + e.ipv4address + ")", i = "(?:" + o + ":){6}" + a, l = "::(?:" + o + ":){5}" + a, c = "(?:" + o + ")?::(?:" + o + ":){4}" + a, u = "(?:(?:" + o + ":){0,1}" + o + ")?::(?:" + o + ":){3}" + a, f = "(?:(?:" + o + ":){0,2}" + o + ")?::(?:" + o + ":){2}" + a, m = "(?:(?:" + o + ":){0,3}" + o + ")?::" + o + ":" + a, h = "(?:(?:" + o + ":){0,4}" + o + ")?::" + a;
                    e.ipv4Cidr = "(?:\\d|[1-2]\\d|3[0-2])", e.ipv6Cidr = "(?:0{0,2}\\d|0?[1-9]\\d|1[01]\\d|12[0-8])", e.ipv6address = "(?:" + i + "|" + l + "|" + c + "|" + u + "|" + f + "|" + m + "|" + h + "|(?:(?:[\\dA-Fa-f]{1,4}:){0,5}[\\dA-Fa-f]{1,4})?::[\\dA-Fa-f]{1,4}|(?:(?:[\\dA-Fa-f]{1,4}:){0,6}[\\dA-Fa-f]{1,4})?::)", e.ipvFuture = "v[\\dA-Fa-f]+\\.[\\w-\\.~" + t + ":]+", e.scheme = "[a-zA-Z][a-zA-Z\\d+-\\.]*", e.schemeRegex = new RegExp(e.scheme);
                    const d = "[\\w-\\.~%\\dA-Fa-f" + t + ":]*", p = "(?:" + ("\\[(?:" + e.ipv6address + "|" + e.ipvFuture + ")\\]") + "|" + e.ipv4address + "|[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=]{1,255})", g = "(?:" + d + "@)?" + p + "(?::\\d*)?", y = "(?:" + d + "@)?(" + p + ")(?::\\d*)?", b = s + "*", v = s + "+", _ = "(?:\\/" + b + ")*", w = "\\/(?:" + v + _ + ")?", $ = v + _, x = "[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=@]+" + _;
                    return e.hierPart = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|" + $ + "|(?:\\/\\/\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*(?:\\/[\\w-\\.~%\\dA-Fa-f!\\$&'\\(\\)\\*\\+,;=:@]*)*))", e.hierPartCapture = "(?:(?:\\/\\/" + y + _ + ")|" + w + "|" + $ + ")", e.relativeRef = "(?:(?:\\/\\/" + g + _ + ")|" + w + "|" + x + "|)", e.relativeRefCapture = "(?:(?:\\/\\/" + y + _ + ")|" + w + "|" + x + "|)", e.query = "[" + r + "\\/\\?]*(?=#|$)", e.queryWithSquareBrackets = "[" + r + "\\[\\]\\/\\?]*(?=#|$)", e.fragment = "[" + r + "\\/\\?]*", e;
                }
            };
            o.rfc3986 = o.generate(), t.ip = {
                v4Cidr: o.rfc3986.ipv4Cidr,
                v6Cidr: o.rfc3986.ipv6Cidr,
                ipv4: o.rfc3986.ipv4address,
                ipv6: o.rfc3986.ipv6address,
                ipvfuture: o.rfc3986.ipvFuture
            }, o.createRegex = function(e) {
                const t = o.rfc3986, r = "(?:\\?" + (e.allowQuerySquareBrackets ? t.queryWithSquareBrackets : t.query) + ")?(?:#" + t.fragment + ")?", a = e.domain ? t.relativeRefCapture : t.relativeRef;
                if (e.relativeOnly) return o.wrap(a + r);
                let i = "";
                if (e.scheme) {
                    s(e.scheme instanceof RegExp || "string" == typeof e.scheme || Array.isArray(e.scheme), "scheme must be a RegExp, String, or Array");
                    const r = [].concat(e.scheme);
                    s(r.length >= 1, "scheme must have at least 1 scheme specified");
                    const o = [];
                    for(let e = 0; e < r.length; ++e){
                        const a = r[e];
                        s(a instanceof RegExp || "string" == typeof a, "scheme at position " + e + " must be a RegExp or String"), a instanceof RegExp ? o.push(a.source.toString()) : (s(t.schemeRegex.test(a), "scheme at position " + e + " must be a valid scheme"), o.push(n(a)));
                    }
                    i = o.join("|");
                }
                const l = "(?:" + (i ? "(?:" + i + ")" : t.scheme) + ":" + (e.domain ? t.hierPartCapture : t.hierPart) + ")", c = e.allowRelative ? "(?:" + l + "|" + a + ")" : l;
                return o.wrap(c + r, i);
            }, o.wrap = function(e, t) {
                return {
                    raw: e = "(?=.)(?!https?:/$)".concat(e),
                    regex: new RegExp("^".concat(e, "$")),
                    scheme: t
                };
            }, o.uriRegex = o.createRegex({}), t.regex = function(e = {}) {
                return e.scheme || e.allowRelative || e.relativeOnly || e.allowQuerySquareBrackets || e.domain ? o.createRegex(e) : o.uriRegex;
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function(e) {
                return e.replace(/[\^\$\.\*\+\-\?\=\!\:\|\\\/\(\)\[\]\{\}\,]/g, "\\$&");
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function(...e) {
                try {
                    return JSON.stringify.apply(null, e);
                } catch (e) {
                    return "[Cannot display object: " + e.message + "]";
                }
            };
        },
        function(e) {
            e.exports = JSON.parse('{"version":"17.1.1"}');
        },
        function(e, t, r) {
            "use strict";
            const s = {};
            e.exports = function(e) {
                if (!e) return "";
                let t = "";
                for(let r = 0; r < e.length; ++r){
                    const n = e.charCodeAt(r);
                    s.isSafe(n) ? t += e[r] : t += s.escapeHtmlChar(n);
                }
                return t;
            }, s.escapeHtmlChar = function(e) {
                const t = s.namedHtml[e];
                if (void 0 !== t) return t;
                if (e >= 256) return "&#" + e + ";";
                const r = e.toString(16).padStart(2, "0");
                return "&#x".concat(r, ";");
            }, s.isSafe = function(e) {
                return void 0 !== s.safeCharCodes[e];
            }, s.namedHtml = {
                38: "&amp;",
                60: "&lt;",
                62: "&gt;",
                34: "&quot;",
                160: "&nbsp;",
                162: "&cent;",
                163: "&pound;",
                164: "&curren;",
                169: "&copy;",
                174: "&reg;"
            }, s.safeCharCodes = function() {
                const e = {};
                for(let t = 32; t < 123; ++t)(t >= 97 || t >= 65 && t <= 90 || t >= 48 && t <= 57 || 32 === t || 46 === t || 44 === t || 45 === t || 58 === t || 95 === t) && (e[t] = null);
                return e;
            }();
        },
        function(e, t, r) {
            "use strict";
            const s = {
                operators: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "<=",
                    ">",
                    ">=",
                    "==",
                    "!=",
                    "&&",
                    "||",
                    "??"
                ],
                operatorCharacters: [
                    "!",
                    "^",
                    "*",
                    "/",
                    "%",
                    "+",
                    "-",
                    "<",
                    "=",
                    ">",
                    "&",
                    "|",
                    "?"
                ],
                operatorsOrder: [
                    [
                        "^"
                    ],
                    [
                        "*",
                        "/",
                        "%"
                    ],
                    [
                        "+",
                        "-"
                    ],
                    [
                        "<",
                        "<=",
                        ">",
                        ">="
                    ],
                    [
                        "==",
                        "!="
                    ],
                    [
                        "&&"
                    ],
                    [
                        "||",
                        "??"
                    ]
                ],
                operatorsPrefix: [
                    "!",
                    "n"
                ],
                literals: {
                    '"': '"',
                    "`": "`",
                    "'": "'",
                    "[": "]"
                },
                numberRx: /^(?:[0-9]*\.?[0-9]*){1}$/,
                tokenRx: /^[\w\$\#\.\@\:\{\}]+$/,
                symbol: Symbol("formula"),
                settings: Symbol("settings")
            };
            t.Parser = class {
                constructor(e, t = {}){
                    if (!t[s.settings] && t.constants) for(const e in t.constants){
                        const r = t.constants[e];
                        if (null !== r && ![
                            "boolean",
                            "number",
                            "string"
                        ].includes(typeof r)) throw new Error("Formula constant ".concat(e, " contains invalid ").concat(typeof r, " value type"));
                    }
                    this.settings = t[s.settings] ? t : Object.assign({
                        [s.settings]: !0,
                        constants: {},
                        functions: {}
                    }, t), this.single = null, this._parts = null, this._parse(e);
                }
                _parse(e) {
                    let r = [], n = "", o = 0, a = !1;
                    const i = (e)=>{
                        if (o) throw new Error("Formula missing closing parenthesis");
                        const i = r.length ? r[r.length - 1] : null;
                        if (a || n || e) {
                            if (i && "reference" === i.type && ")" === e) return i.type = "function", i.value = this._subFormula(n, i.value), void (n = "");
                            if (")" === e) {
                                const e = new t.Parser(n, this.settings);
                                r.push({
                                    type: "segment",
                                    value: e
                                });
                            } else if (a) {
                                if ("]" === a) return r.push({
                                    type: "reference",
                                    value: n
                                }), void (n = "");
                                r.push({
                                    type: "literal",
                                    value: n
                                });
                            } else if (s.operatorCharacters.includes(n)) i && "operator" === i.type && s.operators.includes(i.value + n) ? i.value += n : r.push({
                                type: "operator",
                                value: n
                            });
                            else if (n.match(s.numberRx)) r.push({
                                type: "constant",
                                value: parseFloat(n)
                            });
                            else if (void 0 !== this.settings.constants[n]) r.push({
                                type: "constant",
                                value: this.settings.constants[n]
                            });
                            else {
                                if (!n.match(s.tokenRx)) throw new Error("Formula contains invalid token: ".concat(n));
                                r.push({
                                    type: "reference",
                                    value: n
                                });
                            }
                            n = "";
                        }
                    };
                    for (const t of e)a ? t === a ? (i(), a = !1) : n += t : o ? "(" === t ? (n += t, ++o) : ")" === t ? (--o, o ? n += t : i(t)) : n += t : t in s.literals ? a = s.literals[t] : "(" === t ? (i(), ++o) : s.operatorCharacters.includes(t) ? (i(), n = t, i()) : " " !== t ? n += t : i();
                    i(), r = r.map((e, t)=>"operator" !== e.type || "-" !== e.value || t && "operator" !== r[t - 1].type ? e : {
                            type: "operator",
                            value: "n"
                        });
                    let l = !1;
                    for (const e of r){
                        if ("operator" === e.type) {
                            if (s.operatorsPrefix.includes(e.value)) continue;
                            if (!l) throw new Error("Formula contains an operator in invalid position");
                            if (!s.operators.includes(e.value)) throw new Error("Formula contains an unknown operator ".concat(e.value));
                        } else if (l) throw new Error("Formula missing expected operator");
                        l = !l;
                    }
                    if (!l) throw new Error("Formula contains invalid trailing operator");
                    1 === r.length && [
                        "reference",
                        "literal",
                        "constant"
                    ].includes(r[0].type) && (this.single = {
                        type: "reference" === r[0].type ? "reference" : "value",
                        value: r[0].value
                    }), this._parts = r.map((e)=>{
                        if ("operator" === e.type) return s.operatorsPrefix.includes(e.value) ? e : e.value;
                        if ("reference" !== e.type) return e.value;
                        if (this.settings.tokenRx && !this.settings.tokenRx.test(e.value)) throw new Error("Formula contains invalid reference ".concat(e.value));
                        return this.settings.reference ? this.settings.reference(e.value) : s.reference(e.value);
                    });
                }
                _subFormula(e, r) {
                    const n = this.settings.functions[r];
                    if ("function" != typeof n) throw new Error("Formula contains unknown function ".concat(r));
                    let o = [];
                    if (e) {
                        let t = "", n = 0, a = !1;
                        const i = ()=>{
                            if (!t) throw new Error("Formula contains function ".concat(r, " with invalid arguments ").concat(e));
                            o.push(t), t = "";
                        };
                        for(let r = 0; r < e.length; ++r){
                            const o = e[r];
                            a ? (t += o, o === a && (a = !1)) : o in s.literals && !n ? (t += o, a = s.literals[o]) : "," !== o || n ? (t += o, "(" === o ? ++n : ")" === o && --n) : i();
                        }
                        i();
                    }
                    return o = o.map((e)=>new t.Parser(e, this.settings)), function(e) {
                        const t = [];
                        for (const r of o)t.push(r.evaluate(e));
                        return n.call(e, ...t);
                    };
                }
                evaluate(e) {
                    const t = this._parts.slice();
                    for(let r = t.length - 2; r >= 0; --r){
                        const n = t[r];
                        if (n && "operator" === n.type) {
                            const o = t[r + 1];
                            t.splice(r + 1, 1);
                            const a = s.evaluate(o, e);
                            t[r] = s.single(n.value, a);
                        }
                    }
                    return s.operatorsOrder.forEach((r)=>{
                        for(let n = 1; n < t.length - 1;)if (r.includes(t[n])) {
                            const r = t[n], o = s.evaluate(t[n - 1], e), a = s.evaluate(t[n + 1], e);
                            t.splice(n, 2);
                            const i = s.calculate(r, o, a);
                            t[n - 1] = 0 === i ? 0 : i;
                        } else n += 2;
                    }), s.evaluate(t[0], e);
                }
            }, t.Parser.prototype[s.symbol] = !0, s.reference = function(e) {
                return function(t) {
                    return t && void 0 !== t[e] ? t[e] : null;
                };
            }, s.evaluate = function(e, t) {
                return null === e ? null : "function" == typeof e ? e(t) : e[s.symbol] ? e.evaluate(t) : e;
            }, s.single = function(e, t) {
                if ("!" === e) return !t;
                const r = -t;
                return 0 === r ? 0 : r;
            }, s.calculate = function(e, t, r) {
                if ("??" === e) return s.exists(t) ? t : r;
                if ("string" == typeof t || "string" == typeof r) {
                    if ("+" === e) return (t = s.exists(t) ? t : "") + (r = s.exists(r) ? r : "");
                } else switch(e){
                    case "^":
                        return Math.pow(t, r);
                    case "*":
                        return t * r;
                    case "/":
                        return t / r;
                    case "%":
                        return t % r;
                    case "+":
                        return t + r;
                    case "-":
                        return t - r;
                }
                switch(e){
                    case "<":
                        return t < r;
                    case "<=":
                        return t <= r;
                    case ">":
                        return t > r;
                    case ">=":
                        return t >= r;
                    case "==":
                        return t === r;
                    case "!=":
                        return t !== r;
                    case "&&":
                        return t && r;
                    case "||":
                        return t || r;
                }
                return null;
            }, s.exists = function(e) {
                return null != e;
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(8), i = r(4), l = r(5), c = {};
            e.exports = n.extend({
                type: "alternatives",
                flags: {
                    match: {
                        default: "any"
                    }
                },
                terms: {
                    matches: {
                        init: [],
                        register: l.toSibling
                    }
                },
                args: (e, ...t)=>1 === t.length && Array.isArray(t[0]) ? e.try(...t[0]) : e.try(...t),
                validate (e, t) {
                    const { schema: r, error: s, state: n, prefs: o } = t;
                    if (r._flags.match) {
                        let t, a = 0;
                        for(let s = 0; s < r.$_terms.matches.length; ++s){
                            const i = r.$_terms.matches[s], l = n.nest(i.schema, "match.".concat(s));
                            l.snapshot();
                            const c = i.schema.$_validate(e, l, o);
                            c.errors ? l.restore() : (++a, t = c.value);
                        }
                        return a ? "one" === r._flags.match ? 1 === a ? {
                            value: t
                        } : {
                            errors: s("alternatives.one")
                        } : a === r.$_terms.matches.length ? {
                            value: e
                        } : {
                            errors: s("alternatives.all")
                        } : {
                            errors: s("alternatives.any")
                        };
                    }
                    const a = [];
                    for(let t = 0; t < r.$_terms.matches.length; ++t){
                        const s = r.$_terms.matches[t];
                        if (s.schema) {
                            const r = n.nest(s.schema, "match.".concat(t));
                            r.snapshot();
                            const i = s.schema.$_validate(e, r, o);
                            if (!i.errors) return i;
                            r.restore(), a.push({
                                schema: s.schema,
                                reports: i.errors
                            });
                            continue;
                        }
                        const i = s.ref ? s.ref.resolve(e, n, o) : e, l = s.is ? [
                            s
                        ] : s.switch;
                        for(let r = 0; r < l.length; ++r){
                            const a = l[r], { is: c, then: u, otherwise: f } = a, m = "match.".concat(t).concat(s.switch ? "." + r : "");
                            if (c.$_match(i, n.nest(c, "".concat(m, ".is")), o)) {
                                if (u) return u.$_validate(e, n.nest(u, "".concat(m, ".then")), o);
                            } else if (f) return f.$_validate(e, n.nest(f, "".concat(m, ".otherwise")), o);
                        }
                    }
                    return c.errors(a, t);
                },
                rules: {
                    conditional: {
                        method (e, t) {
                            s(!this._flags._endedSwitch, "Unreachable condition"), s(!this._flags.match, "Cannot combine match mode", this._flags.match, "with conditional rule"), s(void 0 === t.break, "Cannot use break option with alternatives conditional");
                            const r = this.clone(), n = a.when(r, e, t), o = n.is ? [
                                n
                            ] : n.switch;
                            for (const e of o)if (e.then && e.otherwise) {
                                r.$_setFlag("_endedSwitch", !0, {
                                    clone: !1
                                });
                                break;
                            }
                            return r.$_terms.matches.push(n), r.$_mutateRebuild();
                        }
                    },
                    match: {
                        method (e) {
                            if (s([
                                "any",
                                "one",
                                "all"
                            ].includes(e), "Invalid alternatives match mode", e), "any" !== e) for (const t of this.$_terms.matches)s(t.schema, "Cannot combine match mode", e, "with conditional rules");
                            return this.$_setFlag("match", e);
                        }
                    },
                    try: {
                        method (...e) {
                            s(e.length, "Missing alternative schemas"), o.verifyFlat(e, "try"), s(!this._flags._endedSwitch, "Unreachable condition");
                            const t = this.clone();
                            for (const r of e)t.$_terms.matches.push({
                                schema: t.$_compile(r)
                            });
                            return t.$_mutateRebuild();
                        }
                    }
                },
                overrides: {
                    label (e) {
                        return this.$_super.label(e).$_modify({
                            each: (t, r)=>"is" !== r.path[0] ? t.label(e) : void 0,
                            ref: !1
                        });
                    }
                },
                rebuild (e) {
                    e.$_modify({
                        each: (t)=>{
                            o.isSchema(t) && "array" === t.type && e.$_setFlag("_arrayItems", !0, {
                                clone: !1
                            });
                        }
                    });
                },
                manifest: {
                    build (e, t) {
                        if (t.matches) for (const r of t.matches){
                            const { schema: t, ref: s, is: n, not: o, then: a, otherwise: i } = r;
                            e = t ? e.try(t) : s ? e.conditional(s, {
                                is: n,
                                then: a,
                                not: o,
                                otherwise: i,
                                switch: r.switch
                            }) : e.conditional(n, {
                                then: a,
                                otherwise: i
                            });
                        }
                        return e;
                    }
                },
                messages: {
                    "alternatives.all": "{{#label}} does not match all of the required types",
                    "alternatives.any": "{{#label}} does not match any of the allowed types",
                    "alternatives.match": "{{#label}} does not match any of the allowed types",
                    "alternatives.one": "{{#label}} matches more than one allowed type",
                    "alternatives.types": "{{#label}} must be one of {{#types}}"
                }
            }), c.errors = function(e, { error: t, state: r }) {
                if (!e.length) return {
                    errors: t("alternatives.any")
                };
                if (1 === e.length) return {
                    errors: e[0].reports
                };
                const s = new Set, n = [];
                for (const { reports: o, schema: a } of e){
                    if (o.length > 1) return c.unmatched(e, t);
                    const l = o[0];
                    if (l instanceof i.Report == !1) return c.unmatched(e, t);
                    if (l.state.path.length !== r.path.length) {
                        n.push({
                            type: a.type,
                            report: l
                        });
                        continue;
                    }
                    if ("any.only" === l.code) {
                        for (const e of l.local.valids)s.add(e);
                        continue;
                    }
                    const [u, f] = l.code.split(".");
                    "base" === f ? s.add(u) : n.push({
                        type: a.type,
                        report: l
                    });
                }
                return n.length ? 1 === n.length ? {
                    errors: n[0].report
                } : c.unmatched(e, t) : {
                    errors: t("alternatives.types", {
                        types: [
                            ...s
                        ]
                    })
                };
            }, c.unmatched = function(e, t) {
                const r = [];
                for (const t of e)r.push(...t.reports);
                return {
                    errors: t("alternatives.match", i.details(r, {
                        override: !1
                    }))
                };
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(10), a = r(20), i = r(15), l = r(1), c = r(8), u = r(4), f = r(17), m = r(18), h = r(9), d = r(35), p = r(5), g = r(19), y = r(36), b = r(21), v = {
                Base: class {
                    constructor(e){
                        this.type = e, this.$_root = null, this._definition = {}, this._ids = new d.Ids, this._preferences = null, this._refs = new p.Manager, this._cache = null, this._valids = null, this._invalids = null, this._flags = {}, this._rules = [], this._singleRules = new Map, this.$_terms = {}, this.$_temp = {
                            ruleset: null,
                            whens: {}
                        };
                    }
                    describe() {
                        return s("function" == typeof m.describe, "Manifest functionality disabled"), m.describe(this);
                    }
                    allow(...e) {
                        return l.verifyFlat(e, "allow"), this._values(e, "_valids");
                    }
                    alter(e) {
                        s(e && "object" == typeof e && !Array.isArray(e), "Invalid targets argument"), s(!this._inRuleset(), "Cannot set alterations inside a ruleset");
                        const t = this.clone();
                        t.$_terms.alterations = t.$_terms.alterations || [];
                        for(const r in e){
                            const n = e[r];
                            s("function" == typeof n, "Alteration adjuster for", r, "must be a function"), t.$_terms.alterations.push({
                                target: r,
                                adjuster: n
                            });
                        }
                        return t.$_temp.ruleset = !1, t;
                    }
                    cast(e) {
                        return s(!1 === e || "string" == typeof e, "Invalid to value"), s(!1 === e || this._definition.cast[e], "Type", this.type, "does not support casting to", e), this.$_setFlag("cast", !1 === e ? void 0 : e);
                    }
                    default(e, t) {
                        return this._default("default", e, t);
                    }
                    description(e) {
                        return s(e && "string" == typeof e, "Description must be a non-empty string"), this.$_setFlag("description", e);
                    }
                    empty(e) {
                        const t = this.clone();
                        return void 0 !== e && (e = t.$_compile(e, {
                            override: !1
                        })), t.$_setFlag("empty", e, {
                            clone: !1
                        });
                    }
                    error(e) {
                        return s(e, "Missing error"), s(e instanceof Error || "function" == typeof e, "Must provide a valid Error object or a function"), this.$_setFlag("error", e);
                    }
                    example(e, t = {}) {
                        return s(void 0 !== e, "Missing example"), l.assertOptions(t, [
                            "override"
                        ]), this._inner("examples", e, {
                            single: !0,
                            override: t.override
                        });
                    }
                    external(e, t) {
                        return "object" == typeof e && (s(!t, "Cannot combine options with description"), t = e.description, e = e.method), s("function" == typeof e, "Method must be a function"), s(void 0 === t || t && "string" == typeof t, "Description must be a non-empty string"), this._inner("externals", {
                            method: e,
                            description: t
                        }, {
                            single: !0
                        });
                    }
                    failover(e, t) {
                        return this._default("failover", e, t);
                    }
                    forbidden() {
                        return this.presence("forbidden");
                    }
                    id(e) {
                        return e ? (s("string" == typeof e, "id must be a non-empty string"), s(/^[^\.]+$/.test(e), "id cannot contain period character"), this.$_setFlag("id", e)) : this.$_setFlag("id", void 0);
                    }
                    invalid(...e) {
                        return this._values(e, "_invalids");
                    }
                    label(e) {
                        return s(e && "string" == typeof e, "Label name must be a non-empty string"), this.$_setFlag("label", e);
                    }
                    meta(e) {
                        return s(void 0 !== e, "Meta cannot be undefined"), this._inner("metas", e, {
                            single: !0
                        });
                    }
                    note(...e) {
                        s(e.length, "Missing notes");
                        for (const t of e)s(t && "string" == typeof t, "Notes must be non-empty strings");
                        return this._inner("notes", e);
                    }
                    only(e = !0) {
                        return s("boolean" == typeof e, "Invalid mode:", e), this.$_setFlag("only", e);
                    }
                    optional() {
                        return this.presence("optional");
                    }
                    prefs(e) {
                        s(e, "Missing preferences"), s(void 0 === e.context, "Cannot override context"), s(void 0 === e.externals, "Cannot override externals"), s(void 0 === e.warnings, "Cannot override warnings"), s(void 0 === e.debug, "Cannot override debug"), l.checkPreferences(e);
                        const t = this.clone();
                        return t._preferences = l.preferences(t._preferences, e), t;
                    }
                    presence(e) {
                        return s([
                            "optional",
                            "required",
                            "forbidden"
                        ].includes(e), "Unknown presence mode", e), this.$_setFlag("presence", e);
                    }
                    raw(e = !0) {
                        return this.$_setFlag("result", e ? "raw" : void 0);
                    }
                    result(e) {
                        return s([
                            "raw",
                            "strip"
                        ].includes(e), "Unknown result mode", e), this.$_setFlag("result", e);
                    }
                    required() {
                        return this.presence("required");
                    }
                    strict(e) {
                        const t = this.clone(), r = void 0 !== e && !e;
                        return t._preferences = l.preferences(t._preferences, {
                            convert: r
                        }), t;
                    }
                    strip(e = !0) {
                        return this.$_setFlag("result", e ? "strip" : void 0);
                    }
                    tag(...e) {
                        s(e.length, "Missing tags");
                        for (const t of e)s(t && "string" == typeof t, "Tags must be non-empty strings");
                        return this._inner("tags", e);
                    }
                    unit(e) {
                        return s(e && "string" == typeof e, "Unit name must be a non-empty string"), this.$_setFlag("unit", e);
                    }
                    valid(...e) {
                        l.verifyFlat(e, "valid");
                        const t = this.allow(...e);
                        return t.$_setFlag("only", !!t._valids, {
                            clone: !1
                        }), t;
                    }
                    when(e, t) {
                        const r = this.clone();
                        r.$_terms.whens || (r.$_terms.whens = []);
                        const n = c.when(r, e, t);
                        if (![
                            "any",
                            "link"
                        ].includes(r.type)) {
                            const e = n.is ? [
                                n
                            ] : n.switch;
                            for (const t of e)s(!t.then || "any" === t.then.type || t.then.type === r.type, "Cannot combine", r.type, "with", t.then && t.then.type), s(!t.otherwise || "any" === t.otherwise.type || t.otherwise.type === r.type, "Cannot combine", r.type, "with", t.otherwise && t.otherwise.type);
                        }
                        return r.$_terms.whens.push(n), r.$_mutateRebuild();
                    }
                    cache(e) {
                        s(!this._inRuleset(), "Cannot set caching inside a ruleset"), s(!this._cache, "Cannot override schema cache");
                        const t = this.clone();
                        return t._cache = e || i.provider.provision(), t.$_temp.ruleset = !1, t;
                    }
                    clone() {
                        const e = Object.create(Object.getPrototypeOf(this));
                        return this._assign(e);
                    }
                    concat(e) {
                        s(l.isSchema(e), "Invalid schema object"), s("any" === this.type || "any" === e.type || e.type === this.type, "Cannot merge type", this.type, "with another type:", e.type), s(!this._inRuleset(), "Cannot concatenate onto a schema with open ruleset"), s(!e._inRuleset(), "Cannot concatenate a schema with open ruleset");
                        let t = this.clone();
                        if ("any" === this.type && "any" !== e.type) {
                            const r = e.clone();
                            for (const e of Object.keys(t))"type" !== e && (r[e] = t[e]);
                            t = r;
                        }
                        t._ids.concat(e._ids), t._refs.register(e, p.toSibling), t._preferences = t._preferences ? l.preferences(t._preferences, e._preferences) : e._preferences, t._valids = b.merge(t._valids, e._valids, e._invalids), t._invalids = b.merge(t._invalids, e._invalids, e._valids);
                        for (const r of e._singleRules.keys())t._singleRules.has(r) && (t._rules = t._rules.filter((e)=>e.keep || e.name !== r), t._singleRules.delete(r));
                        for (const r of e._rules)e._definition.rules[r.method].multi || t._singleRules.set(r.name, r), t._rules.push(r);
                        if (t._flags.empty && e._flags.empty) {
                            t._flags.empty = t._flags.empty.concat(e._flags.empty);
                            const r = Object.assign({}, e._flags);
                            delete r.empty, a(t._flags, r);
                        } else if (e._flags.empty) {
                            t._flags.empty = e._flags.empty;
                            const r = Object.assign({}, e._flags);
                            delete r.empty, a(t._flags, r);
                        } else a(t._flags, e._flags);
                        for(const r in e.$_terms){
                            const s = e.$_terms[r];
                            s ? t.$_terms[r] ? t.$_terms[r] = t.$_terms[r].concat(s) : t.$_terms[r] = s.slice() : t.$_terms[r] || (t.$_terms[r] = s);
                        }
                        return this.$_root._tracer && this.$_root._tracer._combine(t, [
                            this,
                            e
                        ]), t.$_mutateRebuild();
                    }
                    extend(e) {
                        return s(!e.base, "Cannot extend type with another base"), f.type(this, e);
                    }
                    extract(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.reach(e);
                    }
                    fork(e, t) {
                        s(!this._inRuleset(), "Cannot fork inside a ruleset");
                        let r = this;
                        for (let s of [].concat(e))s = Array.isArray(s) ? s : s.split("."), r = r._ids.fork(s, t, r);
                        return r.$_temp.ruleset = !1, r;
                    }
                    rule(e) {
                        const t = this._definition;
                        l.assertOptions(e, Object.keys(t.modifiers)), s(!1 !== this.$_temp.ruleset, "Cannot apply rules to empty ruleset or the last rule added does not support rule properties");
                        const r = null === this.$_temp.ruleset ? this._rules.length - 1 : this.$_temp.ruleset;
                        s(r >= 0 && r < this._rules.length, "Cannot apply rules to empty ruleset");
                        const o = this.clone();
                        for(let a = r; a < o._rules.length; ++a){
                            const r = o._rules[a], i = n(r);
                            for(const n in e)t.modifiers[n](i, e[n]), s(i.name === r.name, "Cannot change rule name");
                            o._rules[a] = i, o._singleRules.get(i.name) === r && o._singleRules.set(i.name, i);
                        }
                        return o.$_temp.ruleset = !1, o.$_mutateRebuild();
                    }
                    get ruleset() {
                        s(!this._inRuleset(), "Cannot start a new ruleset without closing the previous one");
                        const e = this.clone();
                        return e.$_temp.ruleset = e._rules.length, e;
                    }
                    get $() {
                        return this.ruleset;
                    }
                    tailor(e) {
                        e = [].concat(e), s(!this._inRuleset(), "Cannot tailor inside a ruleset");
                        let t = this;
                        if (this.$_terms.alterations) for (const { target: r, adjuster: n } of this.$_terms.alterations)e.includes(r) && (t = n(t), s(l.isSchema(t), "Alteration adjuster for", r, "failed to return a schema object"));
                        return t = t.$_modify({
                            each: (t)=>t.tailor(e),
                            ref: !1
                        }), t.$_temp.ruleset = !1, t.$_mutateRebuild();
                    }
                    tracer() {
                        return g.location ? g.location(this) : this;
                    }
                    validate(e, t) {
                        return y.entry(e, this, t);
                    }
                    validateAsync(e, t) {
                        return y.entryAsync(e, this, t);
                    }
                    $_addRule(e) {
                        "string" == typeof e && (e = {
                            name: e
                        }), s(e && "object" == typeof e, "Invalid options"), s(e.name && "string" == typeof e.name, "Invalid rule name");
                        for(const t in e)s("_" !== t[0], "Cannot set private rule properties");
                        const t = Object.assign({}, e);
                        t._resolve = [], t.method = t.method || t.name;
                        const r = this._definition.rules[t.method], n = t.args;
                        s(r, "Unknown rule", t.method);
                        const o = this.clone();
                        if (n) {
                            s(1 === Object.keys(n).length || Object.keys(n).length === this._definition.rules[t.name].args.length, "Invalid rule definition for", this.type, t.name);
                            for(const e in n){
                                let a = n[e];
                                if (void 0 !== a) {
                                    if (r.argsByName) {
                                        const i = r.argsByName.get(e);
                                        if (i.ref && l.isResolvable(a)) t._resolve.push(e), o.$_mutateRegister(a);
                                        else if (i.normalize && (a = i.normalize(a), n[e] = a), i.assert) {
                                            const t = l.validateArg(a, e, i);
                                            s(!t, t, "or reference");
                                        }
                                    }
                                    n[e] = a;
                                } else delete n[e];
                            }
                        }
                        return r.multi || (o._ruleRemove(t.name, {
                            clone: !1
                        }), o._singleRules.set(t.name, t)), !1 === o.$_temp.ruleset && (o.$_temp.ruleset = null), r.priority ? o._rules.unshift(t) : o._rules.push(t), o;
                    }
                    $_compile(e, t) {
                        return c.schema(this.$_root, e, t);
                    }
                    $_createError(e, t, r, s, n, o = {}) {
                        const a = !1 !== o.flags ? this._flags : {}, i = o.messages ? h.merge(this._definition.messages, o.messages) : this._definition.messages;
                        return new u.Report(e, t, r, a, i, s, n);
                    }
                    $_getFlag(e) {
                        return this._flags[e];
                    }
                    $_getRule(e) {
                        return this._singleRules.get(e);
                    }
                    $_mapLabels(e) {
                        return e = Array.isArray(e) ? e : e.split("."), this._ids.labels(e);
                    }
                    $_match(e, t, r, s) {
                        (r = Object.assign({}, r)).abortEarly = !0, r._externals = !1, t.snapshot();
                        const n = !y.validate(e, this, t, r, s).errors;
                        return t.restore(), n;
                    }
                    $_modify(e) {
                        return l.assertOptions(e, [
                            "each",
                            "once",
                            "ref",
                            "schema"
                        ]), d.schema(this, e) || this;
                    }
                    $_mutateRebuild() {
                        s(!this._inRuleset(), "Cannot add this rule inside a ruleset"), this._refs.reset(), this._ids.reset();
                        return this.$_modify({
                            each: (e, { source: t, name: r, path: s, key: n })=>{
                                const o = this._definition[t][r] && this._definition[t][r].register;
                                !1 !== o && this.$_mutateRegister(e, {
                                    family: o,
                                    key: n
                                });
                            }
                        }), this._definition.rebuild && this._definition.rebuild(this), this.$_temp.ruleset = !1, this;
                    }
                    $_mutateRegister(e, { family: t, key: r } = {}) {
                        this._refs.register(e, t), this._ids.register(e, {
                            key: r
                        });
                    }
                    $_property(e) {
                        return this._definition.properties[e];
                    }
                    $_reach(e) {
                        return this._ids.reach(e);
                    }
                    $_rootReferences() {
                        return this._refs.roots();
                    }
                    $_setFlag(e, t, r = {}) {
                        s("_" === e[0] || !this._inRuleset(), "Cannot set flag inside a ruleset");
                        const n = this._definition.flags[e] || {};
                        if (o(t, n.default) && (t = void 0), o(t, this._flags[e])) return this;
                        const a = !1 !== r.clone ? this.clone() : this;
                        return void 0 !== t ? (a._flags[e] = t, a.$_mutateRegister(t)) : delete a._flags[e], "_" !== e[0] && (a.$_temp.ruleset = !1), a;
                    }
                    $_validate(e, t, r) {
                        return y.validate(e, this, t, r);
                    }
                    _assign(e) {
                        e.type = this.type, e.$_root = this.$_root, e.$_temp = Object.assign({}, this.$_temp), e.$_temp.whens = {}, e._ids = this._ids.clone(), e._preferences = this._preferences, e._valids = this._valids && this._valids.clone(), e._invalids = this._invalids && this._invalids.clone(), e._rules = this._rules.slice(), e._singleRules = n(this._singleRules, {
                            shallow: !0
                        }), e._refs = this._refs.clone(), e._flags = Object.assign({}, this._flags), e._cache = null, e.$_terms = {};
                        for(const t in this.$_terms)e.$_terms[t] = this.$_terms[t] ? this.$_terms[t].slice() : null;
                        e.$_super = {};
                        for(const t in this.$_super)e.$_super[t] = this._super[t].bind(e);
                        return e;
                    }
                    _default(e, t, r = {}) {
                        return l.assertOptions(r, "literal"), s(void 0 !== t, "Missing", e, "value"), s("function" == typeof t || !r.literal, "Only function value supports literal option"), "function" == typeof t && r.literal && (t = {
                            [l.symbols.literal]: !0,
                            literal: t
                        }), this.$_setFlag(e, t);
                    }
                    _generate(e, t, r) {
                        if (!this.$_terms.whens) return {
                            schema: this
                        };
                        const s = [], n = [];
                        for(let o = 0; o < this.$_terms.whens.length; ++o){
                            const a = this.$_terms.whens[o];
                            if (a.concat) {
                                s.push(a.concat), n.push("".concat(o, ".concat"));
                                continue;
                            }
                            const i = a.ref ? a.ref.resolve(e, t, r) : e, l = a.is ? [
                                a
                            ] : a.switch, c = n.length;
                            for(let c = 0; c < l.length; ++c){
                                const { is: u, then: f, otherwise: m } = l[c], h = "".concat(o).concat(a.switch ? "." + c : "");
                                if (u.$_match(i, t.nest(u, "".concat(h, ".is")), r)) {
                                    if (f) {
                                        const o = t.localize([
                                            ...t.path,
                                            "".concat(h, ".then")
                                        ], t.ancestors, t.schemas), { schema: a, id: i } = f._generate(e, o, r);
                                        s.push(a), n.push("".concat(h, ".then").concat(i ? "(".concat(i, ")") : ""));
                                        break;
                                    }
                                } else if (m) {
                                    const o = t.localize([
                                        ...t.path,
                                        "".concat(h, ".otherwise")
                                    ], t.ancestors, t.schemas), { schema: a, id: i } = m._generate(e, o, r);
                                    s.push(a), n.push("".concat(h, ".otherwise").concat(i ? "(".concat(i, ")") : ""));
                                    break;
                                }
                            }
                            if (a.break && n.length > c) break;
                        }
                        const o = n.join(", ");
                        if (t.mainstay.tracer.debug(t, "rule", "when", o), !o) return {
                            schema: this
                        };
                        if (!t.mainstay.tracer.active && this.$_temp.whens[o]) return {
                            schema: this.$_temp.whens[o],
                            id: o
                        };
                        let a = this;
                        this._definition.generate && (a = this._definition.generate(this, e, t, r));
                        for (const e of s)a = a.concat(e);
                        return this.$_root._tracer && this.$_root._tracer._combine(a, [
                            this,
                            ...s
                        ]), this.$_temp.whens[o] = a, {
                            schema: a,
                            id: o
                        };
                    }
                    _inner(e, t, r = {}) {
                        s(!this._inRuleset(), "Cannot set ".concat(e, " inside a ruleset"));
                        const n = this.clone();
                        return n.$_terms[e] && !r.override || (n.$_terms[e] = []), r.single ? n.$_terms[e].push(t) : n.$_terms[e].push(...t), n.$_temp.ruleset = !1, n;
                    }
                    _inRuleset() {
                        return null !== this.$_temp.ruleset && !1 !== this.$_temp.ruleset;
                    }
                    _ruleRemove(e, t = {}) {
                        if (!this._singleRules.has(e)) return this;
                        const r = !1 !== t.clone ? this.clone() : this;
                        r._singleRules.delete(e);
                        const s = [];
                        for(let t = 0; t < r._rules.length; ++t){
                            const n = r._rules[t];
                            n.name !== e || n.keep ? s.push(n) : r._inRuleset() && t < r.$_temp.ruleset && --r.$_temp.ruleset;
                        }
                        return r._rules = s, r;
                    }
                    _values(e, t) {
                        l.verifyFlat(e, t.slice(1, -1));
                        const r = this.clone(), n = e[0] === l.symbols.override;
                        if (n && (e = e.slice(1)), !r[t] && e.length ? r[t] = new b : n && (r[t] = e.length ? new b : null, r.$_mutateRebuild()), !r[t]) return r;
                        n && r[t].override();
                        for (const n of e){
                            s(void 0 !== n, "Cannot call allow/valid/invalid with undefined"), s(n !== l.symbols.override, "Override must be the first value");
                            const e = "_invalids" === t ? "_valids" : "_invalids";
                            r[e] && (r[e].remove(n), r[e].length || (s("_valids" === t || !r._flags.only, "Setting invalid value", n, "leaves schema rejecting all values due to previous valid rule"), r[e] = null)), r[t].add(n, r._refs);
                        }
                        return r;
                    }
                }
            };
            v.Base.prototype[l.symbols.any] = {
                version: l.version,
                compile: c.compile,
                root: "$_root"
            }, v.Base.prototype.isImmutable = !0, v.Base.prototype.deny = v.Base.prototype.invalid, v.Base.prototype.disallow = v.Base.prototype.invalid, v.Base.prototype.equal = v.Base.prototype.valid, v.Base.prototype.exist = v.Base.prototype.required, v.Base.prototype.not = v.Base.prototype.invalid, v.Base.prototype.options = v.Base.prototype.prefs, v.Base.prototype.preferences = v.Base.prototype.prefs, e.exports = new v.Base;
        },
        function(e, t, r) {
            "use strict";
            function s(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var s = Object.getOwnPropertySymbols(e);
                    t && (s = s.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, s);
                }
                return r;
            }
            function n(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            const o = r(0), a = r(1), i = r(5), l = {};
            t.Ids = l.Ids = class {
                constructor(){
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                clone() {
                    const e = new l.Ids;
                    return e._byId = new Map(this._byId), e._byKey = new Map(this._byKey), e._schemaChain = this._schemaChain, e;
                }
                concat(e) {
                    e._schemaChain && (this._schemaChain = !0);
                    for (const [t, r] of e._byId.entries())o(!this._byKey.has(t), "Schema id conflicts with existing key:", t), this._byId.set(t, r);
                    for (const [t, r] of e._byKey.entries())o(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, r);
                }
                fork(e, t, r) {
                    const s = this._collect(e);
                    s.push({
                        schema: r
                    });
                    const n = s.shift();
                    let i = {
                        id: n.id,
                        schema: t(n.schema)
                    };
                    o(a.isSchema(i.schema), "adjuster function failed to return a joi schema type");
                    for (const e of s)i = {
                        id: e.id,
                        schema: l.fork(e.schema, i.id, i.schema)
                    };
                    return i.schema;
                }
                labels(e, t = []) {
                    const r = e[0], s = this._get(r);
                    if (!s) return [
                        ...t,
                        ...e
                    ].join(".");
                    const n = e.slice(1);
                    return t = [
                        ...t,
                        s.schema._flags.label || r
                    ], n.length ? s.schema._ids.labels(n, t) : t.join(".");
                }
                reach(e, t = []) {
                    const r = e[0], s = this._get(r);
                    o(s, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join("."));
                    const n = e.slice(1);
                    return n.length ? s.schema._ids.reach(n, [
                        ...t,
                        r
                    ]) : s.schema;
                }
                register(e, { key: t } = {}) {
                    if (!e || !a.isSchema(e)) return;
                    (e.$_property("schemaChain") || e._ids._schemaChain) && (this._schemaChain = !0);
                    const r = e._flags.id;
                    if (r) {
                        const t = this._byId.get(r);
                        o(!t || t.schema === e, "Cannot add different schemas with the same id:", r), o(!this._byKey.has(r), "Schema id conflicts with existing key:", r), this._byId.set(r, {
                            schema: e,
                            id: r
                        });
                    }
                    t && (o(!this._byKey.has(t), "Schema already contains key:", t), o(!this._byId.has(t), "Schema key conflicts with existing id:", t), this._byKey.set(t, {
                        schema: e,
                        id: t
                    }));
                }
                reset() {
                    this._byId = new Map, this._byKey = new Map, this._schemaChain = !1;
                }
                _collect(e, t = [], r = []) {
                    const s = e[0], n = this._get(s);
                    o(n, "Schema does not contain path", [
                        ...t,
                        ...e
                    ].join(".")), r = [
                        n,
                        ...r
                    ];
                    const a = e.slice(1);
                    return a.length ? n.schema._ids._collect(a, [
                        ...t,
                        s
                    ], r) : r;
                }
                _get(e) {
                    return this._byId.get(e) || this._byKey.get(e);
                }
            }, l.fork = function(e, r, s) {
                const n = t.schema(e, {
                    each: (e, { key: t })=>{
                        if (r === (e._flags.id || t)) return s;
                    },
                    ref: !1
                });
                return n ? n.$_mutateRebuild() : e;
            }, t.schema = function(e, t) {
                let r;
                for(const s in e._flags){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e._flags[s], {
                        source: "flags",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r._flags[s] = n);
                }
                for(let s = 0; s < e._rules.length; ++s){
                    const n = e._rules[s], o = l.scan(n.args, {
                        source: "rules",
                        name: n.name
                    }, t);
                    if (void 0 !== o) {
                        r = r || e.clone();
                        const t = Object.assign({}, n);
                        t.args = o, r._rules[s] = t, r._singleRules.get(n.name) === n && r._singleRules.set(n.name, t);
                    }
                }
                for(const s in e.$_terms){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e.$_terms[s], {
                        source: "terms",
                        name: s
                    }, t);
                    void 0 !== n && (r = r || e.clone(), r.$_terms[s] = n);
                }
                return r;
            }, l.scan = function(e, t, r, o, c) {
                const u = o || [];
                if (null === e || "object" != typeof e) return;
                let f;
                if (Array.isArray(e)) {
                    for(let s = 0; s < e.length; ++s){
                        const n = "terms" === t.source && "keys" === t.name && e[s].key, o = l.scan(e[s], t, r, [
                            s,
                            ...u
                        ], n);
                        void 0 !== o && (f = f || e.slice(), f[s] = o);
                    }
                    return f;
                }
                if (!1 !== r.schema && a.isSchema(e) || !1 !== r.ref && i.isRef(e)) {
                    const o = r.each(e, function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var r = null != arguments[t] ? arguments[t] : {};
                            t % 2 ? s(Object(r), !0).forEach(function(t) {
                                n(e, t, r[t]);
                            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function(t) {
                                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                            });
                        }
                        return e;
                    }({}, t, {
                        path: u,
                        key: c
                    }));
                    if (o === e) return;
                    return o;
                }
                for(const s in e){
                    if ("_" === s[0]) continue;
                    const n = l.scan(e[s], t, r, [
                        s,
                        ...u
                    ], c);
                    void 0 !== n && (f = f || Object.assign({}, e), f[s] = n);
                }
                return f;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(37), a = r(6), i = r(1), l = r(4), c = r(38), u = {
                result: Symbol("result")
            };
            t.entry = function(e, t, r) {
                let n = i.defaults;
                r && (s(void 0 === r.warnings, "Cannot override warnings preference in synchronous validation"), n = i.preferences(i.defaults, r));
                const o = u.entry(e, t, n);
                s(!o.mainstay.externals.length, "Schema with external rules must use validateAsync()");
                const a = {
                    value: o.value
                };
                return o.error && (a.error = o.error), o.mainstay.warnings.length && (a.warning = l.details(o.mainstay.warnings)), o.mainstay.debug && (a.debug = o.mainstay.debug), a;
            }, t.entryAsync = async function(e, t, r) {
                let s = i.defaults;
                r && (s = i.preferences(i.defaults, r));
                const n = u.entry(e, t, s), o = n.mainstay;
                if (n.error) throw o.debug && (n.error.debug = o.debug), n.error;
                if (o.externals.length) {
                    let e = n.value;
                    for (const { method: t, path: r, label: s } of o.externals){
                        let n, o, i = e;
                        r.length && (n = r[r.length - 1], o = a(e, r.slice(0, -1)), i = o[n]);
                        try {
                            const r = await t(i);
                            if (void 0 === r || r === i) continue;
                            o ? o[n] = r : e = r;
                        } catch (e) {
                            throw e.message += " (".concat(s, ")"), e;
                        }
                    }
                    n.value = e;
                }
                if (!s.warnings && !s.debug) return n.value;
                const c = {
                    value: n.value
                };
                return o.warnings.length && (c.warning = l.details(o.warnings)), o.debug && (c.debug = o.debug), c;
            }, u.entry = function(e, r, s) {
                const { tracer: n, cleanup: o } = u.tracer(r, s), a = {
                    externals: [],
                    warnings: [],
                    tracer: n,
                    debug: s.debug ? [] : null,
                    links: r._ids._schemaChain ? new Map : null
                }, i = r._ids._schemaChain ? [
                    {
                        schema: r
                    }
                ] : null, f = new c([], [], {
                    mainstay: a,
                    schemas: i
                }), m = t.validate(e, r, f, s);
                o && r.$_root.untrace();
                const h = l.process(m.errors, e, s);
                return {
                    value: m.value,
                    error: h,
                    mainstay: a
                };
            }, u.tracer = function(e, t) {
                return e.$_root._tracer ? {
                    tracer: e.$_root._tracer._register(e)
                } : t.debug ? (s(e.$_root.trace, "Debug mode not supported"), {
                    tracer: e.$_root.trace()._register(e),
                    cleanup: !0
                }) : {
                    tracer: u.ignore
                };
            }, t.validate = function(e, t, r, s, n = {}) {
                if (t.$_terms.whens && (t = t._generate(e, r, s).schema), t._preferences && (s = u.prefs(t, s)), t._cache && s.cache) {
                    const s = t._cache.get(e);
                    if (r.mainstay.tracer.debug(r, "validate", "cached", !!s), s) return s;
                }
                const o = (n, o, a)=>t.$_createError(n, e, o, a || r, s), a = {
                    original: e,
                    prefs: s,
                    schema: t,
                    state: r,
                    error: o,
                    warn: (e, t, s)=>r.mainstay.warnings.push(o(e, t, s)),
                    message: (n, o)=>t.$_createError("custom", e, o, r, s, {
                            messages: n
                        })
                };
                r.mainstay.tracer.entry(t, r);
                const l = t._definition;
                if (l.prepare && void 0 !== e && s.convert) {
                    const t = l.prepare(e, a);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "prepare", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), a);
                        e = t.value;
                    }
                }
                if (l.coerce && void 0 !== e && s.convert && (!l.coerce.from || l.coerce.from.includes(typeof e))) {
                    const t = l.coerce.method(e, a);
                    if (t) {
                        if (r.mainstay.tracer.value(r, "coerced", e, t.value), t.errors) return u.finalize(t.value, [].concat(t.errors), a);
                        e = t.value;
                    }
                }
                const c = t._flags.empty;
                c && c.$_match(u.trim(e, t), r.nest(c), i.defaults) && (r.mainstay.tracer.value(r, "empty", e, void 0), e = void 0);
                const f = n.presence || t._flags.presence || (t._flags._endedSwitch ? "ignore" : s.presence);
                if (void 0 === e) {
                    if ("forbidden" === f) return u.finalize(e, null, a);
                    if ("required" === f) return u.finalize(e, [
                        t.$_createError("any.required", e, null, r, s)
                    ], a);
                    if ("optional" === f) {
                        if (t._flags.default !== i.symbols.deepDefault) return u.finalize(e, null, a);
                        r.mainstay.tracer.value(r, "default", e, {}), e = {};
                    }
                } else if ("forbidden" === f) return u.finalize(e, [
                    t.$_createError("any.unknown", e, null, r, s)
                ], a);
                const m = [];
                if (t._valids) {
                    const n = t._valids.get(e, r, s, t._flags.insensitive);
                    if (n) return s.convert && (r.mainstay.tracer.value(r, "valids", e, n.value), e = n.value), r.mainstay.tracer.filter(t, r, "valid", n), u.finalize(e, null, a);
                    if (t._flags.only) {
                        const n = t.$_createError("any.only", e, {
                            valids: t._valids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            n
                        ], a);
                        m.push(n);
                    }
                }
                if (t._invalids) {
                    const n = t._invalids.get(e, r, s, t._flags.insensitive);
                    if (n) {
                        r.mainstay.tracer.filter(t, r, "invalid", n);
                        const o = t.$_createError("any.invalid", e, {
                            invalids: t._invalids.values({
                                display: !0
                            })
                        }, r, s);
                        if (s.abortEarly) return u.finalize(e, [
                            o
                        ], a);
                        m.push(o);
                    }
                }
                if (l.validate) {
                    const t = l.validate(e, a);
                    if (t && (r.mainstay.tracer.value(r, "base", e, t.value), e = t.value, t.errors)) {
                        if (!Array.isArray(t.errors)) return m.push(t.errors), u.finalize(e, m, a);
                        if (t.errors.length) return m.push(...t.errors), u.finalize(e, m, a);
                    }
                }
                return t._rules.length ? u.rules(e, m, a) : u.finalize(e, m, a);
            }, u.rules = function(e, t, r) {
                const { schema: s, state: n, prefs: o } = r;
                for (const a of s._rules){
                    const l = s._definition.rules[a.method];
                    if (l.convert && o.convert) {
                        n.mainstay.tracer.log(s, n, "rule", a.name, "full");
                        continue;
                    }
                    let c, f = a.args;
                    if (a._resolve.length) {
                        f = Object.assign({}, f);
                        for (const t of a._resolve){
                            const r = l.argsByName.get(t), a = f[t].resolve(e, n, o), u = r.normalize ? r.normalize(a) : a, m = i.validateArg(u, null, r);
                            if (m) {
                                c = s.$_createError("any.ref", a, {
                                    arg: t,
                                    ref: f[t],
                                    reason: m
                                }, n, o);
                                break;
                            }
                            f[t] = u;
                        }
                    }
                    c = c || l.validate(e, r, f, a);
                    const m = u.rule(c, a);
                    if (m.errors) {
                        if (n.mainstay.tracer.log(s, n, "rule", a.name, "error"), a.warn) {
                            n.mainstay.warnings.push(...m.errors);
                            continue;
                        }
                        if (o.abortEarly) return u.finalize(e, m.errors, r);
                        t.push(...m.errors);
                    } else n.mainstay.tracer.log(s, n, "rule", a.name, "pass"), n.mainstay.tracer.value(n, "rule", e, m.value, a.name), e = m.value;
                }
                return u.finalize(e, t, r);
            }, u.rule = function(e, t) {
                return e instanceof l.Report ? (u.error(e, t), {
                    errors: [
                        e
                    ],
                    value: null
                }) : Array.isArray(e) && (e[0] instanceof l.Report || e[0] instanceof Error) ? (e.forEach((e)=>u.error(e, t)), {
                    errors: e,
                    value: null
                }) : {
                    errors: null,
                    value: e
                };
            }, u.error = function(e, t) {
                return t.message && e._setTemplate(t.message), e;
            }, u.finalize = function(e, t, r) {
                t = t || [];
                const { schema: n, state: o, prefs: a } = r;
                if (t.length) {
                    const s = u.default("failover", void 0, t, r);
                    void 0 !== s && (o.mainstay.tracer.value(o, "failover", e, s), e = s, t = []);
                }
                if (t.length && n._flags.error) {
                    if ("function" == typeof n._flags.error) {
                        t = n._flags.error(t), Array.isArray(t) || (t = [
                            t
                        ]);
                        for (const e of t)s(e instanceof Error || e instanceof l.Report, "error() must return an Error object");
                    } else t = [
                        n._flags.error
                    ];
                }
                if (void 0 === e) {
                    const s = u.default("default", e, t, r);
                    o.mainstay.tracer.value(o, "default", e, s), e = s;
                }
                if (n._flags.cast && void 0 !== e) {
                    const t = n._definition.cast[n._flags.cast];
                    if (t.from(e)) {
                        const s = t.to(e, r);
                        o.mainstay.tracer.value(o, "cast", e, s, n._flags.cast), e = s;
                    }
                }
                if (n.$_terms.externals && a.externals && !1 !== a._externals) for (const { method: e } of n.$_terms.externals)o.mainstay.externals.push({
                    method: e,
                    path: o.path,
                    label: l.label(n._flags, o, a)
                });
                const i = {
                    value: e,
                    errors: t.length ? t : null
                };
                return n._flags.result && (i.value = "strip" === n._flags.result ? void 0 : r.original, o.mainstay.tracer.value(o, n._flags.result, e, i.value), o.shadow(e, n._flags.result)), n._cache && !1 !== a.cache && !n._refs.length && n._cache.set(r.original, i), i;
            }, u.prefs = function(e, t) {
                const r = t === i.defaults;
                return r && e._preferences[i.symbols.prefs] ? e._preferences[i.symbols.prefs] : (t = i.preferences(t, e._preferences), r && (e._preferences[i.symbols.prefs] = t), t);
            }, u.default = function(e, t, r, s) {
                const { schema: o, state: a, prefs: l } = s, c = o._flags[e];
                if (l.noDefaults || void 0 === c) return t;
                if (a.mainstay.tracer.log(o, a, "rule", e, "full"), !c) return c;
                if ("function" == typeof c) {
                    const t = c.length ? [
                        n(a.ancestors[0]),
                        s
                    ] : [];
                    try {
                        return c(...t);
                    } catch (t) {
                        return void r.push(o.$_createError("any.".concat(e), null, {
                            error: t
                        }, a, l));
                    }
                }
                return "object" != typeof c ? c : c[i.symbols.literal] ? c.literal : i.isResolvable(c) ? c.resolve(t, a, l) : n(c);
            }, u.trim = function(e, t) {
                if ("string" != typeof e) return e;
                const r = t.$_getRule("trim");
                return r && r.args.enabled ? e.trim() : e;
            }, u.ignore = {
                active: !1,
                debug: o,
                entry: o,
                filter: o,
                log: o,
                resolve: o,
                value: o
            };
        },
        function(e, t, r) {
            "use strict";
            e.exports = function() {};
        },
        function(e, t, r) {
            "use strict";
            const s = r(2), n = r(6), o = r(1), a = {
                value: Symbol("value")
            };
            e.exports = a.State = class {
                constructor(e, t, r){
                    this.path = e, this.ancestors = t, this.mainstay = r.mainstay, this.schemas = r.schemas, this.debug = null;
                }
                localize(e, t = null, r = null) {
                    const s = new a.State(e, t, this);
                    return r && s.schemas && (s.schemas = [
                        a.schemas(r),
                        ...s.schemas
                    ]), s;
                }
                nest(e, t) {
                    const r = new a.State(this.path, this.ancestors, this);
                    return r.schemas = r.schemas && [
                        a.schemas(e),
                        ...r.schemas
                    ], r.debug = t, r;
                }
                shadow(e, t) {
                    this.mainstay.shadow = this.mainstay.shadow || new a.Shadow, this.mainstay.shadow.set(this.path, e, t);
                }
                snapshot() {
                    this.mainstay.shadow && (this._snapshot = s(this.mainstay.shadow.node(this.path)));
                }
                restore() {
                    this.mainstay.shadow && (this.mainstay.shadow.override(this.path, this._snapshot), this._snapshot = void 0);
                }
            }, a.schemas = function(e) {
                return o.isSchema(e) ? {
                    schema: e
                } : e;
            }, a.Shadow = class {
                constructor(){
                    this._values = null;
                }
                set(e, t, r) {
                    if (!e.length) return;
                    if ("strip" === r && "number" == typeof e[e.length - 1]) return;
                    this._values = this._values || new Map;
                    let s = this._values;
                    for(let t = 0; t < e.length; ++t){
                        const r = e[t];
                        let n = s.get(r);
                        n || (n = new Map, s.set(r, n)), s = n;
                    }
                    s[a.value] = t;
                }
                get(e) {
                    const t = this.node(e);
                    if (t) return t[a.value];
                }
                node(e) {
                    if (this._values) return n(this._values, e, {
                        iterables: !0
                    });
                }
                override(e, t) {
                    if (!this._values) return;
                    const r = e.slice(0, -1), s = e[e.length - 1], o = n(this._values, r, {
                        iterables: !0
                    });
                    t ? o.set(s, t) : o && o.delete(s);
                }
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(10), o = r(6), a = r(3), i = r(1), l = r(8), c = {};
            e.exports = a.extend({
                type: "array",
                flags: {
                    single: {
                        default: !1
                    },
                    sparse: {
                        default: !1
                    }
                },
                terms: {
                    items: {
                        init: [],
                        manifest: "schema"
                    },
                    ordered: {
                        init: [],
                        manifest: "schema"
                    },
                    _exclusions: {
                        init: []
                    },
                    _inclusions: {
                        init: []
                    },
                    _requireds: {
                        init: []
                    }
                },
                coerce: {
                    from: "object",
                    method (e, { schema: t, state: r, prefs: s }) {
                        if (!Array.isArray(e)) return;
                        const n = t.$_getRule("sort");
                        return n ? c.sort(t, e, n.args.options, r, s) : void 0;
                    }
                },
                validate (e, { schema: t, error: r }) {
                    if (!Array.isArray(e)) {
                        if (t._flags.single) {
                            const t = [
                                e
                            ];
                            return t[i.symbols.arraySingle] = !0, {
                                value: t
                            };
                        }
                        return {
                            errors: r("array.base")
                        };
                    }
                    if (t.$_getRule("items") || t.$_terms.externals) return {
                        value: e.slice()
                    };
                },
                rules: {
                    has: {
                        method (e) {
                            e = this.$_compile(e, {
                                appendPath: !0
                            });
                            const t = this.$_addRule({
                                name: "has",
                                args: {
                                    schema: e
                                }
                            });
                            return t.$_mutateRegister(e), t;
                        },
                        validate (e, { state: t, prefs: r, error: s }, { schema: n }) {
                            const o = [
                                e,
                                ...t.ancestors
                            ];
                            for(let s = 0; s < e.length; ++s){
                                const a = t.localize([
                                    ...t.path,
                                    s
                                ], o, n);
                                if (n.$_match(e[s], a, r)) return e;
                            }
                            const a = n._flags.label;
                            return a ? s("array.hasKnown", {
                                patternLabel: a
                            }) : s("array.hasUnknown", null);
                        },
                        multi: !0
                    },
                    items: {
                        method (...e) {
                            i.verifyFlat(e, "items");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                t.$_terms.items.push(s);
                            }
                            return t.$_mutateRebuild();
                        },
                        validate (e, { schema: t, error: r, state: s, prefs: n }) {
                            const o = t.$_terms._requireds.slice(), a = t.$_terms.ordered.slice(), l = [
                                ...t.$_terms._inclusions,
                                ...o
                            ], u = !e[i.symbols.arraySingle];
                            delete e[i.symbols.arraySingle];
                            const f = [];
                            let m = e.length;
                            for(let i = 0; i < m; ++i){
                                const h = e[i];
                                let d = !1, p = !1;
                                const g = u ? i : new Number(i), y = [
                                    ...s.path,
                                    g
                                ];
                                if (!t._flags.sparse && void 0 === h) {
                                    if (f.push(r("array.sparse", {
                                        key: g,
                                        path: y,
                                        pos: i,
                                        value: void 0
                                    }, s.localize(y))), n.abortEarly) return f;
                                    a.shift();
                                    continue;
                                }
                                const b = [
                                    e,
                                    ...s.ancestors
                                ];
                                for (const e of t.$_terms._exclusions)if (e.$_match(h, s.localize(y, b, e), n, {
                                    presence: "ignore"
                                })) {
                                    if (f.push(r("array.excludes", {
                                        pos: i,
                                        value: h
                                    }, s.localize(y))), n.abortEarly) return f;
                                    d = !0, a.shift();
                                    break;
                                }
                                if (d) continue;
                                if (t.$_terms.ordered.length) {
                                    if (a.length) {
                                        const o = a.shift(), l = o.$_validate(h, s.localize(y, b, o), n);
                                        if (l.errors) {
                                            if (f.push(...l.errors), n.abortEarly) return f;
                                        } else if ("strip" === o._flags.result) c.fastSplice(e, i), --i, --m;
                                        else {
                                            if (!t._flags.sparse && void 0 === l.value) {
                                                if (f.push(r("array.sparse", {
                                                    key: g,
                                                    path: y,
                                                    pos: i,
                                                    value: void 0
                                                }, s.localize(y))), n.abortEarly) return f;
                                                continue;
                                            }
                                            e[i] = l.value;
                                        }
                                        continue;
                                    }
                                    if (!t.$_terms.items.length) {
                                        if (f.push(r("array.orderedLength", {
                                            pos: i,
                                            limit: t.$_terms.ordered.length
                                        })), n.abortEarly) return f;
                                        break;
                                    }
                                }
                                const v = [];
                                let _ = o.length;
                                for(let a = 0; a < _; ++a){
                                    const l = s.localize(y, b, o[a]);
                                    l.snapshot();
                                    const u = o[a].$_validate(h, l, n);
                                    if (v[a] = u, !u.errors) {
                                        if (e[i] = u.value, p = !0, c.fastSplice(o, a), --a, --_, !t._flags.sparse && void 0 === u.value && (f.push(r("array.sparse", {
                                            key: g,
                                            path: y,
                                            pos: i,
                                            value: void 0
                                        }, s.localize(y))), n.abortEarly)) return f;
                                        break;
                                    }
                                    l.restore();
                                }
                                if (p) continue;
                                const w = n.stripUnknown && !!n.stripUnknown.arrays || !1;
                                _ = l.length;
                                for (const a of l){
                                    let l;
                                    const u = o.indexOf(a);
                                    if (-1 !== u) l = v[u];
                                    else {
                                        const o = s.localize(y, b, a);
                                        if (o.snapshot(), l = a.$_validate(h, o, n), !l.errors) {
                                            "strip" === a._flags.result ? (c.fastSplice(e, i), --i, --m) : t._flags.sparse || void 0 !== l.value ? e[i] = l.value : (f.push(r("array.sparse", {
                                                key: g,
                                                path: y,
                                                pos: i,
                                                value: void 0
                                            }, s.localize(y))), d = !0), p = !0;
                                            break;
                                        }
                                        o.restore();
                                    }
                                    if (1 === _) {
                                        if (w) {
                                            c.fastSplice(e, i), --i, --m, p = !0;
                                            break;
                                        }
                                        if (f.push(...l.errors), n.abortEarly) return f;
                                        d = !0;
                                        break;
                                    }
                                }
                                if (!d && t.$_terms._inclusions.length && !p) {
                                    if (w) {
                                        c.fastSplice(e, i), --i, --m;
                                        continue;
                                    }
                                    if (f.push(r("array.includes", {
                                        pos: i,
                                        value: h
                                    }, s.localize(y))), n.abortEarly) return f;
                                }
                            }
                            return o.length && c.fillMissedErrors(t, f, o, e, s, n), a.length && c.fillOrderedErrors(t, f, a, e, s, n), f.length ? f : e;
                        },
                        priority: !0,
                        manifest: !1
                    },
                    length: {
                        method (e) {
                            return this.$_addRule({
                                name: "length",
                                args: {
                                    limit: e
                                },
                                operator: "="
                            });
                        },
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: o })=>i.compare(e.length, r, n) ? e : t.error("array." + s, {
                                limit: o.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: i.limit,
                                message: "must be a positive integer"
                            }
                        ]
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "length",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    ordered: {
                        method (...e) {
                            i.verifyFlat(e, "ordered");
                            const t = this.$_addRule("items");
                            for(let r = 0; r < e.length; ++r){
                                const s = i.tryWithPath(()=>this.$_compile(e[r]), r, {
                                    append: !0
                                });
                                c.validateSingle(s, t), t.$_mutateRegister(s), t.$_terms.ordered.push(s);
                            }
                            return t.$_mutateRebuild();
                        }
                    },
                    single: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return s(!t || !this._flags._arrayItems, "Cannot specify single rule when array has array items"), this.$_setFlag("single", t);
                        }
                    },
                    sort: {
                        method (e = {}) {
                            i.assertOptions(e, [
                                "by",
                                "order"
                            ]);
                            const t = {
                                order: e.order || "ascending"
                            };
                            return e.by && (t.by = l.ref(e.by, {
                                ancestor: 0
                            }), s(!t.by.ancestor, "Cannot sort by ancestor")), this.$_addRule({
                                name: "sort",
                                args: {
                                    options: t
                                }
                            });
                        },
                        validate (e, { error: t, state: r, prefs: s, schema: n }, { options: o }) {
                            const { value: a, errors: i } = c.sort(n, e, o, r, s);
                            if (i) return i;
                            for(let r = 0; r < e.length; ++r)if (e[r] !== a[r]) return t("array.sort", {
                                order: o.order,
                                by: o.by ? o.by.key : "value"
                            });
                            return e;
                        },
                        convert: !0
                    },
                    sparse: {
                        method (e) {
                            const t = void 0 === e || !!e;
                            return this._flags.sparse === t ? this : (t ? this.clone() : this.$_addRule("items")).$_setFlag("sparse", t, {
                                clone: !1
                            });
                        }
                    },
                    unique: {
                        method (e, t = {}) {
                            s(!e || "function" == typeof e || "string" == typeof e, "comparator must be a function or a string"), i.assertOptions(t, [
                                "ignoreUndefined",
                                "separator"
                            ]);
                            const r = {
                                name: "unique",
                                args: {
                                    options: t,
                                    comparator: e
                                }
                            };
                            if (e) {
                                if ("string" == typeof e) {
                                    const s = i.default(t.separator, ".");
                                    r.path = s ? e.split(s) : [
                                        e
                                    ];
                                } else r.comparator = e;
                            }
                            return this.$_addRule(r);
                        },
                        validate (e, { state: t, error: r, schema: a }, { comparator: i, options: l }, { comparator: c, path: u }) {
                            const f = {
                                string: Object.create(null),
                                number: Object.create(null),
                                undefined: Object.create(null),
                                boolean: Object.create(null),
                                object: new Map,
                                function: new Map,
                                custom: new Map
                            }, m = c || n, h = l.ignoreUndefined;
                            for(let n = 0; n < e.length; ++n){
                                const a = u ? o(e[n], u) : e[n], l = c ? f.custom : f[typeof a];
                                if (s(l, "Failed to find unique map container for type", typeof a), l instanceof Map) {
                                    const s = l.entries();
                                    let o;
                                    for(; !(o = s.next()).done;)if (m(o.value[0], a)) {
                                        const s = t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]), a = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: o.value[1],
                                            dupeValue: e[o.value[1]]
                                        };
                                        return u && (a.path = i), r("array.unique", a, s);
                                    }
                                    l.set(a, n);
                                } else {
                                    if ((!h || void 0 !== a) && void 0 !== l[a]) {
                                        const s = {
                                            pos: n,
                                            value: e[n],
                                            dupePos: l[a],
                                            dupeValue: e[l[a]]
                                        };
                                        return u && (s.path = i), r("array.unique", s, t.localize([
                                            ...t.path,
                                            n
                                        ], [
                                            e,
                                            ...t.ancestors
                                        ]));
                                    }
                                    l[a] = n;
                                }
                            }
                            return e;
                        },
                        args: [
                            "comparator",
                            "options"
                        ],
                        multi: !0
                    }
                },
                cast: {
                    set: {
                        from: Array.isArray,
                        to: (e, t)=>new Set(e)
                    }
                },
                rebuild (e) {
                    e.$_terms._inclusions = [], e.$_terms._exclusions = [], e.$_terms._requireds = [];
                    for (const t of e.$_terms.items)c.validateSingle(t, e), "required" === t._flags.presence ? e.$_terms._requireds.push(t) : "forbidden" === t._flags.presence ? e.$_terms._exclusions.push(t) : e.$_terms._inclusions.push(t);
                    for (const t of e.$_terms.ordered)c.validateSingle(t, e);
                },
                manifest: {
                    build: (e, t)=>(t.items && (e = e.items(...t.items)), t.ordered && (e = e.ordered(...t.ordered)), e)
                },
                messages: {
                    "array.base": "{{#label}} must be an array",
                    "array.excludes": "{{#label}} contains an excluded value",
                    "array.hasKnown": '{{#label}} does not contain at least one required match for type "{#patternLabel}"',
                    "array.hasUnknown": "{{#label}} does not contain at least one required match",
                    "array.includes": "{{#label}} does not match any of the allowed types",
                    "array.includesRequiredBoth": "{{#label}} does not contain {{#knownMisses}} and {{#unknownMisses}} other required value(s)",
                    "array.includesRequiredKnowns": "{{#label}} does not contain {{#knownMisses}}",
                    "array.includesRequiredUnknowns": "{{#label}} does not contain {{#unknownMisses}} required value(s)",
                    "array.length": "{{#label}} must contain {{#limit}} items",
                    "array.max": "{{#label}} must contain less than or equal to {{#limit}} items",
                    "array.min": "{{#label}} must contain at least {{#limit}} items",
                    "array.orderedLength": "{{#label}} must contain at most {{#limit}} items",
                    "array.sort": "{{#label}} must be sorted in {#order} order by {{#by}}",
                    "array.sort.mismatching": "{{#label}} cannot be sorted due to mismatching types",
                    "array.sort.unsupported": "{{#label}} cannot be sorted due to unsupported type {#type}",
                    "array.sparse": "{{#label}} must not be a sparse array item",
                    "array.unique": "{{#label}} contains a duplicate value"
                }
            }), c.fillMissedErrors = function(e, t, r, s, n, o) {
                const a = [];
                let i = 0;
                for (const e of r){
                    const t = e._flags.label;
                    t ? a.push(t) : ++i;
                }
                a.length ? i ? t.push(e.$_createError("array.includesRequiredBoth", s, {
                    knownMisses: a,
                    unknownMisses: i
                }, n, o)) : t.push(e.$_createError("array.includesRequiredKnowns", s, {
                    knownMisses: a
                }, n, o)) : t.push(e.$_createError("array.includesRequiredUnknowns", s, {
                    unknownMisses: i
                }, n, o));
            }, c.fillOrderedErrors = function(e, t, r, s, n, o) {
                const a = [];
                for (const e of r)"required" === e._flags.presence && a.push(e);
                a.length && c.fillMissedErrors(e, t, a, s, n, o);
            }, c.fastSplice = function(e, t) {
                let r = t;
                for(; r < e.length;)e[r++] = e[r];
                --e.length;
            }, c.validateSingle = function(e, t) {
                ("array" === e.type || e._flags._arrayItems) && (s(!t._flags.single, "Cannot specify array item with single rule enabled"), t.$_setFlag("_arrayItems", !0, {
                    clone: !1
                }));
            }, c.sort = function(e, t, r, s, n) {
                const o = "ascending" === r.order ? 1 : -1, a = -1 * o, i = o, l = (l, u)=>{
                    let f = c.compare(l, u, a, i);
                    if (null !== f) return f;
                    if (r.by && (l = r.by.resolve(l, s, n), u = r.by.resolve(u, s, n)), f = c.compare(l, u, a, i), null !== f) return f;
                    const m = typeof l;
                    if (m !== typeof u) throw e.$_createError("array.sort.mismatching", t, null, s, n);
                    if ("number" !== m && "string" !== m) throw e.$_createError("array.sort.unsupported", t, {
                        type: m
                    }, s, n);
                    return "number" === m ? (l - u) * o : l < u ? a : i;
                };
                try {
                    return {
                        value: t.slice().sort(l)
                    };
                } catch (e) {
                    return {
                        errors: e
                    };
                }
            }, c.compare = function(e, t, r, s) {
                return e === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : null === e ? s : null === t ? r : null;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(21), i = {
                isBool: function(e) {
                    return "boolean" == typeof e;
                }
            };
            e.exports = n.extend({
                type: "boolean",
                flags: {
                    sensitive: {
                        default: !1
                    }
                },
                terms: {
                    falsy: {
                        init: null,
                        manifest: "values"
                    },
                    truthy: {
                        init: null,
                        manifest: "values"
                    }
                },
                coerce (e, { schema: t }) {
                    if ("boolean" != typeof e) {
                        if ("string" == typeof e) {
                            const r = t._flags.sensitive ? e : e.toLowerCase();
                            e = "true" === r || "false" !== r && e;
                        }
                        return "boolean" != typeof e && (e = t.$_terms.truthy && t.$_terms.truthy.has(e, null, null, !t._flags.sensitive) || (!t.$_terms.falsy || !t.$_terms.falsy.has(e, null, null, !t._flags.sensitive)) && e), {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("boolean" != typeof e) return {
                        value: e,
                        errors: t("boolean.base")
                    };
                },
                rules: {
                    truthy: {
                        method (...e) {
                            o.verifyFlat(e, "truthy");
                            const t = this.clone();
                            t.$_terms.truthy = t.$_terms.truthy || new a;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call truthy with undefined"), t.$_terms.truthy.add(n);
                            }
                            return t;
                        }
                    },
                    falsy: {
                        method (...e) {
                            o.verifyFlat(e, "falsy");
                            const t = this.clone();
                            t.$_terms.falsy = t.$_terms.falsy || new a;
                            for(let r = 0; r < e.length; ++r){
                                const n = e[r];
                                s(void 0 !== n, "Cannot call falsy with undefined"), t.$_terms.falsy.add(n);
                            }
                            return t;
                        }
                    },
                    sensitive: {
                        method (e = !0) {
                            return this.$_setFlag("sensitive", e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: i.isBool,
                        to: (e, t)=>e ? 1 : 0
                    },
                    string: {
                        from: i.isBool,
                        to: (e, t)=>e ? "true" : "false"
                    }
                },
                manifest: {
                    build: (e, t)=>(t.truthy && (e = e.truthy(...t.truthy)), t.falsy && (e = e.falsy(...t.falsy)), e)
                },
                messages: {
                    "boolean.base": "{{#label}} must be a boolean"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(7), i = {
                isDate: function(e) {
                    return e instanceof Date;
                }
            };
            e.exports = n.extend({
                type: "date",
                coerce: {
                    from: [
                        "number",
                        "string"
                    ],
                    method: (e, { schema: t })=>({
                            value: i.parse(e, t._flags.format) || e
                        })
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e instanceof Date && !isNaN(e.getTime())) return;
                    const n = t._flags.format;
                    return s.convert && n && "string" == typeof e ? {
                        value: e,
                        errors: r("date.format", {
                            format: n
                        })
                    } : {
                        value: e,
                        errors: r("date.base")
                    };
                },
                rules: {
                    compare: {
                        method: !1,
                        validate (e, t, { date: r }, { name: s, operator: n, args: a }) {
                            const i = "now" === r ? Date.now() : r.getTime();
                            return o.compare(e.getTime(), i, n) ? e : t.error("date." + s, {
                                limit: a.date,
                                value: e
                            });
                        },
                        args: [
                            {
                                name: "date",
                                ref: !0,
                                normalize: (e)=>"now" === e ? e : i.parse(e),
                                assert: (e)=>null !== e,
                                message: "must have a valid date format"
                            }
                        ]
                    },
                    format: {
                        method (e) {
                            return s([
                                "iso",
                                "javascript",
                                "unix"
                            ].includes(e), "Unknown date format", e), this.$_setFlag("format", e);
                        }
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    iso: {
                        method () {
                            return this.format("iso");
                        }
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    date: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    timestamp: {
                        method (e = "javascript") {
                            return s([
                                "javascript",
                                "unix"
                            ].includes(e), '"type" must be one of "javascript, unix"'), this.format(e);
                        }
                    }
                },
                cast: {
                    number: {
                        from: i.isDate,
                        to: (e, t)=>e.getTime()
                    },
                    string: {
                        from: i.isDate,
                        to: (e, { prefs: t })=>a.date(e, t)
                    }
                },
                messages: {
                    "date.base": "{{#label}} must be a valid date",
                    "date.format": '{{#label}} must be in {msg("date.format." + #format) || #format} format',
                    "date.greater": '{{#label}} must be greater than "{{#limit}}"',
                    "date.less": '{{#label}} must be less than "{{#limit}}"',
                    "date.max": '{{#label}} must be less than or equal to "{{#limit}}"',
                    "date.min": '{{#label}} must be larger than or equal to "{{#limit}}"',
                    "date.format.iso": "ISO 8601 date",
                    "date.format.javascript": "timestamp or number of milliseconds",
                    "date.format.unix": "timestamp or number of seconds"
                }
            }), i.parse = function(e, t) {
                if (e instanceof Date) return e;
                if ("string" != typeof e && (isNaN(e) || !isFinite(e))) return null;
                if (/^\s*$/.test(e)) return null;
                if ("iso" === t) return o.isIsoDate(e) ? i.date(e.toString()) : null;
                const r = e;
                if ("string" == typeof e && /^[+-]?\d+(\.\d+)?$/.test(e) && (e = parseFloat(e)), t) {
                    if ("javascript" === t) return i.date(1 * e);
                    if ("unix" === t) return i.date(1e3 * e);
                    if ("string" == typeof r) return null;
                }
                return i.date(e);
            }, i.date = function(e) {
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(22);
            e.exports = n.extend({
                type: "function",
                properties: {
                    typeof: "function"
                },
                rules: {
                    arity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "arity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length === r ? e : t.error("function.arity", {
                                n: r
                            })
                    },
                    class: {
                        method () {
                            return this.$_addRule("class");
                        },
                        validate: (e, t)=>/^\s*class\s/.test(e.toString()) ? e : t.error("function.class", {
                                value: e
                            })
                    },
                    minArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e > 0, "n must be a strict positive integer"), this.$_addRule({
                                name: "minArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length >= r ? e : t.error("function.minArity", {
                                n: r
                            })
                    },
                    maxArity: {
                        method (e) {
                            return s(Number.isSafeInteger(e) && e >= 0, "n must be a positive integer"), this.$_addRule({
                                name: "maxArity",
                                args: {
                                    n: e
                                }
                            });
                        },
                        validate: (e, t, { n: r })=>e.length <= r ? e : t.error("function.maxArity", {
                                n: r
                            })
                    }
                },
                messages: {
                    "function.arity": "{{#label}} must have an arity of {{#n}}",
                    "function.class": "{{#label}} must be a class",
                    "function.maxArity": "{{#label}} must have an arity lesser or equal to {{#n}}",
                    "function.minArity": "{{#label}} must have an arity greater or equal to {{#n}}"
                }
            });
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(2), o = r(20), a = r(6), i = {};
            e.exports = function(e, t, r = {}) {
                if (s(e && "object" == typeof e, "Invalid defaults value: must be an object"), s(!t || !0 === t || "object" == typeof t, "Invalid source value: must be true, falsy or an object"), s("object" == typeof r, "Invalid options: must be an object"), !t) return null;
                if (r.shallow) return i.applyToDefaultsWithShallow(e, t, r);
                const a = n(e);
                if (!0 === t) return a;
                const l = void 0 !== r.nullOverride && r.nullOverride;
                return o(a, t, {
                    nullOverride: l,
                    mergeArrays: !1
                });
            }, i.applyToDefaultsWithShallow = function(e, t, r) {
                const l = r.shallow;
                s(Array.isArray(l), "Invalid keys");
                const c = new Map, u = !0 === t ? null : new Set;
                for (let r of l){
                    r = Array.isArray(r) ? r : r.split(".");
                    const s = a(e, r);
                    s && "object" == typeof s ? c.set(s, u && a(t, r) || s) : u && u.add(r);
                }
                const f = n(e, {}, c);
                if (!u) return f;
                for (const e of u)i.reachCopy(f, t, e);
                return o(f, t, {
                    mergeArrays: !1,
                    nullOverride: !1
                });
            }, i.reachCopy = function(e, t, r) {
                for (const e of r){
                    if (!(e in t)) return;
                    t = t[e];
                }
                const s = t;
                let n = e;
                for(let e = 0; e < r.length - 1; ++e){
                    const t = r[e];
                    "object" != typeof n[t] && (n[t] = {}), n = n[t];
                }
                n[r[r.length - 1]] = s;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = {};
            t.Sorter = class {
                constructor(){
                    this._items = [], this.nodes = [];
                }
                add(e, t) {
                    const r = [].concat((t = t || {}).before || []), n = [].concat(t.after || []), o = t.group || "?", a = t.sort || 0;
                    s(!r.includes(o), "Item cannot come before itself: ".concat(o)), s(!r.includes("?"), "Item cannot come before unassociated items"), s(!n.includes(o), "Item cannot come after itself: ".concat(o)), s(!n.includes("?"), "Item cannot come after unassociated items"), Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e){
                        const e = {
                            seq: this._items.length,
                            sort: a,
                            before: r,
                            after: n,
                            group: o,
                            node: t
                        };
                        this._items.push(e);
                    }
                    const i = this._sort();
                    return s(i, "item", "?" !== o ? "added into group ".concat(o) : "", "created a dependencies error"), this.nodes;
                }
                merge(e) {
                    Array.isArray(e) || (e = [
                        e
                    ]);
                    for (const t of e)if (t) for (const e of t._items)this._items.push(Object.assign({}, e));
                    this._items.sort(n.mergeSort);
                    for(let e = 0; e < this._items.length; ++e)this._items[e].seq = e;
                    const t = this._sort();
                    return s(t, "merge created a dependencies error"), this.nodes;
                }
                _sort() {
                    const e = {}, t = Object.create(null), r = Object.create(null);
                    for (const s of this._items){
                        const n = s.seq, o = s.group;
                        r[o] = r[o] || [], r[o].push(n), e[n] = s.before;
                        for (const e of s.after)t[e] = t[e] || [], t[e].push(n);
                    }
                    for(const t in e){
                        const s = [];
                        for(const n in e[t]){
                            const o = e[t][n];
                            r[o] = r[o] || [], s.push(...r[o]);
                        }
                        e[t] = s;
                    }
                    for(const s in t)if (r[s]) for (const n of r[s])e[n].push(...t[s]);
                    const s = {};
                    for(const t in e){
                        const r = e[t];
                        for (const e of r)s[e] = s[e] || [], s[e].push(t);
                    }
                    const n = {}, o = [];
                    for(let e = 0; e < this._items.length; ++e){
                        let t = e;
                        if (s[e]) {
                            t = null;
                            for(let e = 0; e < this._items.length; ++e){
                                if (!0 === n[e]) continue;
                                s[e] || (s[e] = []);
                                const r = s[e].length;
                                let o = 0;
                                for(let t = 0; t < r; ++t)n[s[e][t]] && ++o;
                                if (o === r) {
                                    t = e;
                                    break;
                                }
                            }
                        }
                        null !== t && (n[t] = !0, o.push(t));
                    }
                    if (o.length !== this._items.length) return !1;
                    const a = {};
                    for (const e of this._items)a[e.seq] = e;
                    this._items = [], this.nodes = [];
                    for (const e of o){
                        const t = a[e];
                        this.nodes.push(t.node), this._items.push(t);
                    }
                    return !0;
                }
            }, n.mergeSort = (e, t)=>e.sort === t.sort ? 0 : e.sort < t.sort ? -1 : 1;
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = r(8), i = r(4), l = {};
            e.exports = n.extend({
                type: "link",
                properties: {
                    schemaChain: !0
                },
                terms: {
                    link: {
                        init: null,
                        manifest: "single",
                        register: !1
                    }
                },
                args: (e, t)=>e.ref(t),
                validate (e, { schema: t, state: r, prefs: n }) {
                    s(t.$_terms.link, "Uninitialized link schema");
                    const o = l.generate(t, e, r, n), a = t.$_terms.link[0].ref;
                    return o.$_validate(e, r.nest(o, "link:".concat(a.display, ":").concat(o.type)), n);
                },
                generate: (e, t, r, s)=>l.generate(e, t, r, s),
                rules: {
                    ref: {
                        method (e) {
                            s(!this.$_terms.link, "Cannot reinitialize schema"), e = a.ref(e), s("value" === e.type || "local" === e.type, "Invalid reference type:", e.type), s("local" === e.type || "root" === e.ancestor || e.ancestor > 0, "Link cannot reference itself");
                            const t = this.clone();
                            return t.$_terms.link = [
                                {
                                    ref: e
                                }
                            ], t;
                        }
                    },
                    relative: {
                        method (e = !0) {
                            return this.$_setFlag("relative", e);
                        }
                    }
                },
                overrides: {
                    concat (e) {
                        s(this.$_terms.link, "Uninitialized link schema"), s(o.isSchema(e), "Invalid schema object"), s("link" !== e.type, "Cannot merge type link with another link");
                        const t = this.clone();
                        return t.$_terms.whens || (t.$_terms.whens = []), t.$_terms.whens.push({
                            concat: e
                        }), t.$_mutateRebuild();
                    }
                },
                manifest: {
                    build: (e, t)=>(s(t.link, "Invalid link description missing link"), e.ref(t.link))
                }
            }), l.generate = function(e, t, r, s) {
                let n = r.mainstay.links.get(e);
                if (n) return n._generate(t, r, s).schema;
                const o = e.$_terms.link[0].ref, { perspective: a, path: i } = l.perspective(o, r);
                l.assert(a, "which is outside of schema boundaries", o, e, r, s);
                try {
                    n = i.length ? a.$_reach(i) : a;
                } catch (t) {
                    l.assert(!1, "to non-existing schema", o, e, r, s);
                }
                return l.assert("link" !== n.type, "which is another link", o, e, r, s), e._flags.relative || r.mainstay.links.set(e, n), n._generate(t, r, s).schema;
            }, l.perspective = function(e, t) {
                if ("local" === e.type) {
                    for (const { schema: r, key: s } of t.schemas){
                        if ((r._flags.id || s) === e.path[0]) return {
                            perspective: r,
                            path: e.path.slice(1)
                        };
                        if (r.$_terms.shared) {
                            for (const t of r.$_terms.shared)if (t._flags.id === e.path[0]) return {
                                perspective: t,
                                path: e.path.slice(1)
                            };
                        }
                    }
                    return {
                        perspective: null,
                        path: null
                    };
                }
                return "root" === e.ancestor ? {
                    perspective: t.schemas[t.schemas.length - 1].schema,
                    path: e.path
                } : {
                    perspective: t.schemas[e.ancestor] && t.schemas[e.ancestor].schema,
                    path: e.path
                };
            }, l.assert = function(e, t, r, n, o, a) {
                e || s(!1, '"'.concat(i.label(n._flags, o, a), '" contains link reference "').concat(r.display, '" ').concat(t));
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = r(1), a = {
                numberRx: /^\s*[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e([+-]?\d+))?\s*$/i,
                precisionRx: /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/
            };
            e.exports = n.extend({
                type: "number",
                flags: {
                    unsafe: {
                        default: !1
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, error: r }) {
                        const s = e.match(a.numberRx);
                        if (!s) return;
                        e = e.trim();
                        const n = {
                            value: parseFloat(e)
                        };
                        if (0 === n.value && (n.value = 0), !t._flags.unsafe) {
                            if (e.match(/e/i)) {
                                if (a.normalizeExponent("".concat(n.value / Math.pow(10, s[1]), "e").concat(s[1])) !== a.normalizeExponent(e)) return n.errors = r("number.unsafe"), n;
                            } else {
                                const t = n.value.toString();
                                if (t.match(/e/i)) return n;
                                if (t !== a.normalizeDecimal(e)) return n.errors = r("number.unsafe"), n;
                            }
                        }
                        return n;
                    }
                },
                validate (e, { schema: t, error: r, prefs: s }) {
                    if (e === 1 / 0 || e === -1 / 0) return {
                        value: e,
                        errors: r("number.infinity")
                    };
                    if (!o.isNumber(e)) return {
                        value: e,
                        errors: r("number.base")
                    };
                    const n = {
                        value: e
                    };
                    if (s.convert) {
                        const e = t.$_getRule("precision");
                        if (e) {
                            const t = Math.pow(10, e.args.limit);
                            n.value = Math.round(n.value * t) / t;
                        }
                    }
                    return 0 === n.value && (n.value = 0), !t._flags.unsafe && (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) && (n.errors = r("number.unsafe")), n;
                },
                rules: {
                    compare: {
                        method: !1,
                        validate: (e, t, { limit: r }, { name: s, operator: n, args: a })=>o.compare(e, r, n) ? e : t.error("number." + s, {
                                limit: a.limit,
                                value: e
                            }),
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: o.isNumber,
                                message: "must be a number"
                            }
                        ]
                    },
                    greater: {
                        method (e) {
                            return this.$_addRule({
                                name: "greater",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">"
                            });
                        }
                    },
                    integer: {
                        method () {
                            return this.$_addRule("integer");
                        },
                        validate: (e, t)=>Math.trunc(e) - e == 0 ? e : t.error("number.integer")
                    },
                    less: {
                        method (e) {
                            return this.$_addRule({
                                name: "less",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<"
                            });
                        }
                    },
                    max: {
                        method (e) {
                            return this.$_addRule({
                                name: "max",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: "<="
                            });
                        }
                    },
                    min: {
                        method (e) {
                            return this.$_addRule({
                                name: "min",
                                method: "compare",
                                args: {
                                    limit: e
                                },
                                operator: ">="
                            });
                        }
                    },
                    multiple: {
                        method (e) {
                            return this.$_addRule({
                                name: "multiple",
                                args: {
                                    base: e
                                }
                            });
                        },
                        validate: (e, t, { base: r }, s)=>e % r == 0 ? e : t.error("number.multiple", {
                                multiple: s.args.base,
                                value: e
                            }),
                        args: [
                            {
                                name: "base",
                                ref: !0,
                                assert: (e)=>"number" == typeof e && isFinite(e) && e > 0,
                                message: "must be a positive number"
                            }
                        ],
                        multi: !0
                    },
                    negative: {
                        method () {
                            return this.sign("negative");
                        }
                    },
                    port: {
                        method () {
                            return this.$_addRule("port");
                        },
                        validate: (e, t)=>Number.isSafeInteger(e) && e >= 0 && e <= 65535 ? e : t.error("number.port")
                    },
                    positive: {
                        method () {
                            return this.sign("positive");
                        }
                    },
                    precision: {
                        method (e) {
                            return s(Number.isSafeInteger(e), "limit must be an integer"), this.$_addRule({
                                name: "precision",
                                args: {
                                    limit: e
                                }
                            });
                        },
                        validate (e, t, { limit: r }) {
                            const s = e.toString().match(a.precisionRx);
                            return Math.max((s[1] ? s[1].length : 0) - (s[2] ? parseInt(s[2], 10) : 0), 0) <= r ? e : t.error("number.precision", {
                                limit: r,
                                value: e
                            });
                        },
                        convert: !0
                    },
                    sign: {
                        method (e) {
                            return s([
                                "negative",
                                "positive"
                            ].includes(e), "Invalid sign", e), this.$_addRule({
                                name: "sign",
                                args: {
                                    sign: e
                                }
                            });
                        },
                        validate: (e, t, { sign: r })=>"negative" === r && e < 0 || "positive" === r && e > 0 ? e : t.error("number.".concat(r))
                    },
                    unsafe: {
                        method (e = !0) {
                            return s("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("unsafe", e);
                        }
                    }
                },
                cast: {
                    string: {
                        from: (e)=>"number" == typeof e,
                        to: (e, t)=>e.toString()
                    }
                },
                messages: {
                    "number.base": "{{#label}} must be a number",
                    "number.greater": "{{#label}} must be greater than {{#limit}}",
                    "number.infinity": "{{#label}} cannot be infinity",
                    "number.integer": "{{#label}} must be an integer",
                    "number.less": "{{#label}} must be less than {{#limit}}",
                    "number.max": "{{#label}} must be less than or equal to {{#limit}}",
                    "number.min": "{{#label}} must be larger than or equal to {{#limit}}",
                    "number.multiple": "{{#label}} must be a multiple of {{#multiple}}",
                    "number.negative": "{{#label}} must be a negative number",
                    "number.port": "{{#label}} must be a valid port",
                    "number.positive": "{{#label}} must be a positive number",
                    "number.precision": "{{#label}} must have no more than {{#limit}} decimal places",
                    "number.unsafe": "{{#label}} must be a safe number"
                }
            }), a.normalizeExponent = function(e) {
                return e.replace(/E/, "e").replace(/\.(\d*[1-9])?0+e/, ".$1e").replace(/\.e/, "e").replace(/e\+/, "e").replace(/^\+/, "").replace(/^(-?)0+([1-9])/, "$1$2");
            }, a.normalizeDecimal = function(e) {
                return (e = e.replace(/^\+/, "").replace(/\.0+$/, "").replace(/^(-?)\.([^\.]*)$/, "$10.$2").replace(/^(-?)0+([1-9])/, "$1$2")).includes(".") && e.endsWith("0") && (e = e.replace(/0+$/, "")), "-0" === e ? "0" : e;
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(22);
            e.exports = s.extend({
                type: "object",
                cast: {
                    map: {
                        from: (e)=>e && "object" == typeof e,
                        to: (e, t)=>new Map(Object.entries(e))
                    }
                }
            });
        },
        function(e, t, r) {
            "use strict";
            function s(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var s = Object.getOwnPropertySymbols(e);
                    t && (s = s.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), r.push.apply(r, s);
                }
                return r;
            }
            function n(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? s(Object(r), !0).forEach(function(t) {
                        o(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                }
                return e;
            }
            function o(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            const a = r(0), i = r(23), l = r(49), c = r(50), u = r(27), f = r(51), m = r(26), h = r(3), d = r(1), p = {
                tlds: f instanceof Set && {
                    tlds: {
                        allow: f,
                        deny: null
                    }
                },
                base64Regex: {
                    true: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}==|[\w\-]{3}=)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/
                    },
                    false: {
                        true: /^(?:[\w\-]{2}[\w\-]{2})*(?:[\w\-]{2}(==)?|[\w\-]{3}=?)?$/,
                        false: /^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}(==)?|[A-Za-z0-9+\/]{3}=?)?$/
                    }
                },
                dataUriRegex: /^data:[\w+.-]+\/[\w+.-]+;((charset=[\w-]+|base64),)?(.*)$/,
                hexRegex: /^[a-f0-9]+$/i,
                ipRegex: c.regex().regex,
                isoDurationRegex: /^P(?!$)(\d+Y)?(\d+M)?(\d+W)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?$/,
                guidBrackets: {
                    "{": "}",
                    "[": "]",
                    "(": ")",
                    "": ""
                },
                guidVersions: {
                    uuidv1: "1",
                    uuidv2: "2",
                    uuidv3: "3",
                    uuidv4: "4",
                    uuidv5: "5"
                },
                cidrPresences: [
                    "required",
                    "optional",
                    "forbidden"
                ],
                normalizationForms: [
                    "NFC",
                    "NFD",
                    "NFKC",
                    "NFKD"
                ]
            };
            e.exports = h.extend({
                type: "string",
                flags: {
                    insensitive: {
                        default: !1
                    },
                    truncate: {
                        default: !1
                    }
                },
                terms: {
                    replacements: {
                        init: null
                    }
                },
                coerce: {
                    from: "string",
                    method (e, { schema: t, state: r, prefs: s }) {
                        const n = t.$_getRule("normalize");
                        n && (e = e.normalize(n.args.form));
                        const o = t.$_getRule("case");
                        o && (e = "upper" === o.args.direction ? e.toLocaleUpperCase() : e.toLocaleLowerCase());
                        const a = t.$_getRule("trim");
                        if (a && a.args.enabled && (e = e.trim()), t.$_terms.replacements) for (const r of t.$_terms.replacements)e = e.replace(r.pattern, r.replacement);
                        const i = t.$_getRule("hex");
                        if (i && i.args.options.byteAligned && e.length % 2 != 0 && (e = "0".concat(e)), t.$_getRule("isoDate")) {
                            const t = p.isoDate(e);
                            t && (e = t);
                        }
                        if (t._flags.truncate) {
                            const n = t.$_getRule("max");
                            if (n) {
                                let o = n.args.limit;
                                if (d.isResolvable(o) && (o = o.resolve(e, r, s), !d.limit(o))) return {
                                    value: e,
                                    errors: t.$_createError("any.ref", o, {
                                        ref: n.args.limit,
                                        arg: "limit",
                                        reason: "must be a positive integer"
                                    }, r, s)
                                };
                                e = e.slice(0, o);
                            }
                        }
                        return {
                            value: e
                        };
                    }
                },
                validate: (e, { error: t })=>"string" != typeof e ? {
                        value: e,
                        errors: t("string.base")
                    } : "" === e ? {
                        value: e,
                        errors: t("string.empty")
                    } : void 0,
                rules: {
                    alphanum: {
                        method () {
                            return this.$_addRule("alphanum");
                        },
                        validate: (e, t)=>/^[a-zA-Z0-9]+$/.test(e) ? e : t.error("string.alphanum")
                    },
                    base64: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "paddingRequired",
                                "urlSafe"
                            ]), e = n({
                                urlSafe: !1,
                                paddingRequired: !0
                            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), a("boolean" == typeof e.urlSafe, "urlSafe must be boolean"), this.$_addRule({
                                name: "base64",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>p.base64Regex[r.paddingRequired][r.urlSafe].test(e) ? e : t.error("string.base64")
                    },
                    case: {
                        method (e) {
                            return a([
                                "lower",
                                "upper"
                            ].includes(e), "Invalid case:", e), this.$_addRule({
                                name: "case",
                                args: {
                                    direction: e
                                }
                            });
                        },
                        validate: (e, t, { direction: r })=>"lower" === r && e === e.toLocaleLowerCase() || "upper" === r && e === e.toLocaleUpperCase() ? e : t.error("string.".concat(r, "case")),
                        convert: !0
                    },
                    creditCard: {
                        method () {
                            return this.$_addRule("creditCard");
                        },
                        validate (e, t) {
                            let r = e.length, s = 0, n = 1;
                            for(; r--;){
                                const t = e.charAt(r) * n;
                                s += t - 9 * (t > 9), n ^= 3;
                            }
                            return s > 0 && s % 10 == 0 ? e : t.error("string.creditCard");
                        }
                    },
                    dataUri: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "paddingRequired"
                            ]), e = n({
                                paddingRequired: !0
                            }, e), a("boolean" == typeof e.paddingRequired, "paddingRequired must be boolean"), this.$_addRule({
                                name: "dataUri",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate (e, t, { options: r }) {
                            const s = e.match(p.dataUriRegex);
                            if (s) {
                                if (!s[2]) return e;
                                if ("base64" !== s[2]) return e;
                                if (p.base64Regex[r.paddingRequired].false.test(s[3])) return e;
                            }
                            return t.error("string.dataUri");
                        }
                    },
                    domain: {
                        method (e) {
                            e && d.assertOptions(e, [
                                "allowUnicode",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const t = p.addressOptions(e);
                            return this.$_addRule({
                                name: "domain",
                                args: {
                                    options: e
                                },
                                address: t
                            });
                        },
                        validate: (e, t, r, { address: s })=>i.isValid(e, s) ? e : t.error("string.domain")
                    },
                    email: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "allowUnicode",
                                "ignoreLength",
                                "minDomainSegments",
                                "multiple",
                                "separator",
                                "tlds"
                            ]), a(void 0 === e.multiple || "boolean" == typeof e.multiple, "multiple option must be an boolean");
                            const t = p.addressOptions(e), r = new RegExp("\\s*[".concat(e.separator ? u(e.separator) : ",", "]\\s*"));
                            return this.$_addRule({
                                name: "email",
                                args: {
                                    options: e
                                },
                                regex: r,
                                address: t
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, address: n }) {
                            const o = r.multiple ? e.split(s) : [
                                e
                            ], a = [];
                            for (const e of o)l.isValid(e, n) || a.push(e);
                            return a.length ? t.error("string.email", {
                                value: e,
                                invalids: a
                            }) : e;
                        }
                    },
                    guid: {
                        alias: "uuid",
                        method (e = {}) {
                            d.assertOptions(e, [
                                "version"
                            ]);
                            let t = "";
                            if (e.version) {
                                const r = [].concat(e.version);
                                a(r.length >= 1, "version must have at least 1 valid version specified");
                                const s = new Set;
                                for(let e = 0; e < r.length; ++e){
                                    const n = r[e];
                                    a("string" == typeof n, "version at position " + e + " must be a string");
                                    const o = p.guidVersions[n.toLowerCase()];
                                    a(o, "version at position " + e + " must be one of " + Object.keys(p.guidVersions).join(", ")), a(!s.has(o), "version at position " + e + " must not be a duplicate"), t += o, s.add(o);
                                }
                            }
                            const r = new RegExp("^([\\[{\\(]?)[0-9A-F]{8}([:-]?)[0-9A-F]{4}\\2?[".concat(t || "0-9A-F", "][0-9A-F]{3}\\2?[").concat(t ? "89AB" : "0-9A-F", "][0-9A-F]{3}\\2?[0-9A-F]{12}([\\]}\\)]?)$"), "i");
                            return this.$_addRule({
                                name: "guid",
                                args: {
                                    options: e
                                },
                                regex: r
                            });
                        },
                        validate (e, t, r, { regex: s }) {
                            const n = s.exec(e);
                            return n ? p.guidBrackets[n[1]] !== n[n.length - 1] ? t.error("string.guid") : e : t.error("string.guid");
                        }
                    },
                    hex: {
                        method (e = {}) {
                            return d.assertOptions(e, [
                                "byteAligned"
                            ]), e = n({
                                byteAligned: !1
                            }, e), a("boolean" == typeof e.byteAligned, "byteAligned must be boolean"), this.$_addRule({
                                name: "hex",
                                args: {
                                    options: e
                                }
                            });
                        },
                        validate: (e, t, { options: r })=>p.hexRegex.test(e) ? r.byteAligned && e.length % 2 != 0 ? t.error("string.hexAlign") : e : t.error("string.hex")
                    },
                    hostname: {
                        method () {
                            return this.$_addRule("hostname");
                        },
                        validate: (e, t)=>i.isValid(e, {
                                minDomainSegments: 1
                            }) || p.ipRegex.test(e) ? e : t.error("string.hostname")
                    },
                    insensitive: {
                        method () {
                            return this.$_setFlag("insensitive", !0);
                        }
                    },
                    ip: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "cidr",
                                "version"
                            ]);
                            const { cidr: t, versions: r, regex: s } = c.regex(e), n = e.version ? r : void 0;
                            return this.$_addRule({
                                name: "ip",
                                args: {
                                    options: {
                                        cidr: t,
                                        version: n
                                    }
                                },
                                regex: s
                            });
                        },
                        validate: (e, t, { options: r }, { regex: s })=>s.test(e) ? e : r.version ? t.error("string.ipVersion", {
                                value: e,
                                cidr: r.cidr,
                                version: r.version
                            }) : t.error("string.ip", {
                                value: e,
                                cidr: r.cidr
                            })
                    },
                    isoDate: {
                        method () {
                            return this.$_addRule("isoDate");
                        },
                        validate: (e, { error: t })=>p.isoDate(e) ? e : t("string.isoDate")
                    },
                    isoDuration: {
                        method () {
                            return this.$_addRule("isoDuration");
                        },
                        validate: (e, t)=>p.isoDurationRegex.test(e) ? e : t.error("string.isoDuration")
                    },
                    length: {
                        method (e, t) {
                            return p.length(this, "length", e, "=", t);
                        },
                        validate (e, t, { limit: r, encoding: s }, { name: n, operator: o, args: a }) {
                            const i = !s && e.length;
                            return d.compare(i, r, o) ? e : t.error("string." + n, {
                                limit: a.limit,
                                value: e,
                                encoding: s
                            });
                        },
                        args: [
                            {
                                name: "limit",
                                ref: !0,
                                assert: d.limit,
                                message: "must be a positive integer"
                            },
                            "encoding"
                        ]
                    },
                    lowercase: {
                        method () {
                            return this.case("lower");
                        }
                    },
                    max: {
                        method (e, t) {
                            return p.length(this, "max", e, "<=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    min: {
                        method (e, t) {
                            return p.length(this, "min", e, ">=", t);
                        },
                        args: [
                            "limit",
                            "encoding"
                        ]
                    },
                    normalize: {
                        method (e = "NFC") {
                            return a(p.normalizationForms.includes(e), "normalization form must be one of " + p.normalizationForms.join(", ")), this.$_addRule({
                                name: "normalize",
                                args: {
                                    form: e
                                }
                            });
                        },
                        validate: (e, { error: t }, { form: r })=>e === e.normalize(r) ? e : t("string.normalize", {
                                value: e,
                                form: r
                            }),
                        convert: !0
                    },
                    pattern: {
                        alias: "regex",
                        method (e, t = {}) {
                            a(e instanceof RegExp, "regex must be a RegExp"), a(!e.flags.includes("g") && !e.flags.includes("y"), "regex should not use global or sticky mode"), "string" == typeof t && (t = {
                                name: t
                            }), d.assertOptions(t, [
                                "invert",
                                "name"
                            ]);
                            const r = [
                                "string.pattern",
                                t.invert ? ".invert" : "",
                                t.name ? ".name" : ".base"
                            ].join("");
                            return this.$_addRule({
                                name: "pattern",
                                args: {
                                    regex: e,
                                    options: t
                                },
                                errorCode: r
                            });
                        },
                        validate: (e, t, { regex: r, options: s }, { errorCode: n })=>r.test(e) ^ s.invert ? e : t.error(n, {
                                name: s.name,
                                regex: r,
                                value: e
                            }),
                        args: [
                            "regex",
                            "options"
                        ],
                        multi: !0
                    },
                    replace: {
                        method (e, t) {
                            "string" == typeof e && (e = new RegExp(u(e), "g")), a(e instanceof RegExp, "pattern must be a RegExp"), a("string" == typeof t, "replacement must be a String");
                            const r = this.clone();
                            return r.$_terms.replacements || (r.$_terms.replacements = []), r.$_terms.replacements.push({
                                pattern: e,
                                replacement: t
                            }), r;
                        }
                    },
                    token: {
                        method () {
                            return this.$_addRule("token");
                        },
                        validate: (e, t)=>/^\w+$/.test(e) ? e : t.error("string.token")
                    },
                    trim: {
                        method (e = !0) {
                            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_addRule({
                                name: "trim",
                                args: {
                                    enabled: e
                                }
                            });
                        },
                        validate: (e, t, { enabled: r })=>r && e !== e.trim() ? t.error("string.trim") : e,
                        convert: !0
                    },
                    truncate: {
                        method (e = !0) {
                            return a("boolean" == typeof e, "enabled must be a boolean"), this.$_setFlag("truncate", e);
                        }
                    },
                    uppercase: {
                        method () {
                            return this.case("upper");
                        }
                    },
                    uri: {
                        method (e = {}) {
                            d.assertOptions(e, [
                                "allowRelative",
                                "allowQuerySquareBrackets",
                                "domain",
                                "relativeOnly",
                                "scheme"
                            ]), e.domain && d.assertOptions(e.domain, [
                                "allowUnicode",
                                "minDomainSegments",
                                "tlds"
                            ]);
                            const { regex: t, scheme: r } = m.regex(e), s = e.domain ? p.addressOptions(e.domain) : null;
                            return this.$_addRule({
                                name: "uri",
                                args: {
                                    options: e
                                },
                                regex: t,
                                domain: s,
                                scheme: r
                            });
                        },
                        validate (e, t, { options: r }, { regex: s, domain: n, scheme: o }) {
                            if ([
                                "http:/",
                                "https:/"
                            ].includes(e)) return t.error("string.uri");
                            const a = s.exec(e);
                            if (a) {
                                if (n) {
                                    const e = a[1] || a[2];
                                    if (!i.isValid(e, n)) return t.error("string.domain", {
                                        value: e
                                    });
                                }
                                return e;
                            }
                            return r.relativeOnly ? t.error("string.uriRelativeOnly") : r.scheme ? t.error("string.uriCustomScheme", {
                                scheme: o,
                                value: e
                            }) : t.error("string.uri");
                        }
                    }
                },
                manifest: {
                    build (e, t) {
                        if (t.replacements) for (const { pattern: r, replacement: s } of t.replacements)e = e.replace(r, s);
                        return e;
                    }
                },
                messages: {
                    "string.alphanum": "{{#label}} must only contain alpha-numeric characters",
                    "string.base": "{{#label}} must be a string",
                    "string.base64": "{{#label}} must be a valid base64 string",
                    "string.creditCard": "{{#label}} must be a credit card",
                    "string.dataUri": "{{#label}} must be a valid dataUri string",
                    "string.domain": "{{#label}} must contain a valid domain name",
                    "string.email": "{{#label}} must be a valid email",
                    "string.empty": "{{#label}} is not allowed to be empty",
                    "string.guid": "{{#label}} must be a valid GUID",
                    "string.hex": "{{#label}} must only contain hexadecimal characters",
                    "string.hexAlign": "{{#label}} hex decoded representation must be byte aligned",
                    "string.hostname": "{{#label}} must be a valid hostname",
                    "string.ip": "{{#label}} must be a valid ip address with a {{#cidr}} CIDR",
                    "string.ipVersion": "{{#label}} must be a valid ip address of one of the following versions {{#version}} with a {{#cidr}} CIDR",
                    "string.isoDate": "{{#label}} must be in iso format",
                    "string.isoDuration": "{{#label}} must be a valid ISO 8601 duration",
                    "string.length": "{{#label}} length must be {{#limit}} characters long",
                    "string.lowercase": "{{#label}} must only contain lowercase characters",
                    "string.max": "{{#label}} length must be less than or equal to {{#limit}} characters long",
                    "string.min": "{{#label}} length must be at least {{#limit}} characters long",
                    "string.normalize": "{{#label}} must be unicode normalized in the {{#form}} form",
                    "string.token": "{{#label}} must only contain alpha-numeric and underscore characters",
                    "string.pattern.base": '{{#label}} with value "{[.]}" fails to match the required pattern: {{#regex}}',
                    "string.pattern.name": '{{#label}} with value "{[.]}" fails to match the {{#name}} pattern',
                    "string.pattern.invert.base": '{{#label}} with value "{[.]}" matches the inverted pattern: {{#regex}}',
                    "string.pattern.invert.name": '{{#label}} with value "{[.]}" matches the inverted {{#name}} pattern',
                    "string.trim": "{{#label}} must not have leading or trailing whitespace",
                    "string.uri": "{{#label}} must be a valid uri",
                    "string.uriCustomScheme": "{{#label}} must be a valid uri with a scheme matching the {{#scheme}} pattern",
                    "string.uriRelativeOnly": "{{#label}} must be a valid relative uri",
                    "string.uppercase": "{{#label}} must only contain uppercase characters"
                }
            }), p.addressOptions = function(e) {
                if (!e) return e;
                if (a(void 0 === e.minDomainSegments || Number.isSafeInteger(e.minDomainSegments) && e.minDomainSegments > 0, "minDomainSegments must be a positive integer"), !1 === e.tlds) return e;
                if (!0 === e.tlds || void 0 === e.tlds) return a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds);
                a("object" == typeof e.tlds, "tlds must be true, false, or an object");
                const t = e.tlds.deny;
                if (t) return Array.isArray(t) && (e = Object.assign({}, e, {
                    tlds: {
                        deny: new Set(t)
                    }
                })), a(e.tlds.deny instanceof Set, "tlds.deny must be an array, Set, or boolean"), a(!e.tlds.allow, "Cannot specify both tlds.allow and tlds.deny lists"), e;
                const r = e.tlds.allow;
                return r ? !0 === r ? (a(p.tlds, "Built-in TLD list disabled"), Object.assign({}, e, p.tlds)) : (Array.isArray(r) && (e = Object.assign({}, e, {
                    tlds: {
                        allow: new Set(r)
                    }
                })), a(e.tlds.allow instanceof Set, "tlds.allow must be an array, Set, or boolean"), e) : e;
            }, p.isoDate = function(e) {
                if (!d.isIsoDate(e)) return null;
                const t = new Date(e);
                return isNaN(t.getTime()) ? null : t.toISOString();
            }, p.length = function(e, t, r, s, n) {
                return a(!n || !1, "Invalid encoding:", n), e.$_addRule({
                    name: t,
                    method: "length",
                    args: {
                        limit: r,
                        encoding: n
                    },
                    operator: s
                });
            };
        },
        function(e, t, r) {
            "use strict";
            const s = r(24), n = r(23), o = r(25), a = {
                nonAsciiRx: /[^\x00-\x7f]/,
                encoder: new (s.TextEncoder || TextEncoder)
            };
            t.analyze = function(e, t) {
                return a.email(e, t);
            }, t.isValid = function(e, t) {
                return !a.email(e, t);
            }, a.email = function(e, t = {}) {
                if ("string" != typeof e) throw new Error("Invalid input: email must be a string");
                if (!e) return o.code("EMPTY_STRING");
                const r = !a.nonAsciiRx.test(e);
                if (!r) {
                    if (!1 === t.allowUnicode) return o.code("FORBIDDEN_UNICODE");
                    e = e.normalize("NFC");
                }
                const s = e.split("@");
                if (2 !== s.length) return s.length > 2 ? o.code("MULTIPLE_AT_CHAR") : o.code("MISSING_AT_CHAR");
                const [i, l] = s;
                if (!i) return o.code("EMPTY_LOCAL");
                if (!t.ignoreLength) {
                    if (e.length > 254) return o.code("ADDRESS_TOO_LONG");
                    if (a.encoder.encode(i).length > 64) return o.code("LOCAL_TOO_LONG");
                }
                return a.local(i, r) || n.analyze(l, t);
            }, a.local = function(e, t) {
                const r = e.split(".");
                for (const e of r){
                    if (!e.length) return o.code("EMPTY_LOCAL_SEGMENT");
                    if (t) {
                        if (!a.atextRx.test(e)) return o.code("INVALID_LOCAL_CHARS");
                    } else for (const t of e){
                        if (a.atextRx.test(t)) continue;
                        const e = a.binary(t);
                        if (!a.atomRx.test(e)) return o.code("INVALID_LOCAL_CHARS");
                    }
                }
            }, a.binary = function(e) {
                return Array.from(a.encoder.encode(e)).map((e)=>String.fromCharCode(e)).join("");
            }, a.atextRx = /^[\w!#\$%&'\*\+\-/=\?\^`\{\|\}~]+$/, a.atomRx = new RegExp([
                "(?:[\\xc2-\\xdf][\\x80-\\xbf])",
                "(?:\\xe0[\\xa0-\\xbf][\\x80-\\xbf])|(?:[\\xe1-\\xec][\\x80-\\xbf]{2})|(?:\\xed[\\x80-\\x9f][\\x80-\\xbf])|(?:[\\xee-\\xef][\\x80-\\xbf]{2})",
                "(?:\\xf0[\\x90-\\xbf][\\x80-\\xbf]{2})|(?:[\\xf1-\\xf3][\\x80-\\xbf]{3})|(?:\\xf4[\\x80-\\x8f][\\x80-\\xbf]{2})"
            ].join("|"));
        },
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(26);
            t.regex = function(e = {}) {
                s(void 0 === e.cidr || "string" == typeof e.cidr, "options.cidr must be a string");
                const t = e.cidr ? e.cidr.toLowerCase() : "optional";
                s([
                    "required",
                    "optional",
                    "forbidden"
                ].includes(t), "options.cidr must be one of required, optional, forbidden"), s(void 0 === e.version || "string" == typeof e.version || Array.isArray(e.version), "options.version must be a string or an array of string");
                let r = e.version || [
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ];
                Array.isArray(r) || (r = [
                    r
                ]), s(r.length >= 1, "options.version must have at least 1 version specified");
                for(let e = 0; e < r.length; ++e)s("string" == typeof r[e], "options.version must only contain strings"), r[e] = r[e].toLowerCase(), s([
                    "ipv4",
                    "ipv6",
                    "ipvfuture"
                ].includes(r[e]), "options.version contains unknown version " + r[e] + " - must be one of ipv4, ipv6, ipvfuture");
                r = Array.from(new Set(r));
                const o = r.map((e)=>{
                    if ("forbidden" === t) return n.ip[e];
                    const r = "\\/".concat("ipv4" === e ? n.ip.v4Cidr : n.ip.v6Cidr);
                    return "required" === t ? "".concat(n.ip[e]).concat(r) : "".concat(n.ip[e], "(?:").concat(r, ")?");
                }), a = "(?:".concat(o.join("|"), ")"), i = new RegExp("^".concat(a, "$"));
                return {
                    cidr: t,
                    versions: r,
                    regex: i,
                    raw: a
                };
            };
        },
        function(e, t) {},
        function(e, t, r) {
            "use strict";
            const s = r(0), n = r(3), o = {};
            o.Map = class extends Map {
                slice() {
                    return new o.Map(this);
                }
            }, e.exports = n.extend({
                type: "symbol",
                terms: {
                    map: {
                        init: new o.Map
                    }
                },
                coerce: {
                    method (e, { schema: t, error: r }) {
                        const s = t.$_terms.map.get(e);
                        return s && (e = s), t._flags.only && "symbol" != typeof e ? {
                            value: e,
                            errors: r("symbol.map", {
                                map: t.$_terms.map
                            })
                        } : {
                            value: e
                        };
                    }
                },
                validate (e, { error: t }) {
                    if ("symbol" != typeof e) return {
                        value: e,
                        errors: t("symbol.base")
                    };
                },
                rules: {
                    map: {
                        method (e) {
                            e && !e[Symbol.iterator] && "object" == typeof e && (e = Object.entries(e)), s(e && e[Symbol.iterator], "Iterable must be an iterable or object");
                            const t = this.clone(), r = [];
                            for (const n of e){
                                s(n && n[Symbol.iterator], "Entry must be an iterable");
                                const [e, o] = n;
                                s("object" != typeof e && "function" != typeof e && "symbol" != typeof e, "Key must not be of type object, function, or Symbol"), s("symbol" == typeof o, "Value must be a Symbol"), t.$_terms.map.set(e, o), r.push(o);
                            }
                            return t.valid(...r);
                        }
                    }
                },
                manifest: {
                    build: (e, t)=>(t.map && (e = e.map(t.map)), e)
                },
                messages: {
                    "symbol.base": "{{#label}} must be a symbol",
                    "symbol.map": "{{#label}} must be one of {{#map}}"
                }
            });
        }
    ]);
});

});

parcelRegister("3oOJ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $279af62ecda52f92$export$2e2bcd8739ae039; });

var $cBna0 = parcelRequire("cBna0");

var $jJj9x = parcelRequire("jJj9x");

var $8olSf = parcelRequire("8olSf");

var $4JUhT = parcelRequire("4JUhT");
class $279af62ecda52f92$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cBna0))).Component {
    constructor(...args){
        super(...args);
        this.track = (event, properties, options, callback)=>{
            if (!properties) properties = {};
            if (!properties.source) properties.source = "Connect (Client)";
            const runtime = (0, $4JUhT.getRuntimeConfig)();
            if (!properties.environment) properties.environment = runtime.environmentName;
            if (!properties.deploymentTier) properties.deploymentTier = runtime.deploymentTier;
            if (!properties.publicOrigin) properties.publicOrigin = runtime.publicOrigin;
            // Per-org slicing in Amplitude/LogRocket: attach the user's primary
            // org (cached at identify time) to every event unless the caller
            // already set one explicitly.
            try {
                if (!properties.orgId) {
                    const orgId = localStorage.getItem('audirie_primary_org_id');
                    const orgName = localStorage.getItem('audirie_primary_org_name');
                    if (orgId) properties.orgId = orgId;
                    if (orgName && !properties.orgName) properties.orgName = orgName;
                }
            } catch (err) {}
            window.analytics.track(event, properties, options, callback);
        };
        this.identify = (id, traits, options)=>{
            //if (Analytics) {
            //    Analytics.identify(id, traits, options);
            //} else {
            const includedTraits = [
                'email',
                'firstName',
                'lastName',
                'name',
                'memberDetails',
                'userStatus'
            ];
            let newTraits = {};
            includedTraits.forEach((key)=>{
                if (traits && traits[key]) {
                    if (key == "memberDetails" && Array.isArray(traits[key])) {
                        newTraits[key] = [];
                        for (let thisOrg of traits[key])newTraits[key].push(thisOrg.company);
                    } else newTraits[key] = traits[key];
                }
            });
            // Structured org traits so Amplitude groups / LogRocket session traits
            // can slice by organisation id, not just company name. memberDetails
            // (names only) is kept unchanged for existing dashboards.
            if (traits && Array.isArray(traits.memberDetails)) {
                const organisations = traits.memberDetails.filter((org)=>org && org.orgId).map((org)=>({
                        orgId: String(org.orgId),
                        orgName: org.company || null
                    }));
                if (organisations.length > 0) {
                    newTraits.organisations = organisations;
                    newTraits.orgIds = organisations.map((org)=>org.orgId);
                    newTraits.primaryOrgId = organisations[0].orgId;
                    newTraits.primaryOrgName = organisations[0].orgName;
                    try {
                        localStorage.setItem('audirie_primary_org_id', organisations[0].orgId);
                        if (organisations[0].orgName) localStorage.setItem('audirie_primary_org_name', organisations[0].orgName);
                    } catch (err) {}
                }
            }
            try {
                let resetTraits = false;
                let oldUserId = "";
                try {
                    oldUserId = JSON.parse(localStorage.getItem('ajs_user_id'));
                } catch (errUserId) {
                    console.error(`[TrackableReact] Could not get old userId`);
                    console.error(errUserId);
                }
                if (oldUserId != id) resetTraits = true;
                let oldUserTraits = "";
                try {
                    oldUserTraits = JSON.parse(localStorage.getItem(`ajs_user_traits`));
                } catch (errUserTraits) {
                    console.error(`[TrackableReact] Could not get old user traits`);
                    console.error(errUserTraits);
                }
                if (oldUserTraits?.toString()?.length > 10000) resetTraits = true;
                if (resetTraits) //window.analytics.reset()
                localStorage.setItem(`ajs_user_traits`, []);
            } catch (err) {
                console.error(`[TrackableReact] Could not clear user traits`);
                console.error(err);
            }
            window.analytics.identify(id, newTraits, options);
        //}
        };
    }
    componentDidMount() {
        // Subclasses that never initialise state have this.state === null.
        const userId = this.state?.userId;
        if (userId /*&& !Analytics.storedId*/ ) window.analytics.identify(userId);
        if ((0, $8olSf.default).href !== (0, $jJj9x.default).priorHref) {
            window.analytics.page();
            (0, $jJj9x.default).priorHref = (0, $8olSf.default).href;
        }
    }
}

});
parcelRegister("jJj9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edf0be1bfbfca0d0$export$2e2bcd8739ae039; });

var $cNIxq = parcelRequire("cNIxq");
const $edf0be1bfbfca0d0$var$protectAttributes = [
    'password',
    'encrypted_password',
    'confirm_password'
];
const $edf0be1bfbfca0d0$var$profile = (0, $cNIxq.default).get('profile');
const $edf0be1bfbfca0d0$var$oldIdentify = window.analytics.identify;
const $edf0be1bfbfca0d0$var$oldTrack = window.analytics.track;
class $edf0be1bfbfca0d0$export$2e2bcd8739ae039 {
    constructor(){
        this.page = ()=>{
            window.analytics.page();
        };
    }
    identify(id, profileArg, options) {
        if (profileArg) $edf0be1bfbfca0d0$var$protectAttributes.forEach((protectedAttr)=>{
            delete profileArg[protectedAttr];
        });
        if ($edf0be1bfbfca0d0$var$profile && $edf0be1bfbfca0d0$var$profile.userId) pendo.identify($edf0be1bfbfca0d0$var$profile.userId);
        window.analytics.identify(id, profileArg, options);
    }
    track(msg, properties, options) {
        if ($edf0be1bfbfca0d0$var$profile && $edf0be1bfbfca0d0$var$profile.userId) pendo.track(msg, $edf0be1bfbfca0d0$var$profile.userId);
        window.analytics.track(msg, properties, options);
    }
}

});
parcelRegister("cNIxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951c9bfbe80648a4$export$2e2bcd8739ae039; });
const $951c9bfbe80648a4$var$myStorage = window.localStorage;
var $951c9bfbe80648a4$export$2e2bcd8739ae039 = {
    // A full quota (or blocked site data) must not break the page that saves.
    set: (key, value)=>{
        try {
            $951c9bfbe80648a4$var$myStorage.setItem(key, JSON.stringify(value));
        } catch (err) {
            console.warn(`[storage] Could not save ${key}`, err?.name);
        }
    },
    get: (key)=>JSON.parse($951c9bfbe80648a4$var$myStorage.getItem(key)),
    remove: (key)=>$951c9bfbe80648a4$var$myStorage.removeItem(key),
    clear: ()=>$951c9bfbe80648a4$var$myStorage.clear()
};

});


parcelRegister("8olSf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b69699beed891a35$export$2e2bcd8739ae039; });
var $b69699beed891a35$export$2e2bcd8739ae039 = window.location;

});

parcelRegister("4JUhT", function(module, exports) {
const $373706eda9e4ee96$var$CONFIG_KEY = '__AUDIRIE_RUNTIME_CONFIG__';
const $373706eda9e4ee96$var$getRuntimeConfig = ()=>{
    const config = window[$373706eda9e4ee96$var$CONFIG_KEY];
    if (!config || typeof config !== 'object' || !config.publicOrigin || !config.capabilities || config.capabilities.identity !== false && (!config.firebase?.apiKey || !config.firebase?.projectId)) throw new Error('Audirie runtime configuration was not loaded');
    return config;
};
const $373706eda9e4ee96$var$isLocalDevelopment = ()=>$373706eda9e4ee96$var$getRuntimeConfig().deploymentTier === 'development';
const $373706eda9e4ee96$var$LOCAL_DIAGNOSTIC_HOSTS = new Set([
    'localhost',
    '127.0.0.1',
    '::1',
    '[::1]'
]);
/**
 * Developer-only diagnostics on screen. `development` is a plain local run.
 * Isolated environments (Safe Dev and friends) report the `preview` tier, so
 * gating on `development` alone hides these where they are most needed —
 * `preview` therefore qualifies only when the page is served from a local
 * address. A hosted preview on a real domain, staging and production never
 * show them.
 */ const $373706eda9e4ee96$var$showDeveloperDiagnostics = ()=>{
    try {
        const tier = $373706eda9e4ee96$var$getRuntimeConfig().deploymentTier;
        if (tier === 'development') return true;
        if (tier !== 'preview') return false;
        return $373706eda9e4ee96$var$LOCAL_DIAGNOSTIC_HOSTS.has(String(window.location?.hostname || ''));
    } catch (err) {
        return false;
    }
};
const $373706eda9e4ee96$var$DIAGNOSTICS_LATCH_KEY = 'audirieDiagnostics';
/**
 * Being allowed to show diagnostics is not a reason to. Safe Dev is where the
 * product is reviewed, not only debugged, so the detail stays off until
 * somebody asks for it with ?diagnostics=1, and off again with ?diagnostics=0.
 *
 * The learner app rewrites the address bar to "/" shortly after it boots, so
 * the query string is only there to be read while this module is loading —
 * hence the latch, and hence sessionStorage, which also keeps the setting
 * through the in-app navigation that drops it. Storage is best effort: a
 * private window that throws just leaves diagnostics off.
 */ const $373706eda9e4ee96$var$latchDiagnosticsFromLocation = ()=>{
    try {
        const requested = new URLSearchParams(window.location?.search || '').get('diagnostics');
        if (requested !== '1' && requested !== '0') return;
        if (requested === '1') window.sessionStorage.setItem($373706eda9e4ee96$var$DIAGNOSTICS_LATCH_KEY, '1');
        else window.sessionStorage.removeItem($373706eda9e4ee96$var$DIAGNOSTICS_LATCH_KEY);
    } catch (err) {}
};
$373706eda9e4ee96$var$latchDiagnosticsFromLocation();
const $373706eda9e4ee96$var$diagnosticsRequested = ()=>{
    try {
        return window.sessionStorage.getItem($373706eda9e4ee96$var$DIAGNOSTICS_LATCH_KEY) === '1';
    } catch (err) {
        return false;
    }
};
const $373706eda9e4ee96$var$DEFAULT_PROFILE_TIMEOUT_MS = 10000;
/**
 * How long the dashboard waits for /api/profile. Served per deployment tier
 * (see `profileTimeoutMs` in configs/runtime.js) because an isolated
 * environment far from its database needs far longer than production.
 */ const $373706eda9e4ee96$var$getProfileTimeoutMs = ()=>{
    try {
        const timeout = $373706eda9e4ee96$var$getRuntimeConfig().profileTimeoutMs;
        return Number.isInteger(timeout) && timeout > 0 ? timeout : $373706eda9e4ee96$var$DEFAULT_PROFILE_TIMEOUT_MS;
    } catch (err) {
        return $373706eda9e4ee96$var$DEFAULT_PROFILE_TIMEOUT_MS;
    }
};
const $373706eda9e4ee96$var$getFirebaseClientConfig = ()=>{
    const runtime = $373706eda9e4ee96$var$getRuntimeConfig();
    if (!runtime.capabilities.identity || !runtime.firebase?.enabled) throw new Error('Firebase identity is disabled');
    const firebase = runtime.firebase;
    return Object.fromEntries(Object.entries({
        apiKey: firebase.apiKey,
        authDomain: firebase.authDomain,
        projectId: firebase.projectId,
        storageBucket: firebase.storageBucket,
        messagingSenderId: firebase.messagingSenderId,
        appId: firebase.appId,
        measurementId: firebase.measurementId
    }).filter(([, value])=>value != null && value !== ''));
};
module.exports = {
    getFirebaseClientConfig: $373706eda9e4ee96$var$getFirebaseClientConfig,
    getProfileTimeoutMs: $373706eda9e4ee96$var$getProfileTimeoutMs,
    getRuntimeConfig: $373706eda9e4ee96$var$getRuntimeConfig,
    diagnosticsRequested: $373706eda9e4ee96$var$diagnosticsRequested,
    isLocalDevelopment: $373706eda9e4ee96$var$isLocalDevelopment,
    latchDiagnosticsFromLocation: $373706eda9e4ee96$var$latchDiagnosticsFromLocation,
    showDeveloperDiagnostics: $373706eda9e4ee96$var$showDeveloperDiagnostics
};

});


parcelRegister("4uQJZ", function(module, exports) {
'use strict';
/**
 * Post-login redirect helpers, shared between the backend and the login
 * frontend (Parcel bundles CommonJS from lib/ without trouble).
 *
 * Redirect targets are attacker-influenced (query params, sessionStorage),
 * so everything here is strict-whitelist: relative same-origin paths only.
 */ /**
 * Validates a client-supplied `next` path. Accepts only paths that start
 * with a single `/` — rejects protocol-relative (`//…`), absolute URLs
 * (`…://…`), backslash tricks and control characters. Returns the path
 * unchanged when safe, otherwise null.
 *
 * @param {*} value candidate redirect path
 * @returns {string|null}
 */ const $3462dff68270a7f5$var$sanitizeNextPath = (value)=>{
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed.startsWith('/')) return null;
    if (trimmed.startsWith('//')) return null;
    if (trimmed.includes('\\')) return null;
    if (trimmed.includes('://')) return null;
    // Control characters can smuggle a scheme past naive prefix checks.
    // eslint-disable-next-line no-control-regex
    if (/[\u0000-\u001f]/.test(trimmed)) return null;
    return trimmed;
};
/**
 * Maps an enrollment destination ({ bundleId, simId }) to the path the
 * dashboard itself uses to open a simulation. A bundle without a simulation
 * has no direct page, so it falls through to the dashboard (null).
 *
 * @param {{bundleId?: string, simId?: string}|null} destination
 * @returns {string|null} path to land on, or null for the default dashboard
 */ const $3462dff68270a7f5$var$destinationToPath = (destination)=>{
    if (!destination || typeof destination !== 'object') return null;
    const clean = (value)=>typeof value === 'string' && value.trim() ? value.trim() : null;
    const simId = clean(destination.simId);
    const bundleId = clean(destination.bundleId);
    if (simId && bundleId) return `/custom_assessment_adv_vid/${encodeURIComponent(bundleId)}/${encodeURIComponent(simId)}`;
    if (simId) return `/custom_assessment_adv_vid/${encodeURIComponent(simId)}`;
    return null;
};
/**
 * When a `?aid=` token login fails, cookie-auth redirects to `/login` and
 * re-attaches the original query (including `return=` and an appended
 * `next=`). The login page used to take *everything after* the literal
 * `return=` substring — so an empty `return=` grabbed `&next=/…` as the
 * redirect target, which the browser resolved to a path like `/&next=/`
 * and nginx 404'd.
 *
 * Parse `return` properly. Only honour a non-empty absolute http(s) URL
 * (org `failedLoginReturnUrl`). Empty / relative / junk → null (stay on
 * the login page).
 *
 * @param {string} search `location.search` (with or without leading `?`)
 * @returns {string|null}
 */ const $3462dff68270a7f5$var$resolveAidFailureReturnUrl = (search)=>{
    if (typeof search !== 'string' || !search) return null;
    const qs = search.startsWith('?') ? search.slice(1) : search;
    let value;
    try {
        value = new URLSearchParams(qs).get('return');
    } catch (err) {
        return null;
    }
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    // Absolute http(s) only — partner failure URLs. Reject relative junk
    // (`&next=/…`, `/foo`, `//evil`) that would resolve against /login.
    if (!/^https?:\/\//i.test(trimmed)) return null;
    try {
        const parsed = new URL(trimmed);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
        return parsed.toString();
    } catch (err) {
        return null;
    }
};
/**
 * Validates a host return URL for the end of a top-level embedded launch
 * (AUDR-220): `launch_presentation.return_url` from the verified launch, or
 * the registration's default. Absolute `http(s)` only, no credentials in
 * the authority, bounded length; anything else is null (no redirect). The
 * value must come from the sealed embed session — never from the page or
 * the query string — this only guards its shape.
 *
 * @param {*} value candidate URL
 * @returns {string|null} normalised URL or null
 */ const $3462dff68270a7f5$var$MAX_RETURN_URL = 2048;
const $3462dff68270a7f5$var$sanitizeReturnUrl = (value)=>{
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (!trimmed || trimmed.length > $3462dff68270a7f5$var$MAX_RETURN_URL) return null;
    // eslint-disable-next-line no-control-regex
    if (/[\u0000-\u001f\s]/.test(trimmed)) return null;
    if (!/^https?:\/\//i.test(trimmed)) return null;
    let parsed;
    try {
        parsed = new URL(trimmed);
    } catch (err) {
        return null;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
    if (parsed.username || parsed.password) return null;
    if (!parsed.hostname) return null;
    return parsed.toString();
};
module.exports = {
    sanitizeNextPath: $3462dff68270a7f5$var$sanitizeNextPath,
    destinationToPath: $3462dff68270a7f5$var$destinationToPath,
    resolveAidFailureReturnUrl: $3462dff68270a7f5$var$resolveAidFailureReturnUrl,
    sanitizeReturnUrl: $3462dff68270a7f5$var$sanitizeReturnUrl
};

});

parcelRegister("kzXQB", function(module, exports) {

$parcel$export(module.exports, "MFA_PHONE_FACTORID", function () { return $efb57ff9122ff87b$export$a15e15d343b3e124; });
$parcel$export(module.exports, "signOutOfFirebase", function () { return $efb57ff9122ff87b$export$80372759db089d0; });
$parcel$export(module.exports, "getRecaptcha", function () { return $efb57ff9122ff87b$export$38b9d75d8815e68b; });
$parcel$export(module.exports, "updateFirebasePassword", function () { return $efb57ff9122ff87b$export$7e20a0b9c5942898; });
$parcel$export(module.exports, "signInToFirebase", function () { return $efb57ff9122ff87b$export$74a9edc1d827e984; });
$parcel$export(module.exports, "signInWithSso", function () { return $efb57ff9122ff87b$export$a116e16baaca3838; });
$parcel$export(module.exports, "getSsoRedirectResult", function () { return $efb57ff9122ff87b$export$5ab56d17a9dfbd40; });
$parcel$export(module.exports, "multiFactorAuth", function () { return $efb57ff9122ff87b$export$d1af4b2e04c18c63; });
$parcel$export(module.exports, "verifyPhoneNumber", function () { return $efb57ff9122ff87b$export$dc8bab6522832a8; });
$parcel$export(module.exports, "getUserSession", function () { return $efb57ff9122ff87b$export$8c60d41759eab72b; });
$parcel$export(module.exports, "getFactorType", function () { return $efb57ff9122ff87b$export$3185dfa60c5e17da; });
$parcel$export(module.exports, "resolveVerification", function () { return $efb57ff9122ff87b$export$ba0df6589826c167; });
$parcel$export(module.exports, "enrollPhoneNumber", function () { return $efb57ff9122ff87b$export$617d4db491e02094; });
parcelRequire("6ILBi");
var $8vnFK = parcelRequire("8vnFK");
parcelRequire("eGTQ8");
var $1iout = parcelRequire("1iout");

var $cNIxq = parcelRequire("cNIxq");

var $4JUhT = parcelRequire("4JUhT");

var $TAT8G = parcelRequire("TAT8G");
const $efb57ff9122ff87b$var$runtimeConfig = (0, $4JUhT.getRuntimeConfig)();
(0, $8vnFK.initializeApp)((0, $4JUhT.getFirebaseClientConfig)());
// Identity Platform tenant selection is request-time state, not a build
// decision. Set it before creating providers or starting password, redirect,
// MFA, reset, or enrollment-related authentication.
const $efb57ff9122ff87b$var$auth = (0, $1iout.D)();
(0, $TAT8G.applyFirebaseTenant)($efb57ff9122ff87b$var$auth, $efb57ff9122ff87b$var$runtimeConfig.firebase.tenantId);
const $efb57ff9122ff87b$var$phoneAuthProvider = new (0, $1iout.i)($efb57ff9122ff87b$var$auth);
const $efb57ff9122ff87b$export$a15e15d343b3e124 = (0, $1iout.j).FACTOR_ID;
const $efb57ff9122ff87b$export$7cbf767827cd68ba = ()=>{
    $efb57ff9122ff87b$var$auth.currentUser?.getIdToken(true);
    return $efb57ff9122ff87b$var$auth.currentUser;
};
const $efb57ff9122ff87b$export$80372759db089d0 = async ()=>{
    await (0, $1iout.ak)($efb57ff9122ff87b$var$auth);
};
const $efb57ff9122ff87b$export$38b9d75d8815e68b = (recaptchaEl)=>{
    return new (0, $1iout.R)($efb57ff9122ff87b$var$auth, recaptchaEl, {
        size: "invisible"
    });
};
const $efb57ff9122ff87b$export$7e20a0b9c5942898 = async (password)=>{
    let user = $efb57ff9122ff87b$export$7cbf767827cd68ba();
    if (!user) throw {
        code: 'custom/no-user-found'
    };
    return await (0, $1iout.ao)(user, password).then(()=>true).catch(()=>false);
};
const $efb57ff9122ff87b$export$e434e2b73b143cb7 = (factors)=>{
    const factorObj = {};
    if (!Array.isArray(factors)) return;
    factors.forEach((factor)=>{
        if (!factor.factorId) return;
        if (!factorObj[factor.factorId]) factorObj[factor.factorId] = factor;
        else {
            const [date1, date2] = [
                new Date(factorObj[factor.factorId].enrollmentTime || 0),
                new Date(factor.enrollmentTime || 0)
            ];
            if (date2.getTime() > date1.getTime()) factor[factor.factorId] = factor;
        }
    });
    (0, $cNIxq.default).set('factors', factorObj);
};
// Firebase error codes that mean "auth is temporarily unavailable" rather
// than "the credentials are wrong" — e.g. Firebase throttling repeated
// sign-ins from the same IP (auth/too-many-requests), or transient network/
// backend problems. These must NOT be treated as a failed password.
const $efb57ff9122ff87b$var$TRANSIENT_FIREBASE_ERROR_CODES = new Set([
    'auth/too-many-requests',
    'auth/network-request-failed',
    'auth/internal-error',
    'auth/timeout'
]);
const $efb57ff9122ff87b$export$74a9edc1d827e984 = async (email, password)=>{
    const result = await (0, $1iout.af)($efb57ff9122ff87b$var$auth, email, password).then((credential)=>{
        return {
            type: 'credential',
            data: credential
        };
    }).catch((err)=>{
        if (!err?.code) console.error(err);
        if (err.code == 'auth/multi-factor-auth-required') {
            const resolver = (0, $1iout.J)($efb57ff9122ff87b$var$auth, err);
            $efb57ff9122ff87b$export$e434e2b73b143cb7(resolver?.hints || []);
            return {
                type: 'multiFactor',
                data: resolver
            };
        }
        // Surface transient failures distinctly so the caller can ask the user
        // to retry instead of silently falling back to a raw password attempt
        // (which fails as "incorrect password" for Firebase-managed accounts).
        if ($efb57ff9122ff87b$var$TRANSIENT_FIREBASE_ERROR_CODES.has(err?.code)) return {
            type: 'transientError',
            code: err.code
        };
        return null;
    });
    return result;
};
const $efb57ff9122ff87b$var$credentialWithToken = async (credential)=>{
    if (!credential?.user) return null;
    return {
        type: 'credential',
        data: {
            user: {
                accessToken: await credential.user.getIdToken(),
                email: credential.user.email || null
            }
        }
    };
};
const $efb57ff9122ff87b$var$isSsoProviderNotFound = (error)=>[
        'auth/invalid-provider-id',
        'auth/provider-not-found',
        'auth/operation-not-allowed'
    ].includes(error?.code);
const $efb57ff9122ff87b$export$c4de61e7fbbdb76b = (providerId)=>{
    const id = String(providerId || '');
    if (id.startsWith('saml.')) return new (0, $1iout.S)(id);
    if (id.startsWith('oidc.')) return new (0, $1iout.g)(id);
    throw new Error(`Unsupported SSO provider id: ${id}`);
};
const $efb57ff9122ff87b$var$signInWithSsoPopup = async (provider)=>{
    try {
        const credential = await (0, $1iout.ai)($efb57ff9122ff87b$var$auth, provider);
        return $efb57ff9122ff87b$var$credentialWithToken(credential);
    } catch (popupError) {
        if ($efb57ff9122ff87b$var$isSsoProviderNotFound(popupError)) return {
            type: 'providerNotFound'
        };
        if (popupError?.code === 'auth/popup-blocked') return {
            type: 'popupBlocked'
        };
        throw popupError;
    }
};
const $efb57ff9122ff87b$export$a116e16baaca3838 = async (providerId)=>{
    if (!$efb57ff9122ff87b$var$runtimeConfig.capabilities.sso) return {
        type: 'providerNotFound'
    };
    let provider;
    try {
        provider = $efb57ff9122ff87b$export$c4de61e7fbbdb76b(providerId);
    } catch (err) {
        return {
            type: 'providerNotFound'
        };
    }
    // HTTP localhost cannot use the same-origin redirect proxy reliably.
    if ($efb57ff9122ff87b$var$runtimeConfig.firebase.usePopupForSso) return $efb57ff9122ff87b$var$signInWithSsoPopup(provider);
    try {
        await (0, $1iout.aj)($efb57ff9122ff87b$var$auth, provider);
        return {
            type: 'redirect'
        };
    } catch (redirectError) {
        if ($efb57ff9122ff87b$var$isSsoProviderNotFound(redirectError)) return {
            type: 'providerNotFound'
        };
        console.warn('SSO redirect sign-in failed; attempting popup fallback.', redirectError);
        return $efb57ff9122ff87b$var$signInWithSsoPopup(provider);
    }
};
const $efb57ff9122ff87b$export$5ab56d17a9dfbd40 = async ()=>{
    try {
        const credential = await (0, $1iout.K)($efb57ff9122ff87b$var$auth);
        return $efb57ff9122ff87b$var$credentialWithToken(credential);
    } catch (error) {
        if ($efb57ff9122ff87b$var$isSsoProviderNotFound(error)) return {
            type: 'providerNotFound'
        };
        throw error;
    }
};
const $efb57ff9122ff87b$export$6c3238710906c815 = $efb57ff9122ff87b$export$a116e16baaca3838;
const $efb57ff9122ff87b$export$213e6a362714f438 = $efb57ff9122ff87b$export$5ab56d17a9dfbd40;
const $efb57ff9122ff87b$export$d1af4b2e04c18c63 = async (session, factor, recaptchaVerifier)=>{
    switch(factor.factorId){
        case (0, $1iout.j).FACTOR_ID:
            const phoneInfoOptions = {
                multiFactorHint: factor,
                session: session
            };
            return $efb57ff9122ff87b$export$dc8bab6522832a8(phoneInfoOptions, recaptchaVerifier);
        default:
            break;
    }
};
const $efb57ff9122ff87b$export$dc8bab6522832a8 = async (options, recaptchaVerifier)=>{
    const verifiedId = await $efb57ff9122ff87b$var$phoneAuthProvider.verifyPhoneNumber(options, recaptchaVerifier);
    return verifiedId;
};
const $efb57ff9122ff87b$export$8c60d41759eab72b = async ()=>{
    const user = $efb57ff9122ff87b$export$7cbf767827cd68ba();
    if (!user) throw {
        code: 'custom/user-not-found'
    };
    return await (0, $1iout.Z)(user).getSession();
};
const $efb57ff9122ff87b$export$3185dfa60c5e17da = (factor)=>{
    if (!factor) return "unknown";
    switch(factor.factorId){
        case (0, $1iout.j).FACTOR_ID:
            return "phone";
        default:
            return "unknown";
    }
};
const $efb57ff9122ff87b$export$9513f3e810780d05 = (verificationId, code)=>{
    const cred = (0, $1iout.i).credential(verificationId, code);
    return (0, $1iout.j).assertion(cred);
};
const $efb57ff9122ff87b$export$ba0df6589826c167 = async (type, verificationId, code, resolver)=>{
    let assertion;
    switch(type){
        case "phone":
            assertion = $efb57ff9122ff87b$export$9513f3e810780d05(verificationId, code);
            break;
        default:
            console.error("Unknown factor type");
            return null;
    }
    return await resolver.resolveSignIn(assertion);
};
const $efb57ff9122ff87b$export$617d4db491e02094 = async (verificationId, code)=>{
    const assertion = $efb57ff9122ff87b$export$9513f3e810780d05(verificationId, code);
    await (0, $1iout.Z)($efb57ff9122ff87b$export$7cbf767827cd68ba()).enroll(assertion, "Default");
    return;
};

});
parcelRegister("6ILBi", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("8vnFK")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("8vnFK")).registerVersion; });

var $8vnFK = parcelRequire("8vnFK");
var $4e4bc69ae68c26a0$var$name = "firebase";
var $4e4bc69ae68c26a0$var$version = "12.17.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $8vnFK.registerVersion)($4e4bc69ae68c26a0$var$name, $4e4bc69ae68c26a0$var$version, 'app');

});
parcelRegister("8vnFK", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $631394d717c79ea9$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $631394d717c79ea9$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $631394d717c79ea9$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $631394d717c79ea9$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $631394d717c79ea9$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $631394d717c79ea9$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $631394d717c79ea9$export$f9962582c9e66d99; });

var $3eXgh = parcelRequire("3eXgh");

var $eR2Kc = parcelRequire("eR2Kc");

var $7PthC = parcelRequire("7PthC");

var $6hxVm = parcelRequire("6hxVm");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $631394d717c79ea9$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($631394d717c79ea9$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $631394d717c79ea9$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $631394d717c79ea9$var$name$q = "@firebase/app";
const $631394d717c79ea9$var$version$1 = "0.16.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $631394d717c79ea9$var$logger = new (0, $eR2Kc.Logger)('@firebase/app');
const $631394d717c79ea9$var$name$p = "@firebase/app-compat";
const $631394d717c79ea9$var$name$o = "@firebase/analytics-compat";
const $631394d717c79ea9$var$name$n = "@firebase/analytics";
const $631394d717c79ea9$var$name$m = "@firebase/app-check-compat";
const $631394d717c79ea9$var$name$l = "@firebase/app-check";
const $631394d717c79ea9$var$name$k = "@firebase/auth";
const $631394d717c79ea9$var$name$j = "@firebase/auth-compat";
const $631394d717c79ea9$var$name$i = "@firebase/database";
const $631394d717c79ea9$var$name$h = "@firebase/data-connect";
const $631394d717c79ea9$var$name$g = "@firebase/database-compat";
const $631394d717c79ea9$var$name$f = "@firebase/functions";
const $631394d717c79ea9$var$name$e = "@firebase/functions-compat";
const $631394d717c79ea9$var$name$d = "@firebase/installations";
const $631394d717c79ea9$var$name$c = "@firebase/installations-compat";
const $631394d717c79ea9$var$name$b = "@firebase/messaging";
const $631394d717c79ea9$var$name$a = "@firebase/messaging-compat";
const $631394d717c79ea9$var$name$9 = "@firebase/performance";
const $631394d717c79ea9$var$name$8 = "@firebase/performance-compat";
const $631394d717c79ea9$var$name$7 = "@firebase/remote-config";
const $631394d717c79ea9$var$name$6 = "@firebase/remote-config-compat";
const $631394d717c79ea9$var$name$5 = "@firebase/storage";
const $631394d717c79ea9$var$name$4 = "@firebase/storage-compat";
const $631394d717c79ea9$var$name$3 = "@firebase/firestore";
const $631394d717c79ea9$var$name$2 = "@firebase/ai";
const $631394d717c79ea9$var$name$1 = "@firebase/firestore-compat";
const $631394d717c79ea9$var$name = "firebase";
const $631394d717c79ea9$var$version = "12.17.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $631394d717c79ea9$export$9f30fa0c10967f7f = '[DEFAULT]';
const $631394d717c79ea9$var$PLATFORM_LOG_STRING = {
    [$631394d717c79ea9$var$name$q]: 'fire-core',
    [$631394d717c79ea9$var$name$p]: 'fire-core-compat',
    [$631394d717c79ea9$var$name$n]: 'fire-analytics',
    [$631394d717c79ea9$var$name$o]: 'fire-analytics-compat',
    [$631394d717c79ea9$var$name$l]: 'fire-app-check',
    [$631394d717c79ea9$var$name$m]: 'fire-app-check-compat',
    [$631394d717c79ea9$var$name$k]: 'fire-auth',
    [$631394d717c79ea9$var$name$j]: 'fire-auth-compat',
    [$631394d717c79ea9$var$name$i]: 'fire-rtdb',
    [$631394d717c79ea9$var$name$h]: 'fire-data-connect',
    [$631394d717c79ea9$var$name$g]: 'fire-rtdb-compat',
    [$631394d717c79ea9$var$name$f]: 'fire-fn',
    [$631394d717c79ea9$var$name$e]: 'fire-fn-compat',
    [$631394d717c79ea9$var$name$d]: 'fire-iid',
    [$631394d717c79ea9$var$name$c]: 'fire-iid-compat',
    [$631394d717c79ea9$var$name$b]: 'fire-fcm',
    [$631394d717c79ea9$var$name$a]: 'fire-fcm-compat',
    [$631394d717c79ea9$var$name$9]: 'fire-perf',
    [$631394d717c79ea9$var$name$8]: 'fire-perf-compat',
    [$631394d717c79ea9$var$name$7]: 'fire-rc',
    [$631394d717c79ea9$var$name$6]: 'fire-rc-compat',
    [$631394d717c79ea9$var$name$5]: 'fire-gcs',
    [$631394d717c79ea9$var$name$4]: 'fire-gcs-compat',
    [$631394d717c79ea9$var$name$3]: 'fire-fst',
    [$631394d717c79ea9$var$name$1]: 'fire-fst-compat',
    [$631394d717c79ea9$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$631394d717c79ea9$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $631394d717c79ea9$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $631394d717c79ea9$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $631394d717c79ea9$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $631394d717c79ea9$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $631394d717c79ea9$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $631394d717c79ea9$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $631394d717c79ea9$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($631394d717c79ea9$export$9566bce3835c0f28.has(componentName)) {
        $631394d717c79ea9$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $631394d717c79ea9$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $631394d717c79ea9$export$b4e3c36c855b14b5.values())$631394d717c79ea9$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $631394d717c79ea9$export$fb03ad8d3d5c5f76.values())$631394d717c79ea9$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $631394d717c79ea9$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $631394d717c79ea9$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $631394d717c79ea9$export$9f30fa0c10967f7f) {
    $631394d717c79ea9$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $631394d717c79ea9$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $631394d717c79ea9$export$38e311c93c671bec(obj) {
    if ($631394d717c79ea9$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $631394d717c79ea9$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $631394d717c79ea9$export$3685d89b9c3cdfaf() {
    $631394d717c79ea9$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $631394d717c79ea9$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different {$mismatchedParam}. Existing: '{$oldValue}'. New: '{$newValue}'.",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $631394d717c79ea9$var$ERROR_FACTORY = new (0, $7PthC.ErrorFactory)('app', 'Firebase', $631394d717c79ea9$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $631394d717c79ea9$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $3eXgh.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $631394d717c79ea9$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $631394d717c79ea9$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $7PthC.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $631394d717c79ea9$var$FirebaseServerAppImpl extends $631394d717c79ea9$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $631394d717c79ea9$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $631394d717c79ea9$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $631394d717c79ea9$export$d29d5299a7137abc($631394d717c79ea9$var$name$q, $631394d717c79ea9$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $631394d717c79ea9$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $631394d717c79ea9$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $631394d717c79ea9$export$31499a9cd224b78c = $631394d717c79ea9$var$version;
function $631394d717c79ea9$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $631394d717c79ea9$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $631394d717c79ea9$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $7PthC.getDefaultAppConfig)());
    if (!options) throw $631394d717c79ea9$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $631394d717c79ea9$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if (!(0, $7PthC.deepEqual)(options, existingApp.options)) throw $631394d717c79ea9$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name,
            mismatchedParam: 'options',
            oldValue: JSON.stringify(existingApp.options),
            newValue: JSON.stringify(options)
        });
        else if (!(0, $7PthC.deepEqual)(config, existingApp.config)) throw $631394d717c79ea9$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name,
            mismatchedParam: 'config',
            oldValue: JSON.stringify(existingApp.config),
            newValue: JSON.stringify(config)
        });
        else return existingApp;
    }
    const container = new (0, $3eXgh.ComponentContainer)(name);
    for (const component of $631394d717c79ea9$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $631394d717c79ea9$var$FirebaseAppImpl(options, config, container);
    $631394d717c79ea9$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $631394d717c79ea9$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $7PthC.isBrowser)() && !(0, $7PthC.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $631394d717c79ea9$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($631394d717c79ea9$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($631394d717c79ea9$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $7PthC.getDefaultAppConfig)());
    if (!firebaseOptions) throw $631394d717c79ea9$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $631394d717c79ea9$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $631394d717c79ea9$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $3eXgh.ComponentContainer)(nameString);
    for (const component of $631394d717c79ea9$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $631394d717c79ea9$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $631394d717c79ea9$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $631394d717c79ea9$export$f9962582c9e66d99(name = $631394d717c79ea9$export$9f30fa0c10967f7f) {
    const app = $631394d717c79ea9$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $631394d717c79ea9$export$9f30fa0c10967f7f && (0, $7PthC.getDefaultAppConfig)()) return $631394d717c79ea9$export$c55cfd413944906d();
    if (!app) throw $631394d717c79ea9$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $631394d717c79ea9$export$68ddedf7d44b3bdf() {
    return Array.from($631394d717c79ea9$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $631394d717c79ea9$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($631394d717c79ea9$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $631394d717c79ea9$export$b4e3c36c855b14b5.delete(name);
    } else if ($631394d717c79ea9$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $631394d717c79ea9$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $631394d717c79ea9$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $631394d717c79ea9$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $631394d717c79ea9$var$logger.warn(warning.join(' '));
        return;
    }
    $631394d717c79ea9$export$c930050e7bb63965(new (0, $3eXgh.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $631394d717c79ea9$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $631394d717c79ea9$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $eR2Kc.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $631394d717c79ea9$export$c622e99c0ce7b1c9(logLevel) {
    (0, $eR2Kc.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $631394d717c79ea9$var$DB_NAME = 'firebase-heartbeat-database';
const $631394d717c79ea9$var$DB_VERSION = 1;
const $631394d717c79ea9$var$STORE_NAME = 'firebase-heartbeat-store';
let $631394d717c79ea9$var$dbPromise = null;
function $631394d717c79ea9$var$getDbPromise() {
    if (!$631394d717c79ea9$var$dbPromise) $631394d717c79ea9$var$dbPromise = (0, $6hxVm.openDB)($631394d717c79ea9$var$DB_NAME, $631394d717c79ea9$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($631394d717c79ea9$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $631394d717c79ea9$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $631394d717c79ea9$var$dbPromise;
}
async function $631394d717c79ea9$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $631394d717c79ea9$var$getDbPromise();
        const tx = db.transaction($631394d717c79ea9$var$STORE_NAME);
        const result = await tx.objectStore($631394d717c79ea9$var$STORE_NAME).get($631394d717c79ea9$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $7PthC.FirebaseError)) $631394d717c79ea9$var$logger.warn(e.message);
        else {
            const idbGetError = $631394d717c79ea9$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $631394d717c79ea9$var$logger.warn(idbGetError.message);
        }
    }
}
async function $631394d717c79ea9$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $631394d717c79ea9$var$getDbPromise();
        const tx = db.transaction($631394d717c79ea9$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($631394d717c79ea9$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $631394d717c79ea9$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $7PthC.FirebaseError)) $631394d717c79ea9$var$logger.warn(e.message);
        else {
            const idbGetError = $631394d717c79ea9$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $631394d717c79ea9$var$logger.warn(idbGetError.message);
        }
    }
}
function $631394d717c79ea9$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $631394d717c79ea9$var$MAX_HEADER_BYTES = 1024;
const $631394d717c79ea9$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $631394d717c79ea9$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $631394d717c79ea9$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $631394d717c79ea9$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $631394d717c79ea9$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $631394d717c79ea9$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $631394d717c79ea9$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $631394d717c79ea9$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $631394d717c79ea9$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $7PthC.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $631394d717c79ea9$var$logger.warn(e);
            return '';
        }
    }
}
function $631394d717c79ea9$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $631394d717c79ea9$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $631394d717c79ea9$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($631394d717c79ea9$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($631394d717c79ea9$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $631394d717c79ea9$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $7PthC.isIndexedDBAvailable)()) return false;
        else return (0, $7PthC.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $631394d717c79ea9$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $631394d717c79ea9$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $631394d717c79ea9$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $631394d717c79ea9$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $7PthC.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $631394d717c79ea9$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $631394d717c79ea9$var$registerCoreComponents(variant) {
    $631394d717c79ea9$export$c930050e7bb63965(new (0, $3eXgh.Component)('platform-logger', (container)=>new $631394d717c79ea9$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $631394d717c79ea9$export$c930050e7bb63965(new (0, $3eXgh.Component)('heartbeat', (container)=>new $631394d717c79ea9$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $631394d717c79ea9$export$d29d5299a7137abc($631394d717c79ea9$var$name$q, $631394d717c79ea9$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $631394d717c79ea9$export$d29d5299a7137abc($631394d717c79ea9$var$name$q, $631394d717c79ea9$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $631394d717c79ea9$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $631394d717c79ea9$var$registerCoreComponents('');

});
parcelRegister("3eXgh", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $25c0a5fe864be3af$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $25c0a5fe864be3af$export$436a80eea5d5c0c5; });

var $7PthC = parcelRequire("7PthC");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $25c0a5fe864be3af$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $25c0a5fe864be3af$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $7PthC.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($25c0a5fe864be3af$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $25c0a5fe864be3af$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $25c0a5fe864be3af$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $25c0a5fe864be3af$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $25c0a5fe864be3af$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $25c0a5fe864be3af$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $25c0a5fe864be3af$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("7PthC", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $5b3402df97a950fb$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $5b3402df97a950fb$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $5b3402df97a950fb$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $5b3402df97a950fb$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $5b3402df97a950fb$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $5b3402df97a950fb$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $5b3402df97a950fb$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $5b3402df97a950fb$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $5b3402df97a950fb$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $5b3402df97a950fb$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isCloudflareWorker", function () { return $5b3402df97a950fb$export$ad9e9b75cb9fb797; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $5b3402df97a950fb$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $5b3402df97a950fb$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $5b3402df97a950fb$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $5b3402df97a950fb$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $5b3402df97a950fb$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $5b3402df97a950fb$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $5b3402df97a950fb$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $5b3402df97a950fb$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $5b3402df97a950fb$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $5b3402df97a950fb$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $5b3402df97a950fb$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $5b3402df97a950fb$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $5b3402df97a950fb$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $5b3402df97a950fb$export$4befe9b5fa509a1b; });
$parcel$export(module.exports, "isCloudWorkstation", function () { return $5b3402df97a950fb$export$5b4d24b45140ad90; });
$parcel$export(module.exports, "pingServer", function () { return $5b3402df97a950fb$export$c0f0d0ce4283a937; });

var $3HCI1 = parcelRequire("3HCI1");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $5b3402df97a950fb$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $5b3402df97a950fb$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $5b3402df97a950fb$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $5b3402df97a950fb$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $5b3402df97a950fb$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5b3402df97a950fb$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $5b3402df97a950fb$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $5b3402df97a950fb$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($5b3402df97a950fb$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $5b3402df97a950fb$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $5b3402df97a950fb$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $5b3402df97a950fb$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $5b3402df97a950fb$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $5b3402df97a950fb$var$stringToByteArray$1(str);
    return $5b3402df97a950fb$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $5b3402df97a950fb$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $5b3402df97a950fb$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $5b3402df97a950fb$export$c62426fdd000a97e = function(str) {
    try {
        return $5b3402df97a950fb$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $5b3402df97a950fb$export$6c40052bed430212(value) {
    return $5b3402df97a950fb$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $5b3402df97a950fb$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$5b3402df97a950fb$var$isValidKey(prop)) continue;
        target[prop] = $5b3402df97a950fb$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $5b3402df97a950fb$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $5b3402df97a950fb$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5b3402df97a950fb$var$getDefaultsFromGlobal = ()=>$5b3402df97a950fb$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $5b3402df97a950fb$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $5b3402df97a950fb$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $5b3402df97a950fb$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $5b3402df97a950fb$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $3HCI1.getDefaultsFromPostinstall)() || $5b3402df97a950fb$var$getDefaultsFromGlobal() || $5b3402df97a950fb$var$getDefaultsFromEnvVariable() || $5b3402df97a950fb$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $5b3402df97a950fb$export$9c11895284c8adad = (productName)=>$5b3402df97a950fb$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $5b3402df97a950fb$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $5b3402df97a950fb$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $5b3402df97a950fb$export$3dfb6827a9f89756 = ()=>$5b3402df97a950fb$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $5b3402df97a950fb$export$5539a1a3afe87d6 = (name)=>$5b3402df97a950fb$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5b3402df97a950fb$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b3402df97a950fb$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $5b3402df97a950fb$export$4b5284a3025a455(JSON.stringify(header)),
        $5b3402df97a950fb$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $5b3402df97a950fb$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $5b3402df97a950fb$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($5b3402df97a950fb$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $5b3402df97a950fb$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $5b3402df97a950fb$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $5b3402df97a950fb$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $5b3402df97a950fb$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $5b3402df97a950fb$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $5b3402df97a950fb$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $5b3402df97a950fb$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $5b3402df97a950fb$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $5b3402df97a950fb$export$f2f6a8999f8ebd30() {
    return $5b3402df97a950fb$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $5b3402df97a950fb$export$7e7b1a9668aaed8() {
    const ua = $5b3402df97a950fb$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $5b3402df97a950fb$export$202944b2d2824246() {
    return $5b3402df97a950fb$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $5b3402df97a950fb$export$5d1d834fbbf8bab7() {
    return $5b3402df97a950fb$export$588c7fdda06fbb0a.NODE_CLIENT === true || $5b3402df97a950fb$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $5b3402df97a950fb$export$95df08bae54cb4df() {
    return !$5b3402df97a950fb$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $5b3402df97a950fb$export$ef10bcfb06572016() {
    return !$5b3402df97a950fb$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $5b3402df97a950fb$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $5b3402df97a950fb$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $5b3402df97a950fb$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $5b3402df97a950fb$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $5b3402df97a950fb$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $5b3402df97a950fb$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $5b3402df97a950fb$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $5b3402df97a950fb$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $5b3402df97a950fb$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $5b3402df97a950fb$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $5b3402df97a950fb$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $5b3402df97a950fb$var$replaceTemplate(template, data) {
    try {
        let ptr = 0;
        let result = '';
        while(ptr < template.length){
            const start = template.indexOf('{$', ptr);
            if (start === -1) {
                result += template.substring(ptr);
                break;
            }
            const end = template.indexOf('}', start + 2);
            if (end === -1) {
                result += template.substring(ptr);
                break;
            }
            const key = template.substring(start + 2, end);
            const value = data[key];
            result += template.substring(ptr, start) + (value != null ? String(value) : `<${key}?>`);
            ptr = end + 1;
        }
        return result;
    } catch (e) {
        // Should never happen, but fallback just in case
        return template;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $5b3402df97a950fb$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $5b3402df97a950fb$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b3402df97a950fb$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $5b3402df97a950fb$export$c5a53ce6a17cf18d($5b3402df97a950fb$export$c62426fdd000a97e(parts[0]) || '');
        claims = $5b3402df97a950fb$export$c5a53ce6a17cf18d($5b3402df97a950fb$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b3402df97a950fb$export$5f870fcca7ae6a88 = function(token) {
    const claims = $5b3402df97a950fb$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b3402df97a950fb$export$701c661ec91095f2 = function(token) {
    const claims = $5b3402df97a950fb$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b3402df97a950fb$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $5b3402df97a950fb$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $5b3402df97a950fb$export$fc970ed23da99565 = function(token) {
    const claims = $5b3402df97a950fb$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b3402df97a950fb$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $5b3402df97a950fb$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $5b3402df97a950fb$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $5b3402df97a950fb$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $5b3402df97a950fb$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($5b3402df97a950fb$var$isObject(aProp) && $5b3402df97a950fb$var$isObject(bProp)) {
            if (!$5b3402df97a950fb$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $5b3402df97a950fb$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $5b3402df97a950fb$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $5b3402df97a950fb$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $5b3402df97a950fb$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $5b3402df97a950fb$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $5b3402df97a950fb$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $5b3402df97a950fb$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $5b3402df97a950fb$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $5b3402df97a950fb$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $5b3402df97a950fb$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($5b3402df97a950fb$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $5b3402df97a950fb$var$noop;
        if (observer.error === undefined) observer.error = $5b3402df97a950fb$var$noop;
        if (observer.complete === undefined) observer.complete = $5b3402df97a950fb$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5b3402df97a950fb$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $5b3402df97a950fb$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $5b3402df97a950fb$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $5b3402df97a950fb$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $5b3402df97a950fb$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $5b3402df97a950fb$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($5b3402df97a950fb$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $5b3402df97a950fb$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($5b3402df97a950fb$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $5b3402df97a950fb$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($5b3402df97a950fb$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $5b3402df97a950fb$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $5b3402df97a950fb$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $5b3402df97a950fb$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $5b3402df97a950fb$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $5b3402df97a950fb$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $5b3402df97a950fb$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $5b3402df97a950fb$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $5b3402df97a950fb$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $5b3402df97a950fb$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $5b3402df97a950fb$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $5b3402df97a950fb$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($5b3402df97a950fb$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $5b3402df97a950fb$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $5b3402df97a950fb$var$indicator(i);
}
function $5b3402df97a950fb$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5b3402df97a950fb$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $5b3402df97a950fb$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $5b3402df97a950fb$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $5b3402df97a950fb$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}

});
parcelRegister("3HCI1", function(module, exports) {

$parcel$export(module.exports, "getDefaultsFromPostinstall", function () { return $66b0a587b75ebf31$export$6d3c090e66a883b1; });
const $66b0a587b75ebf31$export$6d3c090e66a883b1 = ()=>undefined;

});



parcelRegister("eR2Kc", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $ad0824d83713c14d$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $ad0824d83713c14d$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $ad0824d83713c14d$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $ad0824d83713c14d$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $ad0824d83713c14d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $ad0824d83713c14d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($ad0824d83713c14d$export$243e62d78d3b544d || ($ad0824d83713c14d$export$243e62d78d3b544d = {}));
const $ad0824d83713c14d$var$levelStringToEnum = {
    'debug': $ad0824d83713c14d$export$243e62d78d3b544d.DEBUG,
    'verbose': $ad0824d83713c14d$export$243e62d78d3b544d.VERBOSE,
    'info': $ad0824d83713c14d$export$243e62d78d3b544d.INFO,
    'warn': $ad0824d83713c14d$export$243e62d78d3b544d.WARN,
    'error': $ad0824d83713c14d$export$243e62d78d3b544d.ERROR,
    'silent': $ad0824d83713c14d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $ad0824d83713c14d$var$defaultLogLevel = $ad0824d83713c14d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $ad0824d83713c14d$var$ConsoleMethod = {
    [$ad0824d83713c14d$export$243e62d78d3b544d.DEBUG]: 'log',
    [$ad0824d83713c14d$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$ad0824d83713c14d$export$243e62d78d3b544d.INFO]: 'info',
    [$ad0824d83713c14d$export$243e62d78d3b544d.WARN]: 'warn',
    [$ad0824d83713c14d$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $ad0824d83713c14d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $ad0824d83713c14d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $ad0824d83713c14d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $ad0824d83713c14d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $ad0824d83713c14d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $ad0824d83713c14d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $ad0824d83713c14d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $ad0824d83713c14d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $ad0824d83713c14d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $ad0824d83713c14d$export$c622e99c0ce7b1c9(level) {
    $ad0824d83713c14d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $ad0824d83713c14d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $ad0824d83713c14d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $ad0824d83713c14d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $ad0824d83713c14d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("6hxVm", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $492ea53b86178259$export$ca0ed41b1a2af7e; });

var $2Vqio = parcelRequire("2Vqio");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $492ea53b86178259$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $2Vqio.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $2Vqio.w)(request.result), event.oldVersion, event.newVersion, (0, $2Vqio.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $492ea53b86178259$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $2Vqio.w)(request).then(()=>undefined);
}
const $492ea53b86178259$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $492ea53b86178259$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $492ea53b86178259$var$cachedMethods = new Map();
function $492ea53b86178259$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($492ea53b86178259$var$cachedMethods.get(prop)) return $492ea53b86178259$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $492ea53b86178259$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $492ea53b86178259$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $492ea53b86178259$var$cachedMethods.set(prop, method);
    return method;
}
(0, $2Vqio.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$492ea53b86178259$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$492ea53b86178259$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("2Vqio", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $22154d668fbc89ad$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $22154d668fbc89ad$export$43caf9889c228507; });
const $22154d668fbc89ad$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $22154d668fbc89ad$var$idbProxyableTypes;
let $22154d668fbc89ad$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $22154d668fbc89ad$var$getIdbProxyableTypes() {
    return $22154d668fbc89ad$var$idbProxyableTypes || ($22154d668fbc89ad$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $22154d668fbc89ad$var$getCursorAdvanceMethods() {
    return $22154d668fbc89ad$var$cursorAdvanceMethods || ($22154d668fbc89ad$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $22154d668fbc89ad$var$cursorRequestMap = new WeakMap();
const $22154d668fbc89ad$var$transactionDoneMap = new WeakMap();
const $22154d668fbc89ad$var$transactionStoreNamesMap = new WeakMap();
const $22154d668fbc89ad$var$transformCache = new WeakMap();
const $22154d668fbc89ad$export$407448d2b89b1813 = new WeakMap();
function $22154d668fbc89ad$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($22154d668fbc89ad$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $22154d668fbc89ad$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $22154d668fbc89ad$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $22154d668fbc89ad$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($22154d668fbc89ad$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $22154d668fbc89ad$var$transactionDoneMap.set(tx, done);
}
let $22154d668fbc89ad$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $22154d668fbc89ad$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $22154d668fbc89ad$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $22154d668fbc89ad$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $22154d668fbc89ad$export$43caf9889c228507(callback) {
    $22154d668fbc89ad$var$idbProxyTraps = callback($22154d668fbc89ad$var$idbProxyTraps);
}
function $22154d668fbc89ad$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($22154d668fbc89ad$export$3b14a55fb2447963(this), storeNames, ...args);
        $22154d668fbc89ad$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $22154d668fbc89ad$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($22154d668fbc89ad$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($22154d668fbc89ad$export$3b14a55fb2447963(this), args);
        return $22154d668fbc89ad$export$efccba1c4a2ef57b($22154d668fbc89ad$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $22154d668fbc89ad$export$efccba1c4a2ef57b(func.apply($22154d668fbc89ad$export$3b14a55fb2447963(this), args));
    };
}
function $22154d668fbc89ad$var$transformCachableValue(value) {
    if (typeof value === 'function') return $22154d668fbc89ad$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $22154d668fbc89ad$var$cacheDonePromiseForTransaction(value);
    if ($22154d668fbc89ad$export$23f2a1d2818174ef(value, $22154d668fbc89ad$var$getIdbProxyableTypes())) return new Proxy(value, $22154d668fbc89ad$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $22154d668fbc89ad$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $22154d668fbc89ad$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($22154d668fbc89ad$var$transformCache.has(value)) return $22154d668fbc89ad$var$transformCache.get(value);
    const newValue = $22154d668fbc89ad$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $22154d668fbc89ad$var$transformCache.set(value, newValue);
        $22154d668fbc89ad$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $22154d668fbc89ad$export$3b14a55fb2447963 = (value)=>$22154d668fbc89ad$export$407448d2b89b1813.get(value);

});




parcelRegister("eGTQ8", function(module, exports) {
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("1iout")).D; });
$parcel$export(module.exports, "getMultiFactorResolver", function () { return (parcelRequire("1iout")).J; });
$parcel$export(module.exports, "getRedirectResult", function () { return (parcelRequire("1iout")).K; });
$parcel$export(module.exports, "multiFactor", function () { return (parcelRequire("1iout")).Z; });
$parcel$export(module.exports, "OAuthProvider", function () { return (parcelRequire("1iout")).g; });
$parcel$export(module.exports, "PhoneAuthProvider", function () { return (parcelRequire("1iout")).i; });
$parcel$export(module.exports, "PhoneMultiFactorGenerator", function () { return (parcelRequire("1iout")).j; });
$parcel$export(module.exports, "RecaptchaVerifier", function () { return (parcelRequire("1iout")).R; });
$parcel$export(module.exports, "SAMLAuthProvider", function () { return (parcelRequire("1iout")).S; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("1iout")).af; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("1iout")).ai; });
$parcel$export(module.exports, "signInWithRedirect", function () { return (parcelRequire("1iout")).aj; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("1iout")).ak; });
$parcel$export(module.exports, "updatePassword", function () { return (parcelRequire("1iout")).ao; });
parcelRequire("eMJpN");

});
parcelRegister("eMJpN", function(module, exports) {

$parcel$export(module.exports, "OAuthProvider", function () { return (parcelRequire("1iout")).g; });
$parcel$export(module.exports, "PhoneAuthProvider", function () { return (parcelRequire("1iout")).i; });
$parcel$export(module.exports, "PhoneMultiFactorGenerator", function () { return (parcelRequire("1iout")).j; });
$parcel$export(module.exports, "RecaptchaVerifier", function () { return (parcelRequire("1iout")).R; });
$parcel$export(module.exports, "SAMLAuthProvider", function () { return (parcelRequire("1iout")).S; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("1iout")).D; });
$parcel$export(module.exports, "getMultiFactorResolver", function () { return (parcelRequire("1iout")).J; });
$parcel$export(module.exports, "getRedirectResult", function () { return (parcelRequire("1iout")).K; });
$parcel$export(module.exports, "multiFactor", function () { return (parcelRequire("1iout")).Z; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("1iout")).af; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("1iout")).ai; });
$parcel$export(module.exports, "signInWithRedirect", function () { return (parcelRequire("1iout")).aj; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("1iout")).ak; });
$parcel$export(module.exports, "updatePassword", function () { return (parcelRequire("1iout")).ao; });

var $1iout = parcelRequire("1iout");
parcelRequire("8vnFK");
parcelRequire("7PthC");
parcelRequire("eR2Kc");
parcelRequire("3eXgh");

});
parcelRegister("1iout", function(module, exports) {

$parcel$export(module.exports, "g", function () { return $0f1a78304a2c0ffa$export$39b482c5e57630a8; });
$parcel$export(module.exports, "S", function () { return $0f1a78304a2c0ffa$export$25ce5a424b770e84; });
$parcel$export(module.exports, "af", function () { return $0f1a78304a2c0ffa$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "ao", function () { return $0f1a78304a2c0ffa$export$7a38258bbe170828; });
$parcel$export(module.exports, "ak", function () { return $0f1a78304a2c0ffa$export$21579262ef46735b; });
$parcel$export(module.exports, "J", function () { return $0f1a78304a2c0ffa$export$b4171a6734a65d42; });
$parcel$export(module.exports, "Z", function () { return $0f1a78304a2c0ffa$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "R", function () { return $0f1a78304a2c0ffa$export$db202ddc8be9136; });
$parcel$export(module.exports, "i", function () { return $0f1a78304a2c0ffa$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "ai", function () { return $0f1a78304a2c0ffa$export$f38c853ae54ed474; });
$parcel$export(module.exports, "aj", function () { return $0f1a78304a2c0ffa$export$3b513254972cfc9c; });
$parcel$export(module.exports, "K", function () { return $0f1a78304a2c0ffa$export$3466f893ebf79586; });
$parcel$export(module.exports, "j", function () { return $0f1a78304a2c0ffa$export$35e795649ee09318; });
$parcel$export(module.exports, "D", function () { return $0f1a78304a2c0ffa$export$96f57966bedc81b4; });

var $8vnFK = parcelRequire("8vnFK");

var $7PthC = parcelRequire("7PthC");

var $eR2Kc = parcelRequire("eR2Kc");

var $3eXgh = parcelRequire("3eXgh");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$f1e1789686576879 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$342063e11d6c3cad = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$882b5998b3b9117c = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$dda1d9f60106f0e9 = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $0f1a78304a2c0ffa$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$4a5767248b18ef41 = $0f1a78304a2c0ffa$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$3c2fa207a37baaea = $0f1a78304a2c0ffa$var$_prodErrorMap;
const $0f1a78304a2c0ffa$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $7PthC.ErrorFactory)('auth', 'Firebase', $0f1a78304a2c0ffa$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$db3b6bfb95261072 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$logClient = new (0, $eR2Kc.Logger)('@firebase/auth');
function $0f1a78304a2c0ffa$var$_logWarn(msg, ...args) {
    if ($0f1a78304a2c0ffa$var$logClient.logLevel <= (0, $eR2Kc.LogLevel).WARN) $0f1a78304a2c0ffa$var$logClient.warn(`Auth (${(0, $8vnFK.SDK_VERSION)}): ${msg}`, ...args);
}
function $0f1a78304a2c0ffa$var$_logError(msg, ...args) {
    if ($0f1a78304a2c0ffa$var$logClient.logLevel <= (0, $eR2Kc.LogLevel).ERROR) $0f1a78304a2c0ffa$var$logClient.error(`Auth (${(0, $8vnFK.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$export$3d12bd131bb975d1(authOrCode, ...rest) {
    throw $0f1a78304a2c0ffa$var$createErrorInternal(authOrCode, ...rest);
}
function $0f1a78304a2c0ffa$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $0f1a78304a2c0ffa$var$createErrorInternal(authOrCode, ...rest);
}
function $0f1a78304a2c0ffa$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$0f1a78304a2c0ffa$export$3c2fa207a37baaea(),
        [code]: message
    };
    const factory = new (0, $7PthC.ErrorFactory)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $0f1a78304a2c0ffa$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $0f1a78304a2c0ffa$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $0f1a78304a2c0ffa$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $0f1a78304a2c0ffa$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $0f1a78304a2c0ffa$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(assertion, authOrCode, ...rest) {
    if (!assertion) throw $0f1a78304a2c0ffa$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $0f1a78304a2c0ffa$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $0f1a78304a2c0ffa$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $0f1a78304a2c0ffa$export$92108d983e8ee699(assertion, message) {
    if (!assertion) $0f1a78304a2c0ffa$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $0f1a78304a2c0ffa$var$_isHttpOrHttps() {
    return $0f1a78304a2c0ffa$var$_getCurrentScheme() === 'http:' || $0f1a78304a2c0ffa$var$_getCurrentScheme() === 'https:';
}
function $0f1a78304a2c0ffa$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $0f1a78304a2c0ffa$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($0f1a78304a2c0ffa$var$_isHttpOrHttps() || (0, $7PthC.isBrowserExtension)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $0f1a78304a2c0ffa$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $0f1a78304a2c0ffa$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $0f1a78304a2c0ffa$export$92108d983e8ee699(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $7PthC.isMobileCordova)() || (0, $7PthC.isReactNative)();
    }
    get() {
        if (!$0f1a78304a2c0ffa$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$_emulatorUrl(config, path) {
    $0f1a78304a2c0ffa$export$92108d983e8ee699(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$export$faec65b429be379 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $0f1a78304a2c0ffa$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $0f1a78304a2c0ffa$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $0f1a78304a2c0ffa$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $0f1a78304a2c0ffa$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $0f1a78304a2c0ffa$var$DEFAULT_API_TIMEOUT_MS = new $0f1a78304a2c0ffa$var$Delay(30000, 60000);
function $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $0f1a78304a2c0ffa$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $0f1a78304a2c0ffa$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $7PthC.querystring)({
            ...params,
            key: auth.config.apiKey
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $7PthC.isCloudflareWorker)()) fetchArgs.referrerPolicy = 'strict-origin-when-cross-origin';
        if (auth.emulatorConfig && (0, $7PthC.isCloudWorkstation)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $0f1a78304a2c0ffa$export$faec65b429be379.fetch()(await $0f1a78304a2c0ffa$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $0f1a78304a2c0ffa$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$0f1a78304a2c0ffa$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $0f1a78304a2c0ffa$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $0f1a78304a2c0ffa$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $0f1a78304a2c0ffa$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $0f1a78304a2c0ffa$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $0f1a78304a2c0ffa$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $0f1a78304a2c0ffa$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $7PthC.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $0f1a78304a2c0ffa$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $0f1a78304a2c0ffa$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $0f1a78304a2c0ffa$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $0f1a78304a2c0ffa$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($0f1a78304a2c0ffa$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $0f1a78304a2c0ffa$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $0f1a78304a2c0ffa$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $0f1a78304a2c0ffa$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $0f1a78304a2c0ffa$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $0f1a78304a2c0ffa$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $0f1a78304a2c0ffa$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $0f1a78304a2c0ffa$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$getRecaptchaParams(auth) {
    return (await $0f1a78304a2c0ffa$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $0f1a78304a2c0ffa$var$getRecaptchaConfig(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$deleteAccount(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $0f1a78304a2c0ffa$var$deleteLinkedAccounts(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $0f1a78304a2c0ffa$var$getAccountInfo(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$7f8ddf7c7c20b3cd(user, forceRefresh = false) {
    return (0, $7PthC.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$9bb611d729802a56(user, forceRefresh = false) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $0f1a78304a2c0ffa$var$_parseToken(token);
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $0f1a78304a2c0ffa$var$utcTimestampToDateString($0f1a78304a2c0ffa$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $0f1a78304a2c0ffa$var$utcTimestampToDateString($0f1a78304a2c0ffa$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $0f1a78304a2c0ffa$var$utcTimestampToDateString($0f1a78304a2c0ffa$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $0f1a78304a2c0ffa$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $0f1a78304a2c0ffa$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $0f1a78304a2c0ffa$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $7PthC.base64Decode)(payload);
        if (!decoded) {
            $0f1a78304a2c0ffa$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $0f1a78304a2c0ffa$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $0f1a78304a2c0ffa$var$_tokenExpiresIn(token) {
    const parsedToken = $0f1a78304a2c0ffa$var$_parseToken(token);
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $7PthC.FirebaseError) && $0f1a78304a2c0ffa$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $0f1a78304a2c0ffa$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $0f1a78304a2c0ffa$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $0f1a78304a2c0ffa$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(user, $0f1a78304a2c0ffa$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $0f1a78304a2c0ffa$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $0f1a78304a2c0ffa$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $0f1a78304a2c0ffa$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$2e2af4578d910ddf(user) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    await $0f1a78304a2c0ffa$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $0f1a78304a2c0ffa$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $0f1a78304a2c0ffa$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable camelcase */ async function $0f1a78304a2c0ffa$var$requestStsToken(auth, refreshToken) {
    const response = await $0f1a78304a2c0ffa$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $7PthC.querystring)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $0f1a78304a2c0ffa$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $7PthC.isCloudWorkstation)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $0f1a78304a2c0ffa$export$faec65b429be379.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $0f1a78304a2c0ffa$var$revokeToken(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $0f1a78304a2c0ffa$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $0f1a78304a2c0ffa$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $0f1a78304a2c0ffa$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $0f1a78304a2c0ffa$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $0f1a78304a2c0ffa$var$StsTokenManager();
        if (refreshToken) {
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $0f1a78304a2c0ffa$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $0f1a78304a2c0ffa$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$assertStringOrUndefined(assertion, appName) {
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $0f1a78304a2c0ffa$export$2ed0fc6709e59212 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $0f1a78304a2c0ffa$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $0f1a78304a2c0ffa$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $0f1a78304a2c0ffa$export$9bb611d729802a56(this, forceRefresh);
    }
    reload() {
        return $0f1a78304a2c0ffa$export$2e2af4578d910ddf(this);
    }
    _assign(user) {
        if (this === user) return;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $0f1a78304a2c0ffa$export$2ed0fc6709e59212({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $0f1a78304a2c0ffa$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $8vnFK._isFirebaseServerApp)(this.auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(this, $0f1a78304a2c0ffa$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $0f1a78304a2c0ffa$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(displayName, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(email, auth.name);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(phoneNumber, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(photoURL, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(tenantId, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(createdAt, auth.name);
        $0f1a78304a2c0ffa$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $0f1a78304a2c0ffa$export$2ed0fc6709e59212({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $0f1a78304a2c0ffa$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $0f1a78304a2c0ffa$export$2ed0fc6709e59212({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $0f1a78304a2c0ffa$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $0f1a78304a2c0ffa$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $0f1a78304a2c0ffa$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $0f1a78304a2c0ffa$export$2ed0fc6709e59212({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $0f1a78304a2c0ffa$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$instanceCache = new Map();
function $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(cls) {
    $0f1a78304a2c0ffa$export$92108d983e8ee699(cls instanceof Function, 'Expected a class definition');
    let instance = $0f1a78304a2c0ffa$var$instanceCache.get(cls);
    if (instance) {
        $0f1a78304a2c0ffa$export$92108d983e8ee699(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $0f1a78304a2c0ffa$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$0f1a78304a2c0ffa$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$61196ced6d74a310 = $0f1a78304a2c0ffa$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $0f1a78304a2c0ffa$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $0f1a78304a2c0ffa$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $0f1a78304a2c0ffa$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $0f1a78304a2c0ffa$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $0f1a78304a2c0ffa$var$PersistenceUserManager($0f1a78304a2c0ffa$export$cf2f7c5792f80b46($0f1a78304a2c0ffa$export$61196ced6d74a310), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $0f1a78304a2c0ffa$export$cf2f7c5792f80b46($0f1a78304a2c0ffa$export$61196ced6d74a310);
        const key = $0f1a78304a2c0ffa$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $0f1a78304a2c0ffa$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $0f1a78304a2c0ffa$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $0f1a78304a2c0ffa$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $0f1a78304a2c0ffa$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($0f1a78304a2c0ffa$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($0f1a78304a2c0ffa$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($0f1a78304a2c0ffa$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($0f1a78304a2c0ffa$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($0f1a78304a2c0ffa$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $0f1a78304a2c0ffa$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($0f1a78304a2c0ffa$export$28f7fcd39efa255(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $0f1a78304a2c0ffa$var$_isFirefox(ua = (0, $7PthC.getUA)()) {
    return /firefox\//i.test(ua);
}
function $0f1a78304a2c0ffa$var$_isSafari(userAgent = (0, $7PthC.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $0f1a78304a2c0ffa$var$_isChromeIOS(ua = (0, $7PthC.getUA)()) {
    return /crios\//i.test(ua);
}
function $0f1a78304a2c0ffa$var$_isIEMobile(ua = (0, $7PthC.getUA)()) {
    return /iemobile/i.test(ua);
}
function $0f1a78304a2c0ffa$export$28f7fcd39efa255(ua = (0, $7PthC.getUA)()) {
    return /android/i.test(ua);
}
function $0f1a78304a2c0ffa$var$_isBlackBerry(ua = (0, $7PthC.getUA)()) {
    return /blackberry/i.test(ua);
}
function $0f1a78304a2c0ffa$var$_isWebOS(ua = (0, $7PthC.getUA)()) {
    return /webos/i.test(ua);
}
function $0f1a78304a2c0ffa$export$9fa96a7d116ea3ce(ua = (0, $7PthC.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $0f1a78304a2c0ffa$export$9d398bebfec1c039(ua = (0, $7PthC.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $0f1a78304a2c0ffa$var$_isIOSStandalone(ua = (0, $7PthC.getUA)()) {
    return $0f1a78304a2c0ffa$export$9fa96a7d116ea3ce(ua) && !!window.navigator?.standalone;
}
function $0f1a78304a2c0ffa$var$_isIE10() {
    return (0, $7PthC.isIE)() && document.documentMode === 10;
}
function $0f1a78304a2c0ffa$var$_isMobileBrowser(ua = (0, $7PthC.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $0f1a78304a2c0ffa$export$9fa96a7d116ea3ce(ua) || $0f1a78304a2c0ffa$export$28f7fcd39efa255(ua) || $0f1a78304a2c0ffa$var$_isWebOS(ua) || $0f1a78304a2c0ffa$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $0f1a78304a2c0ffa$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $0f1a78304a2c0ffa$export$738ab4df8bf92ae9(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $0f1a78304a2c0ffa$var$_getBrowserName((0, $7PthC.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$0f1a78304a2c0ffa$var$_getBrowserName((0, $7PthC.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $8vnFK.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $0f1a78304a2c0ffa$var$_getPasswordPolicy(auth, request = {}) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $0f1a78304a2c0ffa$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $0f1a78304a2c0ffa$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $0f1a78304a2c0ffa$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $0f1a78304a2c0ffa$var$Subscription(this);
        this.idTokenSubscription = new $0f1a78304a2c0ffa$var$Subscription(this);
        this.beforeStateQueue = new $0f1a78304a2c0ffa$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $0f1a78304a2c0ffa$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $0f1a78304a2c0ffa$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $0f1a78304a2c0ffa$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $8vnFK._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $0f1a78304a2c0ffa$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $0f1a78304a2c0ffa$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $8vnFK._isFirebaseServerApp)(this.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $7PthC.getModularInstance)(userExtern) : null;
        if (user) $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $8vnFK._isFirebaseServerApp)(this.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $8vnFK._isFirebaseServerApp)(this.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($0f1a78304a2c0ffa$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $0f1a78304a2c0ffa$var$_getPasswordPolicy(this);
        const passwordPolicy = new $0f1a78304a2c0ffa$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $7PthC.ErrorFactory)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $0f1a78304a2c0ffa$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $0f1a78304a2c0ffa$var$PersistenceUserManager.create(this, [
                $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $0f1a78304a2c0ffa$export$738ab4df8bf92ae9(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $8vnFK._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $0f1a78304a2c0ffa$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $0f1a78304a2c0ffa$export$23ebac1979863676(auth) {
    return (0, $7PthC.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $0f1a78304a2c0ffa$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $7PthC.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $0f1a78304a2c0ffa$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $0f1a78304a2c0ffa$var$_setExternalJSProvider(p) {
    $0f1a78304a2c0ffa$var$externalJSProvider = p;
}
function $0f1a78304a2c0ffa$var$_loadJS(url) {
    return $0f1a78304a2c0ffa$var$externalJSProvider.loadJS(url);
}
function $0f1a78304a2c0ffa$var$_recaptchaV2ScriptUrl() {
    return $0f1a78304a2c0ffa$var$externalJSProvider.recaptchaV2Script;
}
function $0f1a78304a2c0ffa$var$_recaptchaEnterpriseScriptUrl() {
    return $0f1a78304a2c0ffa$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $0f1a78304a2c0ffa$var$_gapiScriptUrl() {
    return $0f1a78304a2c0ffa$var$externalJSProvider.gapiScript;
}
function $0f1a78304a2c0ffa$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$_SOLVE_TIME_MS = 500;
const $0f1a78304a2c0ffa$var$_EXPIRATION_TIME_MS = 60000;
const $0f1a78304a2c0ffa$var$_WIDGET_ID_START = 1000000000000;
class $0f1a78304a2c0ffa$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $0f1a78304a2c0ffa$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $0f1a78304a2c0ffa$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $0f1a78304a2c0ffa$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $0f1a78304a2c0ffa$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $0f1a78304a2c0ffa$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $0f1a78304a2c0ffa$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $0f1a78304a2c0ffa$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $0f1a78304a2c0ffa$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $0f1a78304a2c0ffa$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $0f1a78304a2c0ffa$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $0f1a78304a2c0ffa$var$_EXPIRATION_TIME_MS);
        }, $0f1a78304a2c0ffa$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $0f1a78304a2c0ffa$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $0f1a78304a2c0ffa$var$FAKE_TOKEN = 'NO_RECAPTCHA';
const $0f1a78304a2c0ffa$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME = 'onFirebaseAuthREInstanceReady';
class $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $0f1a78304a2c0ffa$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $0f1a78304a2c0ffa$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $0f1a78304a2c0ffa$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $0f1a78304a2c0ffa$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($0f1a78304a2c0ffa$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($0f1a78304a2c0ffa$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $0f1a78304a2c0ffa$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then(async (siteKey)=>{
                if (!forceRefresh && $0f1a78304a2c0ffa$var$isEnterprise(window.grecaptcha) && // If download has already been initiated, do not trigger another
                // download, await the promise here.
                $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred) {
                    await $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred.promise;
                    retrieveRecaptchaToken(siteKey, resolve, reject);
                } else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $0f1a78304a2c0ffa$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey + `&onload=${$0f1a78304a2c0ffa$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME}`;
                    // Existence of deferred indicates download has been initiated.
                    $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = new (0, $7PthC.Deferred)();
                    /**
                     * Script attached to global window object that will be called
                     * when the ReCAPTCHA Enterprise instance is ready.
                     * grecaptcha.ready() is not reliable when there are multiple
                     * scripts on the page, and script.onload only indicates the
                     * script has downloaded, not that it has initialized.
                     */ window[$0f1a78304a2c0ffa$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME] = ()=>{
                        $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.resolve();
                    };
                    $0f1a78304a2c0ffa$var$_loadJS(url).then(()=>$0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.promise).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
/**
 * Deferred that resolves when script tag has been injected onto the page
 * and the script is ready (grecaptcha.ready() and script.onload are not
 * reliable indicators, so this resolves when the global
 * `window[RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME]()` callback provided to the recaptcha url param "onload"
 * is triggered).
 * As a static variable this is applied to all instances of the class.
 * This will cause an error if users try to create multiple RecaptchaVerifiers
 * with different Recaptcha Enterprise sitekeys, which should be an
 * unuspported use case.
 */ $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = null;
async function $0f1a78304a2c0ffa$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $0f1a78304a2c0ffa$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $0f1a78304a2c0ffa$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $0f1a78304a2c0ffa$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $0f1a78304a2c0ffa$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $0f1a78304a2c0ffa$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $0f1a78304a2c0ffa$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $0f1a78304a2c0ffa$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $0f1a78304a2c0ffa$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const response = await $0f1a78304a2c0ffa$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $0f1a78304a2c0ffa$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $0f1a78304a2c0ffa$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$a07804094c3ecf2d(app, deps) {
    const provider = (0, $8vnFK._getProvider)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $7PthC.deepEqual)(initialOptions, deps ?? {})) return auth;
        else $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $0f1a78304a2c0ffa$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($0f1a78304a2c0ffa$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$efccba1c4a2ef57b(auth, url, options) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $0f1a78304a2c0ffa$var$extractProtocol(url);
    const { host: host, port: port } = $0f1a78304a2c0ffa$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd((0, $7PthC.deepEqual)(emulator, authInternal.config.emulator) && (0, $7PthC.deepEqual)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $7PthC.isCloudWorkstation)(host)) (0, $7PthC.pingServer)(`${protocol}//${host}${portStr}`);
    else if (!disableWarnings) $0f1a78304a2c0ffa$var$emitEmulatorWarning();
}
function $0f1a78304a2c0ffa$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $0f1a78304a2c0ffa$var$extractHostAndPort(url) {
    const protocol = $0f1a78304a2c0ffa$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $0f1a78304a2c0ffa$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $0f1a78304a2c0ffa$var$parsePort(port)
        };
    }
}
function $0f1a78304a2c0ffa$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $0f1a78304a2c0ffa$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $0f1a78304a2c0ffa$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $0f1a78304a2c0ffa$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $0f1a78304a2c0ffa$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $0f1a78304a2c0ffa$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$resetPassword(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$updateEmailPassword(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $0f1a78304a2c0ffa$var$linkEmailPassword(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $0f1a78304a2c0ffa$var$applyActionCode$1(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$signInWithPassword(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$sendOobCode(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$sendEmailVerification$1(auth, request) {
    return $0f1a78304a2c0ffa$var$sendOobCode(auth, request);
}
async function $0f1a78304a2c0ffa$var$sendPasswordResetEmail$1(auth, request) {
    return $0f1a78304a2c0ffa$var$sendOobCode(auth, request);
}
async function $0f1a78304a2c0ffa$var$sendSignInLinkToEmail$1(auth, request) {
    return $0f1a78304a2c0ffa$var$sendOobCode(auth, request);
}
async function $0f1a78304a2c0ffa$var$verifyAndChangeEmail(auth, request) {
    return $0f1a78304a2c0ffa$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$signInWithEmailLink$1(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$signInWithEmailLinkForLinking(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$a9c23c6ac3fc3eca extends $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $0f1a78304a2c0ffa$export$a9c23c6ac3fc3eca(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $0f1a78304a2c0ffa$export$a9c23c6ac3fc3eca(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $0f1a78304a2c0ffa$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $0f1a78304a2c0ffa$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $0f1a78304a2c0ffa$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $0f1a78304a2c0ffa$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $0f1a78304a2c0ffa$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $0f1a78304a2c0ffa$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$signInWithIdp(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$c4ce752e73470fba extends $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $0f1a78304a2c0ffa$export$c4ce752e73470fba(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $0f1a78304a2c0ffa$export$3d12bd131bb975d1("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $0f1a78304a2c0ffa$export$c4ce752e73470fba(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $0f1a78304a2c0ffa$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $7PthC.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$sendPhoneVerificationCode(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$signInWithPhoneNumber$1(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
async function $0f1a78304a2c0ffa$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $0f1a78304a2c0ffa$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $0f1a78304a2c0ffa$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $0f1a78304a2c0ffa$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, apiRequest), $0f1a78304a2c0ffa$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$56c0d5a1e737357d extends $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $0f1a78304a2c0ffa$export$56c0d5a1e737357d({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $0f1a78304a2c0ffa$export$56c0d5a1e737357d({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $0f1a78304a2c0ffa$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $0f1a78304a2c0ffa$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $0f1a78304a2c0ffa$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $0f1a78304a2c0ffa$export$56c0d5a1e737357d({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $0f1a78304a2c0ffa$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $0f1a78304a2c0ffa$var$parseDeepLink(url) {
    const link = (0, $7PthC.querystringDecode)((0, $7PthC.extractQuerystring)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $7PthC.querystringDecode)((0, $7PthC.extractQuerystring)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $7PthC.querystringDecode)((0, $7PthC.extractQuerystring)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $7PthC.querystringDecode)((0, $7PthC.extractQuerystring)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$407448d2b89b1813 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $7PthC.querystringDecode)((0, $7PthC.extractQuerystring)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $0f1a78304a2c0ffa$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $0f1a78304a2c0ffa$var$parseDeepLink(link);
        try {
            return new $0f1a78304a2c0ffa$export$407448d2b89b1813(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$34aec0b863436764(link) {
    return $0f1a78304a2c0ffa$export$407448d2b89b1813.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$4368d992c4eafac0 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $0f1a78304a2c0ffa$export$4368d992c4eafac0.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $0f1a78304a2c0ffa$export$a9c23c6ac3fc3eca._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $0f1a78304a2c0ffa$export$407448d2b89b1813.parseLink(emailLink);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $0f1a78304a2c0ffa$export$a9c23c6ac3fc3eca._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $0f1a78304a2c0ffa$export$4368d992c4eafac0.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $0f1a78304a2c0ffa$export$4368d992c4eafac0.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $0f1a78304a2c0ffa$export$4368d992c4eafac0.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $0f1a78304a2c0ffa$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $0f1a78304a2c0ffa$var$BaseOAuthProvider extends $0f1a78304a2c0ffa$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $0f1a78304a2c0ffa$export$39b482c5e57630a8 extends $0f1a78304a2c0ffa$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$39b482c5e57630a8.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$39b482c5e57630a8.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $0f1a78304a2c0ffa$export$39b482c5e57630a8(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$d66501df72047452 extends $0f1a78304a2c0ffa$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams({
            providerId: $0f1a78304a2c0ffa$export$d66501df72047452.PROVIDER_ID,
            signInMethod: $0f1a78304a2c0ffa$export$d66501df72047452.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$d66501df72047452.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$d66501df72047452.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $0f1a78304a2c0ffa$export$d66501df72047452.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $0f1a78304a2c0ffa$export$d66501df72047452.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $0f1a78304a2c0ffa$export$d66501df72047452.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$2d1720544b23b823 extends $0f1a78304a2c0ffa$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams({
            providerId: $0f1a78304a2c0ffa$export$2d1720544b23b823.PROVIDER_ID,
            signInMethod: $0f1a78304a2c0ffa$export$2d1720544b23b823.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$2d1720544b23b823.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$2d1720544b23b823.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $0f1a78304a2c0ffa$export$2d1720544b23b823.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $0f1a78304a2c0ffa$export$2d1720544b23b823.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $0f1a78304a2c0ffa$export$2d1720544b23b823.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $0f1a78304a2c0ffa$export$2329c99376c9d0a4 extends $0f1a78304a2c0ffa$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams({
            providerId: $0f1a78304a2c0ffa$export$2329c99376c9d0a4.PROVIDER_ID,
            signInMethod: $0f1a78304a2c0ffa$export$2329c99376c9d0a4.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$2329c99376c9d0a4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$2329c99376c9d0a4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $0f1a78304a2c0ffa$export$2329c99376c9d0a4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $0f1a78304a2c0ffa$export$2329c99376c9d0a4.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $0f1a78304a2c0ffa$export$2329c99376c9d0a4.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the SAML credentials returned by an {@link SAMLAuthProvider}.
 *
 * @public
 */ const $0f1a78304a2c0ffa$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $0f1a78304a2c0ffa$export$c03999cb2f36933f extends $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $0f1a78304a2c0ffa$export$c03999cb2f36933f(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $0f1a78304a2c0ffa$export$c03999cb2f36933f(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $0f1a78304a2c0ffa$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$25ce5a424b770e84 extends $0f1a78304a2c0ffa$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(providerId.startsWith($0f1a78304a2c0ffa$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$25ce5a424b770e84.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$25ce5a424b770e84.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $0f1a78304a2c0ffa$export$c03999cb2f36933f.fromJSON(json);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $0f1a78304a2c0ffa$export$c03999cb2f36933f._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5 extends $0f1a78304a2c0ffa$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $0f1a78304a2c0ffa$export$c4ce752e73470fba._fromParams({
            providerId: $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.PROVIDER_ID,
            signInMethod: $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $0f1a78304a2c0ffa$export$7ccc53e8f1e7dfc5.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$signUp(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $0f1a78304a2c0ffa$export$2ed0fc6709e59212._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $0f1a78304a2c0ffa$var$providerIdForResponse(idTokenResponse);
        const userCred = new $0f1a78304a2c0ffa$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $0f1a78304a2c0ffa$var$providerIdForResponse(response);
        return new $0f1a78304a2c0ffa$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $0f1a78304a2c0ffa$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$2219238a014317b0(auth) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $0f1a78304a2c0ffa$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $0f1a78304a2c0ffa$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $0f1a78304a2c0ffa$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$MultiFactorError extends (0, $7PthC.FirebaseError) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0f1a78304a2c0ffa$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $0f1a78304a2c0ffa$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $0f1a78304a2c0ffa$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $0f1a78304a2c0ffa$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $0f1a78304a2c0ffa$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$ab83b03e4111b1d0(user, providerId) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    await $0f1a78304a2c0ffa$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $0f1a78304a2c0ffa$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $0f1a78304a2c0ffa$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $0f1a78304a2c0ffa$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $0f1a78304a2c0ffa$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $0f1a78304a2c0ffa$var$_assertLinkedStatus(expected, user, provider) {
    await $0f1a78304a2c0ffa$var$_reloadWithoutSaving(user);
    const providerIds = $0f1a78304a2c0ffa$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(user, $0f1a78304a2c0ffa$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $0f1a78304a2c0ffa$var$_parseToken(response.idToken);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $0f1a78304a2c0ffa$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $0f1a78304a2c0ffa$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $0f1a78304a2c0ffa$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$4c3d22f3d993c33f(auth, credential) {
    return $0f1a78304a2c0ffa$var$_signInWithCredential($0f1a78304a2c0ffa$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$e7c866399fa523f5(user, credential) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    await $0f1a78304a2c0ffa$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $0f1a78304a2c0ffa$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$ce26c07117d59d6a(user, credential) {
    return $0f1a78304a2c0ffa$var$_reauthenticate((0, $7PthC.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$signInWithCustomToken$1(auth, request) {
    return $0f1a78304a2c0ffa$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$f787f51d84a910ad(auth, customToken) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const response = await $0f1a78304a2c0ffa$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $0f1a78304a2c0ffa$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $0f1a78304a2c0ffa$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $0f1a78304a2c0ffa$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $0f1a78304a2c0ffa$var$PhoneMultiFactorInfoImpl extends $0f1a78304a2c0ffa$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $0f1a78304a2c0ffa$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $0f1a78304a2c0ffa$var$TotpMultiFactorInfoImpl extends $0f1a78304a2c0ffa$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $0f1a78304a2c0ffa$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $0f1a78304a2c0ffa$var$recachePasswordPolicy(auth) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$a9c996f45e5784d0(auth, email, actionCodeSettings) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $0f1a78304a2c0ffa$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $0f1a78304a2c0ffa$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $0f1a78304a2c0ffa$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$90a7f3efeed30595(auth, oobCode, newPassword) {
    await $0f1a78304a2c0ffa$var$resetPassword((0, $7PthC.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $0f1a78304a2c0ffa$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$ae1af26003f05816(auth, oobCode) {
    await $0f1a78304a2c0ffa$var$applyActionCode$1((0, $7PthC.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$3b14a55fb2447963(auth, oobCode) {
    const authModular = (0, $7PthC.getModularInstance)(auth);
    const response = await $0f1a78304a2c0ffa$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $0f1a78304a2c0ffa$var$MultiFactorInfoImpl._fromServerResponse($0f1a78304a2c0ffa$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$1fbe638ecf81657e(auth, code) {
    const { data: data } = await $0f1a78304a2c0ffa$export$3b14a55fb2447963((0, $7PthC.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$d141bba7fdc215a3(auth, email, password) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $0f1a78304a2c0ffa$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $0f1a78304a2c0ffa$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $0f1a78304a2c0ffa$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $0f1a78304a2c0ffa$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$c9170ad7d4cd7e57(auth, email, password) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $0f1a78304a2c0ffa$export$4c3d22f3d993c33f((0, $7PthC.getModularInstance)(auth), $0f1a78304a2c0ffa$export$4368d992c4eafac0.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $0f1a78304a2c0ffa$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$7910e0436ed8d1de(auth, email, actionCodeSettings) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $0f1a78304a2c0ffa$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $0f1a78304a2c0ffa$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $0f1a78304a2c0ffa$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$3a6d5c9ae78a2c08(auth, emailLink) {
    const actionCodeUrl = $0f1a78304a2c0ffa$export$407448d2b89b1813.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$ee7c8ad385a60b7b(auth, email, emailLink) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $7PthC.getModularInstance)(auth);
    const credential = $0f1a78304a2c0ffa$export$4368d992c4eafac0.credentialWithLink(email, emailLink || $0f1a78304a2c0ffa$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $0f1a78304a2c0ffa$export$4c3d22f3d993c33f(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$createAuthUri(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $0f1a78304a2c0ffa$export$ef35774e6d314e91(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $0f1a78304a2c0ffa$var$_isHttpOrHttps() ? $0f1a78304a2c0ffa$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $0f1a78304a2c0ffa$var$createAuthUri((0, $7PthC.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$c3950d9923825c02(user, actionCodeSettings) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $0f1a78304a2c0ffa$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $0f1a78304a2c0ffa$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$493d36ec626b6698(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $0f1a78304a2c0ffa$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $0f1a78304a2c0ffa$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$var$updateProfile$1(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$8a5498727ef6be21(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $7PthC.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(userInternal, $0f1a78304a2c0ffa$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$306ddfe3a8403e2(user, newEmail) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    if ((0, $8vnFK._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $0f1a78304a2c0ffa$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$7a38258bbe170828(user, newPassword) {
    return $0f1a78304a2c0ffa$var$updateEmailOrPassword((0, $7PthC.getModularInstance)(user), null, newPassword);
}
async function $0f1a78304a2c0ffa$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(user, $0f1a78304a2c0ffa$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $0f1a78304a2c0ffa$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $0f1a78304a2c0ffa$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $0f1a78304a2c0ffa$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $0f1a78304a2c0ffa$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $0f1a78304a2c0ffa$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $0f1a78304a2c0ffa$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $0f1a78304a2c0ffa$var$FederatedAdditionalUserInfoWithUsername extends $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $0f1a78304a2c0ffa$var$FacebookAdditionalUserInfo extends $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $0f1a78304a2c0ffa$var$GithubAdditionalUserInfo extends $0f1a78304a2c0ffa$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $0f1a78304a2c0ffa$var$GoogleAdditionalUserInfo extends $0f1a78304a2c0ffa$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $0f1a78304a2c0ffa$var$TwitterAdditionalUserInfo extends $0f1a78304a2c0ffa$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$e7094788287c5e9b(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $0f1a78304a2c0ffa$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$555508cbc6add439(auth, persistence) {
    return (0, $7PthC.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$3722cfe417b6ed86(auth) {
    return $0f1a78304a2c0ffa$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$6554612db691658e(auth, password) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$3d8c2f653ac9d0b9(auth, nextOrObserver, error, completed) {
    return (0, $7PthC.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $0f1a78304a2c0ffa$export$ffb5f4729a158638(auth, callback, onAbort) {
    return (0, $7PthC.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$71511d61b312f219(auth, nextOrObserver, error, completed) {
    return (0, $7PthC.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$d24c54395ce0c509(auth) {
    (0, $7PthC.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$1a82df3d29112e01(auth, user) {
    return (0, $7PthC.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$21579262ef46735b(auth) {
    return (0, $7PthC.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$a93c5207d687da10(auth, token) {
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$df995fae86a55f06(user) {
    return (0, $7PthC.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $0f1a78304a2c0ffa$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $0f1a78304a2c0ffa$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $0f1a78304a2c0ffa$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $0f1a78304a2c0ffa$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $0f1a78304a2c0ffa$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$0f1a78304a2c0ffa$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $0f1a78304a2c0ffa$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $0f1a78304a2c0ffa$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $0f1a78304a2c0ffa$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $0f1a78304a2c0ffa$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$b4171a6734a65d42(auth, error) {
    const authModular = (0, $7PthC.getModularInstance)(auth);
    const errorInternal = error;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $0f1a78304a2c0ffa$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$startEnrollPhoneMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$finalizeEnrollPhoneMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$startEnrollTotpMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$finalizeEnrollTotpMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$withdrawMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
class $0f1a78304a2c0ffa$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$0f1a78304a2c0ffa$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $0f1a78304a2c0ffa$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $0f1a78304a2c0ffa$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $0f1a78304a2c0ffa$var$_logoutIfInvalidated(this.user, $0f1a78304a2c0ffa$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $0f1a78304a2c0ffa$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$dc98b0b04f4c7758(user) {
    const userModular = (0, $7PthC.getModularInstance)(user);
    if (!$0f1a78304a2c0ffa$var$multiFactorUserCache.has(userModular)) $0f1a78304a2c0ffa$var$multiFactorUserCache.set(userModular, $0f1a78304a2c0ffa$var$MultiFactorUserImpl._fromUser(userModular));
    return $0f1a78304a2c0ffa$var$multiFactorUserCache.get(userModular);
}
const $0f1a78304a2c0ffa$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $0f1a78304a2c0ffa$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($0f1a78304a2c0ffa$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($0f1a78304a2c0ffa$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $0f1a78304a2c0ffa$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $0f1a78304a2c0ffa$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $0f1a78304a2c0ffa$var$BrowserLocalPersistence extends $0f1a78304a2c0ffa$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $0f1a78304a2c0ffa$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($0f1a78304a2c0ffa$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $0f1a78304a2c0ffa$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $0f1a78304a2c0ffa$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$0f1a78304a2c0ffa$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$43caf9889c228507 = $0f1a78304a2c0ffa$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $0f1a78304a2c0ffa$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $0f1a78304a2c0ffa$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $0f1a78304a2c0ffa$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $0f1a78304a2c0ffa$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $0f1a78304a2c0ffa$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $0f1a78304a2c0ffa$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $0f1a78304a2c0ffa$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $0f1a78304a2c0ffa$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $0f1a78304a2c0ffa$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $0f1a78304a2c0ffa$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$0f1a78304a2c0ffa$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $0f1a78304a2c0ffa$export$9e5f44173e64f162 = $0f1a78304a2c0ffa$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$BrowserSessionPersistence extends $0f1a78304a2c0ffa$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$0f1a78304a2c0ffa$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$625550452a3fa3ec = $0f1a78304a2c0ffa$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $0f1a78304a2c0ffa$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $0f1a78304a2c0ffa$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $0f1a78304a2c0ffa$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $0f1a78304a2c0ffa$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$0f1a78304a2c0ffa$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$export$f96d196f7728bb5(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $0f1a78304a2c0ffa$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $0f1a78304a2c0ffa$export$f96d196f7728bb5('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $0f1a78304a2c0ffa$var$_window() {
    return window;
}
function $0f1a78304a2c0ffa$var$_setWindowLocation(url) {
    $0f1a78304a2c0ffa$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$_isWorker() {
    return typeof $0f1a78304a2c0ffa$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $0f1a78304a2c0ffa$var$_window()['importScripts'] === 'function';
}
async function $0f1a78304a2c0ffa$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $0f1a78304a2c0ffa$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $0f1a78304a2c0ffa$var$_getWorkerGlobalScope() {
    return $0f1a78304a2c0ffa$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$DB_NAME = 'firebaseLocalStorageDb';
const $0f1a78304a2c0ffa$var$DB_VERSION = 1;
const $0f1a78304a2c0ffa$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $0f1a78304a2c0ffa$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $0f1a78304a2c0ffa$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $0f1a78304a2c0ffa$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $0f1a78304a2c0ffa$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($0f1a78304a2c0ffa$var$DB_OBJECTSTORE_NAME);
}
function $0f1a78304a2c0ffa$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($0f1a78304a2c0ffa$var$DB_NAME);
    return new $0f1a78304a2c0ffa$var$DBPromise(request).toPromise();
}
function $0f1a78304a2c0ffa$var$_openDatabase() {
    const request = indexedDB.open($0f1a78304a2c0ffa$var$DB_NAME, $0f1a78304a2c0ffa$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($0f1a78304a2c0ffa$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $0f1a78304a2c0ffa$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($0f1a78304a2c0ffa$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $0f1a78304a2c0ffa$var$_deleteDatabase();
                resolve(await $0f1a78304a2c0ffa$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $0f1a78304a2c0ffa$var$_putObject(db, key, value) {
    const request = $0f1a78304a2c0ffa$var$getObjectStore(db, true).put({
        [$0f1a78304a2c0ffa$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $0f1a78304a2c0ffa$var$DBPromise(request).toPromise();
}
async function $0f1a78304a2c0ffa$var$getObject(db, key) {
    const request = $0f1a78304a2c0ffa$var$getObjectStore(db, false).get(key);
    const data = await new $0f1a78304a2c0ffa$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $0f1a78304a2c0ffa$var$_deleteObject(db, key) {
    const request = $0f1a78304a2c0ffa$var$getObjectStore(db, true).delete(key);
    return new $0f1a78304a2c0ffa$var$DBPromise(request).toPromise();
}
const $0f1a78304a2c0ffa$var$_POLLING_INTERVAL_MS = 800;
const $0f1a78304a2c0ffa$var$_TRANSACTION_RETRY_COUNT = 3;
class $0f1a78304a2c0ffa$var$IndexedDBLocalPersistence {
    registerLifecycleListeners() {
        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
            window.addEventListener('pagehide', this.onPageHide);
            window.addEventListener('pageshow', this.onPageShow);
        }
        if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    unregisterLifecycleListeners() {
        if (typeof window !== 'undefined' && typeof window.removeEventListener === 'function') {
            window.removeEventListener('pagehide', this.onPageHide);
            window.removeEventListener('pageshow', this.onPageShow);
        }
        if (typeof document !== 'undefined' && typeof document.removeEventListener === 'function') document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this.dbPromise = null;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.isHiding = false;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        this.onPageHide = ()=>{
            this.isHiding = true;
            this.stopPolling();
            if (this.dbPromise) {
                this.dbPromise.then((db)=>db.close()).catch(()=>{});
                this.dbPromise = null;
            }
        };
        this.onPageShow = ()=>{
            if (this.isHiding) {
                this.isHiding = false;
                if (Object.keys(this.listeners).length > 0) this.startPolling();
            }
        };
        this.onVisibilityChange = ()=>{
            if (typeof document !== 'undefined') {
                if (document.visibilityState === 'hidden') this.onPageHide();
                else if (document.visibilityState === 'visible') this.onPageShow();
            }
        };
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.isHiding) throw new Error('Database is closing/hidden');
        if (this.dbPromise) return this.dbPromise;
        this.dbPromise = $0f1a78304a2c0ffa$var$_openDatabase();
        this.dbPromise.catch(()=>{
            this.dbPromise = null;
        });
        return this.dbPromise;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (this.isHiding) throw e;
            if (numAttempts++ > $0f1a78304a2c0ffa$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = null;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $0f1a78304a2c0ffa$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $0f1a78304a2c0ffa$var$Receiver._getInstance($0f1a78304a2c0ffa$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $0f1a78304a2c0ffa$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $0f1a78304a2c0ffa$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $0f1a78304a2c0ffa$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            await this._withRetries(async (db)=>{
                await $0f1a78304a2c0ffa$var$_putObject(db, $0f1a78304a2c0ffa$var$STORAGE_AVAILABLE_KEY, '1');
                await $0f1a78304a2c0ffa$var$_deleteObject(db, $0f1a78304a2c0ffa$var$STORAGE_AVAILABLE_KEY);
            });
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$0f1a78304a2c0ffa$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$0f1a78304a2c0ffa$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$0f1a78304a2c0ffa$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        if (this.isHiding) return [];
        try {
            // TODO: check if we need to fallback if getAll is not supported
            const result = await this._withRetries((db)=>{
                const getAllRequest = $0f1a78304a2c0ffa$var$getObjectStore(db, false).getAll();
                return new $0f1a78304a2c0ffa$var$DBPromise(getAllRequest).toPromise();
            });
            if (this.isHiding) return [];
            if (!result) return [];
            // If we have pending writes in progress abort, we'll get picked up on the next poll
            if (this.pendingWrites !== 0) return [];
            const keys = [];
            const keysInResult = new Set();
            if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
                keysInResult.add(key);
                if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                    this.notifyListeners(key, value);
                    keys.push(key);
                }
            }
            for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
                // Deleted
                this.notifyListeners(localKey, null);
                keys.push(localKey);
            }
            return keys;
        } catch (e) {
            if (!this.isHiding) $0f1a78304a2c0ffa$var$_logWarn(`Firebase Auth cross-tab polling failed with error: ${e}`);
            return [];
        }
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $0f1a78304a2c0ffa$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            this.startPolling();
            this.registerLifecycleListeners();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.stopPolling();
            this.unregisterLifecycleListeners();
        }
    }
}
$0f1a78304a2c0ffa$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$3a1a48c8f6ef640e = $0f1a78304a2c0ffa$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$startSignInPhoneMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$finalizeSignInPhoneMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
function $0f1a78304a2c0ffa$var$finalizeSignInTotpMfa(auth, request) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $0f1a78304a2c0ffa$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $0f1a78304a2c0ffa$var$_JSLOAD_CALLBACK = $0f1a78304a2c0ffa$var$_generateCallbackName('rcb');
const $0f1a78304a2c0ffa$var$NETWORK_TIMEOUT_DELAY = new $0f1a78304a2c0ffa$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $0f1a78304a2c0ffa$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$0f1a78304a2c0ffa$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd($0f1a78304a2c0ffa$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $0f1a78304a2c0ffa$var$isV2($0f1a78304a2c0ffa$var$_window().grecaptcha)) return Promise.resolve($0f1a78304a2c0ffa$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $0f1a78304a2c0ffa$var$_window().setTimeout(()=>{
                reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $0f1a78304a2c0ffa$var$NETWORK_TIMEOUT_DELAY.get());
            $0f1a78304a2c0ffa$var$_window()[$0f1a78304a2c0ffa$var$_JSLOAD_CALLBACK] = ()=>{
                $0f1a78304a2c0ffa$var$_window().clearTimeout(networkTimeout);
                delete $0f1a78304a2c0ffa$var$_window()[$0f1a78304a2c0ffa$var$_JSLOAD_CALLBACK];
                const recaptcha = $0f1a78304a2c0ffa$var$_window().grecaptcha;
                if (!recaptcha || !$0f1a78304a2c0ffa$var$isV2(recaptcha)) {
                    reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$0f1a78304a2c0ffa$var$_recaptchaV2ScriptUrl()}?${(0, $7PthC.querystring)({
                onload: $0f1a78304a2c0ffa$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $0f1a78304a2c0ffa$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$0f1a78304a2c0ffa$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $0f1a78304a2c0ffa$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $0f1a78304a2c0ffa$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $0f1a78304a2c0ffa$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $0f1a78304a2c0ffa$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$0f1a78304a2c0ffa$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $0f1a78304a2c0ffa$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $0f1a78304a2c0ffa$var$MockReCaptchaLoaderImpl() : new $0f1a78304a2c0ffa$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $0f1a78304a2c0ffa$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd($0f1a78304a2c0ffa$var$_isHttpOrHttps() && !$0f1a78304a2c0ffa$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $0f1a78304a2c0ffa$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $0f1a78304a2c0ffa$var$getRecaptchaParams(this.auth);
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $0f1a78304a2c0ffa$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $0f1a78304a2c0ffa$export$56c0d5a1e737357d._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$995eb9fca571757(auth, phoneNumber, appVerifier) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const verificationId = await $0f1a78304a2c0ffa$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $7PthC.getModularInstance)(appVerifier));
    return new $0f1a78304a2c0ffa$var$ConfirmationResultImpl(verificationId, (cred)=>$0f1a78304a2c0ffa$export$4c3d22f3d993c33f(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$71cec2538cb2c617(user, phoneNumber, appVerifier) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    await $0f1a78304a2c0ffa$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $0f1a78304a2c0ffa$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $7PthC.getModularInstance)(appVerifier));
    return new $0f1a78304a2c0ffa$var$ConfirmationResultImpl(verificationId, (cred)=>$0f1a78304a2c0ffa$export$e7c866399fa523f5(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$6559d589eb85fbb6(user, phoneNumber, appVerifier) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    if ((0, $8vnFK._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $0f1a78304a2c0ffa$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $7PthC.getModularInstance)(appVerifier));
    return new $0f1a78304a2c0ffa$var$ConfirmationResultImpl(verificationId, (cred)=>$0f1a78304a2c0ffa$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $0f1a78304a2c0ffa$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $0f1a78304a2c0ffa$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $0f1a78304a2c0ffa$var$FAKE_TOKEN) {
                        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(verifier?.type === $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $0f1a78304a2c0ffa$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $0f1a78304a2c0ffa$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $0f1a78304a2c0ffa$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $0f1a78304a2c0ffa$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $0f1a78304a2c0ffa$var$FAKE_TOKEN) {
                        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(verifier?.type === $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $0f1a78304a2c0ffa$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $0f1a78304a2c0ffa$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $0f1a78304a2c0ffa$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $0f1a78304a2c0ffa$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $0f1a78304a2c0ffa$var$FAKE_TOKEN) {
                    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(verifier?.type === $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $0f1a78304a2c0ffa$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $0f1a78304a2c0ffa$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $0f1a78304a2c0ffa$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $0f1a78304a2c0ffa$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$2f6ca3d3b1f80bf5(user, credential) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    if ((0, $8vnFK._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $0f1a78304a2c0ffa$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $0f1a78304a2c0ffa$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(recaptchaV2Verifier.type === $0f1a78304a2c0ffa$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$23f2a1d2818174ef {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $0f1a78304a2c0ffa$export$23f2a1d2818174ef.PROVIDER_ID;
        this.auth = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $0f1a78304a2c0ffa$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $7PthC.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $0f1a78304a2c0ffa$export$56c0d5a1e737357d._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $0f1a78304a2c0ffa$export$23f2a1d2818174ef.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $0f1a78304a2c0ffa$export$23f2a1d2818174ef.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $0f1a78304a2c0ffa$export$56c0d5a1e737357d._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $0f1a78304a2c0ffa$export$23f2a1d2818174ef.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $0f1a78304a2c0ffa$export$23f2a1d2818174ef.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $0f1a78304a2c0ffa$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(resolverOverride);
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$IdpCredential extends $0f1a78304a2c0ffa$export$8b22cf2602fb60ce {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $0f1a78304a2c0ffa$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $0f1a78304a2c0ffa$var$_signIn(params) {
    return $0f1a78304a2c0ffa$var$_signInWithCredential(params.auth, new $0f1a78304a2c0ffa$var$IdpCredential(params), params.bypassAuthState);
}
function $0f1a78304a2c0ffa$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $0f1a78304a2c0ffa$var$_reauthenticate(user, new $0f1a78304a2c0ffa$var$IdpCredential(params), params.bypassAuthState);
}
async function $0f1a78304a2c0ffa$var$_link(params) {
    const { auth: auth, user: user } = params;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $0f1a78304a2c0ffa$var$_link$1(user, new $0f1a78304a2c0ffa$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $0f1a78304a2c0ffa$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $0f1a78304a2c0ffa$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $0f1a78304a2c0ffa$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $0f1a78304a2c0ffa$var$_reauth;
            default:
                $0f1a78304a2c0ffa$export$3d12bd131bb975d1(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $0f1a78304a2c0ffa$export$92108d983e8ee699(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $0f1a78304a2c0ffa$export$92108d983e8ee699(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $0f1a78304a2c0ffa$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$f38c853ae54ed474(auth, provider, resolver) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    $0f1a78304a2c0ffa$var$_assertInstanceOf(auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(authInternal, resolver);
    const action = new $0f1a78304a2c0ffa$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$efca4cbe5dd06740(user, provider, resolver) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    if ((0, $8vnFK._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $0f1a78304a2c0ffa$var$_assertInstanceOf(userInternal.auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $0f1a78304a2c0ffa$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$78acf4525d8a74c4(user, provider, resolver) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    $0f1a78304a2c0ffa$var$_assertInstanceOf(userInternal.auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $0f1a78304a2c0ffa$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $0f1a78304a2c0ffa$var$PopupOperation extends $0f1a78304a2c0ffa$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($0f1a78304a2c0ffa$var$PopupOperation.currentPopupAction) $0f1a78304a2c0ffa$var$PopupOperation.currentPopupAction.cancel();
        $0f1a78304a2c0ffa$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $0f1a78304a2c0ffa$export$92108d983e8ee699(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $0f1a78304a2c0ffa$export$f96d196f7728bb5();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $0f1a78304a2c0ffa$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $0f1a78304a2c0ffa$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$0f1a78304a2c0ffa$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $0f1a78304a2c0ffa$var$redirectOutcomeMap = new Map();
class $0f1a78304a2c0ffa$var$RedirectAction extends $0f1a78304a2c0ffa$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $0f1a78304a2c0ffa$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $0f1a78304a2c0ffa$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $0f1a78304a2c0ffa$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $0f1a78304a2c0ffa$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $0f1a78304a2c0ffa$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $0f1a78304a2c0ffa$var$pendingRedirectKey(auth);
    const persistence = $0f1a78304a2c0ffa$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $0f1a78304a2c0ffa$var$_setPendingRedirectStatus(resolver, auth) {
    return $0f1a78304a2c0ffa$var$resolverPersistence(resolver)._set($0f1a78304a2c0ffa$var$pendingRedirectKey(auth), 'true');
}
function $0f1a78304a2c0ffa$export$a05254e7c3aeba6e() {
    $0f1a78304a2c0ffa$var$redirectOutcomeMap.clear();
}
function $0f1a78304a2c0ffa$export$b9a6b53f9be3734(auth, result) {
    $0f1a78304a2c0ffa$var$redirectOutcomeMap.set(auth._key(), result);
}
function $0f1a78304a2c0ffa$var$resolverPersistence(resolver) {
    return $0f1a78304a2c0ffa$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $0f1a78304a2c0ffa$var$pendingRedirectKey(auth) {
    return $0f1a78304a2c0ffa$export$53a70dd1ebbae346($0f1a78304a2c0ffa$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$3b513254972cfc9c(auth, provider, resolver) {
    return $0f1a78304a2c0ffa$var$_signInWithRedirect(auth, provider, resolver);
}
async function $0f1a78304a2c0ffa$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    $0f1a78304a2c0ffa$var$_assertInstanceOf(auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(authInternal, resolver);
    await $0f1a78304a2c0ffa$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$a8550f7dbe79f93a(user, provider, resolver) {
    return $0f1a78304a2c0ffa$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $0f1a78304a2c0ffa$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    $0f1a78304a2c0ffa$var$_assertInstanceOf(userInternal.auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    if ((0, $8vnFK._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(userInternal.auth, resolver);
    await $0f1a78304a2c0ffa$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $0f1a78304a2c0ffa$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$8743009a87fcb00f(user, provider, resolver) {
    return $0f1a78304a2c0ffa$var$_linkWithRedirect(user, provider, resolver);
}
async function $0f1a78304a2c0ffa$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $7PthC.getModularInstance)(user);
    $0f1a78304a2c0ffa$var$_assertInstanceOf(userInternal.auth, provider, $0f1a78304a2c0ffa$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $0f1a78304a2c0ffa$var$_withDefaultResolver(userInternal.auth, resolver);
    await $0f1a78304a2c0ffa$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $0f1a78304a2c0ffa$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $0f1a78304a2c0ffa$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $0f1a78304a2c0ffa$export$3466f893ebf79586(auth, resolver) {
    await $0f1a78304a2c0ffa$export$23ebac1979863676(auth)._initializationPromise;
    return $0f1a78304a2c0ffa$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $0f1a78304a2c0ffa$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $8vnFK._isFirebaseServerApp)(auth.app)) return Promise.reject($0f1a78304a2c0ffa$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $0f1a78304a2c0ffa$export$23ebac1979863676(auth);
    const resolver = $0f1a78304a2c0ffa$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $0f1a78304a2c0ffa$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $0f1a78304a2c0ffa$var$prepareUserForRedirect(user) {
    const eventId = $0f1a78304a2c0ffa$export$f96d196f7728bb5(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $0f1a78304a2c0ffa$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $0f1a78304a2c0ffa$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$0f1a78304a2c0ffa$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$0f1a78304a2c0ffa$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($0f1a78304a2c0ffa$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $0f1a78304a2c0ffa$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($0f1a78304a2c0ffa$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($0f1a78304a2c0ffa$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $0f1a78304a2c0ffa$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $0f1a78304a2c0ffa$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $0f1a78304a2c0ffa$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $0f1a78304a2c0ffa$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $0f1a78304a2c0ffa$export$24baa2b76016ce0e(auth, request = {}) {
    return $0f1a78304a2c0ffa$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $0f1a78304a2c0ffa$var$HTTP_REGEX = /^https?/;
async function $0f1a78304a2c0ffa$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $0f1a78304a2c0ffa$export$24baa2b76016ce0e(auth);
    for (const domain of authorizedDomains)try {
        if ($0f1a78304a2c0ffa$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $0f1a78304a2c0ffa$var$matchDomain(expected) {
    const currentUrl = $0f1a78304a2c0ffa$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$0f1a78304a2c0ffa$var$HTTP_REGEX.test(protocol)) return false;
    if ($0f1a78304a2c0ffa$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$NETWORK_TIMEOUT = new $0f1a78304a2c0ffa$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $0f1a78304a2c0ffa$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $0f1a78304a2c0ffa$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $0f1a78304a2c0ffa$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $0f1a78304a2c0ffa$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $0f1a78304a2c0ffa$var$resetUnloadedGapiModules();
                    reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $0f1a78304a2c0ffa$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($0f1a78304a2c0ffa$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$0f1a78304a2c0ffa$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $0f1a78304a2c0ffa$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $0f1a78304a2c0ffa$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $0f1a78304a2c0ffa$var$_loadJS(`${$0f1a78304a2c0ffa$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $0f1a78304a2c0ffa$var$cachedGApiLoader = null;
        throw error;
    });
}
let $0f1a78304a2c0ffa$var$cachedGApiLoader = null;
function $0f1a78304a2c0ffa$var$_loadGapi(auth) {
    $0f1a78304a2c0ffa$var$cachedGApiLoader = $0f1a78304a2c0ffa$var$cachedGApiLoader || $0f1a78304a2c0ffa$var$loadGapi(auth);
    return $0f1a78304a2c0ffa$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$PING_TIMEOUT = new $0f1a78304a2c0ffa$var$Delay(5000, 15000);
const $0f1a78304a2c0ffa$var$IFRAME_PATH = '__/auth/iframe';
const $0f1a78304a2c0ffa$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $0f1a78304a2c0ffa$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $0f1a78304a2c0ffa$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $0f1a78304a2c0ffa$var$getIframeUrl(auth) {
    const config = auth.config;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $0f1a78304a2c0ffa$var$_emulatorUrl(config, $0f1a78304a2c0ffa$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$0f1a78304a2c0ffa$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $8vnFK.SDK_VERSION)
    };
    const eid = $0f1a78304a2c0ffa$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $7PthC.querystring)(params).slice(1)}`;
}
async function $0f1a78304a2c0ffa$var$_openIframe(auth) {
    const context = await $0f1a78304a2c0ffa$var$_loadGapi(auth);
    const gapi1 = $0f1a78304a2c0ffa$var$_window().gapi;
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $0f1a78304a2c0ffa$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $0f1a78304a2c0ffa$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $0f1a78304a2c0ffa$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $0f1a78304a2c0ffa$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $0f1a78304a2c0ffa$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $0f1a78304a2c0ffa$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $0f1a78304a2c0ffa$var$DEFAULT_WIDTH = 500;
const $0f1a78304a2c0ffa$var$DEFAULT_HEIGHT = 600;
const $0f1a78304a2c0ffa$var$TARGET_BLANK = '_blank';
const $0f1a78304a2c0ffa$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $0f1a78304a2c0ffa$export$9f4f30ee63539e24 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $0f1a78304a2c0ffa$var$_open(auth, url, name, width = $0f1a78304a2c0ffa$var$DEFAULT_WIDTH, height = $0f1a78304a2c0ffa$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$0f1a78304a2c0ffa$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $7PthC.getUA)().toLowerCase();
    if (name) target = $0f1a78304a2c0ffa$var$_isChromeIOS(ua) ? $0f1a78304a2c0ffa$var$TARGET_BLANK : name;
    if ($0f1a78304a2c0ffa$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $0f1a78304a2c0ffa$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($0f1a78304a2c0ffa$var$_isIOSStandalone(ua) && target !== '_self') {
        $0f1a78304a2c0ffa$var$openAsNewWindowIOS(url || '', target);
        return new $0f1a78304a2c0ffa$export$9f4f30ee63539e24(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $0f1a78304a2c0ffa$export$9f4f30ee63539e24(newWin);
}
function $0f1a78304a2c0ffa$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $0f1a78304a2c0ffa$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $0f1a78304a2c0ffa$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $0f1a78304a2c0ffa$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $0f1a78304a2c0ffa$export$91c6e00c14e7e6fd(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $8vnFK.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $0f1a78304a2c0ffa$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $7PthC.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $0f1a78304a2c0ffa$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$0f1a78304a2c0ffa$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$0f1a78304a2c0ffa$var$getHandlerBase(auth)}?${(0, $7PthC.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $0f1a78304a2c0ffa$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$0f1a78304a2c0ffa$var$WIDGET_PATH}`;
    return $0f1a78304a2c0ffa$var$_emulatorUrl(config, $0f1a78304a2c0ffa$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $0f1a78304a2c0ffa$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $0f1a78304a2c0ffa$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $0f1a78304a2c0ffa$export$625550452a3fa3ec;
        this._completeRedirectFn = $0f1a78304a2c0ffa$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $0f1a78304a2c0ffa$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $0f1a78304a2c0ffa$export$92108d983e8ee699(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $0f1a78304a2c0ffa$export$91c6e00c14e7e6fd(auth, provider, authType, $0f1a78304a2c0ffa$var$_getCurrentUrl(), eventId);
        return $0f1a78304a2c0ffa$var$_open(auth, url, $0f1a78304a2c0ffa$export$f96d196f7728bb5());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $0f1a78304a2c0ffa$export$91c6e00c14e7e6fd(auth, provider, authType, $0f1a78304a2c0ffa$var$_getCurrentUrl(), eventId);
        $0f1a78304a2c0ffa$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $0f1a78304a2c0ffa$export$92108d983e8ee699(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $0f1a78304a2c0ffa$var$_openIframe(auth);
        const manager = new $0f1a78304a2c0ffa$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($0f1a78304a2c0ffa$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $0f1a78304a2c0ffa$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$0f1a78304a2c0ffa$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $0f1a78304a2c0ffa$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $0f1a78304a2c0ffa$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $0f1a78304a2c0ffa$var$_isMobileBrowser() || $0f1a78304a2c0ffa$var$_isSafari() || $0f1a78304a2c0ffa$export$9fa96a7d116ea3ce();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $0f1a78304a2c0ffa$export$2408f22a0fab9ae5 = $0f1a78304a2c0ffa$var$BrowserPopupRedirectResolver;
class $0f1a78304a2c0ffa$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $0f1a78304a2c0ffa$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $0f1a78304a2c0ffa$var$PhoneMultiFactorAssertionImpl extends $0f1a78304a2c0ffa$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $0f1a78304a2c0ffa$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $0f1a78304a2c0ffa$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $0f1a78304a2c0ffa$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$35e795649ee09318 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $0f1a78304a2c0ffa$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $0f1a78304a2c0ffa$export$35e795649ee09318.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $0f1a78304a2c0ffa$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $0f1a78304a2c0ffa$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $0f1a78304a2c0ffa$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $0f1a78304a2c0ffa$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $0f1a78304a2c0ffa$export$953cecd6e717a553._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $0f1a78304a2c0ffa$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $0f1a78304a2c0ffa$var$TotpMultiFactorAssertionImpl extends $0f1a78304a2c0ffa$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $0f1a78304a2c0ffa$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $0f1a78304a2c0ffa$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $0f1a78304a2c0ffa$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $0f1a78304a2c0ffa$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $0f1a78304a2c0ffa$export$953cecd6e717a553 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $0f1a78304a2c0ffa$export$953cecd6e717a553(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($0f1a78304a2c0ffa$var$_isEmptyString(accountName) || $0f1a78304a2c0ffa$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($0f1a78304a2c0ffa$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($0f1a78304a2c0ffa$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $0f1a78304a2c0ffa$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $0f1a78304a2c0ffa$var$name = "@firebase/auth";
var $0f1a78304a2c0ffa$var$version = "1.13.4";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0f1a78304a2c0ffa$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0f1a78304a2c0ffa$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $0f1a78304a2c0ffa$var$registerAuth(clientPlatform) {
    (0, $8vnFK._registerComponent)(new (0, $3eXgh.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $0f1a78304a2c0ffa$export$d66dc83d8cfc8dd(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $0f1a78304a2c0ffa$export$738ab4df8bf92ae9(clientPlatform)
        };
        const authInstance = new $0f1a78304a2c0ffa$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $0f1a78304a2c0ffa$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $8vnFK._registerComponent)(new (0, $3eXgh.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $0f1a78304a2c0ffa$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $0f1a78304a2c0ffa$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $8vnFK.registerVersion)($0f1a78304a2c0ffa$var$name, $0f1a78304a2c0ffa$var$version, $0f1a78304a2c0ffa$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $8vnFK.registerVersion)($0f1a78304a2c0ffa$var$name, $0f1a78304a2c0ffa$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f1a78304a2c0ffa$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $0f1a78304a2c0ffa$var$authIdTokenMaxAge = (0, $7PthC.getExperimentalSetting)('authIdTokenMaxAge') || $0f1a78304a2c0ffa$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $0f1a78304a2c0ffa$var$lastPostedIdToken = null;
const $0f1a78304a2c0ffa$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $0f1a78304a2c0ffa$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($0f1a78304a2c0ffa$var$lastPostedIdToken === idToken) return;
        $0f1a78304a2c0ffa$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $0f1a78304a2c0ffa$export$96f57966bedc81b4(app = (0, $8vnFK.getApp)()) {
    const provider = (0, $8vnFK._getProvider)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $0f1a78304a2c0ffa$export$a07804094c3ecf2d(app, {
        popupRedirectResolver: $0f1a78304a2c0ffa$export$2408f22a0fab9ae5,
        persistence: [
            $0f1a78304a2c0ffa$export$3a1a48c8f6ef640e,
            $0f1a78304a2c0ffa$export$43caf9889c228507,
            $0f1a78304a2c0ffa$export$625550452a3fa3ec
        ]
    });
    const authTokenSyncPath = (0, $7PthC.getExperimentalSetting)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $0f1a78304a2c0ffa$var$mintCookieFactory(authTokenSyncUrl.toString());
            $0f1a78304a2c0ffa$export$ffb5f4729a158638(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $0f1a78304a2c0ffa$export$3d8c2f653ac9d0b9(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $7PthC.getDefaultEmulatorHost)('auth');
    if (authEmulatorHost) $0f1a78304a2c0ffa$export$efccba1c4a2ef57b(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $0f1a78304a2c0ffa$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$0f1a78304a2c0ffa$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $0f1a78304a2c0ffa$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $0f1a78304a2c0ffa$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$0f1a78304a2c0ffa$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});



parcelRegister("TAT8G", function(module, exports) {
'use strict';
function $0a71c06cbf7e203b$var$applyFirebaseTenant(auth, tenantId) {
    if (!auth || typeof auth !== 'object') throw new Error('Firebase Auth instance is required');
    auth.tenantId = tenantId || null;
    return auth;
}
module.exports = {
    applyFirebaseTenant: $0a71c06cbf7e203b$var$applyFirebaseTenant
};

});


parcelRegister("7bAQD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53b624b2cc5c9f13$export$2e2bcd8739ae039; });

var $cRQVA = parcelRequire("cRQVA");

var $cBna0 = parcelRequire("cBna0");

var $kzXQB = parcelRequire("kzXQB");
var $53b624b2cc5c9f13$export$2e2bcd8739ae039 = ({ resolver: resolver, onEnd: onEnd })=>{
    const [step, setStep] = (0, $cBna0.useState)('options');
    const [verificationId, setVerificationId] = (0, $cBna0.useState)('');
    const [verificationCode, setVerificationCode] = (0, $cBna0.useState)('');
    const [verificationType, setVerificationType] = (0, $cBna0.useState)('unknown');
    const [messageType, setMessageType] = (0, $cBna0.useState)({
        type: 'none',
        code: ''
    });
    const [recaptchaVerifier, setRecaptchaVerifier] = (0, $cBna0.useState)();
    const recaptchaRef = (0, $cBna0.useRef)();
    (0, $cBna0.useEffect)(()=>{
        setRecaptchaVerifier((0, $kzXQB.getRecaptcha)(recaptchaRef.current));
    }, []);
    const message = (0, $cBna0.useMemo)(()=>{
        if (messageType.type === 'none') return '';
        switch(messageType.code){
            case 'invalidCode':
                return 'Your code is incorrect. Please try again.';
            default:
                return 'An unknown error has occured. Please refresh and try again.';
        }
    }, [
        messageType
    ]);
    const runFactor = async (type, factor)=>{
        try {
            const verificationId = await (0, $kzXQB.multiFactorAuth)(resolver.session, factor, recaptchaVerifier);
            setStep('verifyCode');
            setVerificationId(verificationId);
            setVerificationType(type);
        } catch (err) {
            handleError(err);
        }
    };
    const verifyInputCode = async ()=>{
        if (verificationCode.length !== 6) {
            setMessageType({
                type: 'error',
                code: 'invalidCode'
            });
            return;
        } else if (verificationType === 'unknown') {
            setMessageType({
                type: 'error',
                code: 'unknown'
            });
            return;
        }
        try {
            const userCredential = await (0, $kzXQB.resolveVerification)(verificationType, verificationId, verificationCode, resolver);
            console.log(userCredential);
            onEnd(userCredential);
        } catch (err) {
            console.error(err);
            handleError(err);
        }
    };
    const handleError = (err)=>{
        if (!err?.code) {
            setMessageType({
                type: 'error',
                code: 'unknown'
            });
            return;
        }
        switch(err.code){
            case 'auth/invalid-multi-factor-session':
                window.location.reload();
                break;
            case 'auth/invalid-verification-code':
                setMessageType({
                    type: 'error',
                    code: 'invalidCode'
                });
                break;
            default:
                setMessageType({
                    type: 'error',
                    code: 'unknown'
                });
        }
    };
    const renderOptions = ()=>{
        const [phone] = [
            []
        ];
        resolver?.hints?.forEach((factor, i)=>{
            if (!factor) return;
            switch((0, $kzXQB.getFactorType)(factor)){
                case 0, $kzXQB.MFA_PHONE_FACTORID:
                    phone.push({
                        type: 'phone',
                        phoneNumber: factor.phoneNumber,
                        factor: factor
                    });
                    break;
                default:
                    break;
            }
        });
        return /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
            className: "col gap-2",
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                    className: "text-primary",
                    children: [
                        /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                            children: "Welcome back! We're glad to see you're taking the security of your account seriously with extra verification."
                        }),
                        /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                            children: "To complete your login, please enter the verification code sent to your selected method:"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                    className: "d-flex flex-column justify-content-center",
                    children: phone.map(({ type: type, phoneNumber: phoneNumber, factor: factor }, i)=>/*#__PURE__*/ (0, $cRQVA.jsxs)("button", {
                            className: "btn btn-primary mt-2",
                            onClick: ()=>{
                                runFactor(type, factor);
                            },
                            children: [
                                "Text Message (SMS) to ",
                                phoneNumber
                            ]
                        }, `factor-${i}`))
                })
            ]
        });
    };
    const getPhoneVerificationText = ()=>{
        return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: "Great choice! We've sent a verification code to the mobile number associated with your account."
                }),
                /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: "Please check your phone for the code and enter it below. If you haven't received the code within a few minutes, you can request a new one by logging in again."
                })
            ]
        });
    };
    const renderVerifyCode = ()=>{
        let title = /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
            children: "Type in your verification code:"
        });
        switch(verificationType){
            case 'phone':
                title = getPhoneVerificationText();
        }
        return /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                    className: "form-floating text-primary",
                    children: [
                        title,
                        messageType.type !== 'none' && message ? /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                            className: `text-${messageType.type === 'error' ? 'danger' : 'success'}`,
                            children: message
                        }) : ''
                    ]
                }),
                /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                    className: "form-floating",
                    children: [
                        /*#__PURE__*/ (0, $cRQVA.jsx)("input", {
                            id: "code-input",
                            className: `form-control`,
                            inputMode: "numeric",
                            pattern: "\\d*",
                            maxLength: "6",
                            onChange: (e)=>{
                                setVerificationCode(e.target.value);
                            },
                            required: true
                        }),
                        /*#__PURE__*/ (0, $cRQVA.jsx)("label", {
                            htmlFor: "code-input",
                            className: "form-label",
                            children: "Verification Code"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                    className: "row mt-2",
                    children: /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                        className: "col text-right",
                        children: /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                            className: "btn btn-primary",
                            onClick: verifyInputCode,
                            children: "Verify Code"
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
        children: [
            step === 'options' ? renderOptions() : renderVerifyCode(),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                ref: recaptchaRef
            })
        ]
    });
};

});

parcelRegister("1MWwR", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return $14d7accea1ee7867$export$25233b7fe55e5696; });
$parcel$export(module.exports, "MaintenanceStep", function () { return $14d7accea1ee7867$export$2628fece6700ccd7; });
$parcel$export(module.exports, "SoftOutageBanner", function () { return $14d7accea1ee7867$export$9e16699ccd33b733; });
$parcel$export(module.exports, "EmailLoginForm", function () { return $14d7accea1ee7867$export$b91a95e8b0ce4584; });
$parcel$export(module.exports, "ContinueAsStep", function () { return $14d7accea1ee7867$export$9f31f96b8cde808; });
$parcel$export(module.exports, "DetectingStep", function () { return $14d7accea1ee7867$export$b799896160fdbae5; });
$parcel$export(module.exports, "OrgPickerStep", function () { return $14d7accea1ee7867$export$8df1388dbebea378; });
$parcel$export(module.exports, "SsoRedirect", function () { return $14d7accea1ee7867$export$fe8e5cada3479854; });
$parcel$export(module.exports, "ReturningStep", function () { return $14d7accea1ee7867$export$d34450bca8f52bda; });
$parcel$export(module.exports, "SsoAccountBlocked", function () { return $14d7accea1ee7867$export$11237e15d2b2eb09; });
$parcel$export(module.exports, "SsoFailure", function () { return $14d7accea1ee7867$export$ce431fefedba151e; });
$parcel$export(module.exports, "SsoEmailMismatch", function () { return $14d7accea1ee7867$export$471290a1fe28aeaf; });
$parcel$export(module.exports, "PasswordLoginForm", function () { return $14d7accea1ee7867$export$1d6057f09de4e194; });
$parcel$export(module.exports, "PasswordResetForm", function () { return $14d7accea1ee7867$export$fafd4f70c104fac2; });

var $cRQVA = parcelRequire("cRQVA");

var $cBna0 = parcelRequire("cBna0");

var $baLkB = parcelRequire("baLkB");

var $5cIbl = parcelRequire("5cIbl");
var $14d7accea1ee7867$require$t = $5cIbl.t;
const $14d7accea1ee7867$export$68b70aa53ee12c4a = ()=>$14d7accea1ee7867$require$t('login.trustLine');
const $14d7accea1ee7867$export$52fcbf27d66ceda6 = ()=>$14d7accea1ee7867$require$t('login.pitchTitle');
const $14d7accea1ee7867$export$f732960ba8d3f21b = ()=>$14d7accea1ee7867$require$t('login.pitchBody');
const $14d7accea1ee7867$export$5e64a9683d127ef6 = ({ error: error, emailOnly: emailOnly, onBack: onBack })=>{
    if (!error) return null;
    switch(error){
        case 'form required':
            return /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error text-danger",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: emailOnly ? $14d7accea1ee7867$require$t('login.emailRequired') : $14d7accea1ee7867$require$t('login.emailAndPasswordRequired')
                })
            });
        case 'User not found':
            return /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error text-danger",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: $14d7accea1ee7867$require$t('login.emailNotFound')
                })
            });
        case 'Invalid password':
            return /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error text-danger",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: $14d7accea1ee7867$require$t('login.passwordIncorrect')
                })
            });
        case 'SSO sign-in failed':
            return /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error text-danger",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: $14d7accea1ee7867$require$t('login.ssoUnavailable')
                })
            });
        case 'popup blocked':
            return /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-info",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    className: "mb-0",
                    children: $14d7accea1ee7867$require$t('login.popupBlocked')
                })
            });
        default:
            return /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                className: "aud-banner aud-banner-error text-danger",
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsxs)("p", {
                        children: [
                            "Unfortunately we could not log you in. Please reach out to",
                            ' ',
                            /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                                href: "mailto:support@audirie.com",
                                children: "support@audirie.com"
                            }),
                            ' ',
                            "if the problem persists."
                        ]
                    }),
                    onBack && /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                        className: "aud-link-btn",
                        type: "button",
                        onClick: onBack,
                        children: $14d7accea1ee7867$require$t('login.backToLogin')
                    })
                ]
            });
    }
};
const $14d7accea1ee7867$var$Spinner = ()=>/*#__PURE__*/ (0, $cRQVA.jsx)("div", {
        className: "aud-spinner",
        role: "status",
        "aria-label": "Loading"
    });
const $14d7accea1ee7867$export$25233b7fe55e5696 = ({ org: org, children: children })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-card",
        id: "LoginForm",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                className: "aud-panel",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("img", {
                        src: "/static/images/audirieLogo.png",
                        alt: "Audirie",
                        className: "aud-panel-logo"
                    }),
                    org ? /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                        className: "aud-panel-body",
                        children: [
                            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                                className: "aud-org-badge",
                                children: (org.name || 'A').charAt(0).toUpperCase()
                            }),
                            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                                className: "aud-panel-title",
                                children: $14d7accea1ee7867$require$t('login.orgOnAudirie', {
                                    values: {
                                        name: org.name
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                                className: "aud-panel-copy",
                                children: org.blurb || $14d7accea1ee7867$require$t('login.orgManagedSignIn')
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                        className: "aud-panel-body",
                        children: [
                            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                                className: "aud-panel-title",
                                children: $14d7accea1ee7867$export$52fcbf27d66ceda6()
                            }),
                            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                                className: "aud-panel-copy",
                                children: $14d7accea1ee7867$export$f732960ba8d3f21b()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                        className: "aud-trust",
                        children: $14d7accea1ee7867$export$68b70aa53ee12c4a()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-main",
                children: children
            })
        ]
    });
const $14d7accea1ee7867$export$2628fece6700ccd7 = ({ message: message, checking: checking, onCheckAgain: onCheckAgain })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        "data-testid": "login-maintenance",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: $14d7accea1ee7867$require$t('login.maintenanceHeading')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        style: {
                            marginTop: 8
                        },
                        children: message || $14d7accea1ee7867$require$t('login.maintenanceDefaultBody')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-info",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    className: "mb-0",
                    children: $14d7accea1ee7867$require$t('login.maintenanceHint')
                })
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                type: "button",
                className: "aud-btn-primary",
                disabled: checking,
                onClick: onCheckAgain,
                children: checking ? $14d7accea1ee7867$require$t('login.oneMoment') : $14d7accea1ee7867$require$t('login.checkAgain')
            })
        ]
    });
const $14d7accea1ee7867$export$9e16699ccd33b733 = ()=>/*#__PURE__*/ (0, $cRQVA.jsx)("div", {
        className: "aud-banner aud-banner-info",
        "data-testid": "login-soft-outage",
        children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
            className: "mb-0",
            children: $14d7accea1ee7867$require$t('login.softOutageBody')
        })
    });
const $14d7accea1ee7867$export$b91a95e8b0ce4584 = ({ login: login, error: error, saving: saving, seenBefore: seenBefore, onSubmit: onSubmit, onInputChange: onInputChange, onBack: onBack, disabled: disabled })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("form", {
        className: "aud-step",
        action: "#",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: seenBefore ? $14d7accea1ee7867$require$t('login.welcomeBack') : $14d7accea1ee7867$require$t('login.findYourWayIn')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        style: {
                            marginTop: 8
                        },
                        children: seenBefore ? $14d7accea1ee7867$require$t('login.startWithWorkEmail') : $14d7accea1ee7867$require$t('login.workEmailTellsUs')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)($14d7accea1ee7867$export$5e64a9683d127ef6, {
                error: error,
                emailOnly: true,
                onBack: onBack
            }),
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                className: "aud-field",
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("label", {
                        htmlFor: "email-input",
                        children: $14d7accea1ee7867$require$t('login.workEmail')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("input", {
                        id: "email-input",
                        className: "form-control",
                        name: "email",
                        type: "email",
                        autoComplete: "username",
                        placeholder: "name@example.com",
                        value: login.email,
                        onChange: onInputChange,
                        autoFocus: true,
                        disabled: disabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                disabled: saving || disabled,
                className: "aud-btn-primary",
                type: "submit",
                children: $14d7accea1ee7867$require$t('login.continue')
            })
        ]
    });
const $14d7accea1ee7867$export$9f31f96b8cde808 = ({ hint: hint, onContinue: onContinue, onDifferent: onDifferent })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: $14d7accea1ee7867$require$t('login.welcomeBack')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        style: {
                            marginTop: 8
                        },
                        children: $14d7accea1ee7867$require$t('login.pickUpWhereLeftOff')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-options",
                children: /*#__PURE__*/ (0, $cRQVA.jsxs)("button", {
                    type: "button",
                    className: "aud-option aud-option-primary",
                    onClick: onContinue,
                    children: [
                        /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                            className: "aud-option-title",
                            children: $14d7accea1ee7867$require$t('login.continueAs', {
                                values: {
                                    email: hint.email
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                            className: "aud-option-detail",
                            children: hint.method === 'sso' ? hint.orgName ? $14d7accea1ee7867$require$t('login.singleSignOnWithOrg', {
                                values: {
                                    orgName: hint.orgName
                                }
                            }) : $14d7accea1ee7867$require$t('login.singleSignOn') : $14d7accea1ee7867$require$t('login.audiriePassword')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                type: "button",
                className: "aud-link-btn aud-quiet",
                onClick: onDifferent,
                children: $14d7accea1ee7867$require$t('login.useDifferentAccount')
            })
        ]
    });
const $14d7accea1ee7867$export$b799896160fdbae5 = ()=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)($14d7accea1ee7867$var$Spinner, {}),
            /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                className: "aud-heading",
                children: $14d7accea1ee7867$require$t('login.oneMoment')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "aud-subline",
                children: $14d7accea1ee7867$require$t('login.checkingOrganisationSignIn')
            })
        ]
    });
const $14d7accea1ee7867$export$8df1388dbebea378 = ({ email: email, providers: providers, onPick: onPick, onBack: onBack })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: $14d7accea1ee7867$require$t('login.whichOrgHeading')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        style: {
                            marginTop: 8
                        },
                        children: $14d7accea1ee7867$require$t('login.belongsToMultipleOrgs', {
                            values: {
                                email: email
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-options",
                children: providers.map((provider)=>/*#__PURE__*/ (0, $cRQVA.jsxs)("button", {
                        type: "button",
                        className: "aud-option",
                        onClick: ()=>onPick(provider),
                        children: [
                            /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                                className: "aud-option-title",
                                children: provider.orgName || $14d7accea1ee7867$require$t('login.yourOrganisation')
                            }),
                            /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                                className: "aud-option-detail",
                                children: $14d7accea1ee7867$require$t('login.singleSignOn')
                            })
                        ]
                    }, provider.providerId))
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                type: "button",
                className: "aud-link-btn aud-quiet",
                onClick: onBack,
                children: $14d7accea1ee7867$require$t('login.useDifferentEmail')
            })
        ]
    });
const $14d7accea1ee7867$export$fe8e5cada3479854 = ({ org: org, error: error, onBack: onBack })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)($14d7accea1ee7867$export$5e64a9683d127ef6, {
                error: error,
                onBack: onBack
            }),
            !error && /*#__PURE__*/ (0, $cRQVA.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cBna0))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: org?.name ? $14d7accea1ee7867$require$t('login.orgTakesItFromHere', {
                            values: {
                                name: org.name
                            }
                        }) : $14d7accea1ee7867$require$t('login.yourOrgTakesItFromHere')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        children: $14d7accea1ee7867$require$t('login.openingTheirSignIn')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                        className: "aud-progress",
                        children: /*#__PURE__*/ (0, $cRQVA.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                        type: "button",
                        className: "aud-link-btn aud-quiet",
                        onClick: onBack,
                        children: $14d7accea1ee7867$require$t('login.notYouStartAgain')
                    })
                ]
            })
        ]
    });
const $14d7accea1ee7867$export$d34450bca8f52bda = ()=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        "aria-live": "polite",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)($14d7accea1ee7867$var$Spinner, {}),
            /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                className: "aud-heading",
                children: $14d7accea1ee7867$require$t('login.welcomeBack')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "aud-subline",
                children: $14d7accea1ee7867$require$t('login.verifiedGettingReady')
            })
        ]
    });
const $14d7accea1ee7867$export$11237e15d2b2eb09 = ({ org: org, message: message, onGoBack: onGoBack })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                className: "aud-heading",
                children: org?.name ? $14d7accea1ee7867$require$t('login.orgSignInComplete', {
                    values: {
                        name: org.name
                    }
                }) : $14d7accea1ee7867$require$t('login.accountNotReady')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "aud-subline",
                children: $14d7accea1ee7867$require$t('login.ssoWorkedButNeedsSetup')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: message || $14d7accea1ee7867$require$t('login.noRoleAssigned')
                })
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                className: "aud-btn-primary",
                type: "button",
                onClick: onGoBack,
                children: $14d7accea1ee7867$require$t('login.backToLogin')
            })
        ]
    });
const $14d7accea1ee7867$export$ce431fefedba151e = ({ org: org, onGoBack: onGoBack })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                className: "aud-heading",
                children: org?.name ? $14d7accea1ee7867$require$t('login.orgDidntLetUsIn', {
                    values: {
                        name: org.name
                    }
                }) : $14d7accea1ee7867$require$t('login.couldntCompleteSso')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "aud-subline",
                children: $14d7accea1ee7867$require$t('login.orgSignInDeclined')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsxs)("p", {
                    children: [
                        "If this keeps happening, send a note to your IT team \u2014 and let us know at",
                        ' ',
                        /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                            href: "mailto:support@audirie.com",
                            children: "support@audirie.com"
                        }),
                        ' ',
                        "so we can help."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                className: "aud-btn-primary",
                type: "button",
                onClick: onGoBack,
                children: $14d7accea1ee7867$require$t('login.tryAgain')
            })
        ]
    });
const $14d7accea1ee7867$export$471290a1fe28aeaf = ({ org: org, onGoBack: onGoBack })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
        className: "aud-step",
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                className: "aud-heading",
                children: org?.name ? $14d7accea1ee7867$require$t('login.orgSignedInAsSomeoneElse', {
                    values: {
                        name: org.name
                    }
                }) : $14d7accea1ee7867$require$t('login.differentAccountSignedIn')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "aud-subline",
                children: $14d7accea1ee7867$require$t('login.orgSignOnConnectedElsewhere')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    children: $14d7accea1ee7867$require$t('login.signOutCorporateFirst')
                })
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                className: "aud-btn-primary",
                type: "button",
                onClick: onGoBack,
                children: $14d7accea1ee7867$require$t('login.backToLogin')
            })
        ]
    });
const $14d7accea1ee7867$export$1d6057f09de4e194 = ({ login: login, error: error, saving: saving, onSubmit: onSubmit, onInputChange: onInputChange, onBack: onBack, onForgotPassword: onForgotPassword })=>/*#__PURE__*/ (0, $cRQVA.jsxs)("form", {
        className: "aud-step",
        action: "#",
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 5
                },
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: $14d7accea1ee7867$require$t('login.enterPassword')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsxs)("button", {
                        type: "button",
                        className: "aud-identifier",
                        onClick: onBack,
                        children: [
                            login.email,
                            " \xb7 ",
                            $14d7accea1ee7867$require$t('login.change')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)($14d7accea1ee7867$export$5e64a9683d127ef6, {
                error: error
            }),
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                className: "aud-field",
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)((0, $baLkB.default), {
                        id: "password-input",
                        label: $14d7accea1ee7867$require$t('login.password'),
                        name: "password",
                        passwordValue: login.password,
                        updateInput: onInputChange,
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                        className: "aud-link-btn",
                        href: "#",
                        onClick: (e)=>{
                            e.preventDefault();
                            onForgotPassword();
                        },
                        children: $14d7accea1ee7867$require$t('login.forgotPassword')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                disabled: saving,
                className: "aud-btn-primary",
                type: "submit",
                children: $14d7accea1ee7867$require$t('login.signIn')
            })
        ]
    });
const $14d7accea1ee7867$export$fafd4f70c104fac2 = ({ email: email, result: result, saving: saving, onSubmit: onSubmit, onInputChange: onInputChange, onCancel: onCancel })=>{
    let message;
    switch(result){
        case 'sent':
            message = /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                className: "text-success",
                children: $14d7accea1ee7867$require$t('login.resetEmailSent')
            });
            break;
        case 'need email':
            message = /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                    className: "text-danger",
                    children: $14d7accea1ee7867$require$t('login.needValidEmail')
                })
            });
            break;
        case 'user not found':
            message = /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsxs)("p", {
                    className: "text-danger",
                    children: [
                        "You must register with Audirie before you can complete this task. If you do not have a registration link, contact us at",
                        ' ',
                        /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                            href: "mailto:support@audirie.com",
                            children: "support@audirie.com"
                        })
                    ]
                })
            });
            break;
        default:
            message = result ? /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                className: "aud-banner aud-banner-error",
                children: /*#__PURE__*/ (0, $cRQVA.jsxs)("p", {
                    className: "text-danger",
                    children: [
                        "We could not reset your password. Please try again. If this persists please contact us at",
                        ' ',
                        /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                            href: "mailto:support@audirie.com",
                            children: "support@audirie.com"
                        })
                    ]
                })
            }) : null;
    }
    return /*#__PURE__*/ (0, $cRQVA.jsxs)("form", {
        className: "aud-step",
        action: "#",
        method: "POST",
        onSubmit: onSubmit,
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("h2", {
                        className: "aud-heading",
                        children: $14d7accea1ee7867$require$t('login.resetPassword')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "aud-subline",
                        style: {
                            marginTop: 8
                        },
                        children: $14d7accea1ee7867$require$t('login.wellEmailLink')
                    })
                ]
            }),
            message,
            /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                className: "aud-field",
                children: [
                    /*#__PURE__*/ (0, $cRQVA.jsx)("label", {
                        htmlFor: "email-input",
                        children: $14d7accea1ee7867$require$t('login.workEmail')
                    }),
                    /*#__PURE__*/ (0, $cRQVA.jsx)("input", {
                        id: "email-input",
                        className: "form-control",
                        name: "email",
                        type: "email",
                        placeholder: "name@example.com",
                        value: email,
                        onChange: onInputChange
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                disabled: saving,
                className: "aud-btn-primary",
                type: "submit",
                children: $14d7accea1ee7867$require$t('login.send')
            }),
            /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                className: "aud-link-btn aud-quiet",
                href: "#",
                onClick: (e)=>{
                    e.preventDefault();
                    onCancel();
                },
                children: $14d7accea1ee7867$require$t('login.cancel')
            })
        ]
    });
};

});
parcelRegister("baLkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b226c1b6d12856d0$export$2e2bcd8739ae039; });

var $cRQVA = parcelRequire("cRQVA");

var $cBna0 = parcelRequire("cBna0");
const $b226c1b6d12856d0$var$styles = `
  .eye-icon {
    position: absolute;
    right: 10px;
    top: 40%;
    transform: translateY(-100%);
    cursor: pointer;
  }
`;
const $b226c1b6d12856d0$var$eyeOpen = /*#__PURE__*/ (0, $cRQVA.jsxs)("svg", {
    fill: "none",
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, $cRQVA.jsx)("path", {
            d: "M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z",
            stroke: "#000000",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ (0, $cRQVA.jsx)("path", {
            d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
            stroke: "#000000",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
});
const $b226c1b6d12856d0$var$eyeClosed = /*#__PURE__*/ (0, $cRQVA.jsx)("svg", {
    fill: "none",
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, $cRQVA.jsx)("path", {
        d: "M20 14.8335C21.3082 13.3317 22 12 22 12C22 12 18.3636 5 12 5C11.6588 5 11.3254 5.02013 11 5.05822C10.6578 5.09828 10.3244 5.15822 10 5.23552M12 9C12.3506 9 12.6872 9.06015 13 9.17071C13.8524 9.47199 14.528 10.1476 14.8293 11C14.9398 11.3128 15 11.6494 15 12M3 3L21 21M12 15C11.6494 15 11.3128 14.9398 11 14.8293C10.1476 14.528 9.47198 13.8524 9.1707 13C9.11386 12.8392 9.07034 12.6721 9.04147 12.5M4.14701 9C3.83877 9.34451 3.56234 9.68241 3.31864 10C2.45286 11.1282 2 12 2 12C2 12 5.63636 19 12 19C12.3412 19 12.6746 18.9799 13 18.9418",
        stroke: "#000000",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
class $b226c1b6d12856d0$var$PasswordFields extends (0, $cBna0.Component) {
    constructor(props){
        super(props);
        this.togglePasswordVisibility = (field)=>{
            this.setState((prevState)=>({
                    [field]: !prevState[field]
                }));
        };
        this.state = {
            profile: {
                password: ''
            },
            showPassword: false
        };
        this.id = this.props.id;
        this.name = this.props.name;
        this.label = this.props.label;
    }
    render() {
        const { profile: profile, showPassword: showPassword } = this.state;
        const { passwordValue: passwordValue, errorMessage: errorMessage, updateInput: updateInput, renderErrorMessage: renderErrorMessage, autoFocus: autoFocus } = this.props;
        return /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
            className: "form-floating",
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                    style: {
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $cRQVA.jsx)("input", {
                            id: this.id,
                            className: `form-control ${errorMessage ? 'is-invalid' : ''}`,
                            name: this.name,
                            type: showPassword ? 'text' : 'password',
                            placeholder: this.label,
                            value: passwordValue,
                            onChange: updateInput,
                            onBlur: this.props.onBlur,
                            autoFocus: autoFocus,
                            autoComplete: this.props.autoComplete,
                            passwordrules: this.props.passwordRules,
                            "aria-describedby": this.props.describedBy,
                            style: {
                                paddingRight: '2em'
                            }
                        }),
                        /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                            className: "eye-icon",
                            onClick: ()=>this.togglePasswordVisibility('showPassword'),
                            style: {
                                position: 'absolute',
                                top: '50%',
                                right: '5px',
                                marginTop: '-12px',
                                cursor: 'pointer'
                            },
                            color: showPassword ? 'gray' : 'black',
                            children: showPassword ? $b226c1b6d12856d0$var$eyeOpen : $b226c1b6d12856d0$var$eyeClosed
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cRQVA.jsx)("label", {
                    htmlFor: this.id,
                    className: "form-label",
                    children: this.label
                }),
                renderErrorMessage(errorMessage)
            ]
        });
    }
}
$b226c1b6d12856d0$var$PasswordFields.defaultProps = {
    id: '',
    name: 'default',
    label: 'Password',
    errorMessage: '',
    renderErrorMessage: ()=>{},
    autoFocus: false,
    autoComplete: undefined,
    // Apple/WebKit hint so generated strong passwords satisfy our rules.
    passwordRules: undefined,
    describedBy: undefined,
    onBlur: ()=>{}
};
var $b226c1b6d12856d0$export$2e2bcd8739ae039 = $b226c1b6d12856d0$var$PasswordFields;

});

parcelRegister("5cIbl", function(module, exports) {
'use strict';

var $hhAfY = parcelRequire("hhAfY");
var $3ca05857b6fdce29$require$locales = $hhAfY.locales;
var $3ca05857b6fdce29$require$DEFAULT_LOCALE = $hhAfY.DEFAULT_LOCALE;
var $3ca05857b6fdce29$require$SUPPORTED_LOCALES = $hhAfY.SUPPORTED_LOCALES;
// Bare language tag → default catalog (`es` → Spain, `de` → Germany).
const $3ca05857b6fdce29$var$LANGUAGE_DEFAULTS = Object.freeze({
    en: 'en-US',
    es: 'es-ES',
    de: 'de-DE'
});
// Per-language region overrides when the exact tag is not registered.
// English: Commonwealth spelling → en-AU; US/Canada → en-US.
// Spanish: Latin America / US → es-US; Spain → es-ES.
// German: AT/CH share de-DE copy for now.
const $3ca05857b6fdce29$var$REGION_BY_LANGUAGE = Object.freeze({
    en: Object.freeze({
        US: 'en-US',
        CA: 'en-US',
        AU: 'en-AU',
        GB: 'en-AU',
        NZ: 'en-AU',
        IE: 'en-AU',
        ZA: 'en-AU'
    }),
    es: Object.freeze({
        US: 'es-US',
        MX: 'es-US',
        AR: 'es-US',
        CO: 'es-US',
        CL: 'es-US',
        PE: 'es-US',
        VE: 'es-US',
        EC: 'es-US',
        GT: 'es-US',
        CU: 'es-US',
        DO: 'es-US',
        HN: 'es-US',
        SV: 'es-US',
        NI: 'es-US',
        CR: 'es-US',
        PA: 'es-US',
        BO: 'es-US',
        PY: 'es-US',
        UY: 'es-US',
        PR: 'es-US',
        419: 'es-US',
        // UN Latin America / Caribbean
        ES: 'es-ES'
    }),
    de: Object.freeze({
        DE: 'de-DE',
        AT: 'de-DE',
        CH: 'de-DE'
    })
});
// Back-compat export used by older tests / callers.
const $3ca05857b6fdce29$var$REGION_LOCALE = $3ca05857b6fdce29$var$REGION_BY_LANGUAGE.en;
const $3ca05857b6fdce29$var$lookupPath = (messages, path)=>{
    if (!messages || typeof path !== 'string' || !path) return undefined;
    return path.split('.').reduce((node, key)=>{
        if (node == null || typeof node !== 'object') return undefined;
        return node[key];
    }, messages);
};
const $3ca05857b6fdce29$var$interpolate = (template, values)=>{
    if (!values || typeof template !== 'string') return template;
    return template.replace(/\{(\w+)\}/g, (match, key)=>{
        if (Object.prototype.hasOwnProperty.call(values, key) && values[key] != null) return String(values[key]);
        return match;
    });
};
/**
 * Normalise a BCP 47-ish tag (`en_US` → `en-US`).
 * @param {*} tag
 * @returns {string|null}
 */ const $3ca05857b6fdce29$var$normaliseTag = (tag)=>{
    if (typeof tag !== 'string') return null;
    const trimmed = tag.trim().replace(/_/g, '-');
    if (!trimmed) return null;
    const parts = trimmed.split('-').filter(Boolean);
    if (parts.length === 0) return null;
    const language = parts[0].toLowerCase();
    if (parts.length === 1) return language;
    const region = parts[1].toUpperCase();
    return `${language}-${region}`;
};
/**
 * Pick the best supported locale from a preference list
 * (e.g. `navigator.languages`).
 *
 * @param {string|string[]|null|undefined} preferred
 * @returns {string} one of SUPPORTED_LOCALES
 */ const $3ca05857b6fdce29$var$resolveLocale = (preferred)=>{
    const candidates = Array.isArray(preferred) ? preferred : preferred != null ? [
        preferred
    ] : [];
    for (const raw of candidates){
        const tag = $3ca05857b6fdce29$var$normaliseTag(raw);
        if (!tag) continue;
        if ($3ca05857b6fdce29$require$locales[tag]) return tag;
        const lowerMatch = $3ca05857b6fdce29$require$SUPPORTED_LOCALES.find((id)=>id.toLowerCase() === tag.toLowerCase());
        if (lowerMatch) return lowerMatch;
        const [language, region] = tag.split('-');
        const regionMap = $3ca05857b6fdce29$var$REGION_BY_LANGUAGE[language];
        if (region && regionMap && regionMap[region] && $3ca05857b6fdce29$require$locales[regionMap[region]]) return regionMap[region];
        // Language-only tag (`es`, `de`, `en`) or unknown region for that language.
        if ($3ca05857b6fdce29$var$LANGUAGE_DEFAULTS[language] && $3ca05857b6fdce29$require$locales[$3ca05857b6fdce29$var$LANGUAGE_DEFAULTS[language]]) return $3ca05857b6fdce29$var$LANGUAGE_DEFAULTS[language];
        const languageMatch = $3ca05857b6fdce29$require$SUPPORTED_LOCALES.find((id)=>id.toLowerCase().startsWith(`${language}-`));
        if (languageMatch) return languageMatch;
    }
    return $3ca05857b6fdce29$require$DEFAULT_LOCALE;
};
/**
 * Read preferred languages from the browser. Empty outside a browser.
 * @returns {string[]}
 */ const $3ca05857b6fdce29$var$detectBrowserLocales = ()=>{
    if (typeof navigator === 'undefined') return [];
    if (Array.isArray(navigator.languages) && navigator.languages.length > 0) return navigator.languages.slice();
    if (typeof navigator.language === 'string' && navigator.language) return [
        navigator.language
    ];
    return [];
};
/**
 * Resolve the active UI locale from the browser (or an override).
 * @param {string|string[]|null|undefined} override
 * @returns {string}
 */ const $3ca05857b6fdce29$var$getActiveLocale = (override)=>{
    if (override != null) return $3ca05857b6fdce29$var$resolveLocale(override);
    return $3ca05857b6fdce29$var$resolveLocale($3ca05857b6fdce29$var$detectBrowserLocales());
};
/**
 * Look up a message key for a locale, falling back to the default catalog.
 * @param {string} key dotted path, e.g. `login.pitchBody`
 * @param {{ locale?: string|string[], values?: Object }} [options]
 * @returns {string}
 */ const $3ca05857b6fdce29$var$t = (key, options = {})=>{
    const locale = $3ca05857b6fdce29$var$getActiveLocale(options.locale);
    const primary = $3ca05857b6fdce29$var$lookupPath($3ca05857b6fdce29$require$locales[locale], key);
    const fallback = locale === $3ca05857b6fdce29$require$DEFAULT_LOCALE ? undefined : $3ca05857b6fdce29$var$lookupPath($3ca05857b6fdce29$require$locales[$3ca05857b6fdce29$require$DEFAULT_LOCALE], key);
    const template = typeof primary === 'string' ? primary : typeof fallback === 'string' ? fallback : key;
    return $3ca05857b6fdce29$var$interpolate(template, options.values);
};
/**
 * Bound translator for a fixed locale (handy in tests).
 * @param {string|string[]} preferred
 * @returns {(key: string, values?: Object) => string}
 */ const $3ca05857b6fdce29$var$createTranslator = (preferred)=>{
    const locale = $3ca05857b6fdce29$var$resolveLocale(preferred);
    return (key, values)=>$3ca05857b6fdce29$var$t(key, {
            locale: locale,
            values: values
        });
};
module.exports = {
    DEFAULT_LOCALE: $3ca05857b6fdce29$require$DEFAULT_LOCALE,
    SUPPORTED_LOCALES: $3ca05857b6fdce29$require$SUPPORTED_LOCALES,
    LANGUAGE_DEFAULTS: $3ca05857b6fdce29$var$LANGUAGE_DEFAULTS,
    REGION_BY_LANGUAGE: $3ca05857b6fdce29$var$REGION_BY_LANGUAGE,
    REGION_LOCALE: $3ca05857b6fdce29$var$REGION_LOCALE,
    resolveLocale: $3ca05857b6fdce29$var$resolveLocale,
    detectBrowserLocales: $3ca05857b6fdce29$var$detectBrowserLocales,
    getActiveLocale: $3ca05857b6fdce29$var$getActiveLocale,
    t: $3ca05857b6fdce29$var$t,
    createTranslator: $3ca05857b6fdce29$var$createTranslator,
    interpolate: $3ca05857b6fdce29$var$interpolate
};

});
parcelRegister("hhAfY", function(module, exports) {
'use strict';

var $7jIrA = parcelRequire("7jIrA");

var $4N6C3 = parcelRequire("4N6C3");

var $atZtl = parcelRequire("atZtl");

var $56jMH = parcelRequire("56jMH");

var $5EbMB = parcelRequire("5EbMB");
const $c95025fe249f3652$var$locales = Object.freeze({
    'en-AU': $7jIrA,
    'en-US': $4N6C3,
    'es-US': $atZtl,
    'es-ES': $56jMH,
    'de-DE': $5EbMB
});
const $c95025fe249f3652$var$DEFAULT_LOCALE = 'en-AU';
module.exports = {
    locales: $c95025fe249f3652$var$locales,
    DEFAULT_LOCALE: $c95025fe249f3652$var$DEFAULT_LOCALE,
    SUPPORTED_LOCALES: Object.freeze(Object.keys($c95025fe249f3652$var$locales))
};

});
parcelRegister("7jIrA", function(module, exports) {
'use strict';
/**
 * Australian English — default product copy.
 * Add keys here first; mirror them in other locale files when translating.
 */ module.exports = {
    login: {
        trustLine: "Trusted by teams in regulated professions worldwide \u2014 wherever the hard conversations matter.",
        pitchTitle: 'Real conversations, before they\u2019re real.',
        pitchBody: "Practise the hard bits \u2014 the objection, the diagnosis, the difficult news \u2014 and get feedback while it still matters.",
        orgManagedSignIn: 'Sign-in is managed by your organisation.',
        orgOnAudirie: '{name} on Audirie',
        welcomeBack: 'Welcome back.',
        findYourWayIn: 'Let\u2019s find your way in.',
        startWithWorkEmail: "Start with your work email \u2014 we\u2019ll take you the right way in.",
        workEmailTellsUs: 'Your work email tells us how your organisation signs in. No password needed if they use single sign-on.',
        workEmail: 'Email address',
        continue: 'Continue',
        pickUpWhereLeftOff: 'Pick up right where you left off.',
        continueAs: 'Continue as {email}',
        singleSignOn: 'Single sign-on',
        singleSignOnWithOrg: "Single sign-on \xb7 {orgName}",
        audiriePassword: 'Audirie password',
        useDifferentAccount: 'Use a different account',
        oneMoment: "One moment\u2026",
        checkingOrganisationSignIn: "We\u2019re checking how your organisation signs in.",
        whichOrgHeading: 'Which one are you signing in as?',
        belongsToMultipleOrgs: '{email} belongs to more than one organisation on Audirie.',
        yourOrganisation: 'Your organisation',
        useDifferentEmail: 'Use a different email',
        orgTakesItFromHere: '{name} takes it from here',
        yourOrgTakesItFromHere: 'Your organisation takes it from here',
        openingTheirSignIn: "We\u2019re opening their sign-in page \u2014 you\u2019ll finish there and come straight back. Nothing you enter on their page reaches us.",
        notYouStartAgain: 'Not you? Start again',
        verifiedGettingReady: "You\u2019re verified. Getting your practice space ready.",
        orgSignInComplete: '{name} sign-in is complete',
        accountNotReady: 'Your account is not ready yet',
        ssoWorkedButNeedsSetup: 'Single sign-on worked, but your Audirie account still needs to be set up before you can enter.',
        noRoleAssigned: 'Your account does not have a role assigned yet. Please contact your organisation administrator.',
        backToLogin: 'Back to login',
        orgDidntLetUsIn: '{name} didn\u2019t let us in',
        couldntCompleteSso: 'We couldn\u2019t complete single sign-on',
        orgSignInDeclined: "Your organisation\u2019s sign-in service either declined the request or didn\u2019t respond. Nothing is wrong with your Audirie account.",
        ifKeepsHappening: "If this keeps happening, send a note to your IT team \u2014 and let us know at support@audirie.com so we can help.",
        tryAgain: 'Try again',
        orgSignedInAsSomeoneElse: '{name} is signed in as someone else',
        differentAccountSignedIn: 'A different account is signed in',
        orgSignOnConnectedElsewhere: "Your organisation\u2019s sign-on is still connected to another email address on this browser.",
        signOutCorporateFirst: 'Sign out of that corporate account first, then come back and try again with the email you want to use.',
        enterPassword: 'Enter your password',
        change: 'change',
        password: 'Password',
        forgotPassword: 'Forgot your password?',
        signIn: 'Sign in',
        resetPassword: 'Reset your password',
        wellEmailLink: "We\u2019ll email you a link to choose a new one.",
        send: 'Send',
        cancel: 'Cancel',
        emailRequired: 'Email is required',
        emailAndPasswordRequired: 'Email and password are required',
        emailNotFound: 'That email was not found.',
        passwordIncorrect: 'Your password is incorrect.',
        ssoUnavailable: 'Single Sign-On is currently unavailable. Please sign in with your password.',
        popupBlocked: 'Your browser blocked the sign-in window. Please allow pop-ups for this site, then refresh the page to continue.',
        couldNotLogIn: 'Unfortunately we could not log you in. Please reach out to support@audirie.com if the problem persists.',
        resetEmailSent: 'If the email address you gave is in our records, you will receive an email with a link to reset your password.',
        needValidEmail: 'Please give us a valid email.',
        mustRegisterFirst: 'You must register with Audirie before you can complete this task. If you do not have a registration link, contact us at support@audirie.com',
        couldNotResetPassword: 'We could not reset your password. Please try again. If this persists please contact us at support@audirie.com',
        maintenanceHeading: "We\u2019ll be right back",
        maintenanceDefaultBody: "We're doing a short maintenance update. Sign-in will be back shortly. Please try again in a few minutes.",
        maintenanceHint: "This is a planned update \u2014 your account and data are safe.",
        checkAgain: 'Check again',
        softOutageBody: "We\u2019re having trouble reaching the service right now. Please try again in a moment."
    }
};

});

parcelRegister("4N6C3", function(module, exports) {
'use strict';
/**
 * US English — American spelling and phrasing.
 * Keep key structure identical to en-AU.js so missing keys fall back cleanly.
 */ module.exports = {
    login: {
        trustLine: "Trusted by teams in regulated professions worldwide \u2014 wherever the hard conversations matter.",
        pitchTitle: 'Real conversations, before they\u2019re real.',
        pitchBody: "Practice the hard conversations \u2014 the objection, the diagnosis, the difficult news \u2014 and get feedback while it still matters.",
        orgManagedSignIn: 'Sign-in is managed by your organization.',
        orgOnAudirie: '{name} on Audirie',
        welcomeBack: 'Welcome back.',
        findYourWayIn: 'Let\u2019s find your way in.',
        startWithWorkEmail: "Start with your work email \u2014 we\u2019ll take you the right way in.",
        workEmailTellsUs: 'Your work email tells us how your organization signs in. No password needed if they use single sign-on.',
        workEmail: 'Email address',
        continue: 'Continue',
        pickUpWhereLeftOff: 'Pick up right where you left off.',
        continueAs: 'Continue as {email}',
        singleSignOn: 'Single sign-on',
        singleSignOnWithOrg: "Single sign-on \xb7 {orgName}",
        audiriePassword: 'Audirie password',
        useDifferentAccount: 'Use a different account',
        oneMoment: "One moment\u2026",
        checkingOrganisationSignIn: "We\u2019re checking how your organization signs in.",
        whichOrgHeading: 'Which one are you signing in as?',
        belongsToMultipleOrgs: '{email} belongs to more than one organization on Audirie.',
        yourOrganisation: 'Your organization',
        useDifferentEmail: 'Use a different email',
        orgTakesItFromHere: '{name} takes it from here',
        yourOrgTakesItFromHere: 'Your organization takes it from here',
        openingTheirSignIn: "We\u2019re opening their sign-in page \u2014 you\u2019ll finish there and come straight back. Nothing you enter on their page reaches us.",
        notYouStartAgain: 'Not you? Start again',
        verifiedGettingReady: "You\u2019re verified. Getting your practice space ready.",
        orgSignInComplete: '{name} sign-in is complete',
        accountNotReady: 'Your account is not ready yet',
        ssoWorkedButNeedsSetup: 'Single sign-on worked, but your Audirie account still needs to be set up before you can enter.',
        noRoleAssigned: 'Your account does not have a role assigned yet. Please contact your organization administrator.',
        backToLogin: 'Back to login',
        orgDidntLetUsIn: '{name} didn\u2019t let us in',
        couldntCompleteSso: 'We couldn\u2019t complete single sign-on',
        orgSignInDeclined: "Your organization\u2019s sign-in service either declined the request or didn\u2019t respond. Nothing is wrong with your Audirie account.",
        ifKeepsHappening: "If this keeps happening, send a note to your IT team \u2014 and let us know at support@audirie.com so we can help.",
        tryAgain: 'Try again',
        orgSignedInAsSomeoneElse: '{name} is signed in as someone else',
        differentAccountSignedIn: 'A different account is signed in',
        orgSignOnConnectedElsewhere: "Your organization\u2019s sign-on is still connected to another email address on this browser.",
        signOutCorporateFirst: 'Sign out of that corporate account first, then come back and try again with the email you want to use.',
        enterPassword: 'Enter your password',
        change: 'change',
        password: 'Password',
        forgotPassword: 'Forgot your password?',
        signIn: 'Sign in',
        resetPassword: 'Reset your password',
        wellEmailLink: "We\u2019ll email you a link to choose a new one.",
        send: 'Send',
        cancel: 'Cancel',
        emailRequired: 'Email is required',
        emailAndPasswordRequired: 'Email and password are required',
        emailNotFound: 'That email was not found.',
        passwordIncorrect: 'Your password is incorrect.',
        ssoUnavailable: 'Single Sign-On is currently unavailable. Please sign in with your password.',
        popupBlocked: 'Your browser blocked the sign-in window. Please allow pop-ups for this site, then refresh the page to continue.',
        couldNotLogIn: 'Unfortunately we could not log you in. Please reach out to support@audirie.com if the problem persists.',
        resetEmailSent: 'If the email address you gave is in our records, you will receive an email with a link to reset your password.',
        needValidEmail: 'Please give us a valid email.',
        mustRegisterFirst: 'You must register with Audirie before you can complete this task. If you do not have a registration link, contact us at support@audirie.com',
        couldNotResetPassword: 'We could not reset your password. Please try again. If this persists please contact us at support@audirie.com',
        maintenanceHeading: "We\u2019ll be right back",
        maintenanceDefaultBody: "We're doing a short maintenance update. Sign-in will be back shortly. Please try again in a few minutes.",
        maintenanceHint: "This is a planned update \u2014 your account and data are safe.",
        checkAgain: 'Check again',
        softOutageBody: "We\u2019re having trouble reaching the service right now. Please try again in a moment."
    }
};

});

parcelRegister("atZtl", function(module, exports) {
'use strict';
/**
 * US / Latin American Spanish (es-US).
 * Prefer Latin American vocabulary (e.g. email, celular-adjacent phrasing)
 * over Spain-specific forms. Keep keys identical to en-AU.js.
 */ module.exports = {
    login: {
        trustLine: "De la confianza de equipos en profesiones reguladas en todo el mundo \u2014 donde las conversaciones dif\xedciles importan.",
        pitchTitle: 'Conversaciones reales, antes de que lo sean.',
        pitchBody: "Practica las conversaciones dif\xedciles \u2014 la objeci\xf3n, el diagn\xf3stico, la mala noticia \u2014 y recibe feedback mientras a\xfan importa.",
        orgManagedSignIn: "El inicio de sesi\xf3n lo administra tu organizaci\xf3n.",
        orgOnAudirie: '{name} en Audirie',
        welcomeBack: 'Bienvenido de nuevo.',
        findYourWayIn: 'Vamos a encontrar tu acceso.',
        startWithWorkEmail: "Empieza con tu email de trabajo \u2014 te llevamos por el camino correcto.",
        workEmailTellsUs: "Tu email de trabajo nos indica c\xf3mo inicia sesi\xf3n tu organizaci\xf3n. No necesitas contrase\xf1a si usan inicio de sesi\xf3n \xfanico.",
        workEmail: "Direcci\xf3n de email",
        continue: 'Continuar',
        pickUpWhereLeftOff: "Contin\xfaa justo donde lo dejaste.",
        continueAs: 'Continuar como {email}',
        singleSignOn: "Inicio de sesi\xf3n \xfanico",
        singleSignOnWithOrg: "Inicio de sesi\xf3n \xfanico \xb7 {orgName}",
        audiriePassword: "Contrase\xf1a de Audirie",
        useDifferentAccount: 'Usar otra cuenta',
        oneMoment: "Un momento\u2026",
        checkingOrganisationSignIn: "Estamos revisando c\xf3mo inicia sesi\xf3n tu organizaci\xf3n.",
        whichOrgHeading: "\xbfCon cu\xe1l est\xe1s iniciando sesi\xf3n?",
        belongsToMultipleOrgs: "{email} pertenece a m\xe1s de una organizaci\xf3n en Audirie.",
        yourOrganisation: "Tu organizaci\xf3n",
        useDifferentEmail: 'Usar otro email',
        orgTakesItFromHere: "{name} se encarga desde aqu\xed",
        yourOrgTakesItFromHere: "Tu organizaci\xf3n se encarga desde aqu\xed",
        openingTheirSignIn: "Estamos abriendo su p\xe1gina de inicio de sesi\xf3n \u2014 terminas all\xed y vuelves aqu\xed. Nada de lo que ingreses en su p\xe1gina nos llega.",
        notYouStartAgain: "\xbfNo eres t\xfa? Empezar de nuevo",
        verifiedGettingReady: "Ya est\xe1s verificado. Preparando tu espacio de pr\xe1ctica.",
        orgSignInComplete: "El inicio de sesi\xf3n de {name} est\xe1 completo",
        accountNotReady: "Tu cuenta a\xfan no est\xe1 lista",
        ssoWorkedButNeedsSetup: "El inicio de sesi\xf3n \xfanico funcion\xf3, pero tu cuenta de Audirie a\xfan necesita configurarse antes de entrar.",
        noRoleAssigned: "Tu cuenta todav\xeda no tiene un rol asignado. Contacta al administrador de tu organizaci\xf3n.",
        backToLogin: "Volver al inicio de sesi\xf3n",
        orgDidntLetUsIn: "{name} no nos dej\xf3 entrar",
        couldntCompleteSso: "No pudimos completar el inicio de sesi\xf3n \xfanico",
        orgSignInDeclined: "El servicio de inicio de sesi\xf3n de tu organizaci\xf3n rechaz\xf3 la solicitud o no respondi\xf3. No hay nada mal con tu cuenta de Audirie.",
        ifKeepsHappening: "Si sigue pasando, avisa a tu equipo de IT \u2014 y escr\xedbenos a support@audirie.com para ayudarte.",
        tryAgain: 'Intentar de nuevo',
        orgSignedInAsSomeoneElse: "{name} tiene iniciada la sesi\xf3n de otra persona",
        differentAccountSignedIn: "Hay otra cuenta con sesi\xf3n iniciada",
        orgSignOnConnectedElsewhere: "El inicio de sesi\xf3n de tu organizaci\xf3n sigue conectado a otro email en este navegador.",
        signOutCorporateFirst: "Cierra primero la sesi\xf3n de esa cuenta corporativa, luego vuelve e int\xe9ntalo con el email que quieres usar.",
        enterPassword: "Ingresa tu contrase\xf1a",
        change: 'cambiar',
        password: "Contrase\xf1a",
        forgotPassword: "\xbfOlvidaste tu contrase\xf1a?",
        signIn: "Iniciar sesi\xf3n",
        resetPassword: "Restablecer tu contrase\xf1a",
        wellEmailLink: 'Te enviaremos un email con un enlace para elegir una nueva.',
        send: 'Enviar',
        cancel: 'Cancelar',
        emailRequired: 'El email es obligatorio',
        emailAndPasswordRequired: "El email y la contrase\xf1a son obligatorios",
        emailNotFound: 'No encontramos ese email.',
        passwordIncorrect: "Tu contrase\xf1a es incorrecta.",
        ssoUnavailable: "El inicio de sesi\xf3n \xfanico no est\xe1 disponible en este momento. Inicia sesi\xf3n con tu contrase\xf1a.",
        popupBlocked: "Tu navegador bloque\xf3 la ventana de inicio de sesi\xf3n. Permite ventanas emergentes en este sitio y luego actualiza la p\xe1gina para continuar.",
        couldNotLogIn: "Lamentablemente no pudimos iniciar tu sesi\xf3n. Escribe a support@audirie.com si el problema contin\xfaa.",
        resetEmailSent: "Si el email que indicaste est\xe1 en nuestros registros, recibir\xe1s un mensaje con un enlace para restablecer tu contrase\xf1a.",
        needValidEmail: "Indica un email v\xe1lido.",
        mustRegisterFirst: "Debes registrarte en Audirie antes de completar esta tarea. Si no tienes un enlace de registro, cont\xe1ctanos en support@audirie.com",
        couldNotResetPassword: "No pudimos restablecer tu contrase\xf1a. Int\xe9ntalo de nuevo. Si el problema contin\xfaa, cont\xe1ctanos en support@audirie.com"
    }
};

});

parcelRegister("56jMH", function(module, exports) {
'use strict';
/**
 * Spain Spanish (es-ES).
 * Iberian phrasing and vocabulary (correo electrónico, contraseña, etc.).
 * Keep keys identical to en-AU.js.
 */ module.exports = {
    login: {
        trustLine: "La confianza de equipos de profesiones reguladas en todo el mundo \u2014 all\xed donde las conversaciones dif\xedciles importan.",
        pitchTitle: 'Conversaciones reales, antes de que lo sean.',
        pitchBody: "Practica las conversaciones dif\xedciles \u2014 la objeci\xf3n, el diagn\xf3stico, la mala noticia \u2014 y recibe comentarios mientras a\xfan importan.",
        orgManagedSignIn: "El acceso lo gestiona tu organizaci\xf3n.",
        orgOnAudirie: '{name} en Audirie',
        welcomeBack: 'Bienvenido de nuevo.',
        findYourWayIn: 'Vamos a encontrar tu forma de acceso.',
        startWithWorkEmail: "Empieza con tu correo electr\xf3nico del trabajo \u2014 te llevaremos por el camino adecuado.",
        workEmailTellsUs: "Tu correo electr\xf3nico del trabajo nos indica c\xf3mo inicia sesi\xf3n tu organizaci\xf3n. No hace falta contrase\xf1a si utilizan el inicio de sesi\xf3n \xfanico.",
        workEmail: "Correo electr\xf3nico",
        continue: 'Continuar',
        pickUpWhereLeftOff: 'Retoma justo donde lo dejaste.',
        continueAs: 'Continuar como {email}',
        singleSignOn: "Inicio de sesi\xf3n \xfanico",
        singleSignOnWithOrg: "Inicio de sesi\xf3n \xfanico \xb7 {orgName}",
        audiriePassword: "Contrase\xf1a de Audirie",
        useDifferentAccount: 'Usar otra cuenta',
        oneMoment: "Un momento\u2026",
        checkingOrganisationSignIn: "Estamos comprobando c\xf3mo inicia sesi\xf3n tu organizaci\xf3n.",
        whichOrgHeading: "\xbfCon cu\xe1l vas a iniciar sesi\xf3n?",
        belongsToMultipleOrgs: "{email} pertenece a m\xe1s de una organizaci\xf3n en Audirie.",
        yourOrganisation: "Tu organizaci\xf3n",
        useDifferentEmail: "Usar otro correo electr\xf3nico",
        orgTakesItFromHere: "{name} se encarga a partir de aqu\xed",
        yourOrgTakesItFromHere: "Tu organizaci\xf3n se encarga a partir de aqu\xed",
        openingTheirSignIn: "Estamos abriendo su p\xe1gina de acceso \u2014 terminar\xe1s all\xed y volver\xe1s aqu\xed. Nada de lo que introduzcas en su p\xe1gina nos llega.",
        notYouStartAgain: "\xbfNo eres t\xfa? Empezar de nuevo",
        verifiedGettingReady: "Ya est\xe1s verificado. Preparando tu espacio de pr\xe1ctica.",
        orgSignInComplete: 'El acceso de {name} se ha completado',
        accountNotReady: "Tu cuenta a\xfan no est\xe1 lista",
        ssoWorkedButNeedsSetup: "El inicio de sesi\xf3n \xfanico ha funcionado, pero tu cuenta de Audirie a\xfan debe configurarse antes de poder entrar.",
        noRoleAssigned: "Tu cuenta todav\xeda no tiene un rol asignado. Contacta con el administrador de tu organizaci\xf3n.",
        backToLogin: "Volver al inicio de sesi\xf3n",
        orgDidntLetUsIn: '{name} no nos ha dejado entrar',
        couldntCompleteSso: "No hemos podido completar el inicio de sesi\xf3n \xfanico",
        orgSignInDeclined: "El servicio de acceso de tu organizaci\xf3n ha rechazado la solicitud o no ha respondido. No hay nada malo en tu cuenta de Audirie.",
        ifKeepsHappening: "Si sigue ocurriendo, avisa a tu equipo de TI \u2014 y escr\xedbenos a support@audirie.com para que podamos ayudarte.",
        tryAgain: 'Volver a intentarlo',
        orgSignedInAsSomeoneElse: "{name} tiene la sesi\xf3n iniciada con otra persona",
        differentAccountSignedIn: "Hay otra cuenta con la sesi\xf3n iniciada",
        orgSignOnConnectedElsewhere: "El acceso de tu organizaci\xf3n sigue conectado a otro correo electr\xf3nico en este navegador.",
        signOutCorporateFirst: "Cierra primero la sesi\xf3n de esa cuenta corporativa y, a continuaci\xf3n, vuelve e int\xe9ntalo con el correo que quieras usar.",
        enterPassword: "Introduce tu contrase\xf1a",
        change: 'cambiar',
        password: "Contrase\xf1a",
        forgotPassword: "\xbfHas olvidado tu contrase\xf1a?",
        signIn: "Iniciar sesi\xf3n",
        resetPassword: "Restablecer tu contrase\xf1a",
        wellEmailLink: 'Te enviaremos un correo con un enlace para elegir una nueva.',
        send: 'Enviar',
        cancel: 'Cancelar',
        emailRequired: "El correo electr\xf3nico es obligatorio",
        emailAndPasswordRequired: "El correo electr\xf3nico y la contrase\xf1a son obligatorios",
        emailNotFound: "No se ha encontrado ese correo electr\xf3nico.",
        passwordIncorrect: "Tu contrase\xf1a es incorrecta.",
        ssoUnavailable: "El inicio de sesi\xf3n \xfanico no est\xe1 disponible en este momento. Inicia sesi\xf3n con tu contrase\xf1a.",
        popupBlocked: "Tu navegador ha bloqueado la ventana de acceso. Permite las ventanas emergentes en este sitio y, despu\xe9s, actualiza la p\xe1gina para continuar.",
        couldNotLogIn: "Lamentablemente no hemos podido iniciar tu sesi\xf3n. Escribe a support@audirie.com si el problema persiste.",
        resetEmailSent: "Si el correo electr\xf3nico que has facilitado figura en nuestros registros, recibir\xe1s un mensaje con un enlace para restablecer tu contrase\xf1a.",
        needValidEmail: "Facil\xedtanos un correo electr\xf3nico v\xe1lido.",
        mustRegisterFirst: 'Debes registrarte en Audirie antes de poder completar esta tarea. Si no dispones de un enlace de registro, contacta con nosotros en support@audirie.com',
        couldNotResetPassword: "No hemos podido restablecer tu contrase\xf1a. Int\xe9ntalo de nuevo. Si el problema persiste, contacta con nosotros en support@audirie.com"
    }
};

});

parcelRegister("5EbMB", function(module, exports) {
'use strict';
/**
 * German (de-DE) — also used for de-AT / de-CH via language fallback.
 * Keep keys identical to en-AU.js.
 */ module.exports = {
    login: {
        trustLine: "Das Vertrauen von Teams in regulierten Berufen weltweit \u2014 \xfcberall dort, wo schwierige Gespr\xe4che z\xe4hlen.",
        pitchTitle: "Echte Gespr\xe4che, bevor sie echt sind.",
        pitchBody: "\xdcben Sie die schwierigen Gespr\xe4che \u2014 den Einwand, die Diagnose, die schlechte Nachricht \u2014 und erhalten Sie Feedback, solange es noch z\xe4hlt.",
        orgManagedSignIn: 'Die Anmeldung wird von Ihrer Organisation verwaltet.',
        orgOnAudirie: '{name} auf Audirie',
        welcomeBack: "Willkommen zur\xfcck.",
        findYourWayIn: 'Lassen Sie uns Ihren Zugang finden.',
        startWithWorkEmail: "Beginnen Sie mit Ihrer dienstlichen E-Mail \u2014 wir f\xfchren Sie den richtigen Weg.",
        workEmailTellsUs: "Ihre dienstliche E-Mail zeigt uns, wie sich Ihre Organisation anmeldet. Kein Passwort n\xf6tig, wenn Single Sign-On genutzt wird.",
        workEmail: 'E-Mail-Adresse',
        continue: 'Weiter',
        pickUpWhereLeftOff: "Machen Sie genau dort weiter, wo Sie aufgeh\xf6rt haben.",
        continueAs: 'Fortfahren als {email}',
        singleSignOn: 'Single Sign-On',
        singleSignOnWithOrg: "Single Sign-On \xb7 {orgName}",
        audiriePassword: 'Audirie-Passwort',
        useDifferentAccount: 'Anderes Konto verwenden',
        oneMoment: "Einen Moment\u2026",
        checkingOrganisationSignIn: "Wir pr\xfcfen, wie sich Ihre Organisation anmeldet.",
        whichOrgHeading: 'Als welche Organisation melden Sie sich an?',
        belongsToMultipleOrgs: "{email} geh\xf6rt zu mehr als einer Organisation auf Audirie.",
        yourOrganisation: 'Ihre Organisation',
        useDifferentEmail: 'Andere E-Mail verwenden',
        orgTakesItFromHere: "{name} \xfcbernimmt ab hier",
        yourOrgTakesItFromHere: "Ihre Organisation \xfcbernimmt ab hier",
        openingTheirSignIn: "Wir \xf6ffnen deren Anmeldeseite \u2014 Sie schlie\xdfen dort ab und kommen direkt zur\xfcck. Nichts, was Sie dort eingeben, erreicht uns.",
        notYouStartAgain: 'Nicht Sie? Neu starten',
        verifiedGettingReady: "Sie sind verifiziert. Ihr \xdcbungsbereich wird vorbereitet.",
        orgSignInComplete: 'Anmeldung bei {name} abgeschlossen',
        accountNotReady: 'Ihr Konto ist noch nicht bereit',
        ssoWorkedButNeedsSetup: "Single Sign-On hat funktioniert, aber Ihr Audirie-Konto muss noch eingerichtet werden, bevor Sie eintreten k\xf6nnen.",
        noRoleAssigned: 'Ihrem Konto ist noch keine Rolle zugewiesen. Bitte wenden Sie sich an den Administrator Ihrer Organisation.',
        backToLogin: "Zur\xfcck zur Anmeldung",
        orgDidntLetUsIn: '{name} hat uns nicht hereinlassen',
        couldntCompleteSso: 'Single Sign-On konnte nicht abgeschlossen werden',
        orgSignInDeclined: 'Der Anmeldedienst Ihrer Organisation hat die Anfrage abgelehnt oder nicht geantwortet. Mit Ihrem Audirie-Konto ist alles in Ordnung.',
        ifKeepsHappening: "Wenn das weiterhin passiert, informieren Sie Ihr IT-Team \u2014 und schreiben Sie uns an support@audirie.com, damit wir helfen k\xf6nnen.",
        tryAgain: 'Erneut versuchen',
        orgSignedInAsSomeoneElse: '{name} ist mit einem anderen Konto angemeldet',
        differentAccountSignedIn: 'Ein anderes Konto ist angemeldet',
        orgSignOnConnectedElsewhere: 'Die Anmeldung Ihrer Organisation ist in diesem Browser noch mit einer anderen E-Mail verbunden.',
        signOutCorporateFirst: "Melden Sie sich zuerst von diesem Unternehmenskonto ab und versuchen Sie es dann erneut mit der gew\xfcnschten E-Mail.",
        enterPassword: 'Geben Sie Ihr Passwort ein',
        change: "\xe4ndern",
        password: 'Passwort',
        forgotPassword: 'Passwort vergessen?',
        signIn: 'Anmelden',
        resetPassword: "Passwort zur\xfccksetzen",
        wellEmailLink: "Wir senden Ihnen einen Link per E-Mail, um ein neues zu w\xe4hlen.",
        send: 'Senden',
        cancel: 'Abbrechen',
        emailRequired: 'E-Mail ist erforderlich',
        emailAndPasswordRequired: 'E-Mail und Passwort sind erforderlich',
        emailNotFound: 'Diese E-Mail wurde nicht gefunden.',
        passwordIncorrect: 'Ihr Passwort ist falsch.',
        ssoUnavailable: "Single Sign-On ist derzeit nicht verf\xfcgbar. Bitte melden Sie sich mit Ihrem Passwort an.",
        popupBlocked: "Ihr Browser hat das Anmeldefenster blockiert. Erlauben Sie Pop-ups f\xfcr diese Website und aktualisieren Sie dann die Seite, um fortzufahren.",
        couldNotLogIn: 'Leider konnten wir Sie nicht anmelden. Schreiben Sie an support@audirie.com, wenn das Problem weiterhin besteht.',
        resetEmailSent: "Wenn die angegebene E-Mail-Adresse in unseren Unterlagen ist, erhalten Sie eine E-Mail mit einem Link zum Zur\xfccksetzen Ihres Passworts.",
        needValidEmail: "Bitte geben Sie eine g\xfcltige E-Mail-Adresse an.",
        mustRegisterFirst: "Sie m\xfcssen sich bei Audirie registrieren, bevor Sie diese Aufgabe abschlie\xdfen k\xf6nnen. Wenn Sie keinen Registrierungslink haben, kontaktieren Sie uns unter support@audirie.com",
        couldNotResetPassword: "Wir konnten Ihr Passwort nicht zur\xfccksetzen. Bitte versuchen Sie es erneut. Wenn das Problem weiterhin besteht, kontaktieren Sie uns unter support@audirie.com"
    }
};

});





var $cRQVA = parcelRequire("cRQVA");
parcelRequire("cBna0");

var $hatoH = parcelRequire("hatoH");

var $cRQVA = parcelRequire("cRQVA");
parcelRequire("cV1mW");
var $gksg3 = parcelRequire("gksg3");
parcelRequire("cBna0");

var $dfdi6 = parcelRequire("dfdi6");

var $3oOJ6 = parcelRequire("3oOJ6");

var $cRQVA = parcelRequire("cRQVA");

var $3oOJ6 = parcelRequire("3oOJ6");
class $27df32bc1535385a$export$2e2bcd8739ae039 extends (0, $3oOJ6.default) {
    constructor(props){
        super(props);
        this.state = {
            show: false
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.error !== this.props.error || prevProps.statusCode !== this.props.statusCode) this.setState({
            show: this.props.error && this.props.statusCode
        });
    }
    render() {
        return this.state.show ? /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
            className: "toast",
            style: {
                opacity: this.props.error && this.props.statusCode ? '1' : '0'
            },
            role: "alert",
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
                    className: "toast-header",
                    children: [
                        /*#__PURE__*/ (0, $cRQVA.jsx)("strong", {
                            className: "mr-auto",
                            style: {
                                backgroundColor: 'rgba(249, 249, 249, 1)'
                            },
                            children: "Error"
                        }),
                        /*#__PURE__*/ (0, $cRQVA.jsx)("button", {
                            type: "button",
                            className: "ml-2 mb-1 close",
                            children: /*#__PURE__*/ (0, $cRQVA.jsx)("span", {
                                "aria-hidden": "true",
                                onClick: ()=>{
                                    this.setState({
                                        show: false
                                    });
                                },
                                children: "\xd7"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                    className: "toast-body",
                    style: {
                        color: 'red',
                        backgroundColor: 'white'
                    },
                    children: this.props.error && this.props.statusCode == 404 ? /*#__PURE__*/ (0, $cRQVA.jsxs)("p", {
                        className: "mb-0",
                        children: [
                            "You must register with Audirie before you can complete this task. If you do not have a registration link, contact us at ",
                            /*#__PURE__*/ (0, $cRQVA.jsx)("a", {
                                href: "mailto:support@audirie.com",
                                children: "support@audirie.com"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                        className: "mb-0",
                        children: "An error has occurred. Please attempt to login with your details."
                    })
                })
            ]
        }) : '';
    }
}
$27df32bc1535385a$export$2e2bcd8739ae039.defaultProps = {
    error: false,
    statusCode: 0
};



var $4uQJZ = parcelRequire("4uQJZ");

var $kzXQB = parcelRequire("kzXQB");

var $7bAQD = parcelRequire("7bAQD");
var $e1892cc9c1071826$exports = {};
'use strict';
/**
 * Normalises the `/api/sso/provider` response into a list of sign-in options.
 *
 * Newer Alpha returns `{ providerId, providers: [{ providerId, orgId, orgName }] }`;
 * older Alpha returns only `{ providerId }`. Either way the login screen wants
 * an array: empty → password sign-in, one entry → straight to SSO handoff,
 * several → let the user pick their organisation.
 */ const $e1892cc9c1071826$var$normaliseProviderOptions = (data)=>{
    if (Array.isArray(data?.providers) && data.providers.length > 0) return data.providers.filter((provider)=>provider && provider.providerId).map((provider)=>({
            providerId: provider.providerId,
            orgId: provider.orgId || null,
            orgName: provider.orgName || null
        }));
    if (data?.providerId) return [
        {
            providerId: data.providerId,
            orgId: null,
            orgName: null
        }
    ];
    return [];
};
$e1892cc9c1071826$exports = {
    normaliseProviderOptions: $e1892cc9c1071826$var$normaliseProviderOptions
};



var $1MWwR = parcelRequire("1MWwR");
var $3d7514a69204b3c4$export$9451fc784c9011a4;
var $3d7514a69204b3c4$export$3697b48029c17a5d;
var $3d7514a69204b3c4$export$d3a76d64cf610c16;
var $3d7514a69204b3c4$export$e95a3fb5b4fd10d1;
var $3d7514a69204b3c4$export$6ae8f499ba5140b6;
var $3d7514a69204b3c4$export$899dee181c955b;
var $3d7514a69204b3c4$export$4a5c8fd41d651ea9;
/**
 * True when both emails are present and differ. Missing either side means we
 * cannot compare (e.g. enrollment with no typed email, or IdP omitted email),
 * so we do not reject.
 */ var $3d7514a69204b3c4$export$c40f0ddd94b76141;
'use strict';
const $3d7514a69204b3c4$var$PENDING_SSO_KEY = 'audirie.pendingSso';
const $3d7514a69204b3c4$var$parsePendingSso = (raw)=>{
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (err) {
        return null;
    }
};
$3d7514a69204b3c4$export$9451fc784c9011a4 = $3d7514a69204b3c4$var$PENDING_SSO_KEY;
$3d7514a69204b3c4$export$3697b48029c17a5d = ()=>{
    try {
        return $3d7514a69204b3c4$var$parsePendingSso(window.sessionStorage.getItem($3d7514a69204b3c4$var$PENDING_SSO_KEY));
    } catch (err) {
        return null;
    }
};
$3d7514a69204b3c4$export$d3a76d64cf610c16 = ()=>{
    try {
        const pending = $3d7514a69204b3c4$var$parsePendingSso(window.sessionStorage.getItem($3d7514a69204b3c4$var$PENDING_SSO_KEY));
        window.sessionStorage.removeItem($3d7514a69204b3c4$var$PENDING_SSO_KEY);
        return pending;
    } catch (err) {
        return null;
    }
};
$3d7514a69204b3c4$export$e95a3fb5b4fd10d1 = (provider)=>{
    try {
        window.sessionStorage.setItem($3d7514a69204b3c4$var$PENDING_SSO_KEY, JSON.stringify(provider));
    } catch (err) {}
};
$3d7514a69204b3c4$export$6ae8f499ba5140b6 = ()=>{
    try {
        window.sessionStorage.removeItem($3d7514a69204b3c4$var$PENDING_SSO_KEY);
    } catch (err) {}
};
$3d7514a69204b3c4$export$899dee181c955b = (err, fallback = 'Login Failed')=>{
    const data = err?.response?.data;
    if (data && typeof data.message === 'string' && data.message.trim()) return data.message;
    if (typeof data === 'string' && data.trim()) return data;
    if (err?.response?.status === 401) return 'Invalid password';
    return fallback;
};
$3d7514a69204b3c4$export$4a5c8fd41d651ea9 = (email)=>{
    if (typeof email !== 'string') return '';
    return email.trim().toLowerCase();
};
$3d7514a69204b3c4$export$c40f0ddd94b76141 = (intendedEmail, assertedEmail)=>{
    const intended = $3d7514a69204b3c4$export$4a5c8fd41d651ea9(intendedEmail);
    const asserted = $3d7514a69204b3c4$export$4a5c8fd41d651ea9(assertedEmail);
    if (!intended || !asserted) return false;
    return intended !== asserted;
};



var $4JUhT = parcelRequire("4JUhT");
const $a9b75c9477f987d6$var$internals = {};
const $a9b75c9477f987d6$var$SSO_REDIRECT_DELAY_MS = (0, $4JUhT.getRuntimeConfig)().deploymentTier === 'production' ? 0 : 5000;
// The "One moment…" spinner only paints if the lookup takes longer than this…
const $a9b75c9477f987d6$var$LOOKUP_SPINNER_AFTER_MS = 400;
// …and once painted it stays up to a fixed floor, so known and unknown
// addresses are indistinguishable from timing alone.
const $a9b75c9477f987d6$var$LOOKUP_FLOOR_MS = 1200;
// A slow lookup falls through to the password step rather than an error.
const $a9b75c9477f987d6$var$LOOKUP_TIMEOUT_MS = 3000;
const $a9b75c9477f987d6$var$SEEN_FLAG = 'audirie.seenLogin';
// Enrollment handle (+ optional destination) from a /enroll link. Stored in
// sessionStorage so it survives the SSO redirect round trip, consumed when
// the login API call resolves (success or failure).
const $a9b75c9477f987d6$var$PENDING_ENROLLMENT_KEY = 'pendingEnrollment';
// Safe `next` deep-link path, honoured for all logins after sign-in. Same
// round-trip survival pattern as pendingEnrollment.
const $a9b75c9477f987d6$var$PENDING_NEXT_KEY = 'audirie.pendingNext';
const $a9b75c9477f987d6$var$readPendingEnrollment = ()=>{
    try {
        const raw = window.sessionStorage.getItem($a9b75c9477f987d6$var$PENDING_ENROLLMENT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
};
const $a9b75c9477f987d6$var$storePendingEnrollment = (enrollment)=>{
    try {
        window.sessionStorage.setItem($a9b75c9477f987d6$var$PENDING_ENROLLMENT_KEY, JSON.stringify(enrollment));
    } catch (err) {}
};
const $a9b75c9477f987d6$var$clearPendingEnrollment = ()=>{
    try {
        window.sessionStorage.removeItem($a9b75c9477f987d6$var$PENDING_ENROLLMENT_KEY);
    } catch (err) {}
};
const $a9b75c9477f987d6$var$storePendingNext = (path)=>{
    try {
        window.sessionStorage.setItem($a9b75c9477f987d6$var$PENDING_NEXT_KEY, path);
    } catch (err) {}
};
const $a9b75c9477f987d6$var$takePendingNext = ()=>{
    try {
        const raw = window.sessionStorage.getItem($a9b75c9477f987d6$var$PENDING_NEXT_KEY);
        window.sessionStorage.removeItem($a9b75c9477f987d6$var$PENDING_NEXT_KEY);
        // Re-validate on the way out — sessionStorage is not a trust boundary.
        return (0, $4uQJZ.sanitizeNextPath)(raw);
    } catch (err) {
        return null;
    }
};
const $a9b75c9477f987d6$var$ENROLL_ERROR_MESSAGES = {
    EXPIRED: 'This enrollment link has expired. Ask your administrator for a new one.',
    CAP_EXCEEDED: 'This enrollment link is no longer available.',
    RULE_DISABLED: 'This enrollment link is no longer available.',
    VERIFY_INVALID: 'This confirmation link is invalid or was already used. Open the enrollment page again to request a new email.',
    VERIFY_EXPIRED: 'This confirmation link has expired. Open the enrollment page again to request a new email.',
    LOGIN_FAILED: 'We confirmed your email but could not sign you in automatically. Sign in below, or request a new confirmation email from the enrollment page.',
    REVOKED: 'This enrollment link has been revoked. Ask your administrator for a new one.'
};
const $a9b75c9477f987d6$var$ENROLL_ERROR_DEFAULT = 'This enrollment link is not valid.';
$a9b75c9477f987d6$var$internals.loginRules = (0, (/*@__PURE__*/$parcel$interopDefault($dfdi6))).object({
    email: (0, (/*@__PURE__*/$parcel$interopDefault($dfdi6))).string().min(1),
    password: (0, (/*@__PURE__*/$parcel$interopDefault($dfdi6))).string().min(1)
});
class $a9b75c9477f987d6$export$2e2bcd8739ae039 extends (0, $3oOJ6.default) {
    constructor(props){
        super(props);
        const pendingSsoReturn = (0, $3d7514a69204b3c4$export$3697b48029c17a5d)();
        this.pendingSso = pendingSsoReturn;
        this.state = {
            login: {
                email: '',
                password: ''
            },
            redirect: {
                error: false,
                statusCode: 0
            },
            pwreset: false,
            mode: pendingSsoReturn ? 'returning' : 'email',
            errs: null,
            saving: !!pendingSsoReturn,
            seenBefore: false,
            multiFactorResolver: null,
            ssoProviderId: null,
            providers: [],
            org: pendingSsoReturn?.orgName ? {
                name: pendingSsoReturn.orgName
            } : null,
            hint: null,
            accountBlockMessage: null,
            enrollError: null,
            platformStatus: null,
            statusChecking: false
        };
        this.login = this.login.bind(this);
        this.resolveSsoProvider = this.resolveSsoProvider.bind(this);
        this.beginSsoSignIn = this.beginSsoSignIn.bind(this);
        this.firebaseAuthentication = this.firebaseAuthentication.bind(this);
        this.updateInput = this.updateInput.bind(this);
        this.resetPW = this.resetPW.bind(this);
        this.pickProvider = this.pickProvider.bind(this);
        this.resetToEmail = this.resetToEmail.bind(this);
        this.continueAsHint = this.continueAsHint.bind(this);
        this.useDifferentAccount = this.useDifferentAccount.bind(this);
        this.completeSsoCredential = this.completeSsoCredential.bind(this);
        this.refreshPlatformStatus = this.refreshPlatformStatus.bind(this);
    }
    async refreshPlatformStatus() {
        this.setState({
            statusChecking: true
        });
        try {
            const { data: data } = await (0, $gksg3.default).get('/api/status', {
                timeout: 8000
            });
            this.setState({
                platformStatus: {
                    maintenanceEnabled: !!data?.maintenance?.enabled,
                    maintenanceMessage: data?.maintenance?.message || null,
                    coreOk: data?.core?.ok !== false
                },
                statusChecking: false
            });
        } catch (err) {
            // Leave prior status if any; don't invent a Core outage from a status fetch blip.
            this.setState({
                statusChecking: false
            });
        }
    }
    async componentDidMount() {
        // Platform status first so maintenance can short-circuit the login flow.
        this.refreshPlatformStatus();
        const urlParams = new URLSearchParams(window.location.search);
        const [error, status] = [
            urlParams.get('error'),
            urlParams.get('status')
        ];
        if (error && status) this.setState({
            redirect: {
                error: error,
                statusCode: status
            }
        });
        // Deep link: remember a safe `next` for after sign-in (all login types).
        const nextPath = (0, $4uQJZ.sanitizeNextPath)(urlParams.get('next'));
        if (nextPath) $a9b75c9477f987d6$var$storePendingNext(nextPath);
        // A /enroll link that failed validation lands here with an error code.
        const enrollError = urlParams.get('enrollError');
        if (enrollError) this.setState({
            enrollError: enrollError
        });
        // A validated /enroll link lands here with a handle + SSO provider (SAML or OIDC).
        const enrollHandle = urlParams.get('enroll');
        const enrollProviderId = urlParams.get('provider');
        let enrollment = null;
        if (enrollHandle && enrollProviderId) {
            let dest = null;
            try {
                dest = urlParams.get('dest') ? JSON.parse(urlParams.get('dest')) : null;
            } catch (err) {}
            enrollment = {
                handle: enrollHandle,
                providerId: enrollProviderId,
                dest: dest
            };
            $a9b75c9477f987d6$var$storePendingEnrollment({
                handle: enrollHandle,
                dest: dest
            });
        }
        let seenBefore = false;
        try {
            seenBefore = !!(window.localStorage.getItem($a9b75c9477f987d6$var$SEEN_FLAG) || window.localStorage.getItem('loginType'));
        } catch (err) {}
        this.setState({
            seenBefore: seenBefore
        });
        try {
            const firebaseResponse = await (0, $kzXQB.getSsoRedirectResult)();
            if (firebaseResponse?.type === 'credential') {
                this.pendingSso = (0, $3d7514a69204b3c4$export$d3a76d64cf610c16)() || this.pendingSso;
                this.setState({
                    mode: 'returning',
                    saving: true,
                    org: this.pendingSso?.orgName ? {
                        name: this.pendingSso.orgName
                    } : null,
                    accountBlockMessage: null,
                    login: this.pendingSso?.email ? {
                        ...this.state.login,
                        email: this.pendingSso.email
                    } : this.state.login
                });
                await this.completeSsoCredential(firebaseResponse.data.user);
                return;
            }
            if (firebaseResponse?.type === 'providerNotFound') {
                (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
                this.setState({
                    mode: 'sso-failed',
                    saving: false
                });
                return;
            }
            if (this.pendingSso) {
                (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
                this.pendingSso = null;
                this.setState({
                    mode: 'sso-failed',
                    saving: false,
                    org: null
                });
                return;
            }
        } catch (err) {
            console.error('Unable to complete SSO sign-in.', err);
            (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
            this.pendingSso = null;
            this.setState({
                mode: 'sso-failed',
                saving: false
            });
            return;
        }
        // Fresh enrollment link (not the redirect-return leg, handled above):
        // skip the email/password steps and go straight to the organisation's
        // IdP sign-in (SAML or OIDC) via the normal SSO handoff.
        if (enrollment) {
            this.pickProvider({
                providerId: enrollment.providerId,
                orgId: null,
                orgName: null
            });
            return;
        }
        this.loadLoginHint();
    }
    async loadLoginHint() {
        try {
            const { data: data } = await (0, $gksg3.default).get('/api/login/hint');
            if (!data?.email || this.state.mode !== 'email') return;
            this.setState({
                hint: data,
                mode: 'continue-as',
                login: {
                    ...this.state.login,
                    email: data.email
                },
                org: data.method === 'sso' && data.orgName ? {
                    name: data.orgName,
                    blurb: 'You\u2019ve signed in on this device before.'
                } : null
            });
        } catch (err) {}
    }
    markSeen() {
        try {
            window.localStorage.setItem($a9b75c9477f987d6$var$SEEN_FLAG, '1');
        } catch (err) {}
    }
    async login(user) {
        // Firebase is the only login path: the session call always carries a
        // Firebase ID token. The former raw email+password fallback was removed
        // (Alpha no longer accepts it) — never send a password to /api/login.
        if (!user?.accessToken) {
            this.setState({
                errs: 'Invalid password',
                saving: false,
                mode: 'login'
            });
            return;
        }
        const loginType = 'firebase';
        const loginPayload = {
            firebaseToken: user.accessToken
        };
        // Routing metadata for the "Continue as" hint cookie; Connect strips it
        // before proxying the session call and pairs it with the verified email.
        loginPayload.hint = this.pendingSso ? {
            method: 'sso',
            providerId: this.pendingSso.providerId,
            orgName: this.pendingSso.orgName
        } : {
            method: 'password'
        };
        // Auto-enrollment: hand the validated handle to Alpha with the session
        // call; Alpha performs the actual enrollment server-side.
        const pendingEnrollment = $a9b75c9477f987d6$var$readPendingEnrollment();
        if (typeof pendingEnrollment?.handle === 'string' && pendingEnrollment.handle) loginPayload.enrollmentHandle = pendingEnrollment.handle;
        (0, $gksg3.default).post('/api/login', loginPayload).then(({ data: data })=>{
            $a9b75c9477f987d6$var$clearPendingEnrollment();
            window.localStorage.setItem('loginType', loginType);
            (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
            this.markSeen();
            this.setState({
                saving: false
            });
            this.identify(data.userId, data);
            if (this.loginStartTime) {
                const timeTaken = new Date().getTime() - this.loginStartTime.getTime();
                console.log(`[Login] Time to login: ${timeTaken} ms`);
                this.track('User Event Timed', {
                    userEvent: 'login',
                    timeTakenMs: timeTaken
                });
            }
            window.location = this.resolvePostLoginPath(data, pendingEnrollment);
        }).catch((err)=>{
            $a9b75c9477f987d6$var$clearPendingEnrollment();
            console.error(err);
            const message = (0, $3d7514a69204b3c4$export$899dee181c955b)(err);
            const status = err.response?.status;
            const wasSsoReturn = this.state.mode === 'returning' || !!this.pendingSso;
            let failedMode = this.state.mode;
            if (wasSsoReturn) failedMode = status === 403 ? 'sso-account-blocked' : 'sso-failed';
            this.setState({
                errs: message,
                accountBlockMessage: status === 403 ? message : null,
                saving: false,
                mode: failedMode
            });
        });
    }
    /**
   * Where to land after a successful login, in priority order:
   * (1) a safe `next` deep link, (2) the enrollment destination — from
   * Alpha's login response or the stored enrollment — mapped to the page
   * the dashboard uses to open a simulation, (3) the dashboard.
   */ resolvePostLoginPath(data, pendingEnrollment) {
        const nextPath = $a9b75c9477f987d6$var$takePendingNext();
        if (nextPath) return nextPath;
        const destination = data?.enrollment?.destination || pendingEnrollment?.dest || null;
        const destinationPath = (0, $4uQJZ.destinationToPath)(destination);
        if (destinationPath) return destinationPath;
        return '/';
    }
    async firebaseAuthentication(e) {
        e.preventDefault();
        this.pendingSso = null;
        this.loginStartTime = new Date();
        const valErrs = $a9b75c9477f987d6$var$internals.loginRules.validate(this.state.login);
        if (valErrs.error) return this.setState({
            errs: 'form required'
        });
        this.setState({
            saving: true,
            errs: null
        });
        const firebaseResponse = await (0, $kzXQB.signInToFirebase)(this.state.login.email, this.state.login.password);
        // Firebase was temporarily unavailable (e.g. rate-limited). Do NOT fall
        // back to the raw password path — for Firebase-managed accounts that
        // returns a misleading "password is incorrect". Ask the user to retry.
        if (firebaseResponse?.type === 'transientError') {
            console.warn(`[Login] Firebase sign-in temporarily unavailable: ${firebaseResponse.code}`);
            this.setState({
                saving: false,
                mode: 'login',
                errs: 'Login temporarily unavailable. Please try again.'
            });
            return;
        }
        // Firebase rejected the credentials (wrong password / unknown account).
        // There is no server-side password fallback any more, so report it here.
        if (!firebaseResponse) {
            this.setState({
                saving: false,
                mode: 'login',
                errs: 'Invalid password'
            });
            return;
        }
        switch(firebaseResponse.type){
            case 'multiFactor':
                this.setState({
                    saving: false,
                    mode: 'mfa',
                    multiFactorResolver: firebaseResponse.data
                });
                break;
            case 'credential':
                this.login(firebaseResponse.data?.user || {});
                break;
            default:
                console.log('Unexpected response type');
        }
    }
    async resolveSsoProvider(e) {
        e.preventDefault();
        const email = this.state.login.email;
        if (!email) {
            this.setState({
                errs: 'form required'
            });
            return;
        }
        this.lookupAndRoute(email);
    }
    continueAsHint() {
        // The hint renders instantly but never routes on its own: the lookup at
        // click time is the source of truth, with the remembered provider only
        // used to skip the picker when it's still valid.
        this.lookupAndRoute(this.state.hint.email, this.state.hint.providerId);
    }
    useDifferentAccount() {
        (0, $gksg3.default).delete('/api/login/hint').catch(()=>{});
        this.setState({
            hint: null
        });
        this.resetToEmail();
    }
    async lookupAndRoute(email, preferredProviderId) {
        this.loginStartTime = new Date();
        this.setState({
            saving: true,
            errs: null
        });
        const started = Date.now();
        const spinnerTimer = window.setTimeout(()=>this.setState({
                mode: 'detecting'
            }), $a9b75c9477f987d6$var$LOOKUP_SPINNER_AFTER_MS);
        const routeWhenPadded = (route)=>{
            const elapsed = Date.now() - started;
            const pad = elapsed > $a9b75c9477f987d6$var$LOOKUP_SPINNER_AFTER_MS ? Math.max(0, $a9b75c9477f987d6$var$LOOKUP_FLOOR_MS - elapsed) : 0;
            window.setTimeout(route, pad);
        };
        try {
            const { data: data } = await (0, $gksg3.default).post('/api/sso/provider', {
                email: email
            }, {
                timeout: $a9b75c9477f987d6$var$LOOKUP_TIMEOUT_MS
            });
            window.clearTimeout(spinnerTimer);
            routeWhenPadded(()=>this.routeFromLookup(data, preferredProviderId));
        } catch (err) {
            window.clearTimeout(spinnerTimer);
            if (err.response?.status === 404 || err.code === 'ECONNABORTED') {
                routeWhenPadded(()=>this.setState({
                        mode: 'login',
                        saving: false,
                        org: null
                    }));
                return;
            }
            console.error('Unable to start SSO sign-in.', err);
            routeWhenPadded(()=>this.setState({
                    mode: 'login',
                    errs: null,
                    saving: false,
                    org: null
                }));
        }
    }
    routeFromLookup(data, preferredProviderId) {
        const providers = (0, $e1892cc9c1071826$exports.normaliseProviderOptions)(data);
        if (providers.length === 0) {
            this.setState({
                mode: 'login',
                saving: false,
                org: null,
                providers: []
            });
            return;
        }
        const preferred = preferredProviderId && providers.find((provider)=>provider.providerId === preferredProviderId);
        if (preferred) {
            this.pickProvider(preferred);
            return;
        }
        if (providers.length === 1) {
            this.pickProvider(providers[0]);
            return;
        }
        this.setState({
            mode: 'picker',
            saving: false,
            providers: providers,
            org: null
        });
    }
    pickProvider(provider) {
        const pending = {
            ...provider,
            email: this.state.login.email || null
        };
        this.pendingSso = pending;
        (0, $3d7514a69204b3c4$export$e95a3fb5b4fd10d1)(pending);
        this.setState({
            mode: 'sso',
            ssoProviderId: provider.providerId,
            org: provider.orgName ? {
                name: provider.orgName
            } : null,
            saving: false
        }, ()=>{
            window.setTimeout(this.beginSsoSignIn, $a9b75c9477f987d6$var$SSO_REDIRECT_DELAY_MS);
        });
    }
    async completeSsoCredential(user) {
        const intendedEmail = this.pendingSso?.email || this.state.login.email;
        if ((0, $3d7514a69204b3c4$export$c40f0ddd94b76141)(intendedEmail, user?.email)) {
            (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
            this.pendingSso = null;
            try {
                await (0, $kzXQB.signOutOfFirebase)();
            } catch (err) {
                console.warn('Firebase sign-out failed after SSO email mismatch.', err);
            }
            this.setState({
                mode: 'sso-email-mismatch',
                saving: false
            });
            return;
        }
        this.login(user);
    }
    async beginSsoSignIn() {
        this.setState({
            saving: true
        });
        try {
            const firebaseResponse = await (0, $kzXQB.signInWithSso)(this.state.ssoProviderId);
            if (firebaseResponse?.type === 'credential') {
                this.setState({
                    mode: 'returning'
                });
                await this.completeSsoCredential(firebaseResponse.data.user);
            }
            if (firebaseResponse?.type === 'providerNotFound') this.setState({
                mode: 'sso-failed',
                saving: false
            });
            if (firebaseResponse?.type === 'popupBlocked') this.setState({
                mode: 'sso',
                errs: 'popup blocked',
                saving: false
            });
        } catch (err) {
            console.error('Unable to start SSO sign-in.', err);
            this.setState({
                mode: 'sso-failed',
                saving: false
            });
        }
    }
    resetPW(e) {
        e.preventDefault();
        if (!this.state.login.email) {
            this.setState({
                pwreset: 'need email'
            });
            return;
        }
        this.setState({
            saving: true
        });
        (0, $gksg3.default).post('/api/pwreset', this.state.login).then(()=>{
            this.setState({
                pwreset: 'sent',
                saving: false,
                login: {
                    email: '',
                    password: ''
                }
            });
        }).catch((err)=>{
            console.log('An error occurred while resetting the password');
            this.setState({
                pwreset: err.response.data,
                saving: false
            });
        });
    }
    updateInput(e) {
        const login = {
            ...this.state.login,
            [e.target.name]: e.target.value
        };
        this.setState({
            login: login,
            errs: null
        });
    }
    resetToEmail() {
        this.pendingSso = null;
        (0, $3d7514a69204b3c4$export$6ae8f499ba5140b6)();
        this.setState({
            mode: 'email',
            errs: null,
            accountBlockMessage: null,
            saving: false,
            org: null,
            providers: [],
            ssoProviderId: null,
            login: {
                email: '',
                password: ''
            }
        });
    }
    renderLoginContent() {
        const { accountBlockMessage: accountBlockMessage, errs: errs, hint: hint, login: login, mode: mode, multiFactorResolver: multiFactorResolver, org: org, platformStatus: platformStatus, providers: providers, pwreset: pwreset, saving: saving, seenBefore: seenBefore, statusChecking: statusChecking } = this.state;
        if (platformStatus?.maintenanceEnabled) return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.MaintenanceStep), {
            message: platformStatus.maintenanceMessage,
            checking: statusChecking,
            onCheckAgain: this.refreshPlatformStatus
        });
        const softOutage = platformStatus && platformStatus.coreOk === false;
        const softBanner = softOutage ? /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.SoftOutageBanner), {}) : null;
        switch(mode){
            case 'continue-as':
                return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
                    children: [
                        softBanner,
                        /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.ContinueAsStep), {
                            hint: hint,
                            onContinue: this.continueAsHint,
                            onDifferent: this.useDifferentAccount
                        })
                    ]
                });
            case 'forgot-pw':
                return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
                    children: [
                        softBanner,
                        /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.PasswordResetForm), {
                            email: login.email,
                            result: pwreset,
                            saving: saving,
                            onSubmit: this.resetPW,
                            onInputChange: this.updateInput,
                            onCancel: ()=>this.setState({
                                    mode: 'login'
                                })
                        })
                    ]
                });
            case 'mfa':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $7bAQD.default), {
                    resolver: multiFactorResolver,
                    onEnd: (userCredential)=>this.login(userCredential?.user)
                });
            case 'login':
                return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
                    children: [
                        softBanner,
                        /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.PasswordLoginForm), {
                            login: login,
                            error: errs,
                            saving: saving,
                            onSubmit: this.firebaseAuthentication,
                            onInputChange: this.updateInput,
                            onBack: ()=>this.setState({
                                    mode: 'email',
                                    errs: null,
                                    org: null,
                                    login: {
                                        ...login,
                                        password: ''
                                    }
                                }),
                            onForgotPassword: ()=>this.setState({
                                    mode: 'forgot-pw'
                                })
                        })
                    ]
                });
            case 'detecting':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.DetectingStep), {});
            case 'picker':
                return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
                    children: [
                        softBanner,
                        /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.OrgPickerStep), {
                            email: login.email,
                            providers: providers,
                            onPick: this.pickProvider,
                            onBack: this.resetToEmail
                        })
                    ]
                });
            case 'sso':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.SsoRedirect), {
                    org: org,
                    error: errs,
                    onBack: this.resetToEmail
                });
            case 'returning':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.ReturningStep), {});
            case 'sso-account-blocked':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.SsoAccountBlocked), {
                    org: org,
                    message: accountBlockMessage || errs,
                    onGoBack: this.resetToEmail
                });
            case 'sso-email-mismatch':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.SsoEmailMismatch), {
                    org: org,
                    onGoBack: this.resetToEmail
                });
            case 'sso-failed':
                return /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.SsoFailure), {
                    org: org,
                    onGoBack: this.resetToEmail
                });
            default:
                return /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $cRQVA.Fragment), {
                    children: [
                        softBanner,
                        /*#__PURE__*/ (0, $cRQVA.jsx)((0, $1MWwR.EmailLoginForm), {
                            login: login,
                            error: errs,
                            saving: saving,
                            seenBefore: seenBefore,
                            onSubmit: this.resolveSsoProvider,
                            onInputChange: this.updateInput,
                            onBack: this.resetToEmail,
                            disabled: softOutage
                        })
                    ]
                });
        }
    }
    render() {
        // Failed `?aid=` token login lands here with the original query reattached
        // (incl. empty `return=` + cookie-auth's `next=`). Only bounce to a real
        // org failure URL — never treat `&next=…` as a redirect (that produced
        // nginx 404s on `/&next=/`).
        if (location.search?.indexOf('aid') > -1) {
            const returnUrl = (0, $4uQJZ.resolveAidFailureReturnUrl)(location.search);
            if (returnUrl) {
                window.location.href = returnUrl;
                return;
            }
            // Empty/missing/unsafe return: show the login form, but surface a clear
            // magic-link failure when enrollError was not already set by the redirect.
            if (!this.state.enrollError) this.state.enrollError = 'LOGIN_FAILED';
        }
        return /*#__PURE__*/ (0, $cRQVA.jsxs)("div", {
            className: "aud-login-page",
            children: [
                /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                    className: "aud-toast-holder",
                    children: /*#__PURE__*/ (0, $cRQVA.jsx)((0, $27df32bc1535385a$export$2e2bcd8739ae039), {
                        error: this.state.redirect.error,
                        statusCode: this.state.redirect.statusCode
                    })
                }),
                /*#__PURE__*/ (0, $cRQVA.jsxs)((0, $1MWwR.LoginCard), {
                    org: this.state.org,
                    children: [
                        this.state.enrollError && /*#__PURE__*/ (0, $cRQVA.jsx)("div", {
                            className: "aud-banner aud-banner-error text-danger",
                            children: /*#__PURE__*/ (0, $cRQVA.jsx)("p", {
                                children: $a9b75c9477f987d6$var$ENROLL_ERROR_MESSAGES[this.state.enrollError] || $a9b75c9477f987d6$var$ENROLL_ERROR_DEFAULT
                            })
                        }),
                        this.renderLoginContent()
                    ]
                })
            ]
        });
    }
}


(0, $hatoH.createRoot)(document.getElementById('app')).render(/*#__PURE__*/ (0, $cRQVA.jsx)((0, $a9b75c9477f987d6$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=app.js.map
